import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import _ from 'lodash';
import ReactDOM from 'react-dom';
import { Toolbar, Editors, Data } from 'react-data-grid-addons';
import { Link, withRouter } from 'react-router';
import { Field } from 'redux-form';
import { Translate, I18n } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';
import axios from 'axios';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb, Input, Dropdown, MenuItem, DropdownButton } from 'react-bootstrap';
const { DOM: { input } } = React;

import ContentWrapper from '../Layout/ContentWrapper';
import { Selection, DisabledSelection, SelectionWithProps } from '../Common/selection';
import { InputField, DisabledInputField } from '../Common/inputField';
import Spinner from '../Widgets/spinner';
import { DatePicker, StartOfThisMonthDatePicker } from '../Common/datePicker';
import checkPermissionLocal from '../Common/permissions';
import ConfirmActionModal from '../Common/confirmActionModal';
import SalesInventoryInfo from '../../containers/Sales/salesInventoryInfo';
import SalesShippingModal from '../../containers/Sales/salesShippingModal';
import { TaxSelectionModal } from '../Common/taxSelectionModal';
import { DiscountChangeModal } from '../Common/discountChangeModal';
import { WeightChangeModal } from '../Common/weightChangeModal';
import ItemHistoryGrid from '../../components/Common/itemHistoryGrid';
import MSOPaymentInfoContainer from '../../containers/Sales/MSOPaymentInfo';
import BoldTextFormatter from '../Common/boldTextFormatter';
import BoldCashFormatter from '../Common/boldCashFormatter';
import SalesOrderAutoSuggest from '../Common/SalesOrderAutoSuggest';
import FilterMultiKeyword from '../Common/filterMultiKeyword';
import { toFromDates } from '../Common/cleanDates';
import PrintIframe from '../Common/PrintIframe';
import DeliveryMethodModal from './DeliveryMethodModal';
import { calculateTax, calculateSavings, roundTo, roundToDecimals, normalizeFourDecimals } from '../Common/NumberUtil';
import DropshipModal from './DropshipModal';
import CheckboxFormatter from '../Common/CheckboxFormatter';
import VerifyPasscodeModal from '../Common/VerifyPasscodeModal';
import ShippingInfoFormModal from './ShippingInfoFormModal';
import salesOrderModals from "../Common/modals/salesOrder";
import { CarrierInfoModal } from '../Common/carrierInfoModal';
import ShippingAddressEditmodal from '../Common/shippingInfoEditModal';
import FBAAddressEditModal from '../Common/fbaAddressEditModal';
import ShippingInfoConfirmModal from '../Common/ShippingInfoConfirmModal';
import BatchesModal2 from '../Common/BatchesModal2';
import MultiBatchModal from '../Common/MultiBatchModal';
import MultiBatchModal2 from '../Common/MultiBatchModal2';
import GenericSelection from '../Common/GenericSelection';
const {
  DriverListModal, ISAEditModal, CTNEditModal, ShippingStatusEditModal,
  Notes, BatchesModal, PromotionAddingModal
} = salesOrderModals;
import {
  ROOT_URL, ROOT_API_URL, companyCodeTitle, isElegant, isLucky88, isEcity, isLO,
  isUSPride, isSY, isRivera, isWUFS,
} from '../../actions/root_url';
import { ACH_EDIT_URL, ZONES_URL, WAREHOUSES_URL } from '../../actions/url';

const isBobaLife = ROOT_API_URL === 'https://premiumstella-scm.truckxi.com/api';
const isMyumyu = (ROOT_API_URL === 'https://mmstage-scm.truckxi.com/api/' || ROOT_API_URL === 'https://myumyu-scm.truckxi.com/api/');
const isHMM = ROOT_API_URL === 'https://hmm-scm.truckxi.com/api/' || ROOT_URL === 'https://hmm-scm.truckxi.com/api/';
const isDHC = ROOT_API_URL === 'https://dhc-scm.truckxi.com/api/' || ROOT_URL === 'https://dhc-scm.truckxi.com/api/';
const isAFG = ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || ROOT_URL === 'https://afg-scm.truckxi.com/api/';
const isWecom = ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/' || ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/';
const isCO = ROOT_API_URL === 'https://co-scm.truckxi.com/api/' || ROOT_URL === 'https://co-scm.truckxi.com/api/';
const isAFM = ROOT_API_URL === 'https://afm-scm.truckxi.com/api/' || ROOT_URL === 'https://afm-scm.truckxi.com/api/';
const isTN = ROOT_API_URL === "https://tn-scm.truckxi.com/api/" || ROOT_URL === "https://tn-scm.truckxi.com/api/";
const isABC = ROOT_API_URL === 'https://abc-scm.truckxi.com/api/' || ROOT_URL === 'https://abc-scm.truckxi.com/api/';
const isAN = ROOT_API_URL === 'https://asian-scm.truckxi.com/api/' || ROOT_URL === 'https://asian-scm.truckxi.com/api/';
const isChinaTown = ROOT_API_URL === 'https://erp.chinatown-supermarket.com/api/' || ROOT_URL === 'https://erp.chinatown-supermarket.com/api/';
const isJML = ROOT_API_URL === 'https://jml-scm.truckxi.com/api/'|| ROOT_URL === 'https://jml-scm.truckxi.com/api/';
const isDSQ = ROOT_API_URL === 'https://dsq-scm.truckxi.com/api/' || ROOT_URL === 'https://dsq-scm.truckxi.com/api/';
const isWIZ = ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || ROOT_URL === 'https://wiz-scm.truckxi.com/api/';
const isFJ = ROOT_API_URL === 'https://fj-scm.truckxi.com/api/' || ROOT_URL === 'https://fj-scm.truckxi.com/api/';
const isJTB = ROOT_API_URL === 'https://jtb-scm.truckxi.com/api/' || ROOT_URL === 'https://jtb-scm.truckxi.com/api/';
const isFung = ROOT_API_URL === 'https://fung-scm.truckxi.com/api/' || ROOT_URL === 'https://fung-scm.truckxi.com/api/';
const isTQ = ROOT_API_URL === 'https://topquality-scm.truckxi.com/api/'|| ROOT_URL === 'https://topquality-scm.truckxi.com/api/';
const isMAG = ROOT_API_URL === 'https://magna-scm.truckxi.com/api/' || ROOT_URL === 'https://magna-scm.truckxi.com/api/';
const isNBT = ROOT_API_URL === 'https://nbt-scm.truckxi.com/api/' || ROOT_URL === 'https://nbt-scm.truckxi.com/api/';
const isKM = ROOT_API_URL === 'https://kingmax-scm.truckxi.com/api/' || ROOT_URL === 'https://kingmax-scm.truckxi.com/api/';
const isOCM = ROOT_API_URL === 'https://ocm-scm.truckxi.com/api/'|| ROOT_URL === 'https://ocm-scm.truckxi.com/api/';
const isATL = ROOT_API_URL === 'https://alton-scm.truckxi.com/api/' || ROOT_URL === 'https://alton-scm.truckxi.com/api/';
const isRS = ROOT_API_URL === 'https://redstone-scm.truckxi.com/api/' || ROOT_URL === 'https://redstone-scm.truckxi.com/api/';
const isKDW = ROOT_API_URL === 'https://kdw-scm.truckxi.com/api/' || ROOT_URL === 'https://kdw-scm.truckxi.com/api/';
const isABCFF = ROOT_API_URL === 'https://abcff-scm.truckxi.com/api/' || ROOT_URL === 'https://abcff-scm.truckxi.com/api/';
const isYI = ROOT_API_URL === 'https://ying-scm.truckxi.com/api/' || ROOT_URL === 'https://ying-scm.truckxi.com/api/';
const isFBD = ROOT_API_URL === 'https://fbd-scm.truckxi.com/api/' || ROOT_URL === 'https://fbd-scm.truckxi.com/api/';
const isCalco = ROOT_API_URL === 'https://calco-scm.truckxi.com/api/' || ROOT_API_URL === 'https://calco-stage.truckxi.com/api/';

var DropDownEditor = Editors.DropDownEditor;

const DateFormatterChina = React.createClass({
  render() {
    if (this.props.value) {
      let year = this.props.value.split('/')[2];
      if (year) {
        year = year.substring(2);
      }
      let date = this.props.value.split('/')[0] + '/' + this.props.value.split('/')[1] + '/' + year;
      return <span>{date}</span>;
    }
    return <span className="label label-danger">-</span>;
  },
});

const DateFormatter2 = React.createClass({
  render() {
    if (this.props.value) {
      const date = moment(this.props.value).format("MM-DD-YY");
      return <span>{date}</span>;
    }
    return <span className="label label-danger">-</span>;
  },
});

const isNumeric = function (n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

const Checkbox = props => {
  return (
    <input
      {...props.input}
      type="checkbox"
      value={!props.input.value ? "true" : "false"}
      checked={props.input.value === true || props.input.value === "true"}
      disabled={props.disabled}
    />
  );
}

class PriceFormatter extends Component {
  render() {
    const { dependentValues } = this.props;
    return <span style={{ 'font-weight': 'bold' }}>{ 
      dependentValues
    }</span>;
  }
}

class HMMPriceFormatter extends Component {
  render() {
    const { Quantity, UnitPrice, PackageSize_1, } = this.props.dependentValues;
    return <span style={{ 'font-weight': 'bold' }}>{ 
      (Quantity * UnitPrice * PackageSize_1).toFixed(2)
    }</span>;
  }
}

class SalesOrderForm extends Component {
    static contextTypes = {
      router: React.PropTypes.object,
    };
    constructor() {
      super();
      this.state = {
        dropShipWarning: false,
        // resellerTemp: null,
        containerSizeOptions: [
          {label: "20", value: "20"},
          {label: "40", value: "40"},
          {label: "45", value: "45"},
        ],
        stateOptions: [
          {label: "CA", value: "CA"},
          {label: "PA", value: "PA"},
        ],
        paymentTermOptions: [],
        yiWarehouseOptions: [],
        FJAgentOptions: [],
        FBAOptions: [],
        FBAOptions2: [],
        fjCarrierOptions: [],
        SalesOrderTypeSyOptions: [
          {label: "Retail", value: "Retail"},
          {label: "Wholesale", value: "Wholesale"},
        ],
        magStatusOptions: [
          {label: "NOT READY", value: "NOT_READY"},
          {label: "NOT READY HOLD NEED RELEASE", value: "NOT_READY_HOLD_NEED_RELEASE"},
          {label: 'DISCHARGE', value: "DISCHARGE"},
          {label: 'DISCHARGE HOLD NEED RELEASE', value: "DISCHARGE_HOLD_NEED_RELEASE"},
          {label: "LOAD READY FOR PICKUP", value: "LOAD_READY_FOR_PICKUP"},
          {label: 'LOAD OUT ON AND READY FOR DELIVERY', value: "LOAD_OUT_ON_AND_READY_FOR_DELIVERY"},
          {label: "LOAD DELIVERED ON", value: "LOAD_DELIVERED_ON"},
          {label: "EMPTY READY FOR PICKUP", value: "EMPTY_READY_FOR_PICKUP"},
          {label: 'EMPTY BACK TO', value: "EMPTY_BACK_TO"},
          {label: "EMPTY RETURNED ON", value: "EMPTY_RETURNED_ON"},
          // {label: "HOLD NEED RELEASE", value: "HOLD_NEED_RELEASE"},
        ],
        kdwStatusOptions: [
          {label: "DISPATCHED", value: "DISPATCHED"},
          {label: "ON THE WAY TO PORT", value: "ON_THE_WAY_TO_PORT"},
          {label: 'ON THE WAY TO CUSTOMER', value: "ON_THE_WAY_TO_CUSTOMER"},
          {label: 'ON THE WAY TO YARD', value: "ON_THE_WAY_TO_YARD"},
          {label: "ON THE WAY TO KDW", value: "ON_THE_WAY_TO_KDW"},
          {label: 'DELIVERED TO CUSTOMER', value: "DELIVERED_TO_CUSTOMER"},
          {label: "DELIVERED TO KDW", value: "DELIVERED_TO_KDW"},
          {label: "FULL IN YARD", value: "FULL_IN_YARD"},
          {label: "DELIVERED TO EXAM SITE", value: "DELIVERED_TO_EXAM_SITE"},
          {label: "EMPTY IN YARD", value: "EMPTY_IN_YARD"},
          // {label: "HOLD NEED RELEASE", value: "HOLD_NEED_RELEASE"},
        ],
        magNoteOptions: [
          {label: "DRYRUN", value: "DRYRUN"},
          {label: "OVERWEIGHT", value: "OVERWEIGHT"},
          {label: "UTL", value: "UTL"},
          {label: "PORTWAITING", value: "PORTWAITING"},
          {label: 'OFFHIRE', value: "OFFHIRE"},
          {label: 'HANDLING', value: "HANDLING"},
          {label: 'PIERPASS', value: "PIERPASS"},
          {label: 'AN_FEE', value: "AN_FEE"},
          {label: 'OTHER', value: "OTHER"},
          {label: "EXTRA STOP", value: "EXTRA STOP"},
          {label: "NO APPT FOR EMPTY RETURN", value: "NO APPT FOR EMPTY RETURN"},
          {label: 'EXAM', value: "EXAM"},
          {label: "REJECTED", value: "REJECTED"},
          {label: "REDELIVERY", value: "REDELIVERY"},
          // {label: "OTHER", value: "OTHER"},
        ],
        magTerminalOptions: [
          {label: "EVERPORT", value: "EVERPORT"},
          {label: "LBCT", value: "LBCT"},
          {label: "SHIPPERS-CARSON", value: "SHIPPERS-CARSON"},
          {label: "SHIPPERS-ALAMEDA", value: "SHIPPERS-ALAMEDA"},
          {label: 'SHIPPERS-LONGBEACH', value: "SHIPPERS-LONGBEACH"},
          {label: "TRAPAC", value: "TRAPAC"},
          {label: "WBCT", value: "WBCT"},
          {label: 'PCT', value: "PCT"},
          {label: "ITS", value: "ITS"},
          {label: "APM", value: "APM"},
          {label: "C60-MATSON", value: "C60-MATSON"},
          {label: "TTI", value: "TTI"},
          {label: "YUSEN", value: "YUSEN"},
          {label: "FMS", value: "FMS"},
          {label: "PIER-A", value: "PIER-A"},
          {label: "EXAM-SITE", value: "EXAM-SITE"},
          {label: "OTHER", value: "OTHER"},
        ],
        magShippingLineOptions: [
          {label: "EVERGREEN", value: "EVERGREEN"},
          {label: "CMA", value: "CMA"},
          {label: "MATSON", value: "MATSON"},
          {label: "MSC", value: "MSC"},
          {label: 'MAERSK', value: "MAERSK"},
          {label: "CMA", value: "CMA"},
          {label: "YANGMING", value: "YANGMING"},
          {label: 'COSCO', value: "COSCO"},
          {label: "SM LINE", value: "SM LINE"},
          {label: "WANHAI", value: "WANHAI"},
          {label: "HYUNDAI", value: "HYUNDAI"},
          {label: "BAL", value: "BAL"},
          {label: "HAPAG LLOYD", value: "HAPAG LLOYD"},
          {label: "SUD ", value: "SUD "},
          {label: "ONE ", value: "ONE "},
          {label: "APL ", value: "APL "},
          {label: "ZIM ", value: "ZIM "},
          {label: "CU LINE", value: "CU LINE"},
          {label: "TRANSFAR", value: "TRANSFAR"},
          {label: "SJJ", value: "SJJ"},
          {label: "LIHUA", value: "LIHUA"},
          {label: "SEALEAD", value: "SEALEAD"},
          {label: "OOLU", value: "OOLU"},
        ],
        magSizeOptions: [
          {label: "40HC", value: "40HC"},
          {label: "45ft", value: "45ft"},
          {label: "40ST", value: "40ST"},
          {label: "20ft", value: "20ft"},
          {label: "40RF", value: "40RF"},
        ],
        creditAmount: 0,
        shareCreditAmount: 0,

        shippingInfoModalVisibility: false,
        ShippingMethod: '',
        cellSelectEnabled: true,
        firstFocus: true,
        useDefaultCustomerAddress: true,
        // Customer payment term
        paymentTerm: null,
        salesOrderNumber: null,
        customerPaymentTerm: null,
        productHistoryLabel: '',
        // Determine Modal visibility
        openOrderOpen: false,
        historyOpen: false,
        customerOpen: false,
        confirmOpen: false,
        showInventoryOpen: false,
        showShippingOpen: false,
        changeTaxOpen: false,
        changeDiscountOpen: false,
        SODiscount: 0,
        SOSavings: 0,
        finalPriceWithPromotion: 0,
        employeeNoteText: '',
        employeeNoteDisplay: '',
        changeEmployeeNoteOpen: false,
        deliveryFeeEdit: null,
        changeWeightOpen: false,
        changeDeliveryFeeOpen: false,
        editSOPermissionOpen: false,
        confirmRefundOpen: false,
        deliveryMethodModalOpen: false,
        showCarrierButton: false,
        carrierInfoModalOpen: false,


        currentZBL: "",
        ZBLRowIndex: null,
        ZBLModalOpen: false,
        zoneDisplay: "",
        zoneSelected: null,
        zoneOptions: [
          // {label: "1", value: "1"},
          // {label: "2z", value: "2"},
        ],
        binDisplay: "",
        binSelected: null,
        binOptions: [
          // {label: "1b", value: "1"},
          // {label: "2b", value: "2"},
        ],
        levelDisplay: "",
        levelSelected: null,
        levelOptions: [
          // {label: "1lv", value: "1"},
          // {label: "2lv", value: "2"},
        ],

        isDropshipOpen: false,
        createBOLModalVisibility: false,
        verifyPasscodeOpen: false,
        verifyPasscodeOpenDiscount: false,
        // Tracks what error to display
        case: null,
        dirty: false,
        // Customer details
        Amount00_30: 0,
        Amount31_60: 0,
        Amount61_90: 0,
        Amount91: 0,
        // Determine expand state of panels
        favoriteItemsOpen: true,
        previousOrdersOpen: false,
        promotionsOpen: false,
        // Tracks information on customer currently chosen
        currentCustomer: null,
        currentCustomerName: null,
        // Variable used to determine which column to highlight prices
        currentPriceLevel: null,
        customersWithFavorites: [],
        salesItemHistory: [],
        // Keeps track of current item to be added to SO
        selectedItemName: '',
        selectedItemNumber: '',
        refPrice: null,
        defaultRefPrice: 0,
        // Order details
        totalPrice: 0,
        finalWeight: 0,
        finalNetWeight: 0,
        finalShippingWeight: 0,
        totalTax: 0,
        finalPrice: 0,
        totalCRV: 0,
        // Tracks items in SO table
        rows: [],
        selectedRows: [],
        filteredRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
        inventoryInput: null,
        // Track tax rate to use
        taxRate: null,
        // Assorted objects holding items in respective tables
        inventories: {
          rows: [],
          allRows: [],
          currString: null,
          selectedRows: [],
          sortColumn: null,
          sortDirection: null,
        },
        favorites: {
          rows: [],
          selectedRows: [],
          sortColumn: null,
          sortDirection: null,
          selectedIndexes: [],
        },
        // Previous SOs, default time for 3 months
        days: '90',
        FromDate: undefined,
        ToDate: undefined,
        previousSOs: {
          rows: [],
          selectedRows: [],
          filters: {},
          sortColumn: null,
          sortDirection: null,
        },
        previousOrders: {
          rows: [],
          selectedRows: [],
          filters: {},
          sortColumn: null,
          sortDirection: null,
          selectedIndexes: [],
        },
        quickEntrySONum: '',
        quickEntryShowError: false,
        promotions: {
          rows: [],
          selectedRows: [],
          sortColumn: null,
          sortDirection: null,
        },
        itemHistory: {
          rows: [],
          sortColumn: null,
          sortDirection: null,
        },
        frequentItems: {
          rows: [],
          selectedRows: [],
          sortColumn: null,
          sortDirection: null,
          selectedIndexes: [],
          selectedPK: [],
        },
        salesHistory: {
          rows: [],
          sortColumn: null,
          sortDirection: null,
          filters: {},
        },
        selectedInventoryRow: {},
        modified_by: null,
        updateTime: null,
        created_by: null,
        created_by_name: null,
        quantityZero: [],

        yourOrderTableHeight: (window.innerHeight < 930) ? 345 : 345,
        taxRateIndex: 0,
        yourOrderKey: 1,
        inboundInfoKey: 1,
        fjInfoKey: 1,

        NameOnAccount: null,
        AccountNum: null,
        Routing: null,

        editSOPermission: true,
        paymentInfo: null,
        shouldPaymentInfoShow: false,
        refundAmount: 0.00,
        refundReason: '',
        CompanyName: '',
        Billing: {
          AddressName: '',
          Cellphone: '',
          City: '',
          CustomerDetail: '',
          Email: '',
          Fax: '',
          FirstName: '',
          IsDefault: null,
          IsDeleted: null,
          LastName: '',
          Note: '',
          Position: '',
          State: '',
          Telephone: '',
          Type: '',
          Zip: '',
          Notation: '',
        },
        ShipTo: {
          Address: '',
          Telephone: '',
          Name: '',
        },
        Shipping: {
          AddressName: '',
          Cellphone: '',
          City: '',
          CustomerDetail: '',
          Email: '',
          Fax: '',
          FirstName: '',
          IsDefault: null,
          IsDeleted: null,
          LastName: '',
          Note: '',
          Position: '',
          State: '',
          Telephone: '',
          Type: '',
          Zip: '',
          TimeSlot: '',
        },
        prevEstDate: false,
        Released: false,
        editing: false,
        suggestValue: '',

        magDryrun: false,
        magOffhire: false,
        magHandling: false,
        magPierpass: false,
        magAnFee: false,
        magOther: false,
        magExtraStop: false,
        magExam: false,
        magExtraDelivery: false,
        magStorage: false,
        magBobtailFee: false,
        magChassisSplit: false,
        magCTF: false,
        magFSC: false,
        magPrepull: false,
        magCongestion: false,
        magDropoff: false,
        magOverweight: false,

        mag2FREIGHT_HOLD: false,
        mag2CUSTOM_HOLD: false,
        mag2PIERPASS_HOLD: false,
        mag2EXAM: false,
        mag2CLOSED_AREA: false,

        shippingPdfFrameLoaded: true,
        pickingListPdfFrameLoaded: true,
        packingListPdfFrameLoaded: true,
        salesOrderPdfFrameLoaded: true,
        salesOrderSIPdfFrameLoaded: true,
        refundPDFFrameLoaded: true,

        // Default tax value
        taxValue: 0,
        // Specifically for the previous Order search
        searchSalesOrderNum: '',
        salesOrderIndexFromLast: 1,

        // CheckboxFormatter
        IsNoReduce: false,
        IsFBAAddress: false,
        Sales_User_id: undefined,

        PaymentTermDesc: '',
        CreditLimit: '',
        delivery: 0,
        verifyPasscodeToCreateSOModalOpen: false,
        customerVerified: false,
        fee: 0,

        shippingInfoEditModalVisibility: false,
        fbaEditModalVisibility: false,
        shippingInfoConfirmModalVisibility: false,
        discountModified: false,

        shippingStatusEditModalVisible: false,
        isNotesModalVisibile: false,
        
        // TQ, OCM
        companyOptions: null,
        warehouseOptions: null,
        // modal
        isBatchesModalVisible: false,
        isBatchesModal2Visible: false,
        isMultiBatchVisible: false,
        lineBatchId: null,
        lineBatchIdx: null,
        lineQty: 0,
        lineBatchRows: [],
        isPromotionAddingAlertModalVisible: null,
        groupOptions: [],
      };
      this.openCustomer = this.openCustomer.bind(this);
      this.closeCustomer = this.closeCustomer.bind(this);
      this.openHistory = this.openHistory.bind(this);
      this.closeHistory = this.closeHistory.bind(this);
      this.moveToSO = this.moveToSO.bind(this);
      this.barcodeScan = this.barcodeScan.bind(this);
      this.handleUnitPriceChange = this.handleUnitPriceChange.bind(this);
      this.openConfirm = this.openConfirm.bind(this);
      this.closeConfirm = this.closeConfirm.bind(this);
      this.closeShowInventory = this.closeShowInventory.bind(this);
      this.selectInventoryInfo = this.selectInventoryInfo.bind(this);
      this.handleOnFocus = this.handleOnFocus.bind(this);
      this.openShowSOCreated = this.openShowSOCreated.bind(this);
      this.openEditSOPermission = this.openEditSOPermission.bind(this);
      this.closeEditSOPermission = this.closeEditSOPermission.bind(this);
      this.closeDropship = this.closeDropship.bind(this);
      this.openDropship = this.openDropship.bind(this);
      this.openShipping = this.openShipping.bind(this);
      this.openCreateBOLModal = this.openCreateBOLModal.bind(this);
      this.closeCreateBOLModal = this.closeCreateBOLModal.bind(this);
      this.closeShipping = this.closeShipping.bind(this);
      this.openChangeTax = this.openChangeTax.bind(this);
      this.closeChangeTax = this.closeChangeTax.bind(this);
      this.openEmployeeNote = this.openEmployeeNote.bind(this);
      this.closeEmployeeNote = this.closeEmployeeNote.bind(this);


      this.openAchEdit = this.openAchEdit.bind(this);
      this.closeAchEdit = this.closeAchEdit.bind(this);


      this.openDeliveryFee = this.openDeliveryFee.bind(this);
      this.closeDeliveryFee = this.closeDeliveryFee.bind(this);
      this.handleSelect = this.handleSelect.bind(this);
      this.handleSelect2 = this.handleSelect2.bind(this);
      this.handleSelect3 = this.handleSelect3.bind(this);
      this.handleDiscountChange = this.handleDiscountChange.bind(this);
      this.setAllProductQuantity = this.setAllProductQuantity.bind(this);
      this.openDeliveryMethodModal = this.openDeliveryMethodModal.bind(this);
      this.openCarrierInfoModal = this.openCarrierInfoModal.bind(this);
      this.closeCarrierInfoModal = this.closeCarrierInfoModal.bind(this);
      this.closeDeliveryMethodModal = this.closeDeliveryMethodModal.bind(this);

      this.openZBLModal = this.openZBLModal.bind(this);
      this.closeZBLModal = this.closeZBLModal.bind(this);
      
      this.handleUpdatePrice = this.handleUpdatePrice.bind(this);
      this.fetchPreviousSalesOrderByCustomer = this.fetchPreviousSalesOrderByCustomer.bind(this);
      this.fetchPreviousOrdersFromALLSalesOrder = this.fetchPreviousOrdersFromALLSalesOrder.bind(this);
      this.fetchPreviousOrderBySearch = this.fetchPreviousOrderBySearch.bind(this);
    }
  
    componentWillMount() {
      if (isAFG && this.props.currentSalesOrder && this.props.currentSalesOrder.SONum && this.props.currentSalesOrder.SONum.charAt(0) !== 'M') {
        if (this.context.router.routes[1].path === 'mobileSalesOrders/:id' || this.context.router.routes[1].path === 'salesOrders/:id') {
          this.state.showCarrierButton = true;
        }
      }
      this.props.fetchBaseUsers();
      this.props.setValue('salesOrderForm', 'Pickup_Warehouse_id', null);
      this.props.setValue('salesOrderForm', 'Sales_User_id', null);
      this.getCompanyOptions();
      let route = null;
      let currentSalesOrder;
      this.props.fetchVendors();
      // https://ct-scm.truckxi.com/api/v1/sale/sales_order/?pk=56774
      if (this.props.currentSalesOrder) {
        const Released = (this.props.currentSalesOrder.SaleStatus === 'Released');
        this.setState({ Released });
        this.props.setValue('salesOrderForm', 'CustomerDetail_id', this.props.currentSalesOrder.Deliver_CustomerDetail_id);
      }
      if (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'salesOrders/:id' || this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
        route = 'salesOrders';
      } else if (this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id') {
        route = 'mobileSalesOrders';
      }
      const { location: { pathname }, params: { id } } = this.props;
      if (!currentSalesOrder && !id) {
        if (pathname.includes('mobileSalesOrders/new')) {
          this.context.router.push('/mobileSalesOrders/');
        }
      }
      if (this.context.router.routes[1].path !== 'salesOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'mobileSalesOrders/new') {
        currentSalesOrder = this.props.currentSalesOrder;
      }
      
      this.props.fetchTaxRates()
       .then(() => {
         const taxRateOptions = this.getTaxRateOptions();
         if ((isHMM || isElegant) && taxRateOptions.length > 0) {
           this.handleTaxValueChange({
             value: taxRateOptions[0].value,
             label: taxRateOptions[0].label,
             index: 0
           })
         }
        //  if (isAN) {
        //   this.handleTaxValueChange({
        //     value: 8.375,
        //     label: 8.375,
        //     index: 0
        //   });
        //  }
      })
  
      if (currentSalesOrder && this.context.router.routes[1].path !== 'salesOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'mobileSalesOrders/new') {
        this.setState({ currentCustomer: currentSalesOrder.Deliver_Customer_id, salesOrderNumber: currentSalesOrder.SONum });
        this.props.setValue('salesOrderForm', 'Deliver_Customer_id', currentSalesOrder.Deliver_Customer_id);
        this.props.fetchCustomers()
          .then(() => {
            if (currentSalesOrder.Shipping_Customer) {
              this.props.fetchSalesCustomerDetail(currentSalesOrder.Shipping_Customer, currentSalesOrder.SalesOrder_id, true);
            } else {
              this.props.fetchSalesCustomerDetail(currentSalesOrder.Deliver_Customer_id, this.props.currentSalesOrder && this.props.currentSalesOrder.SalesOrder_id);
              let fjAgentTemp2 = [];
              if (isFJ) {
                this.props.fetchFJAgents(currentSalesOrder.Deliver_Customer_id)
                .then(response => {
                  if (response.data) {
                    response.data.map(r => {
                      fjAgentTemp2.push({label: r.name, value: r.id});
                    });
                    this.state.FJAgentOptions = fjAgentTemp2;
                  }
                }, err => {
                  if (err.status === 500 || err.status === 404) {
                    alert('error fetching agents');
                  }
                });
              }
            }
          })
          // .then(() => {
          //   this.props.fetchPromotions();
          // })
          .then(() => {
            // this.props.fetchCustomersWithFavorites();
            this.setState({ editSOPermission: false });
            // this.props.setDefaultSearchType('RefNum', 'salesOrderForm');
            this.props.initializeSalesOrderForm('RefNum', 'salesOrderForm');
            this.props.fetchSalesOrderDetail(currentSalesOrder.SalesOrder_id, route);
          });
        // get 90 days sales order
        this.props.fetchPreviousSalesOrderByCustomer(currentSalesOrder.Deliver_Customer_id || (this.props.Deliver_CustomerDetail_id && this.props.Deliver_CustomerDetail_id.value || this.props.Deliver_CustomerDetail_id), this.state.fromDate, this.state.toDate);
      } else {
        this.props.resetCurrentSalesOrder();
        this.props.fetchActiveCustomers();
        // this.props.fetchPromotions();
        this.props.fetchTaxRates();
        // this.props.setDefaultSearchType('RefNum', 'salesOrderForm');
        this.props.initializeSalesOrderForm('RefNum', 'salesOrderForm');
        this.setState({ Released: false });
      }
      // making a leaving hook to confirm leaving
      if (this.props.prevEstDate) { this.setState({ prevEstDate: this.props.prevEstDate }); } else { 
        var currentDate = new Date();
        isEcity && currentDate.setDate(currentDate.getDate() + 1);
        this.setState({ prevEstDate: currentDate });
      }
      if (this.props.prevEstDateIsNeeded) { this.props.destroyEstDate(); }
      this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));

      if (this.props.currentSalesOrder) {
        if (!this.props.currentSalesOrder.FinalNetWeight) {
          this.props.currentSalesOrder.FinalNetWeight = 0.00;
        } else {
          this.props.currentSalesOrder.FinalNetWeight = this.props.currentSalesOrder.FinalNetWeight;
        }
        if (!this.props.currentSalesOrder.FinalShippingWeight && this.props.currentSalesOrder.FinalNetWeight) {
          this.props.currentSalesOrder.FinalShippingWeight = this.props.currentSalesOrder.FinalNetWeight;
          this.state.finalShippingWeight = this.props.currentSalesOrder.FinalNetWeight;
        } else {
          this.state.finalShippingWeight = this.props.currentSalesOrder.FinalShippingWeight;
        }
      }
      if (this.props && this.props.employeeNote) {
        this.state.employeeNoteText = this.props.employeeNote;
        this.state.employeeNoteDisplay = this.props.employeeNote;
      }

      let jmlTemp = [];
      if (isJML) {
        this.props.getPaymentTerms()
        .then(response => {
          if (response.data) {
            response.data.map(r => {
              jmlTemp.push({label: r.Name, value: r.PaymentTerm_id});
              // jmlTemp.push({label: r.Name, value: r.Name});
            });
            this.state.paymentTermOptions = jmlTemp;
          }
        }, err => {
          if (err.status === 500 || err.status === 404) {
            alert('error fetching payment terms');
          }
        });
      }
      
      if (isChinaTown) {
        this.props.setDefaultOfForm("ShippingMethod", "Delivery", "salesOrderForm");    
      }

      if (isWIZ || isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isFJ || isJTB) {
        this.props.fetchInboundProducts();
      }
      if (isWIZ) {
        let fbaAdressTemp1 = [];
        let fbaAdressTemp2 = [];
          this.props.fetchFBAAddressOptions()
          .then(response => {
            if (response.data) {
              response.data.map(r => {
                fbaAdressTemp1.push({label: r.street+", "+r.city+", "+r.zipcode+", "+r.state, value: r.id});
                fbaAdressTemp2.push({label: r.name,  value: r.id});
              });
              this.state.FBAOptions = fbaAdressTemp1;
              this.state.FBAOptions2 = fbaAdressTemp2;
            }
          }, err => {
            if (err.status === 500 || err.status === 404) {
              alert('error fetching FBA address');
            }
          });
      }

      if (isFJ) {
        let fjCarrierTemp1 = [];
        // let fbaAdressTemp2 = [];
          this.props.fetchFJCarriers()
          .then(response => {
            if (response.data) {
              response.data.map(r => {
                fjCarrierTemp1.push({label: r.name, value: r.id});
                // fbaAdressTemp2.push({label: r.name,  value: r.id});
              });
              this.state.fjCarrierOptions = fjCarrierTemp1;
              // this.state.FBAOptions2 = fbaAdressTemp2;
            }
          }, err => {
            if (err.status === 500 || err.status === 404) {
              alert('error fetching carriers');
            }
          });
      }
      // if (isTQ) {
      //   this.props.setDefaultOfForm("Company_id", "Aibou Trading, Inc.", "salesOrderForm"); 
      // }
    }

    componentWillReceiveProps(nextProps) {
      if (isJML && (nextProps.PackageSize_1 !== this.props.PackageSize_1) && this.props.jmlBox) {
        this.props.setValue('salesOrderForm', 'Quantity', nextProps.PackageSize_1*this.props.jmlBox);
      } 
      if (isJML && (nextProps.jmlBox !== this.props.jmlBox)) {
        if(this.props.PackageSize_1) {
          this.props.setValue('salesOrderForm', 'Quantity', nextProps.jmlBox*this.props.PackageSize_1);
        }
        this.setState({
          lineQty: nextProps.jmlBox? Number(nextProps.jmlBox) : 0,
        })
      }

      if (this.context.router.routes[1].path === 'salesOrders/:id' || this.context.router.routes[1].path === 'outboundOrders/:id') {
        if (!this.state.SODiscount && !this.state.SOSavings) {
          this.setState({ SODiscount: nextProps.discount, SOSavings: nextProps.savings });
        } else {
          if (!this.state.discountModified) {
            this.setState({ SODiscount: nextProps.discount, SOSavings: nextProps.savings });
          }
        }
      }
      if ((this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'outboundOrders/new') && !this.state.discountModified) {
        this.setState({ SODiscount: 0, SOSavings: 0 });
      }
      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.FinalNetWeight && nextProps.currentSalesOrderDetail.FinalShippingWeight) {
        // this.props.currentSalesOrder.FinalNetWeight = nextProps.currentSalesOrderDetail.FinalNetWeight;
        // this.props.currentSalesOrder.FinalShippingWeight = nextProps.currentSalesOrderDetail.FinalShippingWeight;
        // this.state.finalShippingWeight = this.props.currentSalesOrder.FinalShippingWeight;
      }
      if (nextProps.employeeNote) {
        this.state.employeeNoteText = nextProps.employeeNote;
        this.state.employeeNoteDisplay = nextProps.employeeNote;
      }
      if (nextProps.customerChosen !== this.props.customerChosen) {
        this.setState({
          customerVerified: false,
        })
      }
      
      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.SaleStatus && nextProps.currentSalesOrderDetail.SaleStatus === 'Released') {
        this.setState({ Released: true });
      }
      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.ShippingMethod) {
        this.setState({ ShippingMethod: nextProps.currentSalesOrderDetail.ShippingMethod });
      }
      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.Billing) {
        this.setState({ Shipping: nextProps.currentSalesOrderDetail.Shipping, Billing: nextProps.currentSalesOrderDetail.Billing });
      }
      if (nextProps.salesCustomerDetails && nextProps.salesCustomerDetails.Billing) {
        this.setState({ Shipping: nextProps.salesCustomerDetails.Shipping, Billing: nextProps.salesCustomerDetails.Billing });
        if (nextProps.salesCustomerDetails.CustomerNum === 'EMP9999' && !nextProps.allShipping) {
          this.props.fetchAllShipping();
        }
      }

      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.ShipTo) {
        this.setState({ ShipTo: nextProps.currentSalesOrderDetail.ShipTo });
      }
      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.CompanyName) {
        this.setState({ CompanyName: nextProps.currentSalesOrderDetail.CompanyName });
      }

      if (nextProps.salesShippingCustomerDetails !== this.props.salesShippingCustomerDetails) {
        this.setState({ Shipping: nextProps.salesShippingCustomerDetails.Shipping });
        if (nextProps.salesShippingCustomerDetails.Shipping) {
          let defaultFound = false;
          const fieldName = (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'outboundOrders/new') ? 'CustomerDetail_id' : 'Deliver_CustomerDetail_id';
          nextProps.salesShippingCustomerDetails.Shipping.map((ShippingInfo) => {
            if (ShippingInfo.IsDefault) {
              defaultFound = true;
              if(nextProps.Deliver_CustomerDetail_id) {
                this.props.setValue('salesOrderForm', fieldName, nextProps.Deliver_CustomerDetail_id);                
              } else {
                if (isHMM) {
                  this.props.setValue('salesOrderForm', fieldName, null);
                } else {
                  this.props.setValue('salesOrderForm', fieldName, ShippingInfo.CustomerDetail_id);
                }
              }
            }
          });

          if (defaultFound === false) {
            if(nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.Deliver_CustomerDetail_id) {
              this.props.setValue('salesOrderForm', 'Deliver_CustomerDetail_id', nextProps.currentSalesOrderDetail.Deliver_CustomerDetail_id);
            } else {
              this.props.setValue('salesOrderForm', fieldName, null);
            }
            
          }
        }
      }

      if (nextProps.allShipping && nextProps.allShipping !== this.props.allShipping && nextProps.allShipping.length && nextProps.salesCustomerDetails && nextProps.salesCustomerDetails.CustomerNum === 'EMP9999') {
        this.setState({ Shipping: nextProps.allShipping });
      }
      if (nextProps.dirty !== this.props.dirty) {
        this.setState({
          dirty: nextProps.dirty,
        });
      }

      if (nextProps.salesOrderCreated && nextProps.salesOrderCreated !== this.props.salesOrderCreated) {
        this.openShowSOCreated();
      }

      if (nextProps.salesOrderEdited && nextProps.salesOrderEdited !== this.props.salesOrderEdited) {
        this.openShowSOCreated();
      }

      if (nextProps.productInfo && nextProps.productInfo !== this.props.productInfo) {
        const productInfo = nextProps.productInfo;
        this.setState({
          productInfo,
          inStock: nextProps.productInfo.InStock,
          purchased: nextProps.productInfo.Purchased,
          presale: nextProps.productInfo.PreSale,
          net_weight: nextProps.productInfo.ProductNum.NetWeight,
          ship_weight: nextProps.productInfo.ProductNum.ShipWeight,
          total_weight: '',
          RefPrice: nextProps.productInfo.RefPrice, //ctn
          LowestSalePrice: nextProps.productInfo.LowestSalePrice,
          PriceLv1: nextProps.productInfo.PriceLv1,
          PriceLv2: nextProps.productInfo.PriceLv2,
          PriceLv3: nextProps.productInfo.PriceLv3,
          PriceLv4: nextProps.productInfo.PriceLv4,
          PriceLv5: nextProps.productInfo.PriceLv5,
        });
      }

      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail !== this.props.currentSalesOrderDetail) {
        const currentSalesOrderDetail = nextProps.currentSalesOrderDetail;
        if (currentSalesOrderDetail.Sales_Order_Lines != null) {
          let totalPrice = 0;
          let totalTax = 0;
          let totalTaxOriginal = 0;
          let finalPrice = 0;
          let finalWeight = 0;
          let totalCRV = 0;
          let delivery = 0;
          // let deliveryFeeEdit = 0;
          let index = currentSalesOrderDetail.Sales_Order_Lines.length;
          let discount = currentSalesOrderDetail.Discount || 0;
          currentSalesOrderDetail.Sales_Order_Lines.map((row) => {
            row.Index = index;
            index--;
            if (row.IsTaxable === true) {
              if (isHMM) {
                totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(nextProps.currentSalesOrderDetail.TaxRate / 100);
              } else {
                if(isAN || isElegant) {
                  let taxable = !this.props.salesCustomerDetails.Reseller;
                  if (isAN) {
                    taxable = row.IsAllTaxable === true || !this.props.salesCustomerDetails.Reseller;
                  }
                  if(taxable) {
                    totalTax += parseFloat(row.TotalPrice) * parseFloat(nextProps.currentSalesOrderDetail.TaxRate / 100);
                  }
                } else {
                  totalTax += parseFloat(row.TotalPrice) * parseFloat(nextProps.currentSalesOrderDetail.TaxRate / 100);
                }
              }
            }
            if (isHMM) {
              totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);          
            } else {
              totalPrice += parseFloat(row.TotalPrice);
            }
            if (row.TotalNetWeight != null) {
              finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight);
            }
            if (row.CRV) {
              row.TotalCRV = +roundTo(parseFloat(row.CRV * row.Quantity), 2).toFixed(2);
            }
            if (row.TotalCRV) {
              totalCRV += row.TotalCRV;
            }
          });
          totalTaxOriginal = totalTax = +roundTo(totalTax, 2).toFixed(2);
          if (isElegant) {
            discount = currentSalesOrderDetail.Discount || (parseFloat(currentSalesOrderDetail.Savings) / totalPrice) * 100 || 0;
            totalTax = +roundTo((1 - (discount / 100)) * totalTax, 2).toFixed(2);
          }
          finalPrice = (parseFloat(totalPrice) * (1 - (discount / 100))) + (parseFloat(totalTax) + parseFloat(totalCRV));
          finalWeight = +roundTo(finalWeight, 2).toFixed(2);
          totalPrice = +roundToDecimals(totalPrice, 4).toFixed(4);
          finalPrice = +roundTo(finalPrice, 2).toFixed(2);
          delivery = nextProps.currentSalesOrderDetail.Delivery;
          // deliveryFeeEdit = nextProps.currentSalesOrderDetail.Delivery;
          let updateTime = new Date(currentSalesOrderDetail.UpdateTime);
          updateTime = this.updateTimeformatDate(updateTime).slice(0, 10);

          let magTempSplit = [];
          if (isMAG && currentSalesOrderDetail.mag_note) {
           magTempSplit = currentSalesOrderDetail.mag_note.split(',');
           magTempSplit.map(r=>{
            if (r === 'DRYRUN') {this.state.magDryrun = true;}
            if (r === 'OFFHIRE') {this.state.magOffhire = true;}
            if (r === 'PIERPASS') {this.state.magPierpass = true;}
            if (r === 'AN_FEE') {this.state.magAnFee = true;}
            if (r === 'OTHER') {this.state.magOther = true;}
            if (r === 'HANDLING') {this.state.magHandling = true;}
            if (r === 'EXTRA_STOP') {this.state.magExtraStop = true;}
            if (r === 'EXAM') {this.state.magExam = true;}
            if (r === 'EXTRA_DELIVERY') {this.state.magExtraDelivery = true;}
            if (r === 'STORAGE') {this.state.magStorage = true;}
            if (r === 'BOBTAIL_FEE') {this.state.magBobtailFee = true;}
            if (r === 'CHASSIS_SPLIT') {this.state.magChassisSplit = true;}
            if (r === 'CTF') {this.state.magCTF = true;}
            if (r === 'FSC') {this.state.magFSC = true;}
            if (r === 'PREPULL') {this.state.magPrepull = true;}
            if (r === 'CONGESTION') {this.state.magCongestion = true;}
            if (r === 'DROPOFF') {this.state.magDropoff = true;}
            if (r === 'OVERWEIGHT') {this.state.magOverweight = true;}
           });
          }

          let mag2TempSpit = [];
          if (isMAG && currentSalesOrderDetail.DeliveryStatus) {
            mag2TempSpit = currentSalesOrderDetail.DeliveryStatus.split(',');
            mag2TempSpit.map(r=>{
             if (r === 'FREIGHT_HOLD') {this.state.mag2FREIGHT_HOLD = true;}
             if (r === 'CUSTOM_HOLD') {this.state.mag2CUSTOM_HOLD = true;}
             if (r === 'PIERPASS_HOLD') {this.state.mag2PIERPASS_HOLD = true;}
             if (r === 'EXAM') {this.state.mag2EXAM = true;}
             if (r === 'CLOSED_AREA') {this.state.mag2CLOSED_AREA = true;}
            });
           }

          this.setState({
            ...this.state,
            finalPrice,
            totalPrice,
            totalTax,
            totalTaxOriginal,
            finalWeight,
            discount,
            totalCRV,
            updateTime,
            delivery,
            fee: currentSalesOrderDetail.Payment_Information ? currentSalesOrderDetail.Payment_Information.Fee : 0,
            taxValue: currentSalesOrderDetail.TaxRate,
            rows: currentSalesOrderDetail.Sales_Order_Lines,
            modified_by: currentSalesOrderDetail.Modifier_User_Name,
            created_by: currentSalesOrderDetail.Sales_User_id,
            created_by_name: currentSalesOrderDetail.Sales_User_Name,
            creator: currentSalesOrderDetail.Sales_User_Name,
            currentCustomer: currentSalesOrderDetail.Deliver_Customer_id,
            paymentInfo: currentSalesOrderDetail.Payment_Information,

            // NameOnAccount: currentSalesOrderDetail.Payment_Information ? currentSalesOrderDetail.Payment_Information.NameOnAccount : null,
            // AccountNum: currentSalesOrderDetail.Payment_Information ? currentSalesOrderDetail.Payment_Information.AccountNum : null,
            // Routing: currentSalesOrderDetail.Payment_Information ? currentSalesOrderDetail.Payment_Information.Routing : null,

            chargeID: currentSalesOrderDetail.Charge_id,
            IsNoReduce: currentSalesOrderDetail.IsNoReduce,
            IsFBAAddress: currentSalesOrderDetail.IsFBAAddress,
            Sales_User_id: currentSalesOrderDetail.Sales_User_id,
            paymentMethod: currentSalesOrderDetail.payment_method,
          }, () => { this.handleDiscountChange(discount); });
        }

        if (nextProps.currentSalesOrderDetail.Shipping_Customer) {
          this.props.setValue('salesOrderForm', 'receivingCustomer', nextProps.currentSalesOrderDetail.Shipping_Customer);
          this.props.fetchSalesCustomerDetail(nextProps.currentSalesOrderDetail.Shipping_Customer, null, true);
          this.setState({ useDefaultCustomerAddress: false });
        }
        if (currentSalesOrderDetail.Shipping != null && currentSalesOrderDetail.CustomerNum !== 'EMP9999') {
          this.setState({
            shipping: currentSalesOrderDetail.Shipping,
          });
        }
        // this.props.setDefaultSearchType('RefNum', 'salesOrderForm');
        this.props.initializeSalesOrderForm('RefNum', 'salesOrderForm');
      }

      if (nextProps.inventories && nextProps.inventories !== this.props.inventories) {
        const inventoryItems = [...nextProps.inventories];
        const tempVariable = [...nextProps.inventories];
        inventoryItems.map((item) => {
          const check = _.findIndex(this.state.rows, { ProductNum: item.ProductNum.ProductNum });
          if (check !== -1) {
            item.inList = true;
          }
          item.PriceLv1 = item.ProductNum__PriceLv1;
          item.PriceLv2 = item.ProductNum__PriceLv2;
          item.PriceLv3 = item.ProductNum__PriceLv3;
          item.PriceLv4 = item.ProductNum__PriceLv4;
          item.PriceLv5 = item.ProductNum__PriceLv5;
          item.Ordered = item.Purchased;
        });
        const inventories = { ...this.state.inventories, allRows: inventoryItems, rows: tempVariable };
        this.setState({ inventories });
      }

      if (nextProps.inventoryIdValue && nextProps.inventoryIdValue !== this.props.inventoryIdValue) {
        const filteredRows = this.state.inventories.allRows.filter((obj) => {
          const match = String(obj.ProductNum).includes(String(nextProps.inventoryIdValue));
          return match;
        });
        const inventories = { ...this.state.inventories, rows: filteredRows };
        this.setState({ inventories });
        const index = _.findIndex(filteredRows, { ProductNum: nextProps.inventoryIdValue });
        if (index > -1) {
          this.setState({
            selectedItemName: filteredRows[index].Name,
            selectedItemNumber: nextProps.inventoryIdValue,
          });
        }
      }

      if (nextProps.customersWithFavorites && nextProps.customersWithFavorites !== this.props.customersWithFavorites) {
        this.setState({ customersWithFavorites: nextProps.customersWithFavorites });
      }

      if (nextProps.previousSOs && nextProps.previousSOs !== this.props.previousSOs) {
        let previousSOs;
        if (nextProps.previousSOs.Orders) {
          previousSOs = {
            ...this.state.previousSOs,
            rows: nextProps.previousSOs.Orders,
            selectedIndexes: [],
            sortColumn: null,
            sortDirection: null,
          };
        } else {
          previousSOs = {
            ...this.state.previousSOs, rows: [], selectedIndexes: [], sortCol: null, sortDirection: null,
          };
        }
        this.setState({ previousSOs });
      }

      if (nextProps.previousOrders && nextProps.previousOrders !== this.props.previousOrders) {
        let previousOrders;
        if (nextProps.previousOrders.Sales_Order_Lines) {
          previousOrders = {
            ...this.state.previousOrders,
            rows: nextProps.previousOrders.Sales_Order_Lines,
            selectedIndexes: [],
            sortColumn: null,
            sortDirection: null,
          };
        } else if (nextProps.previousOrders) {
          // when select to show all product from all previous SOs
          previousOrders = {
            ...this.state.previousOrders,
            rows: nextProps.previousOrders,
            selectedIndexes: [],
            sortColumn: null,
            sortDirection: null,
          };
        } else {
          previousOrders = {
            ...this.state.previousOrders, rows: [], selectedIndexes: [], sortCol: null, sortDirection: null,
          };
        }
        this.setState({ previousOrders });
      }
      if (nextProps.salesOrderDetailByNum && nextProps.salesOrderDetailByNum !== this.props.salesOrderDetailByNum) {
        let previousOrders;
        if (nextProps.salesOrderDetailByNum.Sales_Order_Lines) {
          previousOrders = {
            ...this.state.previousOrders,
            rows: nextProps.salesOrderDetailByNum.Sales_Order_Lines,
            selectedIndexes: [],
            sortColumn: null,
            sortDirection: null,
          };
        } else {
          previousOrders = {
            ...this.state.previousOrders, rows: [], selectedIndexes: [], sortCol: null, sortDirection: null,
          };
        }
        this.setState({ previousOrders });
      }
      // if (nextProps.promotions && nextProps.promotions !== this.props.promotions) {
      //   const promotions = { ...this.state.promotions, rows: nextProps.promotions };
      //   this.setState({ promotions });
      // }

      if (nextProps.customerChosen && nextProps.customerChosen.value && nextProps.customerChosen !== this.props.customerChosen) {
        this.props.fetchSalesCustomerDetail(nextProps.customerChosen.value, this.props.currentSalesOrder && this.props.currentSalesOrder.SalesOrder_id);
        if (!isDSQ && !isWUFS && !isABCFF && !isKDW && !isYI && !isFBD && !isWIZ && !isFJ && !isJTB) {
          this.props.fetchCustomerFrequent(nextProps.customerChosen.value);
        }
        let fjAgentTemp = [];
        if (isFJ) {
          this.props.fetchFJAgents(nextProps.customerChosen.value)
          .then(response => {
            if (response.data) {
              response.data.map(r => {
                fjAgentTemp.push({label: r.name, value: r.id});
              });
              this.state.FJAgentOptions = fjAgentTemp;
            }
          }, err => {
            if (err.status === 500 || err.status === 404) {
              alert('error fetching agents');
            }
          });
        }

        this.props.fetchFavoriteList(nextProps.customerChosen.value);
        this.setState({
          currentCustomer: nextProps.customerChosen.value,
          useDefaultCustomerAddress: true,
          salesOrderIndexFromLast: 1,
          currentCustomerName: nextProps.customerChosen.label,
          previousOrders: {
            rows: [],
            selectedRows: [],
            sortColumn: null,
            sortDirection: null,
            selectedIndexes: [],
          },
        }, this.fetchPreviousSalesOrderByCustomer);
        // ReactDOM.findDOMNode(this.refs.productSearch.getRenderedComponent().myInput.refs.input).focus();
      }

      if (nextProps.customerPrices && nextProps.customerPrices !== this.props.customerPrices) {
        const rows = JSON.parse(JSON.stringify(this.state.inventories.allRows));
        const customerPrices = JSON.parse(JSON.stringify(nextProps.customerPrices));
        const mergedList = _.map(rows, (i) => {
          const newList = _.merge(i, _.find(customerPrices, { Product_id: i.Product_id }));
          return newList;
        });
        const inventories = { ...this.state.inventories, rows: mergedList, allRows: mergedList };
        this.setState({ inventories });
      }
      
      if (isOCM && nextProps.Company_id && nextProps.Company_id !== this.props.Company_id) {
        let warehouseOptions = [];
        const id = nextProps.Company_id;
        this.props.fetchWarehousesByCompany(id)
          .then(response => {
            response.data.map((warehousse) => {
              warehouseOptions.push({ label: warehousse.Name, value: warehousse.Warehouse_id}); 
            });
            this.props.setValue('salesOrderForm', 'Pickup_Warehouse_id', warehouseOptions[0].value);
            this.setState({ warehouseOptions });
          },
          (err) => {
            if (err.status === 500 || err.status === 404) {
              alert('error fetching company names');
            }
          }
        );
      }
      
      if (isSY && nextProps.groups && nextProps.groups !== this.props.groups) {
        const groupOptions = [];
        nextProps.groups.map((group) => {
          groupOptions.push({ value: group.ProductGroup_id, label: group.Name});
        });
        this.setState({ groupOptions });
      }

      if (nextProps.previousOrderFromDate && nextProps.previousOrderToDate && (nextProps.previousOrderFromDate !== this.props.previousOrderFromDate || nextProps.previousOrderToDate !== this.props.previousOrderToDate)) {
        const dates = toFromDates(-1, nextProps.previousOrderFromDate, nextProps.previousOrderToDate);
        if (this.state.currentCustomer) {
          this.props.fetchPreviousOrders(this.state.currentCustomer, dates.fromDate, dates.toDate);
        }
      }

      if (nextProps.salesCustomerDetails && nextProps.salesCustomerDetails !== this.props.salesCustomerDetails) {
        // this.setState({resellerTemp: nextProps.salesCustomerDetails.Reseller});
        if(!this.state.created_by) {
          this.setState({
            created_by: nextProps.salesCustomerDetails.Sales_User_id,
          });
        }
        if(!this.state.created_by_name) {
          this.setState({
            created_by_name: nextProps.salesCustomerDetails.Sales_User_Name,
          });
        }
        if (isEcity && nextProps.salesCustomerDetails.open_orders) {
          if (nextProps.salesCustomerDetails.open_orders.length > 0 && this.context.router.routes[1].path === 'salesOrders/new') {
            // if it is ecity and has open orders -> popup show orders and can edit 
            this.setState({ openOrderOpen : true })
          }
        }
        if (isAN) {
          this.handleTaxValueChange({
            value: 8.375,
            label: 8.375,
            index: 0
          });
        }
        const details = { ...nextProps.salesCustomerDetails };
        if (details.Amount00_30 == null) details.Amount00_30 = 0;
        if (details.Amount61_90 == null) details.Amount61_90 = 0;
        if (details.Amount31_60 == null) details.Amount31_60 = 0;
        if (details.Amount91 == null) details.Amount91 = 0;

        // Set to the default shipping
        if (nextProps.salesCustomerDetails.Shipping) {
          const fieldName = (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'outboundOrders/new') ? 'CustomerDetail_id' : 'Deliver_CustomerDetail_id';
          let defaultFound = false;
          nextProps.salesCustomerDetails.Shipping.map((ShippingInfo) => {
            if (ShippingInfo.IsDefault) {
              defaultFound = true;
              if (isHMM) {
                this.props.setValue('salesOrderForm', fieldName, null);
              } else {
                this.props.setValue('salesOrderForm', fieldName, ShippingInfo.CustomerDetail_id);
              }
            }
            if (ShippingInfo.IsDefault && this.props.params) {
              if (isHMM) {
                this.props.setValue('salesOrderForm', fieldName, null);
              } else {
                this.props.setValue('salesOrderForm', fieldName, ShippingInfo.CustomerDetail_id);
              }
            }
          });

          if (defaultFound === false) {
            this.props.setValue('salesOrderForm', fieldName, null);
          }
        }

        this.props.setCredit(nextProps.salesCustomerDetails.CreditStatus);
        this.setState({
          Amount00_30: details.Amount00_30,
          Amount31_60: details.Amount31_60,
          Amount61_90: details.Amount61_90,
          Amount91: details.Amount91,
          customerPaymentTerm: nextProps.salesCustomerDetails.PaymentTerm,
          customerPriceLevel: nextProps.salesCustomerDetails.PriceLevel,
          PaymentTermDesc: nextProps.salesCustomerDetails.PaymentTermDesc,
          CreditLimit: nextProps.salesCustomerDetails.CreditLimit,
        });
        this.props.setValue('salesOrderForm', 'PaymentTerm_id', nextProps.salesCustomerDetails.PaymentTermId);
      }

      let total_weight = parseFloat(nextProps.quantityValue || 0) * parseFloat(this.state.selectedInventoryRow.NetWeight || 0);
      // if statement for instances where there is text in the quantity field from user input
      if (Number.isNaN(total_weight)) {
        total_weight = 0.00
      }
      total_weight = total_weight.toFixed(2);
      this.setState({ total_weight });

      if (nextProps.unitPrice && nextProps.unitPrice !== this.props.unitPrice) {
        // let subtotal = parseFloat(nextProps.unitPrice) * parseFloat(this.props.quantityValue);
        // this.props.setSubtotal(subtotal);
      }

      if (nextProps.customerFrequent && nextProps.customerFrequent !== this.props.customerFrequent) {
        let frequentItems = {};
        if (isWIZ || isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isFJ || isJTB) {
          frequentItems = { ...this.state.frequentItems, rows: nextProps.customerFrequent.record };
        } else {
          frequentItems = { ...this.state.frequentItems, rows: nextProps.customerFrequent.Frequents };
        }
        this.setState({ frequentItems });
      }

      if (nextProps.customerSalesHistory && nextProps.customerSalesHistory !== this.props.customerSalesHistory) {
        const salesHistory = { ...this.state.salesHistory, rows: nextProps.customerSalesHistory };
        this.setState({ salesHistory });
      }

      if (!nextProps.discount) {
        this.props.setValue('salesOrderForm', 'Discount', 0);
      }

      if ((nextProps.discount && nextProps.discount !== this.props.discount) || nextProps.discount === '') {
        let discount = nextProps.discount;
        if (discount.toString().indexOf('-') !== -1) {
          discount = discount.replace(/-/g, '');
        }
        this.setState({ discount });
        // this.props.setValue('salesOrderForm', 'Discount', discount);
        if (discount === '') {
          this.props.setValue('salesOrderForm', 'Discount', 0);
          this.handleDiscountChange(0);
        } else {
          this.handleDiscountChange(discount);
          if (parseFloat(nextProps.discount) > 100 || isNaN(nextProps.discount)) {
            this.setState({ discount: Math.abs(this.props.discount) });
            this.props.setValue('salesOrderForm', 'Discount', this.props.discount);
          }
        }
      }

      if (nextProps.favoriteList && nextProps.favoriteList !== this.props.favoriteList) {
        if (nextProps.favoriteList.Sales_FavoriteList_Lines) {
          const rows = [...nextProps.favoriteList.Sales_FavoriteList_Lines];
          const favorites = { ...this.state.favorites, rows };
          this.setState({ favorites });
        }
      }

      if (nextProps.checkPermissionSuccess && nextProps.checkPermissionSuccess !== this.props.checkPermissionSuccess) {
        if (nextProps.checkPermissionSuccess.manager) {
          this.closeEditSOPermission();
          this.setState({ editSOPermission: true });
        }
      }

      if (nextProps.salesOrderProduct && nextProps.salesOrderProduct !== this.props.salesOrderProduct) {
        this.selectInventoryInfo(nextProps.salesOrderProduct);
        this.props.setSaleOrderProductValues(roundToDecimals(nextProps.salesOrderProduct.Price, 4), 'salesOrderForm', isJML ? {...nextProps.salesOrderProduct, jmlBox: 0} : nextProps.salesOrderProduct);
        // ReactDOM.findDOMNode(this.refs['quantity'].getRenderedComponent().myInput.refs.input).focus();
      }

      if (nextProps.shipperChosen && nextProps.shipperChosen !== null && nextProps.shipperChosen !== this.props.shipperChosen) {
        const shipping_id = (typeof (nextProps.shipperChosen) === 'object') ? nextProps.shipperChosen.value : nextProps.shipperChosen;
        this.setState({ shipperChosen: shipping_id });
        // this.props.setValue('salesOrderForm', 'CustomerDetail_id', shipping_id);
      }

      if (nextProps.shippingListPDF && nextProps.shippingListPDF !== this.props.shippingListPDF) {
        this.setState({ shippingPdfFrameLoaded: false });
      }

      if (nextProps.pickingListPDF && nextProps.pickingListPDF !== this.props.pickingListPDF) {
        this.setState({ pickingListPdfFrameLoaded: false });
      }

      if (nextProps.packingListPDF && nextProps.packingListPDF !== this.props.packingListPDF) {
        this.setState({ packingListPdfFrameLoaded: false });
      }

      if (nextProps.salesOrderPDF && nextProps.salesOrderPDF !== this.props.salesOrderPDF) {
        this.setState({ salesOrderPdfFrameLoaded: false });
      }
      
      if (nextProps.salesOrderSIPDF && nextProps.salesOrderSIPDF !== this.props.salesOrderSIPDF) {
        this.setState({ salesOrderSIPdfFrameLoaded: false });
      }

      if (nextProps.refundPDF && nextProps.refundPDF !== this.props.refundPDF) {
        this.setState({ refundPDFFrameLoaded: false });
      }

      if (nextProps.receivingCustomer && nextProps.receivingCustomer !== this.props.receivingCustomer) {
        this.setState({ useDefaultCustomerAddress: false });
        if (nextProps.receivingCustomer.value) {
          this.props.fetchSalesCustomerDetail(nextProps.receivingCustomer.value, null, true);
        } else {
          this.props.fetchSalesCustomerDetail(nextProps.receivingCustomer, null, true);
        }
      }

      if(nextProps.salesItemHistory) {
        this.setState({
          salesItemHistory: nextProps.salesItemHistory
        })
      }

      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.CreditAmount) {
        this.setState({
          creditAmount: Number(nextProps.currentSalesOrderDetail.CreditAmount)
        });
      }
      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.ShareCreditAmount) {
        this.setState({
          shareCreditAmount: Number(nextProps.currentSalesOrderDetail.ShareCreditAmount)
        });
      }

      if (isWIZ && (nextProps.BoxPerPallet || this.props.BoxPerPallet) && (nextProps.quantityValue || this.props.quantityValue)) {
        if (isNumeric(nextProps.quantityValue) && isNumeric(nextProps.BoxPerPallet)) {

          if ( !nextProps.PalletQuantity || (Math.ceil(Number(nextProps.quantityValue)/Number(nextProps.BoxPerPallet)) >= nextProps.PalletQuantity) ) {
            this.props.setValue('salesOrderForm', 'BillablePallets', Math.ceil(Number(nextProps.quantityValue)/Number(nextProps.BoxPerPallet)));
          } else {
            this.props.setValue('salesOrderForm', 'BillablePallets', nextProps.PalletQuantity);
          }
        }
      } else if (isWIZ && nextProps.PalletQuantity) {
        this.props.setValue('salesOrderForm', 'BillablePallets', nextProps.PalletQuantity);
      }
      if (isWIZ && !nextProps.BoxPerPallet && !nextProps.PalletQuantity) {
        this.props.setValue('salesOrderForm', 'BillablePallets', 0);
      } else if (isWIZ && !nextProps.BoxPerPallet && nextProps.PalletQuantity) {
        this.props.setValue('salesOrderForm', 'BillablePallets', nextProps.PalletQuantity);
      }
    }

    shouldComponentUpdate(nextProps, nextState) {
      if (nextState.shippingPdfFrameLoaded !== this.state.shippingPdfFrameLoaded && this.state.shippingPdfFrameLoaded == false) {
        return false;
      }
      if (nextState.pickingListPdfFrameLoaded !== this.state.pickingListPdfFrameLoaded && this.state.pickingListPdfFrameLoaded == false) {
        return false;
      }
      if (nextState.packingListPdfFrameLoaded !== this.state.packingListPdfFrameLoaded && this.state.packingListPdfFrameLoaded == false) {
        return false;
      }
      if (nextState.salesOrderPdfFrameLoaded !== this.state.salesOrderPdfFrameLoaded && this.state.salesOrderPdfFrameLoaded == false) {
        return false;
      }
      if (nextState.salesOrderSIPdfFrameLoaded !== this.state.salesOrderSIPdfFrameLoaded && this.state.salesOrderSIPdfFrameLoaded == false) {
        return false;
      }
      if (nextState.refundPDFFrameLoaded !== this.state.refundPDFFrameLoaded && this.state.refundPDFFrameLoaded == false) {
        return false;
      }

      return true;
    }

    componentDidMount() {
      document.title = companyCodeTitle;
      window.addEventListener('beforeunload', this.beforeunload.bind(this));

      let yiWarehouseOptions = [];
      
      if (isSY) {
        this.props.fetchGroups();
      }
      if (isYI) {
        axios.get(
          WAREHOUSES_URL,
          {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          },
        ).then((response) => {
          if  (response && response.data) {
            response.data.map(r=>{
              yiWarehouseOptions.push({label: r.name, value: r.Warehouse_id})
            })
          }
          this.setState({yiWarehouseOptions});
        }, (err) => {
          if (err.status === 500 || err.status === 404) {
            err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
          } 
          alert(JSON.stringify(err.data));
        });
      }

      let zoneOptions = [];
      if (isKDW || isABCFF) {
        axios.get(
          ZONES_URL,
          {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          },
        ).then((response) => {
          // drayageListOptions = response.data;
          if  (response && response.data) {
            response.data.map(r=>{
              zoneOptions.push({label: r.zone_num, value: r.id})
            })
          }
          // drayageListOptions.rows.map((r, index) => {
          //   r.Idx = index++;
          // })
          this.setState({zoneOptions});
        }, (err) => {
          if (err.status === 500 || err.status === 404) {
            err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
          } 
          alert(JSON.stringify(err.data));
        });
      }
    }

    beforeunload(e) {
      e.preventDefault();
      e.returnValue = true;
    }

    componentDidUpdate() {
      if (!this.props.searchType) {
        // this.props.setDefaultSearchType('RefNum', 'salesOrderForm');
        this.props.initializeSalesOrderForm('RefNum', 'salesOrderForm');
      }
      if (this.refs.customer_name && this.state.firstFocus) {
        // this.refs.customer_name.getRenderedComponent().refs.select.focus();
        // this.setState({ firstFocus: false });
      }
    }

    componentWillUnmount() {
      window.removeEventListener('beforeunload', this.beforeunload.bind(this));
      // this.props.clearInventories();
      document.removeEventListener('keydown', this.handleKeyDown.bind(this));
      this.props.finishUnmount();
      // this.props.clearSalesCustomerDetails();
    }

    updateTimeformatDate(date) {
      let formattedDate = `${date.getFullYear()}-`;
      const month = date.getMonth() + 1;
      if (month < 10) {
        formattedDate += `0${month}-`;
      } else {
        formattedDate += `${month}-`;
      }
      if (date.getDate() < 10) {
        formattedDate += `0${date.getDate()}`;
      } else {
        formattedDate += date.getDate();
      }
      return formattedDate;
    }
    formatSimpleDate(date) {
      let formattedDate = '';
      if ((date.getMonth() + 1) < 10) {
        formattedDate += `0${(date.getMonth() + 1)}`;
      } else {
        formattedDate += (date.getMonth() + 1).toString();
      }
      if (date.getDate() < 10) {
        formattedDate += `0${date.getDate()}`;
      } else {
        formattedDate += (date.getDate()).toString();
      }
      formattedDate += (date.getFullYear()).toString();
      return formattedDate;
    }
    routerWillLeave() {
      if (this.state.dirty) return <Translate value="work_not_saved_warning" />;
    }
    printForm() {
      this.props.fetchSalesOrderForm();
    }
    refreshPage(event) {
      if (event) {
        event.preventDefault();
      }
      const currentSalesOrder = this.props.salesOrderCreated || this.props.currentSalesOrder;
      this.closeShowSOCreated();
      if (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
        this.props.fetchInboundProducts();
      }
      this.props.selectSalesOrder(currentSalesOrder);
      if (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'salesOrders/:id') {
        this.context.router.push(`/salesOrders/${currentSalesOrder.SalesOrder_id}`);
      } else if (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
        this.context.router.push(`/outboundOrders/${currentSalesOrder.SalesOrder_id}`);
      } else if (this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id') {
        this.context.router.push(`/mobileSalesOrders/${currentSalesOrder.SalesOrder_id}`);
      }
    }

    selectInventoryInfo(selectedInventoryRow) {
      if (this.props.searchType === 'Barcode') {
        this.setState({
          selectedInventoryRow,
          inStock: selectedInventoryRow.InStock,
          purchased: selectedInventoryRow.Purchased,
          presale: selectedInventoryRow.PreSale,
          net_weight: selectedInventoryRow.NetWeight,
          ship_weight: selectedInventoryRow.NetWeight,
          product_type: selectedInventoryRow.ProductType,
          RefPrice: selectedInventoryRow.RefPrice, //ctn
          LowestSalePrice: selectedInventoryRow.LowestSalePrice,
          PriceLv1: selectedInventoryRow.PriceLv1,
          PriceLv2: selectedInventoryRow.PriceLv2,
          PriceLv3: selectedInventoryRow.PriceLv3,
          PriceLv4: selectedInventoryRow.PriceLv4,
          PriceLv5: selectedInventoryRow.PriceLv5,
        }, () => {
          this.barcodeScan();
        });
      } else {
        this.setState({
          selectedInventoryRow,
          inStock: selectedInventoryRow.InStock,
          purchased: selectedInventoryRow.Purchased,
          presale: selectedInventoryRow.PreSale,
          net_weight: selectedInventoryRow.NetWeight,
          ship_weight: selectedInventoryRow.NetWeight,
          product_type: selectedInventoryRow.ProductType,
          RefPrice: selectedInventoryRow.RefPrice, //ctn
          LowestSalePrice: selectedInventoryRow.LowestSalePrice,
          PriceLv1: selectedInventoryRow.PriceLv1,
          PriceLv2: selectedInventoryRow.PriceLv2,
          PriceLv3: selectedInventoryRow.PriceLv3,
          PriceLv4: selectedInventoryRow.PriceLv4,
          PriceLv5: selectedInventoryRow.PriceLv5,
        });
      }
    }

    clearInventoryInfo = () => {
      this.setState({
        selectedInventoryRow: {},
        inStock: '',
        purchased: '',
        presale: '',
        net_weight: '',
        ship_weight: '',
        product_type: '',
      });
    }

    // Helper function to pop up the add payment term function
    openCustomer() { this.setState({ customerOpen: true }); }
    closeCustomer() { this.setState({ customerOpen: false }); }
    openHistory() {
      this.props.fetchCustomerSalesHistory(this.state.currentCustomer);
      this.setState({ historyOpen: true });
    }
    closeHistory() { this.setState({ historyOpen: false }); }
    openConfirm() { this.setState({ confirmOpen: true }); }
    openShowSOCreated() { this.setState({ showSOCreatedOpen: true }); }
    closeShowSOCreated = () => { this.setState({ showSOCreatedOpen: false }); }
    openEditSOPermission() {
      this.setState({ case: 'editSOPermission', editSOPermissionOpen: true });
    }
    closeEditSOPermission() {
      this.setState({ editSOPermissionOpen: false });
    }
    openConfirmRefund(props) {
      this.setState({ case: 'confirmRefund', confirmRefundOpen: true, ...props });
    }
    closeConfirmRefund() {
      this.setState({ confirmRefundOpen: false });
    }
    openVerifyPasscode = () => {
      this.setState({ verifyPasscodeOpen: true });
    }
    closeVerifyPasscode = () => {
      this.setState({ verifyPasscodeOpen: false });
    }
    openVerifyPasscodeDiscount = () => {
      this.setState({ verifyPasscodeOpenDiscount: true });
    }
    closeVerifyPasscodeDiscount = () => {
      this.setState({ verifyPasscodeOpenDiscount: false });
    }
    openDeliveryMethodModal() {
      this.setState({ deliveryMethodModalOpen: true });
    }
    closeDeliveryMethodModal() {
      this.setState({ deliveryMethodModalOpen: false });
    }
    openCarrierInfoModal() {
      this.setState({ carrierInfoModalOpen: true });
    }
    closeCarrierInfoModal() {
      this.setState({ carrierInfoModalOpen: false });
    }
    openShippingInfoEditModal = () => {
      this.setState({ shippingInfoEditModalVisibility: true });
    }
    closeShippingInfoEditModal = () => {
      this.setState({ shippingInfoEditModalVisibility: false });
    }
    openFBAEditModal = () => {
      this.setState({ fbaEditModalVisibility: true });
    }
    closeFBAEditModal = () => {
      this.setState({ fbaEditModalVisibility: false });
    }
    modalFetchFBA = () => {
      let fbaAdressTemp1 = [];
      let fbaAdressTemp2 = [];
        this.props.fetchFBAAddressOptions()
        .then(response => {
          if (response.data) {
            response.data.map(r => {
              fbaAdressTemp1.push({label: r.street+", "+r.city+", "+r.zipcode+", "+r.state, value: r.id});
              fbaAdressTemp2.push({label: r.name,  value: r.id});
            });
            this.setState({ FBAOptions: fbaAdressTemp1, FBAOptions2: fbaAdressTemp2 });
          }
        }, err => {
          if (err.status === 500 || err.status === 404) {
            alert('error fetching FBA address');
          }
        });
    }
    openDropship() {
      this.setState({ isDropshipOpen: true });
    }
    closeDropship() {
      this.setState({ isDropshipOpen: false });
    }

    openCreateBOLModal() {
      this.setState({ createBOLModalVisibility: true });
    }
    closeCreateBOLModal() {
      this.setState({ createBOLModalVisibility: false });
    }

    openShipping() {
      this.props.clearConvertingToInvoice();
      this.props.clearUpdateSalesInvoice();
      this.setState({ showShippingOpen: true });
    }
    closeShipping() {
      this.props.clearConvertingToInvoice();
      this.props.clearUpdateSalesInvoice();
      this.setState({ showShippingOpen: false });
      this.refreshPage();
    }
    setShippingStatsEditModalVisibility = (shippingStatusEditModalVisible = false) => this.setState({ shippingStatusEditModalVisible })
    closeConfirm() {
      // this.props.resetFormInputs();
      this.setState({ case: null, confirmOpen: false });
      // ReactDOM.findDOMNode(this.refs['quantity'].getRenderedComponent().myInput.refs.input).focus();
    }
    openChangeTax() {
      this.setState({ changeTaxOpen: true });
    }
    closeChangeTax() {
      this.setState({ changeTaxOpen: false });
    }

    openDiscountModal() {
      this.setState({ changeDiscountOpen: true });
    }
    closeDiscountModal() {
      this.setState({ changeDiscountOpen: false });
    }
    onDiscountSavingsConfirm = (discount, savings) => {
      const { totalTax } = this.state;
      let finalPriceTemp = 0;
      let tax = 0;
      if (Number(discount) > 0) {
        if (isElegant) {
          tax = this.state.totalTaxOriginal * (1 - (Number(discount) / 100));
          this.setState({
            totalTax: tax || 0,
          });
          finalPriceTemp = Number(this.state.totalPrice) - (Number(this.state.totalPrice)*(Number(discount)/100)) + tax;
        } else {
          tax = (totalTax-(totalTax*(Number(discount)/100)));
          finalPriceTemp = Number(this.state.totalPrice) - (Number(this.state.totalPrice)*(Number(discount)/100)) + tax;
        }
      } else if (Number(discount) === 0 && Number(savings) > 0) {
        if (isElegant) {
          tax = this.state.totalTaxOriginal * (1 - Number(savings) / this.state.totalPrice);
          finalPriceTemp = Number(this.state.totalPrice) - Number(savings) + tax;
          this.setState({
            totalTax: tax || 0,
          });
        } else {
          tax = totalTax;
          finalPriceTemp = Number(this.state.totalPrice) - Number(savings) + tax;
        }
      } else {
        if (isElegant) {
          this.setState({
            totalTax: this.state.totalTaxOriginal
          });
          finalPriceTemp = Number(this.state.totalPrice) + this.state.totalTaxOriginal1;
        } else {
          tax = totalTax;
          finalPriceTemp = Number(this.state.totalPrice) + tax;
        }
      }
      finalPriceTemp = finalPriceTemp.toFixed(2);
      this.setState({ SODiscount: discount, SOSavings: savings, finalPriceWithPromotion: finalPriceTemp, changeDiscountOpen: false, discountModified: true });
    }

    openZBLModal(val, dep) {
      let currentZBL = val;
      let currentZBLDep = dep;

      this.setState({ 
        ZBLModalOpen: true,
        currentZBL,
        currentZBLDep,
       });
    }
    closeZBLModal() {
      let currentZBL = "";
      let currentZBLDep = null;
      let zoneSelected = null;
      let zoneDisplay = "";

      let binSelected = null;
      let binDisplay = "";
      let binOptions = [];
      let levelSelected = null;
      let levelDisplay = "";
      let levelOptions = [];
  
      this.setState({ 
        currentZBL,
        currentZBLDep,
        zoneSelected, 
        zoneDisplay, 
        binSelected, 
        binDisplay, 
        binOptions, 
        levelSelected, 
        levelDisplay, 
        levelOptions 
      });

      this.setState({ ZBLModalOpen: false });
    }
    onSubmitZBLEdit() {
      let {currentZBLDep, zoneDisplay, zoneSelected, binDisplay, binSelected, levelDisplay, levelSelected} = this.state;
      let rows = [...this.state.rows];

      if (!(zoneSelected && binSelected && levelSelected)) {
        alert("Please select a Zone/Bin/Level");
        return;
      }
      rows.map((r, i) => {
        if (r.Index === currentZBLDep.Index) {
          rows[i].Zone = zoneSelected;
          rows[i].Section = binSelected;
          rows[i].Bin = levelSelected;
          rows[i].Location = zoneDisplay + '-' + binDisplay + '-' + levelDisplay;
          this.setState({ rows, ZBLModalOpen: false });
        }
      });

      // let {paymentInfo} = this.state;
      // let data = {name: this.state.NameOnAccount, account_num: this.state.AccountNum, routing: this.state.Routing};
      // axios.put(
      //   (ACH_EDIT_URL + paymentInfo.pk),
      //   // (ACH_EDIT_URL + '1'),
      //   data,
      //   {
      //     headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      //   },
      // ).then((response) => {
      //   alert("ACH Info Changed");
      //   // this.fetchSalesOrdersByDetails(
      //   //   this.state.days
      //   // );
      //   paymentInfo.NameOnAccount = this.state.NameOnAccount;
      //   paymentInfo.AccountNum = this.state.AccountNum;
      //   paymentInfo.Routing = this.state.Routing;
      //   this.setState({paymentInfo, achEditOpen: false});
      // }, (err) => {
      //   if (err.status === 500 || err.status === 404) {
      //     err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      //   } 
      //   alert(JSON.stringify(err.data));
      // });
    }
   
    openAchEdit() {
      const { paymentInfo } = this.state;

      this.setState({ achEditOpen: true, 
        NameOnAccount: paymentInfo.NameOnAccount,
        AccountNum: paymentInfo.AccountNum,
        Routing: paymentInfo.Routing
       });
    }
    closeAchEdit() {
      this.setState({ achEditOpen: false });
    }
    onChangeNameOnAccount = (e) => {
      this.setState({ NameOnAccount: e.target.value });
    }
    onChangeAccountNum = (e) => {
      this.setState({ AccountNum: e.target.value });
    }
    onChangeRouting = (e) => {
      this.setState({ Routing: e.target.value });
    }
    onSubmitAchEdit() {
      let {paymentInfo} = this.state;
      let data = {name: this.state.NameOnAccount, account_num: this.state.AccountNum, routing: this.state.Routing};
      axios.put(
        (ACH_EDIT_URL + paymentInfo.pk),
        // (ACH_EDIT_URL + '1'),
        data,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      ).then((response) => {
        alert("ACH Info Changed");
        // this.fetchSalesOrdersByDetails(
        //   this.state.days
        // );
        paymentInfo.NameOnAccount = this.state.NameOnAccount;
        paymentInfo.AccountNum = this.state.AccountNum;
        paymentInfo.Routing = this.state.Routing;
        this.setState({paymentInfo, achEditOpen: false});
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
        } 
        alert(JSON.stringify(err.data));
      });

    }

    openEmployeeNote() {
      this.setState({ changeEmployeeNoteOpen: true });
    }
    closeEmployeeNote() {
      this.setState({ changeEmployeeNoteOpen: false });
    }
    onChangeEmployeeNote = (e) => {
      this.setState({ employeeNoteText: e.target.value });
    }
    onSubmitEmployeeNote() {
      const currentSalesOrder = this.props.currentSalesOrder;
      if (!currentSalesOrder) {
        alert("Please create order first before editing Employee Note");
        return;
      }
      this.props.updateEmployeeNote(currentSalesOrder.SalesOrder_id, this.state.employeeNoteText).then((response) => {
        this.setState({ employeeNoteDisplay: this.state.employeeNoteText });
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          alert("Patch Employee Note Failed");
        }
      });
      this.setState({ changeEmployeeNoteOpen: false });
    }

    openDeliveryFee() {
      if (this.props.currentSalesOrder && (this.props.currentSalesOrder.SONum.charAt(0) !== 'M')) {
        this.setState({ changeDeliveryFeeOpen: true, deliveryFeeEdit: this.state.delivery });
      }
    }
    closeDeliveryFee() {
      this.setState({ changeDeliveryFeeOpen: false });
    }
    onChangeDeliveryFee = (e) => {
      e.preventDefault();
      this.setState({ deliveryFeeEdit: e.target.value });
    }
    onConfirmDeliveryFee() {
      this.setState({ delivery: Number(this.state.deliveryFeeEdit) });
      this.closeDeliveryFee();
    }

    openChangeWeight() {
      this.setState({ changeWeightOpen: true });
    }
    closeChangeWeight() {
      this.setState({ changeWeightOpen: false });
    }
    onChangeWeightSubmit() {
      if (this.state.finalShippingWeight < 0 || !this.state.finalShippingWeight) {
        alert('Invalid Weight Value!');
        return;
      }
      const currentSalesOrder = this.props.currentSalesOrder;
      this.props.currentSalesOrder.FinalShippingWeight = this.state.finalShippingWeight;
      this.props.updateShippingWeight(currentSalesOrder.SalesOrder_id, this.state.finalShippingWeight);
      this.setState({ changeWeightOpen: false });
    }
    onShippingWeightChange = (e) => {
      this.state.finalShippingWeight = e.target.value;
    }
    openShowInventory(event) {
      if (!this.props.searchValue || this.props.searchValue === '') {
        return;
      }
      switch (event.charCode) {
        case 13: // ENTER
          event.preventDefault();
          if (this.props.customerChosen) {
            this.setState({ showInventoryOpen: true });
            break;
          } else {
            this.setState({ case: 'noCustomerChosen', confirmOpen: true });
            break;
          }
        default:
          break;
      }
    }
    closeShowInventory(value) {
      this.handleAfterShowInventoryClose(value);
      this.setState({ showInventoryOpen: false });
    }
    handleKeyDown(event) {
      switch (event.keyCode) {
        case 27:
          this.closeShowInventory('productSearch');
          break;
        default:
          break;
      }
    }

    handleFocusAutoSuggest() {
      const autoSuggestField = document.getElementById('sales-auto-suggest');
      autoSuggestField.focus();
      autoSuggestField.select();
    }

    handleDiscountChange(nextDiscount) {
      const totalPrice = parseFloat(this.state.totalPrice) || 0;
      const discount = parseFloat(nextDiscount) || 0;
      const totalTax = parseFloat(this.state.totalTax) || 0;
      const totalCRV = parseFloat(this.state.totalCRV) || 0;
      let finalPrice = (totalPrice * (1 - (discount / 100))) + totalTax + totalCRV;
      finalPrice = +roundTo(finalPrice, 2).toFixed(2);
      this.setState({ discount, finalPrice });
    }
    handleAfterShowInventoryClose(value) {
      ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
    }
    handleUnitPriceChange(event) {
      this.setState({ refPrice: event.target.value });
    }
    showShippingInfoConfirmModal = () => {
      this.setState({
        shippingInfoConfirmModalVisibility: true,
      })
    }
    closeShippinggInfoConfirmModal = () => {
      this.setState({
        shippingInfoConfirmModalVisibility: false,
      })
    }
    handleHMMFormSubmit = (formProps) => {
      this.showShippingInfoConfirmModal();
    }
    setBatchesModalVisibility = (isBatchesModalVisible = false) => this.setState({ isBatchesModalVisible });
    setBatchesModal2Visibility = (isBatchesModal2Visible = false) => this.setState({ isBatchesModal2Visible });
    setMultiBatchModalVisibility = (isMultiBatchVisible = false) => this.setState({ isMultiBatchVisible });
    onSelectedBatch = (Batch_id, BatchExpiredDate, pallet_barcode) => {
      this.setBatchesModalVisibility();
      this.handleFocusAutoSuggest();
      this.setState({
        Batch_id,
        BatchExpiredDate,
        pallet_barcode,
      }, this.checkMoveToSo)
    }
    onSelectedMultiBatch = (rows) => {
      let checkPass = false;
      let time = 0;
      rows.map((r, index) => {
        if (Number(r.quantity) > 0) {
          setTimeout(() => {
            this.setState({
              Batch_id: r.batchId,
              batchQty: r.quantity,
              pallet_barcode: r.pallet_barcode,
            }, this.checkMoveToSo2);                    
          }, time);
          time = time + 50;
          checkPass = true;
        }
      });
      setTimeout(() => {
        this.setState({
          selectedInventoryRow: {},
          inStock: '',
          inStockWarehouse: '',
          purchased: '',
          presale: '',
          net_weight: '',
          ship_weight: '',
          total_weight: '',
          suggestValue: '',
        });
        this.setMultiBatchModalVisibility();
        this.props.resetFormInputs();
        this.setAllProductQuantity(1);
        this.handleFocusAutoSuggest();
      }, 1000);
    }
    onSelectedMultiBatch2 = (selected, lines) => {
      
      // delete select line
      let rows = this.state.rows;
      if(isJML && lines.findIndex(r => r.quantity > 0) == -1) {
        alert('Please select a batch!');
        return
      }
      const filter_rows = rows.filter(
        item => item.Index !== selected.Index
      );
      this.setState({ rows: filter_rows});
      
      // add inventory
      let checkPass = false;
      let time = 0;
      lines.map((r, index) => {
        if (r.quantity > 0) {
          setTimeout(() => {
            this.setState({
              Batch_id: r.batchId,
              BatchExpiredDate: r.expire_datetime,
              batchQty: r.quantity,
              batchPcs: r.pcs || 0,
              pallet_barcode: r.pallet_barcode,
            }, this.checkMoveToSo2);                    
          }, time);
          time = time + 50;
          checkPass = true;
        }
      });
      setTimeout(() => {
        this.setState({
          selectedInventoryRow: {},
          inStock: '',
          inStockWarehouse: '',
          purchased: '',
          presale: '',
          net_weight: '',
          ship_weight: '',
          total_weight: '',
          suggestValue: '',
          lineQty: 0,
          lineBatchIdx: -1,
        });
        this.setBatchesModal2Visibility();
        this.props.resetFormInputs();
        this.setAllProductQuantity(1);
        this.handleFocusAutoSuggest();
      }, 1000);
    }
    onEditBatch = (rows) => {
      this.setState({rows});
      this.setBatchesModal2Visibility();
    }
    handleFormSubmit = (formProps, isQuote) => {
      if (!isDSQ && !isWUFS && !isABCFF && !isKDW && !isYI && !isFBD && !isWIZ && !isFJ && !isJTB) {
        if (!formProps.receivingCustomer && this.context.router.routes[1].path !== 'mobileSalesOrders/:id') {
          alert('Please select a receiving customer first.')
          return;
        }
      }
      if (isJTB && formProps.OrderType && (formProps.OrderType === "Drop Shipping" || formProps.OrderType.value === "Drop Shipping")) {
        if (!formProps.DropshipType || formProps.DropshipType === "") {
          alert('Please select drop shipping type.');
          this.setState({
            dropShipWarning: true,
          });
          return;
        }
      }
      const newOrder = { ...formProps };
      const quantityZero = this.state.rows.filter((obj) => {
        const match = obj.Quantity === 0;
        return match;
      });
      if (quantityZero.length > 0 && !isFung && !isWIZ && !isDSQ && !isWUFS && !isABCFF && !isKDW && !isYI && !isFBD && !isJTB && !isFJ) {
        this.setState({ case: 'zeroQuantity', confirmOpen: true, quantityZero });
        return;
      }
      const {
        createSalesOrder, createSalesQuote, editSalesOrder, orderDate, dispatchDate,
        dispatchStartTime, dispatchEndTime,salesCustomerDetails, shipByDate,
      } = this.props;
      if (!newOrder.Notation && salesCustomerDetails && salesCustomerDetails.Notation) { newOrder.Notation = salesCustomerDetails.Notation; }

      const fieldName = (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'outboundOrders/new') ? 'CustomerDetail_id' : 'Deliver_CustomerDetail_id';
      if (newOrder[fieldName] && newOrder[fieldName].value) {
        newOrder.Deliver_CustomerDetail_id = newOrder[fieldName].value;
      } else {
        newOrder.Deliver_CustomerDetail_id = newOrder[fieldName];
      }
      if (!newOrder.Deliver_CustomerDetail_id && !isRivera && !isHMM && !isABC && !isDSQ && !isWUFS && !isABCFF && !isKDW && !isYI && !isFBD && !isJTB && !isWIZ && !isFJ) {
        let customer_id = this.props.receivingCustomer;
        if (typeof this.props.receivingCustomer.detail_id !== 'object') {
          for (let i = 0; i < this.props.customers.length; i++) {
            if (this.props.customers[i].Customer_id === this.props.receivingCustomer) {
              customer_id = this.props.customers[i].CustomerDetail_id;
            }
          }
        }
        newOrder.Deliver_CustomerDetail_id = customer_id.detail_id || customer_id;
      }
      
      newOrder.Sales_Order_Lines = Data.Selectors.getRows(this.state).map(row => {
        let CostPrice = row.ProductCost;
        if (isEcity || isLucky88) {
          CostPrice = row.ArrivalPrice;
        }
        return {
          ...row,
          CostPrice,
        }
      });
      
      newOrder.IsWholesale = false;
      newOrder.TotalPrice = this.state.totalPrice;
      newOrder.FinalWeight = this.state.finalWeight;
      newOrder.FinalPrice = this.state.finalPrice;
      newOrder.TotalCRV = this.state.totalCRV;
      newOrder.TaxRate = this.state.taxValue;
      newOrder.TaxAmount = +roundTo(this.state.totalTax, 2).toFixed(2);
      newOrder.IsNoReduce = this.state.IsNoReduce;
      newOrder.IsFBAAddress = this.state.IsFBAAddress;

      let magNoteTemp = [];
      if (isMAG) { 
        if (this.state.magDryrun) { magNoteTemp.push('DRYRUN')}
        if (this.state.magOffhire) { magNoteTemp.push('OFFHIRE')}
        if (this.state.magPierpass) { magNoteTemp.push('PIERPASS')}
        if (this.state.magAnFee) { magNoteTemp.push('AN_FEE')}
        if (this.state.magOther) { magNoteTemp.push('OTHER')}
        if (this.state.magHandling) { magNoteTemp.push('HANDLING')}
        if (this.state.magExtraStop) { magNoteTemp.push('EXTRA_STOP')}
        if (this.state.magExam) { magNoteTemp.push('EXAM')}
        if (this.state.magExtraDelivery) { magNoteTemp.push('EXTRA_DELIVERY')}
        if (this.state.magStorage) { magNoteTemp.push('STORAGE')}
        if (this.state.magBobtailFee) { magNoteTemp.push('BOBTAIL_FEE')}
        if (this.state.magChassisSplit) { magNoteTemp.push('CHASSIS_SPLIT')}
        if (this.state.magCTF) { magNoteTemp.push('CTF')}
        if (this.state.magFSC) { magNoteTemp.push('FSC')}
        if (this.state.magPrepull) { magNoteTemp.push('PREPULL')}
        if (this.state.magCongestion) { magNoteTemp.push('CONGESTION')}
        if (this.state.magDropoff) { magNoteTemp.push('DROPOFF')}
        if (this.state.magOverweight) { magNoteTemp.push('OVERWEIGHT')}
        newOrder.mag_note = magNoteTemp.join(',');
      }

      let magHoldTemp = [];
      if (isMAG) { 
        if (this.state.mag2FREIGHT_HOLD) { magHoldTemp.push('FREIGHT_HOLD')}
        if (this.state.mag2CUSTOM_HOLD) { magHoldTemp.push('CUSTOM_HOLD')}
        if (this.state.mag2PIERPASS_HOLD) { magHoldTemp.push('PIERPASS_HOLD')}
        if (this.state.mag2EXAM) { magHoldTemp.push('EXAM')}
        if (this.state.mag2CLOSED_AREA) { magHoldTemp.push('CLOSED_AREA')}
        newOrder.DeliveryStatus = magHoldTemp.join(',');
      }

      if (this.state.delivery) {
        newOrder.Delivery = this.state.delivery;
      } else {
        newOrder.Delivery = 0;
      }
      if (!newOrder.Sales_User_id) {
        newOrder.Sales_User_id = null;
      } else if (this.props.Sales_User_id.value) {
        newOrder.Sales_User_id = this.props.Sales_User_id.value;
      }
      newOrder.Sales_User_id = this.state.created_by;
      if (dispatchDate) {
        newOrder.DispatchDate = dispatchDate;
      } else {
        newOrder.DispatchDate = this.state.prevEstDate;
      }
      if (isOCM) {
        if (dispatchStartTime) {
          newOrder.DispatchStartTime = dispatchStartTime.value;
        } else {
          newOrder.DispatchStartTime = null;
        }
        if (dispatchEndTime) {
          newOrder.DispatchEndTime = dispatchEndTime.value;
        } else {
          newOrder.DispatchEndTime = null;
        }
      }
      
      if (shipByDate) {
        newOrder.ShipByDate = shipByDate;
      } else {
        newOrder.ShipByDate = this.state.prevEstDate;
      }
      if (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'salesOrders/:id' || this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
        newOrder.Discount = Number(this.state.SODiscount);
        newOrder.Savings = Number(this.state.SOSavings);
        newOrder.FinalPrice = Number(this.state.finalPriceWithPromotion);
      }
      if ((isAFG || isMyumyu || isWecom || isAFM || isEcity || isElegant) && this.props.currentSalesOrder && this.props.currentSalesOrder.SONum && (this.props.currentSalesOrder.SONum.charAt(0) !== 'M') && (this.context.router.routes[1].path === 'mobileSalesOrders/:id')) {
        newOrder.FinalPrice = Number(this.state.finalPriceWithPromotion);
      }
      
      if (!this.props.currentSalesOrderDetail && isFJ) {
        console.log("add dummy here?", newOrder);
      }
      if (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) {
        if (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
          newOrder.IsOutbound = true;
        } else {
          newOrder.IsOutbound = false;
        }
      }
      this.setState({ dirty: false, editing: false, shouldDiscountInit: true });
      if (isFung) {
        const success = () => {
          if (!this.props.currentSalesOrderDetail) {
            isQuote ? createSalesQuote(newOrder) : createSalesOrder(newOrder);
          } else {
            editSalesOrder(newOrder, this.props.currentSalesOrderDetail.SalesOrder_id);
          }
        }
        const failed = () => {
            this.props.getQBAuth();
        }
        this.props.QBAuthStatusCheck(success, failed);
      } else {  
        if (!this.props.currentSalesOrderDetail) {
          isQuote ? createSalesQuote(newOrder) : createSalesOrder(newOrder);
        } else {
          editSalesOrder(newOrder, this.props.currentSalesOrderDetail.SalesOrder_id);
        }
      }
    }

    handleSaveDisable() {
      if (isABC && this.state.rows.length > 0 && !this.state.Released) {
        return false;
      }
      if (isFung) { return false; }
      if (((this.state.rows.length === 0 && !isMAG) || (this.state.Released) || (this.props.salesOrderIsCreating))) {
        return true;
      } else if (isRivera || isEcity || (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'salesOrders/:id' || this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id')) {
        return false;
      } else if ((this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id') && (isAFG || isMyumyu || isWecom || isCO || isElegant) && this.props.currentSalesOrder && this.props.currentSalesOrder.SONum && (this.props.currentSalesOrder.SONum.charAt(0) !== 'M')) {
        return false;
      } else {
        return true;
      }
    }

    handleOnFocus(event) {
      event.target.select();
    }

    handleUpdatePrice() {
      const rows = [...this.state.rows];

      let rowToEdit = {};
      let rowIndex = 0;
      let counter = 0;
      rows.map((row) => {
        if (row.Index === this.state.RowBeingEdited.Index) {
          rowToEdit = { ...row };
          rowIndex = counter;
        }
        counter++;
      });

      rowToEdit.UnitPrice = parseFloat(this.state.newPrice);
      if (rowToEdit.ProductType === 'Fixed') {
        rowToEdit.TotalPrice = +roundTo(parseFloat(rowToEdit.UnitPrice * parseFloat(rowToEdit.Quantity)), 2).toFixed(2);
      } else {
        rowToEdit.TotalPrice = +roundTo(parseFloat(rowToEdit.UnitPrice * parseFloat(rowToEdit.Quantity) * parseFloat(rowToEdit.NetWeight)), 2).toFixed(2);
      }
      rows[rowIndex] = rowToEdit;

      let totalPrice = 0;
      let finalWeight = 0;
      let finalPrice = 0;
      let totalTax = 0;
      let totalTaxOriginal = 0;
      let totalCRV = 0;
      let discount = parseFloat(this.props.discount) || 0;
      // if (totalPrice == null)
      //   totalPrice = 0;
      // if (finalWeight ==null)
      //   finalWeight = 0;
      rows.map((row) => {
        if(isHMM) {
          totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);          
        } else {
          totalPrice += parseFloat(row.TotalPrice);
        }
        finalWeight += parseFloat(row.NetWeight * row.Quantity);
        if (row.IsTaxable === true || row.IsTaxable === 'True') {
          if(isHMM) {
            totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(this.state.taxValue / 100);
          } else {
            if(isAN || isElegant) {
              let taxable = !this.props.salesCustomerDetails.Reseller;
              if (isAN) {
                taxable = row.IsAllTaxable === true || !this.props.salesCustomerDetails.Reseller;
              }
              if(taxable) {
                totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
              }
            } else {
              totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
            }
          }
        }
        if (row.CRV) { row.TotalCRV = +roundTo(parseFloat(row.CRV * row.Quantity), 2).toFixed(2); }
        if (row.TotalCRV) { totalCRV += row.TotalCRV; }
      });
      totalTaxOriginal = totalTax = +roundTo(totalTax, 2).toFixed(2);
      if (isElegant) {
        discount = parseFloat(this.state.SODiscount) || (parseFloat(this.state.SOSavings) / totalPrice) * 100 || 0;
        totalTax = +roundTo((1 - (discount / 100)) * totalTax, 2).toFixed(2);
      }
      finalPrice = parseFloat(totalPrice) * (1 - discount / 100) + parseFloat(totalTax) + parseFloat(totalCRV);
      finalWeight = +roundTo(finalWeight, 2).toFixed(2);
      totalPrice = +roundToDecimals(totalPrice, 4).toFixed(4);
      finalPrice = +roundTo(finalPrice, 2).toFixed(2);
      this.setState({
        rows, totalPrice, finalWeight, finalPrice, totalTax, totalCRV, totalTaxOriginal
      });
    }

    handleTaxValueChange = (e) => {
      let taxValue = 0;
      if (e == null) {
        this.setState({ taxValue: 0 });
      } else {
        this.setState({ taxValue: e.value });
        taxValue = e.value;
      }
      let totalPrice = 0;
      let finalWeight = 0;
      let finalPrice = 0;
      let totalTax = 0;
      let totalTaxOriginal = 0;
      let totalCRV = 0;
      // let taxRateIndex = this.state.taxRateIndex;
      let discount = parseFloat(this.props.discount) || 0;
      const rows = [...this.state.rows];

      rows.map((row) => {
        if(isHMM) {
          totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
        } else {
          totalPrice += parseFloat(row.TotalPrice);
        }
        finalWeight += parseFloat(row.NetWeight * row.Quantity);
        if (row.IsTaxable === true || row.IsTaxable === 'True') {
          if(isHMM) {
            totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(taxValue / 100);
          } else {
            if(isAN || isElegant) {
              let taxable = !this.props.salesCustomerDetails.Reseller;
              if (isAN) {
                taxable = row.IsAllTaxable === true || !this.props.salesCustomerDetails.Reseller;
              }
              if(taxable) {
                totalTax += parseFloat(row.TotalPrice) * parseFloat(taxValue / 100);
              }
            } else {
              totalTax += parseFloat(row.TotalPrice) * parseFloat(taxValue / 100);
            }
          }
        }
        if (row.CRV) {
          row.TotalCRV = +roundTo(parseFloat(row.CRV * row.Quantity), 2).toFixed(2);
        }
        if (row.TotalCRV) {
          totalCRV += row.TotalCRV;
        }
      });
      totalTaxOriginal = totalTax = +roundTo(totalTax, 2).toFixed(2);
      if (isElegant) {
        discount = parseFloat(this.state.SODiscount) || (parseFloat(this.state.SOSavings) / totalPrice) * 100 || 0;
        totalTax = +roundTo((1 - (discount / 100)) * totalTax, 2).toFixed(2);
      }
      finalPrice = (parseFloat(totalPrice) * (1 - (discount / 100))) + (parseFloat(totalTax) + parseFloat(totalCRV));
      finalWeight = +roundTo(finalWeight, 2).toFixed(2);
      totalPrice = +roundToDecimals(totalPrice, 4).toFixed(4);
      finalPrice = +roundTo(finalPrice, 2).toFixed(2);
      this.setState({
        rows, totalPrice, finalWeight, finalPrice, totalTax, totalCRV, totalTaxOriginal,
      });
    }

    removeRow(Index) {
      let rows = [...this.state.rows];
      let totalPrice = 0;
      let finalWeight = 0;
      let totalTax = 0;
      let totalTaxOriginal = 0;
      let totalCRV = 0;
      let index = 0;
      let discount = parseFloat(this.props.discount) || 0;
      
      rows = rows.filter((obj) => {
        const match = obj.Index !== Index;
        return match;
      });
      index = rows.length;
      
      rows.map((row) => {
        row.Index = index;
        index--;
        if (row.IsTaxable === true || row.IsTaxable === 'true') {
          if(isHMM) {
            totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(this.state.taxValue / 100);
          } else {
            if(isAN || isElegant) {
              let taxable = !this.props.salesCustomerDetails.Reseller;
              if (isAN) {
                taxable = row.IsAllTaxable === true || !this.props.salesCustomerDetails.Reseller;
              }
              if(taxable) {
                totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
              }
            } else {
              totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
            }
          }
        }
        if(isHMM) {
          totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
        } else {
          totalPrice += parseFloat(row.TotalPrice);
        }
        if (row.Weight != null) {
          finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight);
        }
        totalCRV += +roundTo(parseFloat(row.CRV * row.Quantity), 2).toFixed(2);
      });
      totalTaxOriginal = totalTax = +roundTo(totalTax, 2).toFixed(2);
      if (isElegant) {
        discount = parseFloat(this.state.SODiscount) || (parseFloat(this.state.SOSavings) / totalPrice) * 100 || 0;
        totalTax = +roundTo((1 - (discount / 100)) * totalTax, 2).toFixed(2);
      }
      totalPrice = +roundToDecimals(totalPrice, 4).toFixed(4);
      const finalPrice = +roundTo((totalPrice * (1 - (discount / 100))) + totalTax + totalCRV, 2).toFixed(2);
      
      this.setState({
        rows, finalPrice, totalPrice, totalTax, finalWeight, totalCRV, totalTaxOriginal,
      });
    }
  
    title() {
      if (!this.props.currentSalesOrder) {
        return <h3><Translate value="create_a_new_sales_order" /></h3>;
      }
      return <h3><Translate value="edit_sales_order" /> {this.props.currentSalesOrder.SONum}</h3>;
    }

    setAllProductQuantity(quantity) {
      this.props.setValue('salesOrderForm', 'Quantity', quantity);
    }

    getCustomerNameOptions() {
      const customerOptions = [];
      this.props.customers.map((customer) => {
        customerOptions.push({ value: customer.Customer_id, label: customer.Name, detail_id: customer.CustomerDetail_id });
      });
      return customerOptions;
    }
    getCustomerNumOptions() {
      const customerOptions = [];
      this.props.customers.map((customer) => {
        customerOptions.push({ value: customer.Customer_id, label: customer.CustomerNum });
      });
      return customerOptions;
    }
    getCustomerPhoneOptions() {
      const customerOptions = [];
      this.props.customers.map((customer) => {
        customerOptions.push({ value: customer.Customer_id, label: customer.Telephone });
      });
      return customerOptions;
    }
    getShippingContactOptions() {
      const contactOption = [];
      if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Shipping && this.props.salesCustomerDetails.CustomerNum !== 'EMP9999') {
        this.props.salesCustomerDetails.Shipping.map((ShippingInfo) => {
          contactOption.push({ value: ShippingInfo.CustomerDetail_id, label: `${ShippingInfo.FirstName} ${ShippingInfo.LastName}` });
        });
      } else if (this.props.salesCustomerDetails && this.props.allShipping && this.props.allShipping.length && this.props.salesCustomerDetails.CustomerNum === 'EMP9999') {
        this.props.allShipping.map((ShippingInfo) => {
          contactOption.push({ value: ShippingInfo.CustomerDetail_id, id: ShippingInfo.Customer_id, label: `${ShippingInfo.CustomerName}` });
        });
      }
      return contactOption;
    }
    getShippingPhoneOptions() {
      const phoneOptions = [];
      if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Shipping && this.props.salesCustomerDetails.CustomerNum !== 'EMP9999') {
        if (!this.state.useDefaultCustomerAddress && this.props.salesShippingCustomerDetails && this.props.salesShippingCustomerDetails.Shipping) {
          this.props.salesShippingCustomerDetails.Shipping.map((ShippingInfo) => {
            phoneOptions.push({ value: ShippingInfo.CustomerDetail_id, label: `${ShippingInfo.Telephone}` });
          });
        } else {
          this.props.salesCustomerDetails.Shipping.map((ShippingInfo) => {
            phoneOptions.push({ value: ShippingInfo.CustomerDetail_id, label: `${ShippingInfo.Telephone}` });
          });
        }
      } else if (this.props.salesCustomerDetails && this.props.allShipping && this.props.allShipping.length && this.props.salesCustomerDetails.CustomerNum === 'EMP9999') {
        this.props.allShipping.map((ShippingInfo) => {
          phoneOptions.push({ value: ShippingInfo.CustomerDetail_id, id: ShippingInfo.Customer_id, label: `${ShippingInfo.Telephone}` });
        });
      }
      return phoneOptions;
    }
    getShippingNameOptions = () => {
      const phoneOptions = [];
      if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Shipping && this.props.salesCustomerDetails.CustomerNum !== 'EMP9999') {
        if (!this.state.useDefaultCustomerAddress && this.props.salesShippingCustomerDetails && this.props.salesShippingCustomerDetails.Shipping) {
          this.props.salesShippingCustomerDetails.Shipping.map((ShippingInfo) => {
            phoneOptions.push({ value: ShippingInfo.CustomerDetail_id, label: `${ShippingInfo.AddressName}` });
          });
        } else {
          this.props.salesCustomerDetails.Shipping.map((ShippingInfo) => {
            phoneOptions.push({ value: ShippingInfo.CustomerDetail_id, label: `${ShippingInfo.AddressName}` });
          });
        }
      } else if (this.props.salesCustomerDetails && this.props.allShipping && this.props.allShipping.length && this.props.salesCustomerDetails.CustomerNum === 'EMP9999') {
        this.props.allShipping.map((ShippingInfo) => {
          phoneOptions.push({ value: ShippingInfo.CustomerDetail_id, id: ShippingInfo.Customer_id, label: `${ShippingInfo.Telephone}` });
        });
      }
      return phoneOptions;
    }
    getAddressOptions() {
      const addressOptions = [];
      if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Shipping && this.props.salesCustomerDetails.CustomerNum !== 'EMP9999') {
        if (!this.state.useDefaultCustomerAddress && this.props.salesShippingCustomerDetails && this.props.salesShippingCustomerDetails.Shipping) {
          this.props.salesShippingCustomerDetails.Shipping.map((ShippingInfo) => {
            if (isMAG) {
              addressOptions.push({ value: ShippingInfo.CustomerDetail_id, label: `${ShippingInfo.AddressName}: ${ShippingInfo.Street} ${ShippingInfo.City}, ${ShippingInfo.State}` });
            } else {
              addressOptions.push({ value: ShippingInfo.CustomerDetail_id, label: `${ShippingInfo.Street} ${ShippingInfo.City}, ${ShippingInfo.State}` });
            }
          });
        } else {
          this.props.salesCustomerDetails.Shipping.map((ShippingInfo) => {
            addressOptions.push({ value: ShippingInfo.CustomerDetail_id, label: `${ShippingInfo.Street} ${ShippingInfo.City}, ${ShippingInfo.State}` });
          });
        }
      } else if (this.props.salesCustomerDetails && this.props.allShipping && this.props.allShipping.length && this.props.salesCustomerDetails.CustomerNum === 'EMP9999') {
        this.props.allShipping.map((ShippingInfo) => {
          addressOptions.push({ value: ShippingInfo.CustomerDetail_id, id: ShippingInfo.Customer_id, label: `${ShippingInfo.Street} ${ShippingInfo.City}, ${ShippingInfo.State}` });
        });
      }
      return addressOptions;
    }
    getTaxRateOptions() {
      const taxRateOptions = [];
      if (this.props.taxRates) {
        let index = 0;
        this.props.taxRates.map((taxRate) => {
          taxRateOptions.push({ value: taxRate.Rate, label: taxRate.Rate, index });
          index++;
        });
      }
      return taxRateOptions;
    }
    // for OCM only
    getCompanyOptions() {
      let companyOptions = [];
      this.props.fetchCompany()
        .then(response => {
          response.data.map((company) => {
            // ocm company filter by permission
            if (isOCM) {
              if (company.permission_name === 'view_company_ocm_la'){
                if (checkPermissionLocal('view_company_ocm_la')) {
                  companyOptions.push({ label: company.Name, value: company.id}); 
                }
              }
              if (checkPermissionLocal('view_company_ocm_nj')) {
                if (company.permission_name === 'view_company_ocm_nj') {
                  companyOptions.push({ label: company.Name, value: company.id}); 
                }
              }
            } else {
              companyOptions.push({ label: company.Name, value: company.id}); 
            }
          });
          if (isOCM) {
            this.props.setValue('salesOrderForm', 'Company_id', companyOptions[0].value);
          }
          this.setState({ companyOptions });
        },
        (err) => {
          if (err.status === 500 || err.status === 404) {
            alert('error fetching company names');
          }
        }
      );
    }
    
    
    favoriteItemsHeader() {
      return (
        <div onClick={() => this.setState({ favoriteItemsOpen: !this.state.favoriteItemsOpen })}>
          <label style={{ cursor: 'pointer' }} >
            <Translate value="favorite_items" />
          </label>
        </div>
      );
    }
    previousOrdersHeader() {
      return (
        <div>
          <Row>
            <Col xs={6}>
              <label
                style={{ cursor: 'pointer' }}
                onClick={() => this.setState({ previousOrdersOpen: !this.state.previousOrdersOpen, promotionsOpen: false })}
              >
                <Translate value="previous_order" />
              </label>
            </Col>
            <Col xs={6}>
              <Field name="PreviousOrderDate" component={DatePicker} />
            </Col>
          </Row>
        </div>
      );
    }

    promotionsHeader() {
      return (
        <div onClick={() => this.setState({ promotionsOpen: !this.state.promotionsOpen, previousOrdersOpen: false })} >
          <label style={{ cursor: 'pointer' }} ><Translate value="promotions" /></label>
        </div>
      );
    }

    renderInboundProducts() {
      if (this.props.customerFrequentIsLoading && !this.props.customerFrequentError) return <Spinner />;
      else if (this.props.customerFrequentError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.customerFrequentError)}</div></ContentWrapper>;

      // Parameters of the react-data-grid
      const getRows = () => Data.Selectors.getRows(this.state.frequentItems);
      const getSize = () => getRows().length;
      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };
      const onRowsSelected = (rows) => {
        const newRows = getRows();
        const selectedIndexes = this.state.frequentItems.selectedIndexes.concat(rows.map(r => r.rowIdx));
        let selectedPK = [];
        if (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) {
          selectedPK = this.state.frequentItems.selectedPK.concat(rows.map(r => r.row.pk));
        }
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = true;
        });
        const frequentItems = { ...this.state.frequentItems, rows: newRows, selectedIndexes, selectedPK };
        this.setState({ frequentItems });
      };
      const onRowsDeselected = (rows) => {
        const rowIndexes = rows.map(r => r.rowIdx);
        this.state.frequentItems.rows = this.props.customerFrequent.record;
        const newRows = [...this.state.frequentItems.rows];
        const selectedIndexes = this.state.frequentItems.selectedIndexes.filter(i => rowIndexes.indexOf(i) === -1);

        let rowPKs = [];
        let selectedPK = this.state.frequentItems.selectedPK;
        if (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) {
          rowPKs = rows.map(r => r.row.pk);
          rowPKs.map(r => {
            selectedPK.map( (j, index) => {
              if (r === j) {
                selectedPK.splice(index, 1);
              }
            })
          });
        }

        if (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) {
        newRows.map((r, index) => {
          if (selectedPK && selectedPK.length > 0) {
          selectedPK.map((j)=> {
            if (r.pk === j) {
              newRows[index].isSelected = true;
            } else {
              newRows[index].isSelected = false;
            }
          });
        } else {
          newRows[index].isSelected = false;
        }
        });
      } else {
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = false;
        });
      }

        const frequentItems = { ...this.state.frequentItems, rows: newRows, selectedIndexes, selectedPK };
        this.setState({ frequentItems });
      };
      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        const frequentItems = { ...this.state.frequentItems, sortColumn, sortDirection };
        this.setState({ frequentItems });
      };
      const handleFilterChange = (filter) => {
        this.state.frequentItems.rows = this.props.customerFrequent.record;
        const newFilters = Object.assign({}, this.state.frequentItems.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const frequentItems = { ...this.state.frequentItems, filters: newFilters };
        this.setState({ frequentItems });
      };

      // all filters removed
      const onClearFilters = () => {
        const frequentItems = { ...this.state.frequentItems, filters: {} };
        this.setState({ frequentItems });
      };
      // const onRowSelect = rows => {
      //     var previousOrderes = {...this.state.frequentItems, selectedRows: rows};
      //     this.setState({frequentItems});
      // }
      const onRowClick = (rowIdx, row) => {
        if (rowIdx > -1) {
          if (this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') {
          this.props.fetchItemSalesHistory(this.state.currentCustomer, row.Product_id);
          }
          this.selectInventoryInfo(row);
          // this.props.fetchProductInfo(row.Product_id);
        }
      };
      // Custom Formatter component
      const IsEnabledFormatter = React.createClass({
        render() {
          if (this.props.value) return <span className="label label-success"><Translate value="enabled" /></span>;
          return <span className="label label-danger"><Translate value="disable" /></span>;
        },
      });

      const showProductCost = () => {
        if ((isJML || isChinaTown || isRivera) && checkPermissionLocal('no_show_product_cost')) {
          return false;
        }
        return true;
      };
      // Column definition
      const columns = [
        {
          key: 'ContainerNum',
          name: <Translate value="container" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'RefNum',
          name: isWIZ ?  <Translate value="sku" /> : <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: 150,
        },
        {
          key: 'DispatchType',
          name: <Translate value="dispatch" />,
          resizable: true,
          sortable: true,
          width: 80,
        },
        {
          key: 'AvailableQuantity',
          name: <Translate value="available" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'FulfilledQuantity',
          name: <Translate value="fulfilled" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          // key: 'Quantity',
          key: 'InboundTotalQuantity',
          name: <Translate value="total_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'PickupDate',
          name: <Translate value="pickup_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter2,
        },
        {
          key: 'DropoffDate',
          name: <Translate value="dropoff_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter2,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        },
        ...showProductCost() ? [{
          key: 'CostPrice',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="unit_weight" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        },
      ];

      const wizFreqColumns = [
        {
          key: 'ContainerNum',
          name: <Translate value="container" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'RefNum',
          name: isWIZ ?  <Translate value="sku" /> : <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: 150,
        },
        {
          key: 'DispatchType',
          name: <Translate value="dispatch" />,
          resizable: true,
          sortable: true,
          width: 80,
        },
        {
          key: 'AvailableQuantity',
          name: <Translate value="available" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'FulfilledQuantity',
          name: <Translate value="fulfilled" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          // key: 'Quantity',
          key: 'InboundTotalQuantity',
          name: <Translate value="total_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'Location',
          name: <Translate value="location" />,
          resizable: true,
          sortable: true,
          width: 80,
        },
        {
          key: 'InboundCustomer',
          name: <Translate value="customer" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'PickupDate',
          name: <Translate value="pickup_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter2,
        },
        {
          key: 'DropoffDate',
          name: <Translate value="dropoff_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter2,
        },
        {
          key: 'InboundDate',
          name: <Translate value="inbound_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter2,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        },
        ...showProductCost() ? [{
          key: 'CostPrice',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="unit_weight" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        },
      ];

      const kdwFreqColumns = [
        {
          key: 'ContainerNum',
          name: <Translate value="container" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'RefNum',
          name: <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        },
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: 150,
        },
        {
          key: 'FBARoute',
          name: <Translate value="fba_route" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        },
        {
          key: 'ShipmentID',
          name: <Translate value="shipment_id" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        },
        {
          key: 'ServiceType',
          name: <Translate value="service_type" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        },
        {
          key: 'ISANum',
          name: <Translate value="isa_num" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        },
        {
          key: 'DispatchType',
          name: <Translate value="dispatch" />,
          resizable: true,
          sortable: true,
          width: 80,
        },
        {
          key: 'AvailableQuantity',
          name: <Translate value="available_box" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'FulfilledQuantity',
          name: <Translate value="fulfilled_box" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          // key: 'Quantity',
          key: 'InboundTotalQuantity',
          name: <Translate value="total_qty_box" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'FulfilledPallets',
          name: <Translate value="ob_plt_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'InboundTotalPallets',
          name: <Translate value="ib_plt_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'Location',
          name: <Translate value="location" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'PickupDate',
          name: <Translate value="pickup_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter2,
        },
        {
          key: 'DropoffDate',
          name: <Translate value="dropoff_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter2,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        },
        ...showProductCost() ? [{
          key: 'CostPrice',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="unit_weight" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        },
      ];

      const abcffFreqColumns = [
        {
          key: 'ContainerNum',
          name: <Translate value="container" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'RefNum',
          name: <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        },
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        },
        {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 150,
        },
        {
          key: 'Location',
          name: <Translate value="location" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        },
        {
          key: 'TrackingNum',
          name: <Translate value="tracking_num" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        },
        {
          key: 'FBARoute',
          name: <Translate value="fba_route" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        },
        {
          key: 'DispatchType',
          name: <Translate value="dispatch" />,
          resizable: true,
          sortable: true,
          width: 80,
        },
        {
          key: 'AvailableQuantity',
          name: <Translate value="available_box" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'FulfilledQuantity',
          name: <Translate value="fulfilled_box" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          // key: 'Quantity',
          key: 'InboundTotalQuantity',
          name: <Translate value="total_qty_box" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'InboundTotalPallets',
          name: <Translate value="total_qty_plt" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'PickupDate',
          name: <Translate value="pickup_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter2,
        },
        {
          key: 'DropoffDate',
          name: <Translate value="dropoff_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter2,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        },
        ...showProductCost() ? [{
          key: 'CostPrice',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="unit_weight" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        },
      ];

      const dsqFreqColumns = [
        {
          key: 'ContainerNum',
          name: <Translate value="container" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'RefNum',
          name: <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        },
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: 150,
        },
        {
          key: 'Location',
          name: <Translate value="location" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        },
        {
          key: 'FBARoute',
          name: <Translate value="fba_route" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        },
        {
          key: 'DispatchType',
          name: <Translate value="dispatch" />,
          resizable: true,
          sortable: true,
          width: 80,
        },
        {
          key: 'AvailableQuantity',
          name: <Translate value="available_box" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'FulfilledQuantity',
          name: <Translate value="fulfilled_box" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          // key: 'Quantity',
          key: 'InboundTotalQuantity',
          name: <Translate value="total_qty_box" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'InboundTotalPallets',
          name: <Translate value="total_qty_plt" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'PickupDate',
          name: <Translate value="pickup_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter2,
        },
        {
          key: 'DropoffDate',
          name: <Translate value="dropoff_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter2,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        },
        ...showProductCost() ? [{
          key: 'CostPrice',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="unit_weight" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        },
      ];

      const jtbFreqColumns = [
        {
          key: 'ContainerNum',
          name: <Translate value="container" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'RefNum',
          name: <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        },
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: 150,
        },
        {
          key: 'AvailableQuantity',
          name: <Translate value="available" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'FulfilledQuantity',
          name: <Translate value="fulfilled" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          // key: 'Quantity',
          key: 'InboundTotalQuantity',
          name: <Translate value="total_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        },
        ...showProductCost() ? [{
          key: 'CostPrice',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="unit_weight" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        },
      ];

      const generateFreqColumns = () => {
        if (isJTB) {
          return jtbFreqColumns;
        }
        if (isDSQ || isWUFS || isYI || isFBD) {
          return dsqFreqColumns;
        }
        if (isKDW) {
          return kdwFreqColumns;
        }
        if (isWIZ) {
          return wizFreqColumns;
        }
        if (isABCFF) {
          return abcffFreqColumns;
        }
        return columns
      }
      return (
        <Row>
          <Col xs={12} style={{ marginTop: '-30px' }}>
            <div className="react-table-customizer" id="SalesOrderForm-dataGrid1">
              <ReactDataGrid
                rowKey="Product_id"
                onGridSort={handleGridSort}
                columns={generateFreqColumns()}
                rowHeight={25}
                headerRowHeight={45}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                enableRowSelect="multi"
                toolbar={<Toolbar enableFilter />}
                onAddFilter={handleFilterChange}
                onClearFilters={onClearFilters}
                minHeight={220}
                onRowUpdated={this.handleRowUpdated}
                onRowClick={onRowClick}
                rowSelection={{
                  showCheckbox: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
              />
            {/* <Row id="inventory-details">
                <Col xs={1}>
                  <label className="inventory-label"><Translate value="inventory" />:</label>
                </Col>
                <Col xs={5}>
                  <Row>
                    <Col xs={4}>
                      <label className="col-xs-6 inlineLabel"><Translate value="in_stock" /><span className="colon">:</span></label>
                      <span className="col-xs-6 inventory-highlight"> {this.state.inStock}</span>
                    </Col>
                    <Col xs={4}>
                      <label className="col-xs-7 inlineLabel"><Translate value="purchased" /><span className="colon">:</span></label>
                      <span className="col-xs-5 inventory-highlight"> {this.state.purchased}</span>
                    </Col>
                    <Col xs={4}>
                      <label className="col-xs-6 inlineLabel"><Translate value="presale" /><span className="colon">:</span></label>
                      <span className="col-xs-6 inventory-highlight"> {this.state.presale}</span>
                    </Col>
                  </Row>
                </Col>
                <Col xs={6}>
                  <Col xs={4}>
                    <label className="col-xs-5 inlineLabel"><Translate value="net_wt" /><span className="colon">:</span></label>
                    <span className="col-xs-6 inventory-highlight"> {this.state.net_weight}</span>
                  </Col>
                  <Col xs={4}>
                    <label className="col-xs-5 inlineLabel"><Translate value="ship_wt" /><span className="colon">:</span></label>
                    <span className="col-xs-6 inventory-highlight"> {this.state.ship_weight}</span>
                  </Col>
                  <Col xs={4}>
                    <label className="col-xs-5 inlineLabel"><Translate value="total_wt" /><span className="colon">:</span></label>
                    <span className="col-xs-6 inventory-highlight"> {this.state.total_weight}</span>
                  </Col>
                </Col>
              </Row> */}
            </div>
          </Col>
        </Row>
      );
    }

    renderFrequent() {
      if (this.props.customerFrequentIsLoading && !this.props.customerFrequentError) return <Spinner />;
      else if (this.props.customerFrequentError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.customerFrequentError)}</div></ContentWrapper>;

      // Parameters of the react-data-grid
      const getRows = () => Data.Selectors.getRows(this.state.frequentItems);
      const getSize = () => getRows().length;
      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };
      const onRowsSelected = (rows) => {
        const newRows = getRows();
        const selectedIndexes = this.state.frequentItems.selectedIndexes.concat(rows.map(r => r.rowIdx));
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = true;
        });
        const frequentItems = { ...this.state.frequentItems, rows: newRows, selectedIndexes };
        this.setState({ frequentItems });
      };
      const onRowsDeselected = (rows) => {
        const rowIndexes = rows.map(r => r.rowIdx);
        const newRows = [...this.state.frequentItems.rows];
        const selectedIndexes = this.state.frequentItems.selectedIndexes.filter(i => rowIndexes.indexOf(i) === -1);
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = false;
        });
        const frequentItems = { ...this.state.frequentItems, rows: newRows, selectedIndexes };
        this.setState({ frequentItems });
      };
      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        const frequentItems = { ...this.state.frequentItems, sortColumn, sortDirection };
        this.setState({ frequentItems });
      };
      // const onRowSelect = rows => {
      //     var previousOrderes = {...this.state.frequentItems, selectedRows: rows};
      //     this.setState({frequentItems});
      // }
      const onRowClick = (rowIdx, row) => {
        if (rowIdx > -1) {
          if (this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') {
          this.props.fetchItemSalesHistory(this.state.currentCustomer, row.Product_id);
          }
          this.selectInventoryInfo(row);
          // this.props.fetchProductInfo(row.Product_id);
        }
      };
      // Custom Formatter component
      const IsEnabledFormatter = React.createClass({
        render() {
          if (this.props.value) return <span className="label label-success"><Translate value="enabled" /></span>;
          return <span className="label label-danger"><Translate value="disable" /></span>;
        },
      });

      const showProductCost = () => {
        if ((isJML || isChinaTown || isRivera) && checkPermissionLocal('no_show_product_cost')) {
          return false;
        }
        return true;
      };
      // Column definition
      const columns = [
        ...(!isLO) ? [{
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        }] : [],
        {
          key: 'RefNum',
          name: <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: isLO ? 160:70,
          filterable: true,
        },
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 250,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: 200,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        },
        ...showProductCost() ? [{
          key: 'CostPrice',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="unit_weight" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        },
        ...(isLO) ? [{
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        }] : [],
      ];
      return (
        <Row>
          <Col xs={12}>
            <div className="react-table-customizer" id="SalesOrderForm-dataGrid1">
              <ReactDataGrid
                rowKey="Product_id"
                onGridSort={handleGridSort}
                columns={columns}
                rowHeight={25}
                headerRowHeight={45}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                enableRowSelect="multi"
                minHeight={202}
                onRowUpdated={this.handleRowUpdated}
                onRowClick={onRowClick}
                rowSelection={{
                  showCheckbox: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
              />
              {
                !isChinaTown && 
                <Row id="inventory-details">
                  <Col xs={1}>
                    <label className="inventory-label"><Translate value="inventory" />:</label>
                  </Col>
                  <Col xs={5}>
                    <Row>
                      <Col xs={4}>
                        <label className="col-xs-6 inlineLabel"><Translate value="in_stock" /><span className="colon">:</span></label>
                        <span className="col-xs-6 inventory-highlight"> {this.state.inStock}</span>
                      </Col>
                      <Col xs={4}>
                        <label className="col-xs-7 inlineLabel"><Translate value="purchased" /><span className="colon">:</span></label>
                        <span className="col-xs-5 inventory-highlight"> {this.state.purchased}</span>
                      </Col>
                      <Col xs={4}>
                        <label className="col-xs-6 inlineLabel"><Translate value="presale" /><span className="colon">:</span></label>
                        <span className="col-xs-6 inventory-highlight"> {this.state.presale}</span>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={6}>
                    <Col xs={4}>
                      <label className="col-xs-5 inlineLabel"><Translate value="net_wt" /><span className="colon">:</span></label>
                      <span className="col-xs-6 inventory-highlight"> {this.state.net_weight}</span>
                    </Col>
                    <Col xs={4}>
                      <label className="col-xs-5 inlineLabel"><Translate value="ship_wt" /><span className="colon">:</span></label>
                      <span className="col-xs-6 inventory-highlight"> {this.state.ship_weight}</span>
                    </Col>
                    <Col xs={4}>
                      <label className="col-xs-5 inlineLabel"><Translate value="total_wt" /><span className="colon">:</span></label>
                      <span className="col-xs-6 inventory-highlight"> {this.state.total_weight}</span>
                    </Col>
                  </Col>
                </Row>
              }
              {
                isChinaTown &&
                <Row id="inventory-details" style={{fontSize: '15px'}}>
                  <Col xs={1}>
                   <label className="inventory-label-china"><Translate value="inventory" />:</label>
                  </Col>
                  <Col xs={5}>
                    <Row>
                      <Col xs={4} className="pr1">
                        <label className="col-xs-6 inlineLabel"><Translate value="in_stock" /><span className="colon">:</span></label>
                        <span className="col-xs-6 inventory-highlight-china"> {this.state.inStock}</span>
                      </Col>
                      <Col xs={4} className="pr1">
                        <label className="col-xs-7 inlineLabel"><Translate value="purchased" /><span className="colon">:</span></label>
                        <span className="col-xs-5 inventory-highlight-china"> {this.state.purchased}</span>
                      </Col>
                      <Col xs={4} className="pr1">
                        <label className="col-xs-6 inlineLabel"><Translate value="presale" /><span className="colon">:</span></label>
                        <span className="col-xs-6 inventory-highlight-china"> {this.state.presale}</span>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={6}>
                    <Col xs={4} className="pr1">
                      <label className="col-xs-5 inlineLabel"><Translate value="net_wt" /><span className="colon">:</span></label>
                      <span className="col-xs-6 inventory-highlight-china"> {this.state.net_weight}</span>
                    </Col>
                    <Col xs={4} className="pr1">
                      <label className="col-xs-5 inlineLabel"><Translate value="ship_wt" /><span className="colon">:</span></label>
                      <span className="col-xs-6 inventory-highlight-china"> {this.state.ship_weight}</span>
                    </Col>
                    <Col xs={4} className="pr1">
                      <label className="col-xs-5 inlineLabel"><Translate value="total_wt" /><span className="colon">:</span></label>
                      <span className="col-xs-6 inventory-highlight-china"> {this.state.total_weight}</span>
                    </Col>
                  </Col>
                </Row>
              }
            </div>
          </Col>
        </Row>
      );
    }

    handleShowAll = () => {
      this.fetchPreviousOrdersFromALLSalesOrder();
    }

    handleSelectAll = () => {
      const newRows = [...this.state.previousOrders.rows];
      const selectedRows = [...this.state.previousOrders.selectedRows];
      const selectedIndexes = [];
      let index = 0;
      newRows.map((r) => {
        r.isSelected = true;
        selectedIndexes.push(index);
        selectedRows.push(r);
        index++;
      });
      const previousOrders = { ...this.state.previousOrders, rows: newRows, selectedIndexes, selectedRows };
      this.setState({ previousOrders });
    }

    handleDeselectAll = () => {
      const newRows = [...this.state.previousOrders.rows];
      const selectedIndexes = [];
      const selectedRows = [];
      let index = 0;
      newRows.map((r) => {
        r.isSelected = false;
      });
      const previousOrders = { ...this.state.previousOrders, rows: newRows, selectedIndexes, selectedRows };
      this.setState({ previousOrders });
    }
    
    renderOpenOrder() {
      const { salesCustomerDetails, salesOrderCreated, currentSalesOrder } = this.props;
      const salesOrder = salesOrderCreated || currentSalesOrder;
      let orders = [];
      let orderlist = '';
      let route = '';
      if (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'salesOrders/:id' || this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
        route = 'salesOrders';
      } else if (this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id') {
        route = 'mobileSalesOrders';
      }
      if (salesCustomerDetails && salesCustomerDetails.open_orders) {
        orders = salesCustomerDetails.open_orders;
        orderlist = salesCustomerDetails.open_orders.map((order) =>
          <li style={{fontSize: '20px', listStyleType: 'none' }}>
            <Translate value="sales_orders" /> : {order.SONum}
            <Button
              bsStyle="danger"
              type="button"
              onClick={() => {
                this.props.fetchSalesOrderDetail(order.SalesOrder_id, route)
                .then(() => {
                  this.props.selectSalesOrder(this.props.currentSalesOrderDetail);
                  this.context.router.push(`/salesOrders/${order.SalesOrder_id}`); 
                })
              }}
            >
              <em className="fa fa-edit" /> <Translate value="edit" />
            </Button>
          </li>
        );
      }

      return (
        <div>
          <ul>{orderlist}</ul>
        </div>
      );
    }

    renderHistory() {
      if ((this.props.customerSalesHistoryIsLoading && !this.props.customerSalesHistoryError)) return <Spinner />;
      else if (this.props.customerSalesHistoryError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.customerSalesHistoryError)}</div></ContentWrapper>;

      // Parameters of the react-data-grid
      const getRows = () => Data.Selectors.getRows(this.state.salesHistory);

      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      const handleFilterChange = (filter) => {
        const newFilters = Object.assign({}, this.state.salesHistory.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const salesHistory = { ...this.state.salesHistory, filters: newFilters };
        this.setState({ salesHistory });
      };

      const onClearFilters = () => {
        const salesHistory = { ...this.state.salesHistory, filters: {} };
        this.setState({ salesHistory });
      };

      const HighlightFormatter = React.createClass({
        render() {
          const rows = this.props.state.rows;
          if (rows.some((e) => e.ProductNum === this.props.value)) {
            return (
              <div style={{ backgroundColor: '#5CB85C' }}>{this.props.value}</div>
            );
          }
          return (
            <div>{this.props.value}</div>
          );
        },
      });

      const columns = [
        {
          key: 'productNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 110,
          formatter: <HighlightFormatter state={this.state} />,
        },
        {
          key: 'name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 110,
        },
        {
          key: 'description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 110,
        },
        {
          key: 'quantity',
          name: <Translate value="qty" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 110,
          formatter: BoldTextFormatter,
        },
        {
          key: 'totalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 110,
          formatter: BoldCashFormatter,
        },
      ];

      return (
        <div>
          <Row>
            <Col xs={12}>
              <div id="salesOrders-dataGrid1">
                <ReactDataGrid
                  rowKey="SalesOrder_id"
                  columns={columns}
                  rowHeight={25}
                  headerRowHeight={45}
                  rowGetter={rowGetter}
                  rowsCount={getSize()}
                  minHeight={270}
                  toolbar={<Toolbar enableFilter />}
                  onAddFilter={handleFilterChange}
                  onClearFilters={onClearFilters}
                />
              </div>
            </Col>
          </Row>
        </div>
      );
    }

    renderPreviousSOs() {
      if ((this.props.previousOrdersIsLoading && !this.props.previousOrdersError) || (this.props.detailByNumIsLoading && !this.props.detailByNumError)) return <Spinner />;
      else if (this.props.previousOrdersError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.previousOrdersError)}</div></ContentWrapper>;

      // Parameters of the react-data-grid
      const getRows = () => Data.Selectors.getRows(this.state.previousSOs);

      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      // Handle the row select function
      const onRowClick = (rowIdx, row) => {
        if (rowIdx !== -1) {
          const rows = getRows();

          /* Single row select on row click */
          rows.map((r) => {
            r.isSelected = false;
          });
          const selectedRows = [rows[rowIdx]];
          rows[rowIdx].isSelected = true;

          const previousSOs = { ...this.state.previousSOs, rows, selectedRows };
          this.setState({ previousSOs });
          this.props.fetchPreviousOrderById(row.SalesOrder_id);
        }
      };

      const onRowSelect = (rows) => {
        const previousSOs = { ...this.state.previousSOs, selectedRows: rows };
        this.setState({ previousSOs });
      };

      const onRowsSelected = (rows) => {
        const newRows = getRows();
        newRows.map((r) => {
          r.isSelected = false;
        });
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = true;
        });
        const previousSOs = { ...this.state.previousSOs, rows: newRows, selectedRows: [rows[0].row] };
        this.props.fetchPreviousOrderById(rows[0].row.SalesOrder_id);
        this.setState({ previousSOs });
      };

      const onRowsDeselected = (rows) => {
        const newRows = getRows();
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = false;
        });
        const previousSOs = { ...this.state.previousSOs, rows: newRows, selectedRows: [] };
        this.setState({ previousSOs });
      };

      const columns = [
        {
          key: 'SONum',
          name: <Translate value="so_no" />,
          resizable: true,
          sortable: true,
          filterable: false,
          width: 110,
        },
      ];

      return (
        <div>
          <Row>
            <Col xs={12}>
              <div id="salesOrders-dataGrid1">
                <ReactDataGrid
                  rowKey="SalesOrder_id"
                  columns={columns}
                  rowHeight={25}
                  headerRowHeight={45}
                  rowGetter={rowGetter}
                  rowsCount={getSize()}
                  minHeight={221}
                  enableRowSelect="single"
                  onRowSelect={onRowSelect}
                  onRowClick={onRowClick}
                  rowSelection={{
                    showCheckbox: true,
                    onRowsSelected,
                    onRowsDeselected,
                    selectBy: {
                      isSelectedKey: 'isSelected',
                    },
                  }}
                />
              </div>
            </Col>
          </Row>
        </div>
      );
    }

    renderPreviousOrders() {
      if ((this.props.previousOrdersIsLoading && !this.props.previousOrdersError) || (this.props.detailByNumIsLoading && !this.props.detailByNumError)) return <Spinner />;
      else if (this.props.previousOrdersError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.previousOrdersError)}</div></ContentWrapper>;
      // Parameters of the react-data-grid
      const getRows = () => Data.Selectors.getRows(this.state.previousOrders);
      const getSize = () => getRows().length;
      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };
      const onRowsSelected = (rows) => {
        const newRows = getRows();
        const ordersRows = [...this.state.previousOrders.rows];
        const selectedRows = [...this.state.previousOrders.selectedRows];
        const selectedIndexes = this.state.previousOrders.selectedIndexes.concat(rows.map(r => r.rowIdx));
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = true;
          selectedRows.push(r.row);
        });
        const previousOrders = { ...this.state.previousOrders, rows: ordersRows, selectedIndexes, selectedRows };
        this.setState({ previousOrders });
      };
      const onRowsDeselected = (rows) => {
        const rowIndexes = rows.map(r => r.rowIdx);
        const newRows = [...this.state.previousOrders.rows];
        const selectedIndexes = this.state.previousOrders.selectedIndexes.filter(i => rowIndexes.indexOf(i) === -1);
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = false;
        });
        const previousOrders = { ...this.state.previousOrders, rows: newRows, selectedIndexes };
        this.setState({ previousOrders });
      };
      const onRowClick = (rowIdx, row) => {
        if (rowIdx > -1) {
          if (this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') {
          this.props.fetchItemSalesHistory(this.state.currentCustomer, row.Product_id);
          }
          // this.props.fetchProductInfo(row.Product_id);
        }
      };
      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        const previousOrders = { ...this.state.previousOrders, sortColumn, sortDirection };
        this.setState({ previousOrders });
      };
      const onRowSelect = (rows) => {
        const previousOrderes = { ...this.state.previousOrders, selectedRows: rows };
        this.setState({ previousOrders });
      };
      // Custom Formatter component
      const IsEnabledFormatter = React.createClass({
        render() {
          if (this.props.value) return <span className="label label-success"><Translate value="enabled" /></span>;
          return <span className="label label-danger"><Translate value="disable" /></span>;
        },
      });

      const handleFilterChange = (filter) => {
        const newFilters = Object.assign({}, this.state.previousOrders.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const previousOrders = { ...this.state.previousOrders, filters: newFilters };
        this.setState({ previousOrders });
      };

      // all filters removed
      const onClearFilters = () => {
        const previousOrders = { ...this.state.previousOrders, filters: {} };
        this.setState({ previousOrders });
      };


      const showProductCost = () => {
        if ((isJML || isChinaTown ||isRivera) && checkPermissionLocal('no_show_product_cost')) {
          return false;
        }
        return true;
      };

      // Column difinition
      const columns = [
        ...(!isLO) ? [{
          key: 'ProductNum',
          name: <Translate value="product_num" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        }] : [],
        {
          key: 'RefNum',
          name: <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: isLO ? 160:80,
          filterable: true,
        },
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 170,
          filterable: true,
          filterRenderer: FilterMultiKeyword,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          filterable: true,
          filterRenderer: FilterMultiKeyword,
          width: 100,
        },
        {
          key: 'Quantity',
          name: <Translate value="qty" />,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
          formatter: BoldTextFormatter,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 65,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'CostPrice',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 75,
          filterable: true,
        }] : [],
        {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 55,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'TotalNetWeight',
          name: <Translate value="total_wt" />,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
        },
        ...(isLO) ? [{
          key: 'ProductNum',
          name: <Translate value="product_num" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        }] : [],
      ];
      return (
      // Previous Orders Table
        <Row>
          <Col xs={12} style={{ marginTop: '-22px' }}>
            <div className="PreviousOrders-dataGrid" style={{ maxWidth: '99%' }}>
              <ReactDataGrid
                rowKey="Product_id"
                onGridSort={handleGridSort}
                columns={columns}
                rowHeight={25}
                headerRowHeight={45}
                minHeight={221}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                enableRowSelect="single"
                toolbar={<Toolbar enableFilter />}
                onAddFilter={handleFilterChange}
                onClearFilters={onClearFilters}
                onRowUpdated={this.handleRowUpdated}
                onRowSelect={onRowSelect}
                onRowClick={onRowClick}
                rowSelection={{
                  showCheckbox: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
              />
            </div>
          </Col>
        </Row>
      );
    }
    renderItemHistory() {
      // Column difinition
      const columns = [
        {
          key: 'Quantity',
          name: <Translate value="qty" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: isChinaTown ? 45 : 40,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="so_dollarsign" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 50,
        },
        {
          key: 'SIUnitPrice',
          name: <Translate value="si_dollarsign" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: isChinaTown ? 60 : 50,
        },
        {
          key: 'Date',
          name: <Translate value="date" />,
          resizable: true,
          sortable: true,
          width: 85,
          formatter: DateFormatterChina,
        },
      ];

      if (isChinaTown) {
        const index1 = _.findIndex(columns, { key: "UnitPrice" });
        columns.splice(index1, 1);
      }

      let minHeight = isChinaTown ? 385 : 70; //chinatest
      return (
        <ItemHistoryGrid
          columns={columns}
          rowHeight={25}
          minHeight={minHeight}
        />
      );
    }

    renderTable() {
      const that = this;
      // Parameters of the react-data-grid
      const allRows = Data.Selectors.getRows(this.state);
      if (isHMM) {
        allRows.sort((valueA, valueB) => parseFloat(valueA.Order) <= parseFloat(valueB.Order) ? -1 : 1)
      }
      const getRows = () => allRows;
      const getSize = () => getRows().length;
      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return Object.assign({ Idx: rowIdx + 1 }, rows[rowIdx]);
      };
      const onRowsSelected = (rows) => {
        const newRows = this.state.rows;
        newRows.map((r) => {
          r.isSelected = false;
        });
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = true;
        });
        this.setState({ ...this.state, rows: newRows });
      };
      const onRowsDeselected = (rows) => {
        const newRows = this.state.rows;
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = false;
        });
        this.setState({ ...this.state, rows: newRows });
      };
      
      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        const state = Object.assign({}, this.state, { sortColumn, sortDirection });
        this.setState(state);
      };
      const handleFilterChange = (filter) => {
        let filteredRows = [...this.state.rows];
        const newFilters = Object.assign({}, this.state.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        for (var property in newFilters) {
          if (newFilters.hasOwnProperty(property)) {
            filteredRows = filteredRows.filter((obj) => {
              if (obj[property]) {
                return String((obj[property]).toUpperCase()).includes((newFilters[property].filterTerm).toUpperCase());
              }
              return false;
            });
          }
        }
        this.setState({ filters: newFilters, filteredRows });
      };
      const onClearFilters = () => {
        // all filters removed
        this.setState({ filters: {} });
      };

      const isNumeric = (str) => {
        if (typeof str !== "string") return false; // we only process strings!  
        return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
               !isNaN(parseFloat(str)); // ...and ensure strings of whitespace fail
      }
      
      // for ABCFF to set received case qty [ReceivedCaseQty] = case qty [Quantity]
      const autoLoad = () => {
        const rows = getRows();
        let newRows = [...this.state.rows];
        newRows.map((row, rowIdx) => {
          row.ReceivedCaseQty = row.Quantity;
          const e = {
            cellKey: "autoLoad",
            key: undefined,
            rowIdx: rowIdx,
            updated: {ReceivedCaseQty: String(row.Quantity)}
          }
          handleRowUpdated(e);
        });
        this.setState({ rows: newRows });
      };
      
      const handleRowUpdated = (e) => {
        if (isHMM) {
          if (e.cellKey === 'Order') {
            if (!isNumeric(e.updated.Order)) {
              return;
            }
            const rows = this.state.rows;
            let positionIndexExsited = false;
            rows.forEach((row, idx)=> {
              if (e.updated.Order === row.Order && e.rowIdx !== idx) {
                positionIndexExsited = true;
                alert('Position Index has been taken');
                // return;
              }
            });
            if (positionIndexExsited) {
              return;
            }
          }
        }
      
        const rows = getRows();
        const filteredRows = this.state.filteredRows;
        let index;

        if (e.cellKey==='autoLoad') {
          Object.assign(rows[e.rowIdx], { ReceivedCaseQty: e.updated.ReceivedCaseQty });
        }
        
        if ((e.updated.PalletQuantity != null) && (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD)) { // LALALA
          if (isNaN(e.updated.PalletQuantity)) {
            return;
          }
          // if ((this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && rows[e.rowIdx].AvailablePallets && (e.updated.PalletQuantity > rows[e.rowIdx].AvailablePallets)) {
          //   alert("Cannot exceed available pallet quantity: " + rows[e.rowIdx].AvailablePallets);
          //   return;
          // }
        }

        if (e.updated.Quantity != null) {
          if (isNaN(e.updated.Quantity)) {
            return;
          }
          if ((this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && rows[e.rowIdx].AvailableQuantity && (e.updated.Quantity > rows[e.rowIdx].AvailableQuantity)) {
            alert("Cannot exceed available quantity: " + rows[e.rowIdx].AvailableQuantity);
            return;
          }

          // if ((this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && rows[e.rowIdx].AvailableQuantityPallet && (e.updated.PalletQuantity > rows[e.rowIdx].AvailableQuantityPallet)) {
          //   alert("Cannot exceed available quantity: " + rows[e.rowIdx].AvailableQuantityPallet);
          //   return;
          // }
          // if ((this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && rows[e.rowIdx].AvailableQuantityBox && (e.updated.BoxQuantity > rows[e.rowIdx].AvailableQuantityBox)) {
          //   alert("Cannot exceed available quantity: " + rows[e.rowIdx].AvailableQuantityBox);
          //   return;
          // }
          // if ((this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && rows[e.rowIdx].AvailableQuantityPiece && (e.updated.PieceQuantity > rows[e.rowIdx].AvailableQuantityPiece)) {
          //   alert("Cannot exceed available quantity: " + rows[e.rowIdx].AvailableQuantityPiece);
          //   return;
          // }
          if ((!rows[e.rowIdx].IsOverSaleable && (parseInt(e.updated.Quantity) > rows[e.rowIdx].InStock)) && !isAFG) {
            return;
          }
          if (parseFloat(e.updated.Quantity) < 0) {
            alert("Quantity is not allowed to be negative");
            return;
          }
          if (rows[e.rowIdx].ProductType == 'Fixed') { Object.assign(rows[e.rowIdx], { TotalPrice: +roundToDecimals(parseFloat(e.updated.Quantity * rows[e.rowIdx].UnitPrice), 4).toFixed(4) }); }
          else {
            Object.assign(rows[e.rowIdx], { TotalPrice: +roundToDecimals(parseFloat(e.updated.Quantity * rows[e.rowIdx].UnitPrice * rows[e.rowIdx][!isJML ? 'NetWeight' : 'PackageSize_1']), 4).toFixed(4) });
          }
          Object.assign(rows[e.rowIdx], { TotalNetWeight: roundTo(e.updated.Quantity * rows[e.rowIdx].NetWeight, 2) });
          if (rows[e.rowIdx].CRV) { Object.assign(rows[e.rowIdx], { TotalCRV: +roundTo(parseFloat(e.updated.Quantity * rows[e.rowIdx].CRV), 2).toFixed(2) }); }
        }
        
        if (isABCFF && e.updated.ReceivedCaseQty != null) {
          if (!isNumeric(e.updated.ReceivedCaseQty)) {
            return;
          }
          Object.assign(rows[e.rowIdx], { ReceivedQuantity: e.updated.ReceivedCaseQty*rows[e.rowIdx].PerBoxQty });
        }

        if (isJML && e.updated.jmlPackageSize1 != null) {
          if (isNaN(e.updated.jmlPackageSize1)) {
            return;
          }
          if (parseFloat(e.updated.jmlPackageSize1) < 1) {
            alert("Minimum amount allowed: 1");
            return;
          }
          Object.assign(rows[e.rowIdx], { Quantity: e.updated.jmlPackageSize1*rows[e.rowIdx].jmlBox });
          Object.assign(rows[e.rowIdx], { TotalPrice: +roundToDecimals(parseFloat(rows[e.rowIdx].Quantity * rows[e.rowIdx].UnitPrice), 4).toFixed(4) });
        }

        if (isJML && e.updated.jmlBox != null) {
          if (isNaN(e.updated.jmlBox)) {
            return;
          }
          if (parseFloat(e.updated.jmlBox) < 1) {
            alert("Minimum amount allowed: 1");
            return;
          }
          this.setState({
            lineBatchId: rows[e.rowIdx].Batch_id_id ? rows[e.rowIdx].Batch_id_id : rows[e.rowIdx].Batch_id,
            lineBatchRows: this.state.rows,
            lineBatchIdx: rows[e.rowIdx].Index,
            lineQty: e.updated.jmlBox,
            isBatchesModal2Visible: true,
          });
          
          Object.assign(rows[e.rowIdx], { Quantity: e.updated.jmlBox*rows[e.rowIdx].jmlPackageSize1 });
          Object.assign(rows[e.rowIdx], { TotalPrice: +roundToDecimals(parseFloat(rows[e.rowIdx].Quantity * rows[e.rowIdx].UnitPrice), 4).toFixed(4) });
        }

        if (e.updated.UnitPrice != null) {
          if (isNaN(e.updated.UnitPrice)) {
            return;
          }
          if (parseFloat(e.updated.UnitPrice) > 0  && e.updated.UnitPrice < rows[e.rowIdx].LowestSalePrice) {
            this.setState({
              case: 'belowRefPrice', confirmOpen: true, RowBeingEdited: { ...rows[e.rowIdx] }, newPrice: e.updated.UnitPrice,
            });
            return;
          }
          if (parseFloat(e.updated.UnitPrice) < 0) {
            alert("Unit Price is not allowed to be negative");
            return;
          }
          if (rows[e.rowIdx].ProductType === 'Fixed') { Object.assign(rows[e.rowIdx], { TotalPrice: +roundToDecimals(parseFloat(e.updated.UnitPrice * rows[e.rowIdx].Quantity), 4).toFixed(4) }); } else { Object.assign(rows[e.rowIdx], { TotalPrice: +roundToDecimals(parseFloat(e.updated.UnitPrice * rows[e.rowIdx].NetWeight * rows[e.rowIdx].Quantity), 4).toFixed(4) }); }
        }
        if (e.updated.Remark != null) {
          Object.assign(rows[e.rowIdx], { Remark: e.updated.Remark });
        }
        if (isHMM && e.cellKey === 'Order') {
          Object.assign(rows[e.rowIdx], { Order: parseFloat(e.updated.Order)});
        } else {
          Object.assign(rows[e.rowIdx], e.updated);
        }
        // this.setState({ rows });
        // }
        // CODE FOR UPDATING TOTALS
        let totalPrice = 0;
        let finalWeight = 0;
        let finalPrice = 0;
        let totalTax = 0;
        let totalTaxOriginal = 0;
        let totalCRV = 0;
        let discount = parseFloat(this.props.discount) || 0;
        // if (totalPrice == null)
        //   totalPrice = 0;
        // if (finalWeight ==null)
        //   finalWeight = 0;
        rows.map((row) => {
          if(isHMM) {
            totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
          } else {
            totalPrice += parseFloat(row.TotalPrice);
          }
          finalWeight += parseFloat(row.NetWeight * row.Quantity);
          if (row.IsTaxable === true || row.IsTaxable === 'True') {
            if (isHMM) {
              totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(this.state.taxValue / 100);
            } else {
              if(isAN || isElegant) {
                let taxable = !this.props.salesCustomerDetails.Reseller;
                if (isAN) {
                  taxable = row.IsAllTaxable === true || !this.props.salesCustomerDetails.Reseller;
                }
                if(taxable) {
                  totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
                }
              } else {
                totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
              }
            }
          }
          if (row.CRV) { row.TotalCRV = +roundTo(parseFloat(row.CRV * row.Quantity), 2).toFixed(2); }
          if (row.TotalCRV) { totalCRV += row.TotalCRV; }
        });
        totalTaxOriginal = totalTax = +roundTo(totalTax, 2).toFixed(2);
        if (isElegant) {
          discount = parseFloat(this.state.SODiscount) || (parseFloat(this.state.SOSavings) / totalPrice) * 100 || 0;
          totalTax = +roundTo((1 - (discount / 100)) * totalTax, 2).toFixed(2);
        }
        finalPrice = parseFloat(totalPrice) * (1 - discount / 100) + parseFloat(totalTax) + parseFloat(totalCRV);
        finalWeight = +roundTo(finalWeight, 2).toFixed(2);
        totalPrice = +roundToDecimals(totalPrice, 4).toFixed(4);
        finalPrice = +roundTo(finalPrice, 2).toFixed(2);
        const productNum = this.state.rows[e.rowIdx].ProductNum;
        const productId = this.state.rows[e.rowIdx].Product_id;
        this.setState({
          rows, totalPrice, finalWeight, finalPrice, totalTax, totalCRV, totalTaxOriginal,
        }, () => {
          if (isEcity) {
            if (rows[e.rowIdx].UnitPrice) {
              this.props.fetchProductPromotion(productId, null, () => this.checkForPromotions(productNum));
            }
          }
        });
      };
      const onRowClick = (rowIdx, row) => {
        if (rowIdx > -1) {
          if (this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') {
          this.props.fetchItemSalesHistory(this.state.currentCustomer, row.Product_id);
          }
          // if (this.state.yourOrderKey === 1) {
          // here
          if(isJML) {
            this.props.fetchBatchesByID(row.Product_id, true);
            this.selectInventoryInfo(row);
          } else {
            this.props.fetchProductInfo2(row.Product_id);
          }
          // }
          
        }
      };
      
      const IsVariableFormatter = React.createClass({
        render() {
          return (
            <span>
              <Button
                bsStyle="danger"
                className="textAlignStyle"
                style={{ height: '23px', width: '39px', padding: '0px' }}
                onClick={() => {
                  // const ProductNum = this.props.dependentValues.ProductNum;
                  const Index = this.props.dependentValues.Index;
                  that.removeRow(Index);
                }}
              >X
              </Button>
            </span>
          );
        },
      });
      
      // Column difinition
      const showProductCost = () => {
        if (isHMM || isJML) {
          return false
        }
        if ((isJML || isChinaTown || isRivera) && checkPermissionLocal('no_show_product_cost')) {
          return false;
        }
        return true;
      };

      const unitPriceEditable = () => {
        if (isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) {
          false;
        }
        if (isRivera && !checkPermissionLocal('edit_sales_order_price')) {
          return false
        }
        return true
      }
      
      const columns = isChinaTown ? 
      [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'RefNum',
          name: <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        },
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: 200,
        },
        {
          key: 'Quantity',
          name: !isJML ? <Translate value="qty" /> : <Translate value='box' />,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
          // editable: this.state.editSOPermission,
          editable: true,
          formatter: BoldTextFormatter,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          // editable: this.state.editSOPermission,
          editable: unitPriceEditable(),
          formatter: BoldCashFormatter,
        },
        {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="net_wt" />,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
        },
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'TotalNetWeight',
          name: <Translate value="total_wt" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
      ]
      :
      [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        },
        ...isHMM ? [{
          key: 'Order',
          name: <Translate value="positionIndex" />,
          resizable: true,
          sortable: true,
          editable: true,
          width: 70,
          filterable: true,
        }] : [{
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        }],
        ...(!isLO) ? [{
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }] : [],
        ...isABC ? [{
          key: 'RefNo',
          name: <Translate value="FBA_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'PoNo',
          name: <Translate value="pro_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }]: [],
        ...isTN ? [{
          key: 'RefNum',
          name: <Translate value="sku" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          getRowMetaData: row => row,
          formatter: ({ value, dependentValues }) => {
            return (
              <div
                onDoubleClick={()=>{
                  this.props.fetchSalesOrderProductByID(dependentValues.Product_id, this.state.currentCustomer);
                  this.props.fetchBatchesByID(dependentValues.Product_id).then(()=>{
                    this.setBatchesModal2Visibility(true);
                  })
                  this.setState({
                    lineBatchId: dependentValues.Batch_id_id ? dependentValues.Batch_id_id : dependentValues.Batch_id,
                    lineBatchRows: this.state.rows,
                    lineBatchIdx: dependentValues.Index,
                    lineQty: dependentValues.Quantity,
                  });
                  // this.setBatchesModal2Visibility(true);
                }}
              >
               {value}
              </div>
            )
          }
        }] : [{
          key: 'RefNum',
          name: <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: (isJML || isLO) ? 200 : 70,
          filterable: true,
        }],
        ...isAFM ? [{
          key: 'Brand',
          name: <Translate value="brand" />,
          resizable: true,
          sortable: true,
          width: 100,
        }]: [],
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: isChinaTown ? 200 : 85,
        },
        ...isJML ? [{
          key: 'jmlBox',
          name: <Translate value='box' />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true, // this.state.editSOPermission
          formatter: BoldTextFormatter,
        }] : [],
        ...isJML ? [{
          key: 'jmlPackageSize1',
          name: <Translate value='pcs/box' />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true, // this.state.editSOPermission
          formatter: BoldTextFormatter,
        }] : [],
        {
          key: 'Quantity',
          name: !isJML ? <Translate value="qty" /> : <Translate value='total_units' />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: isJML ? false : true, // this.state.editSOPermission
          formatter: BoldTextFormatter,
        },
        ...isTN ? [{
          key: 'pallet_barcode',
          name: <Translate value="plt_barcode" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 150,
        }] : [],
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: unitPriceEditable(), // this.state.editSOPermission
          formatter: BoldCashFormatter,
        },
        {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />, //okc problem
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="net_wt" />,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
        },
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'TotalNetWeight',
          name: <Translate value="total_wt" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
      ];

      if (isEcity || isLucky88) {
        const costIndex = _.findIndex(columns, { key: 'cost' });
        const cost = {
          key: 'cost',
          name: <Translate value="product_cost" />, //okc problem
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ArrivalPrice ? row.ArrivalPrice : row.UnitArrivalPrice,
        }
        const margin = {
          key: 'SalesMargin',
          name: <Translate value="sales_margin" />, //okc problem
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          // formatter: PriceFormatter,
          // getRowMetaData: row => row.ArrivalPrice ? row.ArrivalPrice : row.UnitArrivalPrice,
        }
        columns.splice(costIndex, 1, cost, margin);
      }
      if (isJML) {
        const index1 = _.findIndex(columns, { key: "NetWeight" });
        columns.splice(index1, 1);
        const index2 = _.findIndex(columns, { key: "TotalNetWeight" });
        columns.splice(index2, 1);
      }

      if (isHMM) {
        let temp = {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: HMMPriceFormatter,
          getRowMetaData: row => row,
        };
        columns.splice(8, 1, temp);
      }
      
      if (isLO) {
        const refIndex = columns.findIndex(column => column.key === 'RefNum');
        if(refIndex !== -1) {
          columns[refIndex].name = <Translate value="item_num" />;
        }
        const nameIndex = columns.findIndex(column => column.key === 'Name');
        if(nameIndex !== -1) {
          columns[nameIndex].name = <Translate value="description" />;
          columns[nameIndex].width = 426;
        }
        const descriptionIndex = columns.findIndex(column => column.key === 'Description');
        if(descriptionIndex !== -1) {
          columns.splice(descriptionIndex, 1);
        }
      }

      const boolOptions = [
        'true',
        'false',
      ];

      const abcffColumn = (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') ? [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        }, {
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        }, {
          key: "UnitQuantity",
          name: <Translate value="unit_qty" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: 'Quantity',
          name: <Translate value="case_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true, // editSOPermission 
          formatter: BoldTextFormatter,
        }, {
          key: "PerBoxQty",
          name: <Translate value="unit/box" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: 'PalletQuantity',
          name: <Translate value="plt_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true, // editSOPermission
          formatter: BoldTextFormatter,
        }, {
          key: 'RepackedPalletQuantity',
          name: <Translate value="repack_plt_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: 'AvailableQuantity',
          name: <Translate value="available_box" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        }, {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'RefNum',
          name: isTN ? <Translate value="sku" /> : <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        }, {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        }, {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: 120,
        }, {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        }, {
          key: 'InnerLabelQty',
          name: <Translate value="inner_label" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true, // editSOPermission
          formatter: BoldTextFormatter,
        }, {
          key: 'OuterLabelQty',
          name: <Translate value="outer_label" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true, // editSOPermission
          formatter: BoldTextFormatter,
        }, {
          key: "FBACode",
          name: <Translate value="FBA-Code" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "FBARoute",
          name: <Translate value="FBA-Route" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "TrailerNum",
          name: <Translate value="trailer" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "POList",
          name: <Translate value="po_list" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "POD",
          name: <Translate value="pod" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
        }, {
          key: "DimUnit",
          name: <Translate value="dim_unit" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "WeightUnit",
          name: <Translate value="weight_unit" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "BoxLength",
          name: <Translate value="box_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxWidth",
          name: <Translate value="box_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxHeight",
          name: <Translate value="box_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxVol",
          name: <Translate value="box_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "BoxWeight",
          name: <Translate value="box_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "PalletLength",
          name: <Translate value="plt_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletWidth",
          name: <Translate value="plt_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletHeight",
          name: <Translate value="plt_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletVol",
          name: <Translate value="plt_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "PalletWeight",
          name: <Translate value="pallet_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "UnitLength",
          name: <Translate value="unit_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "UnitWidth",
          name: <Translate value="unit_w" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "UnitHeight",
          name: <Translate value="unit_h" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "UnitVol",
          name: <Translate value="unit_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "Location",
          name: <Translate value="location" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          formatter: ({ value, dependentValues }) => (
            <div
              style={{ width: "100%", height: "100%", textAlign: "center" }}
              onDoubleClick={() => {
                this.openZBLModal(value, dependentValues);
              }}
            >
              {value}
            </div>
          ),
          getRowMetaData: (row) => row,
        }, {
          key: "PalletStackable",
          name: <Translate value="stackable" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
        }, {
          key: "StoreReady",
          name: <Translate value="store_ready" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
        }, {
          key: "Preticketed",
          name: <Translate value="preticketed" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 120,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
        }, {
          key: "CantonNum",
          name: <Translate value="canton" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "OriginCountry",
          name: <Translate value="country" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "VendorStyleNum",
          name: <Translate value="vendor_style" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        }, {
          key: "TJXStyleNum",
          name: <Translate value="tjx_style" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        }, {
          key: "UPC",
          name: <Translate value="upc" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        }, {
          key: "Color",
          name: <Translate value="color" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        }, {
          key: "Size",
          name: <Translate value="size_ratio" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        }, {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: ((isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) ? false : true),
          formatter: BoldCashFormatter,
        }, {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
      ] : [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        }, {
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        }, {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'RefNum',
          name: isTN ? <Translate value="sku" /> : <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        }, {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        }, {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: 120,
        }, {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        }, {
          key: 'UnitQuantity',
          name: <Translate value="unit_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true, // editSOPermission
          formatter: BoldTextFormatter,
        }, {
          key: 'Quantity',
          name: <Translate value="case_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true, // editSOPermission
          formatter: BoldTextFormatter,
        }, {
          key: "PerBoxQty",
          name: <Translate value="unit_case" />,
          resizable: true,
          width: 80,
          sortable: true,
        }, {
          //
          key: "ReceivedCaseQty",
          name: <Translate value="received_case_qty" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          getRowMetaData: (row) => row,
          formatter: ({ value, dependentValues }) => (
            <div>
              {dependentValues.PerBoxQty ? dependentValues.ReceivedQuantity / dependentValues.PerBoxQty : ""}
            </div>
          ),
          editable: true, 
          // user use this to change ReceivedQuantity
          // received_case_qty = received_unit_qty / PerBoxQty
        }, {
          key: "ReceivedQuantity",
          name: <Translate value="received_unit_qty" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
        }, {
          key: 'PalletQuantity',
          name: <Translate value="plt_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true, // editSOPermission
          formatter: BoldTextFormatter,
        }, {
          key: "Location",
          name: <Translate value="location" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          formatter: ({ value, dependentValues }) => (
            <div
              style={{ width: "100%", height: "100%", textAlign: "center" }}
              onDoubleClick={() => {
                this.openZBLModal(value, dependentValues);
              }}
            >
              {value}
            </div>
          ),
          getRowMetaData: (row) => row,
        }, {
          key: "FBACode",
          name: <Translate value="fba_code" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "FBARoute",
          name: <Translate value="fba_route" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "TrailerNum",
          name: <Translate value="trailer" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "POList",
          name: <Translate value="po_list" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "POD",
          name: <Translate value="pod" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
        }, {
          key: "DimUnit",
          name: <Translate value="dim_unit" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "WeightUnit",
          name: <Translate value="weight_unit" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "BoxLength",
          name: <Translate value="box_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxWidth",
          name: <Translate value="box_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxHeight",
          name: <Translate value="box_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxVol",
          name: <Translate value="box_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "BoxWeight",
          name: <Translate value="box_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "PalletLength",
          name: <Translate value="plt_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletWidth",
          name: <Translate value="plt_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletHeight",
          name: <Translate value="plt_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletVol",
          name: <Translate value="pallet_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "UnitLength",
          name: <Translate value="unit_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "UnitWidth",
          name: <Translate value="unit_w" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "UnitHeight",
          name: <Translate value="unit_h" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "UnitVol",
          name: <Translate value="unit_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "PalletStackable",
          name: <Translate value="stackable" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
        }, {
          key: "StoreReady",
          name: <Translate value="store_ready" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
        }, {
          key: "Preticketed",
          name: <Translate value="preticketed" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 120,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
        }, {
          key: "CantonNum",
          name: <Translate value="canton" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "OriginCountry",
          name: <Translate value="country" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "VendorStyleNum",
          name: <Translate value="vendor_style" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        }, {
          key: "TJXStyleNum",
          name: <Translate value="tjx_style" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        }, {
          key: "UPC",
          name: <Translate value="upc" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        }, {
          key: "Color",
          name: <Translate value="color" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        }, {
          key: "Size",
          name: <Translate value="size_ratio" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        }, {
          key: "PalletWeight",
          name: <Translate value="pallet_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: ((isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) ? false : true),
          formatter: BoldCashFormatter,
        }, {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
      ];

      const kdwColumn = (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') ? [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        }, {
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        }, {
          key: 'Quantity',
          name: <Translate value="box_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: 'PalletQuantity',
          name: <Translate value="plt_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: 'AvailableQuantity',
          name: <Translate value="available_box" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        }, {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'RefNum',
          name: isTN ? <Translate value="sku" /> : <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        }, {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        }, {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: 120,
        }, {
          key: 'InnerLabelQty',
          name: <Translate value="inner_label" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: 'OuterLabelQty',
          name: <Translate value="outer_label" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: "FBACode",
          name: <Translate value="FBA-Code" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "FBARoute",
          name: <Translate value="FBA-Route" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "ShipmentID",
          name: <Translate value="shipment_id" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "ServiceType",
          name: <Translate value="service_type" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "ISANum",
          name: <Translate value="isa_num" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "CustomerRef",
          name: <Translate value="cust_ref#" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "Unloader",
          name: <Translate value="unloader" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "TruckVendor",
          name: <Translate value="truck_vendor" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "TrailerNum",
          name: <Translate value="trailer" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "POList",
          name: <Translate value="po_list" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "POD",
          name: <Translate value="pod" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
        }, {
          key: "DimUnit",
          name: <Translate value="dim_unit" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "WeightUnit",
          name: <Translate value="weight_unit" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "BoxLength",
          name: <Translate value="box_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxWidth",
          name: <Translate value="box_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxHeight",
          name: <Translate value="box_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxVol",
          name: <Translate value="box_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "BoxWeight",
          name: <Translate value="box_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "PalletLength",
          name: <Translate value="plt_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletWidth",
          name: <Translate value="plt_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletHeight",
          name: <Translate value="plt_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletVol",
          name: <Translate value="plt_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "PalletWeight",
          name: <Translate value="pallet_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: ((isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) ? false : true),
          formatter: BoldCashFormatter,
        }, {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
      ] : [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        }, {
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        }, {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'RefNum',
          name: isTN ? <Translate value="sku" /> : <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        }, {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        }, {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: 120,
        }, {
          key: 'Quantity',
          name: <Translate value="box_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: 'PalletQuantity',
          name: <Translate value="plt_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: "ReceivedQuantity",
          name: <Translate value="received_qty" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "Location",
          name: <Translate value="location" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          formatter: ({ value, dependentValues }) => (
            <div
              style={{ width: "100%", height: "100%", textAlign: "center" }}
              onDoubleClick={() => {
                this.openZBLModal(value, dependentValues);
              }}
            >
              {value}
            </div>
          ),
          getRowMetaData: (row) => row,
        }, {
          key: "FBACode",
          name: <Translate value="fba_code" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "FBARoute",
          name: <Translate value="fba_route" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: 'ShipmentID',
          name: <Translate value="shipment_id" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: 'ServiceType',
          name: <Translate value="service_type" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: 'ISANum',
          name: <Translate value="isa_num" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "CustomerRef",
          name: <Translate value="cust_ref#" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "Unloader",
          name: <Translate value="unloader" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "TruckVendor",
          name: <Translate value="truck_vendor" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "TrailerNum",
          name: <Translate value="trailer" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "POList",
          name: <Translate value="po_list" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "POD",
          name: <Translate value="pod" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
        }, {
          key: "DimUnit",
          name: <Translate value="dim_unit" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "WeightUnit",
          name: <Translate value="weight_unit" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "BoxLength",
          name: <Translate value="box_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxWidth",
          name: <Translate value="box_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxHeight",
          name: <Translate value="box_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxVol",
          name: <Translate value="box_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "BoxWeight",
          name: <Translate value="box_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "PalletLength",
          name: <Translate value="plt_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletWidth",
          name: <Translate value="plt_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletHeight",
          name: <Translate value="plt_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletVol",
          name: <Translate value="pallet_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "PalletWeight",
          name: <Translate value="pallet_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: ((isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) ? false : true),
          formatter: BoldCashFormatter,
        }, {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
      ];

      const yiColumn = (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') ? [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        }, {
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        }, {
          key: 'Quantity',
          name: <Translate value="box_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: 'PalletQuantity',
          name: <Translate value="plt_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: 'AvailableQuantity',
          name: <Translate value="available_box" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        }, {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'RefNum',
          name: isTN ? <Translate value="sku" /> : <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        }, {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        }, {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: 120,
        }, {
          key: 'InnerLabelQty',
          name: <Translate value="inner_label" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: 'OuterLabelQty',
          name: <Translate value="outer_label" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: "FBACode",
          name: <Translate value="FBA-Code" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "FBARoute",
          name: <Translate value="FBA-Route" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "TrailerNum",
          name: <Translate value="trailer" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "POList",
          name: <Translate value="po_list" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "POD",
          name: <Translate value="pod" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
        }, {
          key: "TotalShippingWeight",
          name: <Translate value="total_ship_wt" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "NMFCClass",
          name: <Translate value="nmfc" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "BoxLength",
          name: <Translate value="box_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxWidth",
          name: <Translate value="box_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxHeight",
          name: <Translate value="box_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxVol",
          name: <Translate value="box_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "BoxWeight",
          name: <Translate value="box_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "PalletLength",
          name: <Translate value="plt_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletWidth",
          name: <Translate value="plt_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletHeight",
          name: <Translate value="plt_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletVol",
          name: <Translate value="plt_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "PalletWeight",
          name: <Translate value="pallet_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          // editable: this.state.editSOPermission,
          editable: ((isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) ? false : true),
          formatter: BoldCashFormatter,
        }, {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
      ] : [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        }, {
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        }, {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'RefNum',
          name: isTN ? <Translate value="sku" /> : <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        }, {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        }, {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: 120,
        }, {
          key: 'Quantity',
          name: <Translate value="box_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: 'PalletQuantity',
          name: <Translate value="plt_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: "ReceivedQuantity",
          name: <Translate value="received_qty" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "FBACode",
          name: <Translate value="fba_code" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "FBARoute",
          name: <Translate value="fba_route" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "TrailerNum",
          name: <Translate value="trailer" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "POList",
          name: <Translate value="po_list" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "POD",
          name: <Translate value="pod" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
        }, {
          key: "TotalShippingWeight",
          name: <Translate value="total_ship_wt" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "NMFCClass",
          name: <Translate value="nmfc" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "BoxLength",
          name: <Translate value="box_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxWidth",
          name: <Translate value="box_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxHeight",
          name: <Translate value="box_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxVol",
          name: <Translate value="box_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "BoxWeight",
          name: <Translate value="box_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "PalletLength",
          name: <Translate value="plt_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletWidth",
          name: <Translate value="plt_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletHeight",
          name: <Translate value="plt_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletVol",
          name: <Translate value="pallet_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "PalletWeight",
          name: <Translate value="pallet_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: ((isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) ? false : true),
          formatter: BoldCashFormatter,
        }, {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
      ];

      const dsqColumn = (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') ? [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        }, {
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        }, {
          key: 'Quantity',
          name: <Translate value="box_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: 'PalletQuantity',
          name: <Translate value="plt_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: 'AvailableQuantity',
          name: <Translate value="available_box" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        }, {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'RefNum',
          name: isTN ? <Translate value="sku" /> : <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        }, {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        }, {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: 120,
        }, {
          key: 'InnerLabelQty',
          name: <Translate value="inner_label" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: 'OuterLabelQty',
          name: <Translate value="outer_label" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: "FBACode",
          name: <Translate value="FBA-Code" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "FBARoute",
          name: <Translate value="FBA-Route" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "TrailerNum",
          name: <Translate value="trailer" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "POList",
          name: <Translate value="po_list" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "POD",
          name: <Translate value="pod" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
        }, {
          key: "DimUnit",
          name: <Translate value="dim_unit" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "WeightUnit",
          name: <Translate value="weight_unit" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "BoxLength",
          name: <Translate value="box_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxWidth",
          name: <Translate value="box_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxHeight",
          name: <Translate value="box_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxVol",
          name: <Translate value="box_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "BoxWeight",
          name: <Translate value="box_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "PalletLength",
          name: <Translate value="plt_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletWidth",
          name: <Translate value="plt_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletHeight",
          name: <Translate value="plt_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletVol",
          name: <Translate value="plt_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "PalletWeight",
          name: <Translate value="pallet_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: ((isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) ? false : true),
          formatter: BoldCashFormatter,
        }, {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
      ] : [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        }, {
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        }, {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'RefNum',
          name: isTN ? <Translate value="sku" /> : <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        }, {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        }, {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: 120,
        }, {
          key: 'Quantity',
          name: <Translate value="box_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: 'PalletQuantity',
          name: <Translate value="plt_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: "ReceivedQuantity",
          name: <Translate value="received_qty" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "FBACode",
          name: <Translate value="fba_code" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "FBARoute",
          name: <Translate value="fba_route" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "TrailerNum",
          name: <Translate value="trailer" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "POList",
          name: <Translate value="po_list" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "POD",
          name: <Translate value="pod" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
        }, {
          key: "DimUnit",
          name: <Translate value="dim_unit" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "WeightUnit",
          name: <Translate value="weight_unit" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "BoxLength",
          name: <Translate value="box_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxWidth",
          name: <Translate value="box_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxHeight",
          name: <Translate value="box_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxVol",
          name: <Translate value="box_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "BoxWeight",
          name: <Translate value="box_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "PalletLength",
          name: <Translate value="plt_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletWidth",
          name: <Translate value="plt_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletHeight",
          name: <Translate value="plt_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletVol",
          name: <Translate value="pallet_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "PalletWeight",
          name: <Translate value="pallet_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: ((isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) ? false : true),
          formatter: BoldCashFormatter,
        }, {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
      ];

      const wizColumn = (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') ? [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        }, {
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        }, {
          key: 'Quantity',
          name: <Translate value="shipped_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: 'AvailableQuantity',
          name: <Translate value="available" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        }, {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'RefNum',
          name: <Translate value="sku" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        }, {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        }, {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: 120,
        }, {
          key: "FBACode",
          name: <Translate value="FBA" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "CustomerBoxQty",
          name: <Translate value="customer_box" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "OutsideLabelQty",
          name: <Translate value="outside_label" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "InsideLabelQty",
          name: <Translate value="inside_label" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "SpecialHandling",
          name: <Translate value="special_handling" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "CustomerNote",
          name: <Translate value="customer_note" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 150,
          editable: true,
        }, {
          key: "ReceivedQuantity",
          name: <Translate value="customer_qty" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "ShipmentID",
          name: <Translate value="shipment_id" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "BillablePallets",
          name: <Translate value="billable_pallets" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
        }, {
          key: "PalletQuantity",
          name: <Translate value="real_pallets" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "BoxPerPallet",
          name: <Translate value="box_per_plt" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "DispatchType",
          name: <Translate value="dispatch_type" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "BoxLength",
          name: <Translate value="box_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxWidth",
          name: <Translate value="box_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxHeight",
          name: <Translate value="box_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxVol",
          name: <Translate value="box_vol" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "BoxWeight",
          name: <Translate value="box_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "PalletWeight",
          name: <Translate value="pallet_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "PortDray",
          name: <Translate value="port_dray" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "Location",
          name: <Translate value="location" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          // editable: true,
          formatter: ({ value, dependentValues }) => (
            <div
              style={{ width: "100%", height: "100%", textAlign: "center" }}
              onDoubleClick={() => {
                this.openZBLModal(value, dependentValues);
              }}
            >
              {value}
            </div>
          ),
          getRowMetaData: (row) => row,
        }, {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: ((isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) ? false : true),
          formatter: BoldCashFormatter,
        }, {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="net_wt" />,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
        }, {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'TotalNetWeight',
          name: <Translate value="total_wt" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
      ] : [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        }, {
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        }, {
          key: 'Quantity',
          name: <Translate value="rcvd_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: "Location",
          name: <Translate value="location" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: 'RefNum',
          name: <Translate value="sku" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        }, {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        }, {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: 120,
        }, {
          key: "ReceivedQuantity",
          name: <Translate value="customer_qty" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "ShipmentID",
          name: <Translate value="customer_note" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "BillablePallets",
          name: <Translate value="billable_pallets" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
        }, {
          key: "PalletQuantity",
          name: <Translate value="real_pallets" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "BoxPerPallet",
          name: <Translate value="box_per_plt" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "DispatchType",
          name: <Translate value="warehouse_note" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "BoxLength",
          name: <Translate value="box_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxWidth",
          name: <Translate value="box_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxHeight",
          name: <Translate value="box_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxVol",
          name: <Translate value="box_vol" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "BoxWeight",
          name: <Translate value="box_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "PalletWeight",
          name: <Translate value="pallet_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "PortDray",
          name: <Translate value="port_dray" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "DrayageTrucker",
          name: <Translate value="drayage_trucker" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: ((isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) ? false : true),
          formatter: BoldCashFormatter,
        }, {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="net_wt" />,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
        }, {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'TotalNetWeight',
          name: <Translate value="total_wt" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
      ];

      const jtbColumn = (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') ? [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        },
        ...isHMM ? [{
          key: 'Order',
          name: <Translate value="positionIndex" />,
          resizable: true,
          sortable: true,
          editable: true,
          width: 70,
          filterable: true,
        }] : [{
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        }],
        {
          key: 'Quantity',
          name: <Translate value="qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: 'AvailableQuantity',
          name: <Translate value="available" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        }, {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        ...isABC ? [{
          key: 'RefNo',
          name: <Translate value="FBA_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'PoNo',
          name: <Translate value="pro_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }]: [],
        {
          key: 'RefNum',
          name: isTN ? <Translate value="sku" /> : <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: isJML ? 200 : 70,
          filterable: true,
        },
        ...isAFM ? [{
          key: 'Brand',
          name: <Translate value="brand" />,
          resizable: true,
          sortable: true,
          width: 100,
        }]: [],
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        }, {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: isChinaTown ? 200 : 85,
        }, {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: ((isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) ? false : true),
          formatter: BoldCashFormatter,
        }, {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'TotalNetWeight',
          name: <Translate value="total_wt" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
      ] : [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        },
        ...isHMM ? [{
          key: 'Order',
          name: <Translate value="positionIndex" />,
          resizable: true,
          sortable: true,
          editable: true,
          width: 70,
          filterable: true,
        }] : [{
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        }],
        {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        ...isABC ? [{
          key: 'RefNo',
          name: <Translate value="FBA_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'PoNo',
          name: <Translate value="pro_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }]: [],
        {
          key: 'RefNum',
          name: isTN ? <Translate value="sku" /> : <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: isJML ? 200 : 70,
          filterable: true,
        },
        ...isAFM ? [{
          key: 'Brand',
          name: <Translate value="brand" />,
          resizable: true,
          sortable: true,
          width: 100,
        }]: [],
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        }, {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: isChinaTown ? 200 : 85,
        }, {
          key: 'Quantity',
          name: <Translate value="qty" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: ((isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) ? false : true),
          formatter: BoldCashFormatter,
        }, {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="net_wt" />,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
        }, {
          key: 'TotalNetWeight',
          name: <Translate value="total_wt" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
      ];

      const fjColumn = (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') ? [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        }, {
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        }, {
          key: 'Quantity',
          name: <Translate value="qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: 'AvailableQuantity',
          name: <Translate value="available" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        }, {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        ...isABC ? [{
          key: 'RefNo',
          name: <Translate value="FBA_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'PoNo',
          name: <Translate value="pro_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }]: [],
        {
          key: 'RefNum',
          name: isTN ? <Translate value="sku" /> : <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: isJML ? 200 : 70,
          filterable: true,
        },
        ...isAFM ? [{
          key: 'Brand',
          name: <Translate value="brand" />,
          resizable: true,
          sortable: true,
          width: 100,
        }]: [],
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        }, {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: isChinaTown ? 200 : 85,
        }, {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: ((isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) ? false : true),
          formatter: BoldCashFormatter,
        }, {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="net_wt" />,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
        }, {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'TotalNetWeight',
          name: <Translate value="total_wt" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
      ] : [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        },
        ...isHMM ? [{
          key: 'Order',
          name: <Translate value="positionIndex" />,
          resizable: true,
          sortable: true,
          editable: true,
          width: 70,
          filterable: true,
        }] : [{
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        }],
        {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        ...isABC ? [{
          key: 'RefNo',
          name: <Translate value="FBA_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'PoNo',
          name: <Translate value="pro_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }]: [],
        {
          key: 'RefNum',
          name: isTN ? <Translate value="sku" /> : <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: isJML ? 200 : 70,
          filterable: true,
        },
        ...isAFM ? [{
          key: 'Brand',
          name: <Translate value="brand" />,
          resizable: true,
          sortable: true,
          width: 100,
        }]: [],
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        }, {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: isChinaTown ? 200 : 85,
        }, {
          key: 'Quantity',
          name: <Translate value="qty" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: ((isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) ? false : true),
          formatter: BoldCashFormatter,
        }, {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="net_wt" />,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
        }, {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'TotalNetWeight',
          name: <Translate value="total_wt" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
      ];

      const generateColumns = () => {
        if (isDSQ || isWUFS || isFBD) {
          return dsqColumn;
        }
        if (isYI) {
          return yiColumn;
        }
        if (isKDW) {
          return kdwColumn;
        }
        if (isABCFF) {
          return abcffColumn;
        }
        if (isWIZ) {
          return wizColumn;
        }
        if (isJTB) {
          return jtbColumn;
        }
        if (isFJ) {
          return fjColumn;
        }
        return columns
      }

      // Your Sales Order Table
      return (
        <Row>
          {(isEcity) &&
          <Col xs={12}>
            <div className="react-customizer" id="SalesOrderForm-dataGrid3">
              <ReactDataGrid
                rowKey="ProductNum"
                enableCellSelect
                onGridSort={handleGridSort}
                // columns={columns}
                columns={generateColumns()}
                rowHeight={isWIZ ? 40 : 25}
                headerRowHeight={45}
                minHeight={this.state.yourOrderTableHeight}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                onRowClick={onRowClick}
                onRowUpdated={handleRowUpdated}
                enableRowSelect="single"
                rowSelection={{
                  showCheckbox: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
              />
            </div>
          </Col>
          }
          {(!isChinaTown && !isFJ && !isEcity) &&
          <Col xs={12}>
            { 
              (isABCFF && this.context.router.routes[1].path === 'salesOrders/:id') &&
              <ButtonToolbar style={{float: 'right'}}>
                <Button
                  bsStyle="primary"
                  onClick={autoLoad} 
                >
                  <Translate value="auto_load" />
                </Button>
              </ButtonToolbar>
            }
            <div className="react-customizer" id="SalesOrderForm-dataGrid3">
              <ReactDataGrid
                rowKey="ProductNum"
                enableCellSelect
                onGridSort={handleGridSort}
                // columns={columns}
                columns={generateColumns()}
                rowHeight={(isWIZ || isABCFF) ? 40 : 25}
                headerRowHeight={45}
                minHeight={this.state.yourOrderTableHeight}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                onRowClick={onRowClick}
                onRowUpdated={handleRowUpdated}
              />
            </div>
          </Col>
          }
          {isChinaTown &&
          <Col xs={12}>
            <div className="react-customizer" id="SalesOrderForm-dataGrid3China">
              <ReactDataGrid
                rowKey="ProductNum"
                enableCellSelect
                onGridSort={handleGridSort}
                columns={columns}
                rowHeight={40}
                headerRowHeight={45}
                minHeight={this.state.yourOrderTableHeight}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                onRowClick={onRowClick}
                onRowUpdated={handleRowUpdated}
              />
            </div>
          </Col>
          }
          {isFJ &&
          <Col xs={12}>
            <div className="react-customizer" id="SalesOrderForm-dataGrid3">
              <ReactDataGrid
                rowKey="ProductNum"
                enableCellSelect
                onGridSort={handleGridSort}
                // columns={columns}
                columns={generateColumns()}
                rowHeight={25}
                headerRowHeight={45}
                minHeight={150}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                onRowClick={onRowClick}
                onRowUpdated={handleRowUpdated}
              />
            </div>
          </Col>
          }
        </Row>
      );
    }
    moveFavoritesToSO() {
      const {
        inventories, inventoryIdValue, quantityValue, favorites,
        available, inPurchase, preSale, salePrice, refPurchasePrice, unitPrice, description,
      } = this.props;
      const updatedInventories = [...this.state.inventories.allRows];
      const updatedFavorites = JSON.parse(JSON.stringify(this.state.favorites.rows));
      const rowsToAdd = JSON.parse(JSON.stringify(this.state.favorites.rows));
      const newRows = JSON.parse(JSON.stringify(this.state.rows));
      rowsToAdd.map((row) => {
        if (row.isSelected) {
          const check = _.findIndex(this.state.rows, { ProductNum: row.ProductNum });
          if (check == -1) {
            let index = _.findIndex(updatedInventories, { ProductNum: row.ProductNum });
            if (index > -1) {
              if (updatedInventories[index].InStock > 0 || selectedInventory.IsOverSaleable == true) {
                updatedInventories[index].inList = true;
              }
            }
            index = _.findIndex(updatedFavorites, { ProductNum: row.ProductNum });
            if (index > -1) {
              if (updatedFavorites[index].InStock > 0 || updatedFavorites[index].IsOverSaleable == true) {
                updatedFavorites[index].inList = true;
              }
            }
            if (row.InStock > 0 || row.IsOverSaleable == true || isHMM) {
              row.Quantity = 0;
              row.UnitPrice = row.RefPurchasingPrice;
              row.TotalPrice = 0;
              row.isSelected = false;
              row.TotalNetWeight = 0;
              row.Name = row.ProductName;
              const pos = _.findIndex(this.state.inventories.allRows, { Product_id: row.Product_id });
              if (pos > -1) {
                row.Weight = this.state.inventories.allRows[pos].Weight;
              }
              newRows.push(row);
              const favorites = { ...this.state.favorites, rows: updatedFavorites };
              const inventories = { ...this.state.inventories, allRows: updatedInventories };
              this.setState({ inventories, favorites, rows: newRows });
            } else {
              this.setState({ case: 'itemOutOfStock', confirmOpen: true });
            }
          } else {
            this.setState({ case: 'addingDuplicate', confirmOpen: true });
          }
        }
      });
    }

    barcodeScan() {
      const selectedInventoryRow = { ...this.state.selectedInventoryRow };
      const check = _.findIndex(this.state.rows, { ProductNum: selectedInventoryRow.ProductNum });
      if (check === -1) {
        // add product by scaning barcode
        this.moveToSO();
      } else {
        // update existing product
        let rows = [...this.state.rows];
        rows.map((row) => {
          if (row.ProductNum === selectedInventoryRow.ProductNum) {
            const addQty = +(row.Quantity) + 1;
            // more than product in stock
            if (addQty <= row.InStock || row.IsOverSaleable === true || isHMM) {
              row.Quantity = addQty;
              row.TotalNetWeight = roundTo(row.NetWeight * row.Quantity, 2);
              if (row.ProductType === 'Fixed') {
                row.TotalPrice = +roundToDecimals(row.UnitPrice * row.Quantity, 4).toFixed(4);
              } else {
                // row.TotalPrice = +roundToDecimals(row.unitPrice * weight * row.Quantity, 4).toFixed(4);
                row.TotalPrice = +roundToDecimals(row.UnitPrice * row.Quantity, 4).toFixed(4);
              }
              row.TotalCRV = +roundTo(parseFloat(row.Quantity) * parseFloat(row.CRV), 2).toFixed(2);
              row.TotalNetWeight = roundTo(row.NetWeight * row.Quantity, 2);
            } else {
              this.setState({
                case: 'itemOutOfStock',
                confirmOpen: true,
                selectedInventoryRow: {},
                inStock: '',
                purchased: '',
                presale: '',
                net_weight: '',
                suggestValue: '',
              });
              this.props.resetFormInputs();
              return;
            }
          }
        });
        this.setState({ rows });

        // update so detail
        let totalPrice = 0;
        let finalWeight = 0;
        let totalTax = 0;
        let totalTaxOriginal = 0;
        let totalCRV = 0;
        let index = 0;
        let discount = parseFloat(this.props.discount) || 0;
        rows = [...this.state.rows];
        index = rows.length;
        rows.map((row) => {
          row.Index = index;
          index--;
          totalCRV = (parseFloat(row.TotalCRV) || 0) + (+roundTo(parseFloat(totalCRV), 2).toFixed(2));
          if (row.IsTaxable === true) {
            if (isHMM) {
              totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(this.state.taxValue / 100);
            } else {
              if(isAN || isElegant) {
                let taxable = !this.props.salesCustomerDetails.Reseller;
                if (taxable) {
                  taxable = row.IsAllTaxable === true || !this.props.salesCustomerDetails.Reseller;
                }
                if(taxable) {
                  totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
                }
              } else {
                totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
              }
            }
          }
          if (isHMM) {
            totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
          } else {
            totalPrice += parseFloat(row.TotalPrice);
          }          
          if (row.TotalNetWeight != null) {
            finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight);
          }
          finalWeight = Math.round(0.00001 + finalWeight * 100) / 100;
        });
        totalTaxOriginal = totalTax = +roundTo(totalTax, 2).toFixed(2);
        if (isElegant) {
          discount = parseFloat(this.state.SODiscount) || (parseFloat(this.state.SOSavings) / totalPrice) * 100 || 0;
          totalTax = +roundTo((1 - (discount / 100)) * totalTax, 2).toFixed(2);
        }
        finalWeight = Math.round(0.00001 + finalWeight * 100) / 100;
        totalPrice = +roundToDecimals(totalPrice, 4).toFixed(4);
        totalCRV = +roundTo(totalCRV, 2).toFixed(2);
        const finalPrice = +roundTo(totalPrice * (1 - discount / 100) + totalTax + totalCRV, 2).toFixed(2);
        // finalPrice = Math.round(0.00001 + finalPrice * 100) / 100;

        this.setState({
          rows,
          editing: true,
          finalPrice,
          totalPrice,
          totalTax,
          totalTaxOriginal,
          totalCRV,
          finalWeight,
          selectedInventoryRow: {},
          inStock: '',
          purchased: '',
          presale: '',
          net_weight: '',
          ship_weight: '',
          total_weight: '',
          suggestValue: '',
        });
        this.props.resetFormInputs();
        this.setAllProductQuantity(1);
      }
    }

    handleVerifyPasscodeClose = (confirmed) => {
      this.closeVerifyPasscode();
      if(!confirmed) {
        return;
      }
      this.moveToSO('move', confirmed);
    }

    handleVerifyPasscodeCloseDiscount = (confirmed) => {
      this.closeVerifyPasscodeDiscount();
      if (!confirmed) {
        return;
      }
      this.openDiscountModal();
    }

    checkMoveToSo() {
      const selectedInventoryRow = { ...this.state.selectedInventoryRow };
      const check = _.findIndex(this.state.rows, { ProductNum: selectedInventoryRow.ProductNum });
      if (check === -1 || isTN) {
        this.moveToSO();
      } else {
        let { unitPrice } = this.props;
        const selectedInventoryRow = { ...this.state.selectedInventoryRow };
        if ( isOCM && unitPrice < selectedInventoryRow.LowestSalePrice ) {
          this.setState({ case: 'belowLowestSalePriceAndDuplicate', confirmOpen: true });
        } else {
          this.setState({ case: 'addingDuplicate', confirmOpen: true });
        }
      }
    }
    moveToSO() {
      if (isEcity && this.state.case === 'addingDuplicate' ) {
        this.findDuplicate();
      } else {
        const eCityItemPriceTrick = (row) => {
          let priceDisplay = 0;
          switch(this.state.customerPriceLevel) {
            case 1:
              priceDisplay = row.RefPrice;
              break;
            case 2:
              priceDisplay = row.PriceLv1;
              break;
            case 3:
              priceDisplay = row.PriceLv2;
              break;
            default:
              priceDisplay = row.PriceLv1;
              break;
          }
          return priceDisplay;
        }
        if (this.state.selectedInventoryRow.Product_id == null) {
          this.setState({ case: 'chooseProduct', confirmOpen: true});
          return;
        }
        let {
          inventories, inventoryIdValue, quantityValue, favorites, weight,
          available, inPurchase, preSale, salePrice, refPurchasePrice, unitPrice, description, notation, itemNotation,
        } = this.props;
        const selectedInventoryRow = { ...this.state.selectedInventoryRow };
        
        if (!isJTB && unitPrice < selectedInventoryRow.LowestSalePrice && arguments[0] !== 'move') {
          this.setState({ case: 'belowLowestSalePrice', confirmOpen: true });
          return;
        }
        if((isHMM) && unitPrice < selectedInventoryRow.LowestSalePrice && arguments[0] === 'move' && !arguments[1]) {
          this.openVerifyPasscode();
          return;
        }
        // if(isEcity && !this.props.salesCustomerDetails.GoodCredit && !this.state.customerVerified) {
        //   if(!arguments[2]) {
        //     this.openVerifyPasscodeToCreaterSO();
        //     return
        //   }
        // }
        let totalPrice = 0;
        let finalWeight = 0;
        let totalTax = 0;
        let totalTaxOriginal = 0;
        let totalCRV = 0;
        let index = 0;
        let discount = parseFloat(this.props.discount) || 0;
        // const check = _.findIndex(this.state.rows, { ProductNum: selectedInventoryRow.ProductNum });
        if (quantityValue === undefined) { quantityValue = 0; }
        // if (check == -1) {
        if (((selectedInventoryRow.InStock - (isHMM ? 0 : selectedInventoryRow.PreSale)) > 0 && quantityValue <= (selectedInventoryRow.InStock-(isHMM ? 0 : selectedInventoryRow.PreSale))) || selectedInventoryRow.IsOverSaleable === true || isHMM || isAFG) {
          selectedInventoryRow.Quantity = quantityValue;
          selectedInventoryRow.UnitPrice = this.props.unitPrice;
          selectedInventoryRow.TotalNetWeight = roundTo(selectedInventoryRow.NetWeight * selectedInventoryRow.Quantity, 2);
          if (selectedInventoryRow.ProductType === 'Fixed') {
            selectedInventoryRow.TotalPrice = +roundToDecimals(this.props.unitPrice * quantityValue, 4).toFixed(4);
          } else {
            selectedInventoryRow.TotalPrice = +roundToDecimals(this.props.unitPrice * weight * quantityValue, 4).toFixed(4);
          }
          // if (isJML && selectedInventoryRow.ProductType === 'Non-Fixed') {
          //   selectedInventoryRow.TotalPrice = +roundToDecimals(this.props.unitPrice * this.props.PackageSize_1 * quantityValue, 4).toFixed(4);
          // }
          selectedInventoryRow.TotalCRV = +roundTo(parseFloat(selectedInventoryRow.Quantity) * parseFloat(selectedInventoryRow.CRV), 2).toFixed(2);
          selectedInventoryRow.TotalNetWeight = roundTo(selectedInventoryRow.NetWeight * selectedInventoryRow.Quantity, 2);
          selectedInventoryRow.Weight = this.props.weight;
          selectedInventoryRow.Remark = itemNotation;
          // if (isWIZ) {
            if (this.props) {
            selectedInventoryRow.ReceivedQuantity = this.props.ReceivedQuantity;
            selectedInventoryRow.ShipmentID = this.props.ShipmentID;
            selectedInventoryRow.BillablePallets = this.props.BillablePallets;
            selectedInventoryRow.RealPallets = this.props.RealPallets;
            selectedInventoryRow.BoxPerPallet = this.props.BoxPerPallet;
            selectedInventoryRow.DispatchType = this.props.DispatchType;
            selectedInventoryRow.BoxVol = this.props.BoxVol;
            selectedInventoryRow.BoxHeight = this.props.BoxHeight;
            selectedInventoryRow.BoxWidth = this.props.BoxWidth;
            selectedInventoryRow.InnerLabelQty = this.props.InnerLabelQty;
            selectedInventoryRow.OuterLabelQty = this.props.OuterLabelQty;
            selectedInventoryRow.BoxLength = this.props.BoxLength;
            selectedInventoryRow.BoxWeight = this.props.BoxWeight;
            selectedInventoryRow.RepackedPalletQuantity = this.props.RepackedPalletQuantity;
            selectedInventoryRow.PalletHeight = this.props.PalletHeight;
            selectedInventoryRow.PalletWidth = this.props.PalletWidth;
            selectedInventoryRow.PalletLength = this.props.PalletLength;
            selectedInventoryRow.PalletVol = this.props.PalletVol;
            selectedInventoryRow.PalletWeight = this.props.PalletWeight;

            selectedInventoryRow.UnitQuantity = this.props.UnitQuantity;
            selectedInventoryRow.PerBoxQty = this.props.PerBoxQty;
            selectedInventoryRow.UnitLength = this.props.UnitLength;
            selectedInventoryRow.UnitWidth = this.props.UnitWidth;
            selectedInventoryRow.UnitHeight = this.props.UnitHeight;
            selectedInventoryRow.UnitVol = this.props.UnitVol;

            selectedInventoryRow.IsOversize = this.props.IsOversize;
            selectedInventoryRow.IsOverweight = this.props.IsOverweight;
            selectedInventoryRow.PortDray = this.props.PortDray;
            selectedInventoryRow.DrayageTrucker = this.props.DrayageTrucker;
            selectedInventoryRow.Location = this.props.Location;
            selectedInventoryRow.WarehouseLocation = this.props.WarehouseLocation;
            selectedInventoryRow.FBACode = this.props.FBACode;
            selectedInventoryRow.PalletQuantity = this.props.PalletQuantity;
            selectedInventoryRow.BoxQuantity = this.props.BoxQuantity;
            selectedInventoryRow.PieceQuantity = this.props.PieceQuantity;
            selectedInventoryRow.TotalShippingWeight = this.props.TotalShippingWeight;
            selectedInventoryRow.NMFCClass = this.props.NMFCClass;
            selectedInventoryRow.FBARoute = this.props.FBARoute;
            selectedInventoryRow.DimUnit = this.props.DimUnit;
            selectedInventoryRow.ServiceType = this.props.ServiceType;
            selectedInventoryRow.ISANum = this.props.ISANum;
            selectedInventoryRow.CustomerRef = this.props.CustomerRef;
            selectedInventoryRow.Unloader = this.props.Unloader;
            selectedInventoryRow.TruckVendor = this.props.TruckVendor;

            // selectedInventoryRow.VendorStyleNum = this.props.VendorStyleNum;
            // selectedInventoryRow.TJXStyleNum = this.props.TJXStyleNum;
            // selectedInventoryRow.LineDescription = this.props.LineDescription;
            // selectedInventoryRow.UPC = this.props.UPC;
            // selectedInventoryRow.Color = this.props.Color;
            // selectedInventoryRow.Size = this.props.Size;
            // selectedInventoryRow.TotalUnits = this.props.TotalUnits;
            selectedInventoryRow.StoreReady = this.props.StoreReady;
            selectedInventoryRow.PalletStackable = this.props.PalletStackable;
            selectedInventoryRow.Preticketed = this.props.Preticketed;
            selectedInventoryRow.CantonNum = this.props.CantonNum;
            selectedInventoryRow.OriginCountry = this.props.OriginCountry;


            selectedInventoryRow.PackageSize_1 = this.props.PackageSize_1;
            selectedInventoryRow.jmlBox = this.props.jmlBox;
            selectedInventoryRow.jmlPackageSize1 = this.props.PackageSize_1;

            selectedInventoryRow.CustomerBoxQty = this.props.CustomerBoxQty;
            selectedInventoryRow.OutsideLabelQty = this.props.OutsideLabelQty;
            selectedInventoryRow.InsideLabelQty = this.props.InsideLabelQty;
            selectedInventoryRow.SpecialHandling = this.props.SpecialHandling;
            selectedInventoryRow.CustomerNote = this.props.CustomerNote;

            selectedInventoryRow.WeightUnit = this.props.WeightUnit;
            selectedInventoryRow.TrailerNum = this.props.TrailerNum;
            selectedInventoryRow.POList = this.props.POList;
            selectedInventoryRow.POD = this.props.POD;
            if (isOCM) {
              selectedInventoryRow.Batch_id = this.state.Batch_id;
              selectedInventoryRow.BatchExpiredDate = this.state.BatchExpiredDate;
            }
            if (isTN) {
              selectedInventoryRow.Batch_id = this.state.Batch_id;
              selectedInventoryRow.pallet_barcode = this.state.pallet_barcode;
            }
          }
          // }
          if (isEcity) selectedInventoryRow.ProductCost = eCityItemPriceTrick(selectedInventoryRow);
        } else {
          this.setState({
            case: 'itemOutOfStock',
            confirmOpen: true,
            selectedInventoryRow: {},
            inStock: '',
            purchased: '',
            presale: '',
            net_weight: '',
            suggestValue: '',
          });
          this.props.resetFormInputs();
          return;
        }
        const rows = [...this.state.rows];
        if (isHMM) {
          let maxPosition = 0;
          rows.forEach((row) => {
            if (row.Order > maxPosition) {
              maxPosition = row.Order;
            }
          });
          rows.push({ ...selectedInventoryRow, Order: maxPosition + 1 });
        } else {
          rows.unshift(selectedInventoryRow);
        }
        // rows.unshift(selectedInventoryRow);
        index = rows.length;
        rows.map((row) => {
          row.Index = index;
          index--;
          totalCRV = (parseFloat(row.TotalCRV) || 0) + (+roundTo(parseFloat(totalCRV), 2).toFixed(2));
          if (row.IsTaxable === true) {
            if(isHMM) {
              totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(this.state.taxValue / 100);
            } else {
              if(isAN || isElegant) {
                let taxable = !this.props.salesCustomerDetails.Reseller;
                if (isAN) {
                  taxable = row.IsAllTaxable === true || !this.props.salesCustomerDetails.Reseller;
                }
                if(taxable) {
                  totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
                }
              } else {
                totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
              }
            }
          }
          if(isHMM) {
            totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
          } else {
            totalPrice += parseFloat(row.TotalPrice);
          }
          if (row.TotalNetWeight != null) {
            finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight);
          }
          finalWeight = Math.round(0.00001 + finalWeight * 100) / 100;
        });
        totalTaxOriginal = totalTax = +roundTo(totalTax, 2).toFixed(2);
        if (isElegant) {
          discount = parseFloat(this.state.SODiscount) || (parseFloat(this.state.SOSavings) / totalPrice) * 100 || 0;
          totalTax = +roundTo((1 - (discount / 100)) * totalTax, 2).toFixed(2);
        }
        finalWeight = Math.round(0.00001 + finalWeight * 100) / 100;
        totalPrice = +roundToDecimals(totalPrice, 4).toFixed(4);
        totalCRV = +roundTo(totalCRV, 2).toFixed(2);
        const finalPrice = +roundTo(totalPrice * (1 - discount / 100) + totalTax + totalCRV, 2).toFixed(2);
        // finalPrice = Math.round(0.00001 + finalPrice * 100) / 100;
        this.setState({
          rows,
          editing: true,
          finalPrice,
          totalPrice,
          totalTax,
          totalTaxOriginal,
          totalCRV,
          finalWeight,
          selectedInventoryRow: {},
          inStock: '',
          purchased: '',
          presale: '',
          net_weight: '',
          ship_weight: '',
          total_weight: '',
          suggestValue: '',
        }, () => {
          this.checkForPromotions(selectedInventoryRow.ProductNum);
        });
        // }
        this.props.resetFormInputs();
        this.setAllProductQuantity(1);
      }
    }
    
    checkMoveToSo2() {
      const selectedInventoryRow = { ...this.state.selectedInventoryRow };
      
      const check = _.findIndex(this.state.rows, { ProductNum: selectedInventoryRow.ProductNum });
      if (check === -1 || isTN || isJML) {
        this.moveToSO2();
      } else {
        let { unitPrice } = this.props;
        const selectedInventoryRow = { ...this.state.selectedInventoryRow };        
        if ( isOCM && unitPrice < selectedInventoryRow.LowestSalePrice ) {
          this.setState({ case: 'belowLowestSalePriceAndDuplicate', confirmOpen: true });
        } else {
          this.setState({ case: 'addingDuplicate', confirmOpen: true });
        }
      }
    }
    moveToSO2() {
      if (isEcity && this.state.case === 'addingDuplicate' ) {
        this.findDuplicate();
      } else {
        const eCityItemPriceTrick = (row) => {
          let priceDisplay = 0;
          switch(this.state.customerPriceLevel) {
            case 1:
              priceDisplay = row.RefPrice;
              break;
            case 2:
              priceDisplay = row.PriceLv1;
              break;
            case 3:
              priceDisplay = row.PriceLv2;
              break;
            default:
              priceDisplay = row.PriceLv1;
              break;
          }
          return priceDisplay;
        }
        if (this.state.selectedInventoryRow.Product_id == null) {
          this.setState({ case: 'chooseProduct', confirmOpen: true});
          return;
        }
        let {
          inventories, inventoryIdValue, quantityValue, favorites, weight,
          available, inPurchase, preSale, salePrice, refPurchasePrice, unitPrice, description, notation, itemNotation,
        } = this.props;
        const selectedInventoryRow = { ...this.state.selectedInventoryRow };
        
        if (!isJTB && unitPrice < selectedInventoryRow.LowestSalePrice && arguments[0] !== 'move') {
          this.setState({ case: 'belowLowestSalePrice', confirmOpen: true });
          return;
        }
        if((isHMM) && unitPrice < selectedInventoryRow.LowestSalePrice && arguments[0] === 'move' && !arguments[1]) {
          this.openVerifyPasscode();
          return;
        }
        
        // if(isEcity && !this.props.salesCustomerDetails.GoodCredit && !this.state.customerVerified) {
        //   if(!arguments[2]) {
        //     this.openVerifyPasscodeToCreaterSO();
        //     return
        //   }
        // }
        let totalPrice = 0;
        let finalWeight = 0;
        let totalTax = 0;
        let totalTaxOriginal = 0;
        let totalCRV = 0;
        let index = 0;
        let discount = parseFloat(this.props.discount) || 0;
        // const check = _.findIndex(this.state.rows, { ProductNum: selectedInventoryRow.ProductNum });
        if (quantityValue === undefined) { quantityValue = 0; }
        // if (check == -1) {
        if (((selectedInventoryRow.InStock - (isHMM ? 0 : selectedInventoryRow.PreSale)) > 0 && (this.state.batchQty ? this.state.batchQty : quantityValue) <= (selectedInventoryRow.InStock-(isHMM ? 0 : selectedInventoryRow.PreSale))) || selectedInventoryRow.IsOverSaleable === true || isHMM || isAFG || isJML) {
          selectedInventoryRow.Quantity = this.state.batchQty;
          if(isJML) {
            selectedInventoryRow.Quantity = this.state.batchQty * this.state.batchPcs;
            selectedInventoryRow.jmlBox = this.state.batchQty;
            selectedInventoryRow.jmlPackageSize1 = this.state.batchPcs;
            selectedInventoryRow.SalesOrderLine_id = '';
          }
          // selectedInventoryRow.Quantity = quantityValue;
          if(isJML && this.props.unitPrice || !isJML) {
            selectedInventoryRow.UnitPrice = this.props.unitPrice;
          }
          if ((isTN) && this.state.lineQty) {
            selectedInventoryRow.UnitPrice = this.state.lineQty;
          }
          selectedInventoryRow.TotalNetWeight = roundTo(selectedInventoryRow.NetWeight * selectedInventoryRow.Quantity, 2);
          if (selectedInventoryRow.ProductType === 'Fixed') {
            selectedInventoryRow.TotalPrice = +roundToDecimals(selectedInventoryRow.UnitPrice * selectedInventoryRow.Quantity, 4).toFixed(4);
          } else {
            selectedInventoryRow.TotalPrice = +roundToDecimals(selectedInventoryRow.UnitPrice * (!isJML ? weight : selectedInventoryRow.PackageSize_1) * quantityValue, 4).toFixed(4);
          }
          selectedInventoryRow.TotalCRV = +roundTo(parseFloat(selectedInventoryRow.Quantity) * parseFloat(selectedInventoryRow.CRV), 2).toFixed(2);
          selectedInventoryRow.TotalNetWeight = roundTo(selectedInventoryRow.NetWeight * selectedInventoryRow.Quantity, 2);
          selectedInventoryRow.Weight = this.props.weight;
          selectedInventoryRow.Remark = itemNotation;
          // if (isWIZ) {
          if (this.props) {
            selectedInventoryRow.ReceivedQuantity = this.props.ReceivedQuantity;
            selectedInventoryRow.ShipmentID = this.props.ShipmentID;
            selectedInventoryRow.ServiceType = this.props.ServiceType;
            selectedInventoryRow.CustomerRef = this.props.CustomerRef;
            selectedInventoryRow.Unloader = this.props.Unloader;
            selectedInventoryRow.TruckVendor = this.props.TruckVendor;
            selectedInventoryRow.ISANum = this.props.ISANum;
            selectedInventoryRow.BillablePallets = this.props.BillablePallets;
            selectedInventoryRow.RealPallets = this.props.RealPallets;
            selectedInventoryRow.BoxPerPallet = this.props.BoxPerPallet;
            selectedInventoryRow.DispatchType = this.props.DispatchType;
            selectedInventoryRow.BoxVol = this.props.BoxVol;
            selectedInventoryRow.BoxHeight = this.props.BoxHeight;
            selectedInventoryRow.BoxWidth = this.props.BoxWidth;
            selectedInventoryRow.InnerLabelQty = this.props.InnerLabelQty;
            selectedInventoryRow.OuterLabelQty = this.props.OuterLabelQty;
            selectedInventoryRow.BoxLength = this.props.BoxLength;
            selectedInventoryRow.BoxWeight = this.props.BoxWeight;
            selectedInventoryRow.RepackedPalletQuantity = this.props.RepackedPalletQuantity;
            selectedInventoryRow.PalletHeight = this.props.PalletHeight;
            selectedInventoryRow.PalletWidth = this.props.PalletWidth;
            selectedInventoryRow.PalletLength = this.props.PalletLength;
            selectedInventoryRow.PalletVol = this.props.PalletVol;
            selectedInventoryRow.PalletWeight = this.props.PalletWeight;

            selectedInventoryRow.UnitQuantity = this.props.UnitQuantity;
            selectedInventoryRow.PerBoxQty = this.props.PerBoxQty;
            selectedInventoryRow.UnitLength = this.props.UnitLength;
            selectedInventoryRow.UnitWidth = this.props.UnitWidth;
            selectedInventoryRow.UnitHeight = this.props.UnitHeight;
            selectedInventoryRow.UnitVol = this.props.UnitVol;

            selectedInventoryRow.IsOversize = this.props.IsOversize;
            selectedInventoryRow.IsOverweight = this.props.IsOverweight;
            selectedInventoryRow.PortDray = this.props.PortDray;
            selectedInventoryRow.DrayageTrucker = this.props.DrayageTrucker;
            selectedInventoryRow.Location = this.props.Location;
            selectedInventoryRow.WarehouseLocation = this.props.WarehouseLocation;
            selectedInventoryRow.FBACode = this.props.FBACode;
            selectedInventoryRow.PalletQuantity = this.props.PalletQuantity;
            selectedInventoryRow.BoxQuantity = this.props.BoxQuantity;
            selectedInventoryRow.PieceQuantity = this.props.PieceQuantity;
            selectedInventoryRow.TotalShippingWeight = this.props.TotalShippingWeight;
            selectedInventoryRow.NMFCClass = this.props.NMFCClass;
            selectedInventoryRow.FBARoute = this.props.FBARoute;
            selectedInventoryRow.DimUnit = this.props.DimUnit;
            selectedInventoryRow.IsNoReturn = this.props.IsNoReturn;
            // selectedInventoryRow.VendorStyleNum = this.props.VendorStyleNum;
            // selectedInventoryRow.TJXStyleNum = this.props.TJXStyleNum;
            // selectedInventoryRow.LineDescription = this.props.LineDescription;
            // selectedInventoryRow.UPC = this.props.UPC;
            // selectedInventoryRow.Color = this.props.Color;
            // selectedInventoryRow.Size = this.props.Size;
            // selectedInventoryRow.TotalUnits = this.props.TotalUnits;
            selectedInventoryRow.StoreReady = this.props.StoreReady;
            selectedInventoryRow.PalletStackable = this.props.PalletStackable;
            selectedInventoryRow.Preticketed = this.props.Preticketed;
            selectedInventoryRow.CantonNum = this.props.CantonNum;
            selectedInventoryRow.OriginCountry = this.props.OriginCountry;
            selectedInventoryRow.CustomerBoxQty = this.props.CustomerBoxQty;
            selectedInventoryRow.OutsideLabelQty = this.props.OutsideLabelQty;
            selectedInventoryRow.InsideLabelQty = this.props.InsideLabelQty;
            selectedInventoryRow.SpecialHandling = this.props.SpecialHandling;
            selectedInventoryRow.CustomerNote = this.props.CustomerNote;
            selectedInventoryRow.WeightUnit = this.props.WeightUnit;
            selectedInventoryRow.TrailerNum = this.props.TrailerNum;
            selectedInventoryRow.POList = this.props.POList;
            selectedInventoryRow.POD = this.props.POD;
            if (isOCM || isJML) {
              selectedInventoryRow.Batch_id = this.state.Batch_id;
              if(isJML) {
                selectedInventoryRow.Batch_id_id = this.state.Batch_id;
              }
              selectedInventoryRow.BatchExpiredDate = this.state.BatchExpiredDate;
            }
            if (isTN) {
              selectedInventoryRow.Batch_id = this.state.Batch_id;
              selectedInventoryRow.pallet_barcode = this.state.pallet_barcode;
              
            }
          }
          // }
          if (isEcity) selectedInventoryRow.ProductCost = eCityItemPriceTrick(selectedInventoryRow);
        } else {
          this.setState({
            case: 'itemOutOfStock',
            confirmOpen: true,
            selectedInventoryRow: {},
            inStock: '',
            inStockWarehouse: '',
            purchased: '',
            presale: '',
            net_weight: '',
            suggestValue: '',
            lineBatchId:'',
            lineBatchIdx:'',
            lineBatchRows:[],
            lineQty: 0,
            batchPcs:0,
          });
          this.props.resetFormInputs();
          return;
        }
        const rows = [...this.state.rows];
        if (isHMM) {
          let maxPosition = 0;
          rows.forEach((row) => {
            if (row.Order > maxPosition) {
              maxPosition = row.Order;
            }
          });
          rows.push({ ...selectedInventoryRow, Order: maxPosition + 1 });
        } else {
          rows.unshift(selectedInventoryRow);
        }
        // rows.unshift(selectedInventoryRow);
        index = rows.length;
        rows.map((row) => {
          row.Index = index;
          index--;
          totalCRV = (parseFloat(row.TotalCRV) || 0) + (+roundTo(parseFloat(totalCRV), 2).toFixed(2));
          if (row.IsTaxable === true) {
            if(isHMM) {
              totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(this.state.taxValue / 100);
            } else {
              if(isAN || isElegant) {
                let taxable = !this.props.salesCustomerDetails.Reseller;
                if (isAN) {
                  taxable = row.IsAllTaxable === true || !this.props.salesCustomerDetails.Reseller
                }
                if(taxable) {
                  totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
                }
              } else {
                totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
              }
            }
          }
          if(isHMM) {
            totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
          } else {
            totalPrice += parseFloat(row.TotalPrice);
          }
          if (row.TotalNetWeight != null) {
            finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight);
          }
          finalWeight = Math.round(0.00001 + finalWeight * 100) / 100;
        });
        totalTaxOriginal = totalTax = +roundTo(totalTax, 2).toFixed(2);
        if (isElegant) {
          discount = parseFloat(this.state.SODiscount) || (parseFloat(this.state.SOSavings) / totalPrice) * 100 || 0;
          totalTax = +roundTo((1 - (discount / 100)) * totalTax, 2).toFixed(2);
        }
        finalWeight = Math.round(0.00001 + finalWeight * 100) / 100;
        totalPrice = +roundToDecimals(totalPrice, 4).toFixed(4);
        totalCRV = +roundTo(totalCRV, 2).toFixed(2);
        const finalPrice = +roundTo(totalPrice * (1 - discount / 100) + totalTax + totalCRV, 2).toFixed(2);
        // finalPrice = Math.round(0.00001 + finalPrice * 100) / 100;
        this.setState({
          rows,
          editing: true,
          finalPrice,
          totalPrice,
          totalTax,
          totalTaxOriginal,
          totalCRV,
          finalWeight,
          // selectedInventoryRow: {},
          // inStock: '',
          // purchased: '',
          // presale: '',
          // net_weight: '',
          // ship_weight: '',
          // total_weight: '',
          // suggestValue: '',
        });
        // }
        // this.props.resetFormInputs();
        // this.setAllProductQuantity(1);
      }
    }

    findDuplicate() {
      const selectedInventoryRow = { ...this.state.selectedInventoryRow };
      const check = _.findIndex(this.state.rows, { ProductNum: selectedInventoryRow.ProductNum });
      const newRows = this.state.rows;
      newRows.map((r) => {
        r.isSelected = false;
      });
      if (check > -1) {
        newRows[check].isSelected = true;
      }
      this.setState({ ...this.state, rows: newRows });
    }

    renderSelectedItem() {
      return (
        <Row>
          <Col xs={3}>
            <label><Translate value="item_no" /></label>
          </Col>
          <Col xs={3}>
            <label className="col-xs-5 centerStyle">{this.state.selectedItemNumber}</label>
          </Col>
          <Col xs={3}>
            <label><Translate value="item_name" /></label>
          </Col>
          <Col xs={3}>
            <label className="col-xs-5 centerStyle">{this.state.selectedItemName}</label>
          </Col>
        </Row>
      );
    }

    formatDate(date) {
      let formattedDate = `${date.getFullYear()}-`;
      formattedDate += `${date.getMonth() + 1}-`;
      if (date.getDate() < 10) {
        formattedDate += `0${date.getDate()}T`;
      } else {
        formattedDate += `${date.getDate()}T`;
      }
      if (date.getHours() < 10) {
        formattedDate += `0${date.getHours()}:`;
      } else {
        formattedDate += `${date.getHours()}:`;
      }
      if (date.getMinutes() < 10) {
        formattedDate += `0${date.getMinutes()}:`;
      } else {
        formattedDate += `${date.getMinutes()}:`;
      }
      if (date.getSeconds < 10) {
        formattedDate += `0${date.getSeconds()}`;
      } else {
        formattedDate += date.getSeconds();
      }
      return formattedDate;
    }
    handleKeyPress = (value, event) => {
      
      if (event.charCode === 13) {
        event.preventDefault();
        if (value == 'unitPrice' || value == 'itemNotation') {
          if ((!isNumeric(this.props.quantityValue) || this.props.quantityValue < 0) && value !== 'quantity') {
            return;
          }
        }
        // if (value === 'quantity' && this.state.selectedInventoryRow.InStock == null) {
        //   return;
        // }
        ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
      }
    }

    handleFocusQty = () => {
      if (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD) {
      ReactDOM.findDOMNode(this.refs.unitPrice.getRenderedComponent().myInput.refs.input).focus();
      ReactDOM.findDOMNode(this.refs.unitPrice.getRenderedComponent().myInput.refs.input).select();
      } else if (isJML) {
        ReactDOM.findDOMNode(this.refs.jmlBox.getRenderedComponent().myInput.refs.input).focus();
        ReactDOM.findDOMNode(this.refs.jmlBox.getRenderedComponent().myInput.refs.input).select();  
      } else {
        ReactDOM.findDOMNode(this.refs.quantity.getRenderedComponent().myInput.refs.input).focus();
        ReactDOM.findDOMNode(this.refs.quantity.getRenderedComponent().myInput.refs.input).select();
      }
    }

    handleKeyPressTargetInput(value, event) {
      if (event.keyCode === 13) {
        ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
      }
    }
    handleInventoryNumKeyPress(event) {
      if (event.charCode === 13) {
        if (this.state.inventories.rows.length > 0) {
          //           lastChild
          // :
          // div.react-grid-Cell__value
          // lastElementChild
          // :
          // div.react-grid-Cell__value
          // ReactDOM.findDOMNode(this["myRowNameForTest"].refs[0].refs.cell.lastChild).focus();
          const rows = this.state.inventories.rows;
          rows.map((row) => {
            row.isSelected = false;
          });
          rows[0].isSelected = true;
          const inventories = { ...this.state.inventories, rows };
          this.setState({ inventories, cellSelectEnabled: false });
          ReactDOM.findDOMNode(this.refs.testingIfThisWorks.refs.base.refs.viewPortContainer).focus();
        }
      }
    }
    handleUPKeyPress(event) {
      if (event.charCode === 13) {
        event.preventDefault();
        this.moveToSOButton.props.onClick();
        ReactDOM.findDOMNode(this.refs.inventory.getRenderedComponent().myInput.refs.input).focus();
      }
    }
    checkPermission(permission) {
      return false;
    }
    customerHeader() {
      return (
        <div>
          <h2 className="mt0"><Translate value="customer_information" /></h2>
        </div>
      );
    }
    inboundInformationHeader() {
      let type = "";
      if (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'salesOrders/:id') {
        type = "inbound";
      }
      if (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
        type = "outbound";
      }
      return (type==="inbound") ? (
        <div>
          <h2><Translate value="inbound_information" /></h2>
        </div>
      ) : (
        <div>
          <h2><Translate value="outbound_information" /></h2>
        </div>
      );
    }
    generalInformationHeader() {
      return (
        <div>
          <h2><Translate value="general_info" /></h2>
        </div>
      );
    }
    containerInformationHeader() {
      return (
        <div>
          <h2><Translate value="container_info" /></h2>
        </div>
      );
    }
    pickdropInformationHeader() {
      return (
        <div>
          <h2><Translate value="pickdrop_info" /></h2>
        </div>
      );
    }
    renderSubtotal() {
      let subtotal = 0;
      if (this.state.selectedInventoryRow && this.state.selectedInventoryRow.ProductType === 'Fixed') {
        if (this.props.quantityValue) {
          subtotal = (this.props.quantityValue * this.props.unitPrice).toFixed(2);
        }
      } else if (this.props.weight) {
        subtotal = (this.props.unitPrice * this.props.weight * this.props.quantityValue).toFixed(2);
      }
      // if (isJML && this.state.selectedInventoryRow && this.state.selectedInventoryRow.ProductType === 'Non-Fixed') { 
      //   subtotal = (this.props.PackageSize_1 * this.props.unitPrice * this.props.quantityValue).toFixed(2);
      // }
      if (isNaN(subtotal)) {
        subtotal = 0;
      }
      return (
        <Field name="Subtotal" component={DisabledInputField} placeholder={subtotal} />
      );
    }
    renderCustomerDetail() {
      const customerNameOptions = this.getCustomerNameOptions();
      const customerNumOptions = this.getCustomerNumOptions();
      const customerPhoneOptions = this.getCustomerPhoneOptions();
      const SelectionForCustomer = (this.props.currentSalesOrder) ? DisabledSelection : SelectionWithProps;
      // const fieldName = (this.context.router.routes[1].path === 'salesOrders/new') ? 'CustomerDetail_id' : 'Deliver_CustomerDetail_id';
      const addressOptions = this.getAddressOptions();
      const shippingPhoneOptions = this.getShippingPhoneOptions();
      const isMobile = this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id';
      return (
        <Col xs={7} id="customer-details">
          <h4><Translate value="customer" /></h4>
          <div className="form-group">
            {/* <label className="col-xs-3"><Translate value="name" /><span className="asteriksReq" >*</span> </label> */}
            <div id="customer-name-dropdown" className="col-xs-11">
             {
               isMobile ?
                <Field
                  name="Deliver_CustomerName"
                  withRef
                  ref="customer_name"
                  matchPos="any"
                  component={InputField}
                  onFocus={this.handleOnFocus}
                  disabled={true}
                  />
                :
                <Field
                  name="Deliver_Customer_id"
                  matchPos="any"
                  component={SelectionForCustomer}
                  ref="customer_name"
                  withRef
                  options={customerNameOptions}
                  placeholder={
                    <span>
                      <Translate value="name" />
                      <span className="asteriksReq" >*</span>
                    </span>
                  }
                  onSelect={ value => {
                    this.props.setValue('salesOrderForm', 'receivingCustomer', value.value);
                  }}
                  onInputKeyDown={(event) => {
                    if (event.keyCode === 13) {
                      const myField = document.getElementById('sales-auto-suggest');
                      if (myField) {
                        myField.select();
                      }
                    }
                  }}
                />
             }
            </div>
          </div>
          <div className="form-group">
            <label className="col-xs-3"><Translate value="cust_id" /></label>
            <div id="customer-id-dropdown" className="col-xs-8">
            {
              isMobile ?
              <Field
                name="Deliver_Customer_num"
                withRef
                // ref="quantity"
                component={InputField}
                onFocus={this.handleOnFocus}
                disabled={true}
              />
              :
              <Field
                name="Deliver_Customer_id"
                component={SelectionForCustomer}
                options={customerNumOptions}
                onInputKeyDown={(event) => {
                  if (event.keyCode === 13) {
                    const myField = document.getElementById('sales-auto-suggest');
                    if (myField) {
                      myField.select();
                    }
                  }
                }}
                matchPos="any"
                onSelect={ value => {
                  this.props.setValue('salesOrderForm', 'receivingCustomer', value.value);   
                }}
              />
            }
            </div>
          </div>
          <div className="form-group">
            <label className="col-xs-3"><Translate value="phone" /> #</label>
            <div id="customer-phone-dropdown" className="col-xs-8">
            {
              isMobile ?
              <Field
                name="Billing.Telephone"
                withRef
                // ref="quantity"
                component={InputField}
                onFocus={this.handleOnFocus}
                disabled={true}
              />
              :
              <Field
                name="Deliver_Customer_id"
                component={SelectionForCustomer}
                options={customerPhoneOptions}
                onInputKeyDown={(event) => {
                  if (event.keyCode === 13) {
                    const myField = document.getElementById('sales-auto-suggest');
                    if (myField) {
                      myField.select();
                    }
                  }
                }}
                matchPos="any"
                onSelect={ value => {
                  this.props.setValue('salesOrderForm', 'receivingCustomer', value.value);
                }}
              />
            }
            </div>
          </div>
          {
            isOCM &&
            <div>
              <div className="form-group">
                <label className="col-xs-3"><Translate value="company" /></label>
                <div id="customer-company-dropdown" className="col-xs-8">
                  <Field 
                    name="Company_id"
                    matchPos="any"
                    component={SelectionForCustomer}
                    options={this.state.companyOptions}
                    onSelect={ value => {
                      this.props.setValue('salesOrderForm', 'Company_id', value.value);
                    }}
                  />
                </div>
              </div>
              <div className="form-group">
                <label className="col-xs-3"><Translate value="warehouse" /></label>
                <div className="col-xs-8">
                  <Field
                    name="Pickup_Warehouse_id"
                    matchPos="any"
                    component={SelectionForCustomer}
                    options={this.state.warehouseOptions}
                    onSelect={ value => {
                      this.props.setValue('salesOrderForm', 'Pickup_Warehouse_id', value.value);                    }}
                    />
                </div>
              </div>
            </div>
          }
          {
            isFJ &&
            <div className="form-group">
              <label className="col-xs-3"><Translate value="agent" /></label>
              <div id="customer-phone-dropdown" className="col-xs-8">
                <Field name="Agent_id" matchPos="any" component={Selection} options={this.state.FJAgentOptions} />
              </div>
            </div>
          }
        </Col>
      );
      // }
    }
    
    renderCustomerDetailABC() {
      let { CompanyName } = this.state;
      const customerNameOptions = this.getCustomerNameOptions();
      const customerNumOptions = this.getCustomerNumOptions();
      const customerPhoneOptions = this.getCustomerPhoneOptions();
      const SelectionForCustomer = (this.props.currentSalesOrder) ? DisabledSelection : SelectionWithProps;
      const addressOptions = this.getAddressOptions();
      const shippingPhoneOptions = this.getShippingPhoneOptions();
      const isMobile = this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id';
      return (
        <Col xs={7} id="customer-details">
          <h4><Translate value="company" /></h4>
          <div className="form-group">
            {/* <label className="col-xs-3"><Translate value="name" /><span className="asteriksReq" >*</span> </label> */}
            <div id="customer-name-dropdown" className="col-xs-11">
              <Field
                name="CompanyName"
                withRef
                ref="customer_name"
                matchPos="any"
                component={InputField}
                onFocus={this.handleOnFocus}
                disabled={true}
                />
            </div>
          </div>
          <div className="form-group">
          </div>
          <div className="form-group">
          </div>
        </Col>
      );
    }

    openShippingInfoFormModal = () => {
      this.setState({
        shippingInfoModalVisibility: true,
      })
    }

    closeShippingInfoFormModal = () => {
      this.setState({
        shippingInfoModalVisibility: false,
      })
    }

    renderShippingAddressSelections() {
      const customerNameOptions = this.getCustomerNameOptions();
      const shippingContactOptions = this.getShippingContactOptions();
      const shippingPhoneOptions = this.getShippingPhoneOptions();
      const shippingNameOptions = this.getShippingNameOptions();
      const addressOptions = this.getAddressOptions();
      const isMobile = this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id';
      const fieldName = (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'outboundOrders/new') ? 'CustomerDetail_id' : 'Deliver_CustomerDetail_id';
      const mobileSalesUserShippingAddress = this.props.initialValues ? `${this.props.initialValues.Shipping.Street} ${this.props.initialValues.Shipping.City} ${this.props.initialValues.Shipping.State} ${this.props.initialValues.Shipping.Zip}` : null;
      // if (this.props.receivingCustomer && !this.props.shipperChosen && shippingPhoneOptions.length) {
      //   this.props.setValue('salesOrderForm', fieldName, shippingPhoneOptions[0].value);   
      // }
      return (
        <Col xs={6} id="customer-details">
          <div style={{ width: '300px', display: 'flex' }}>
          {
            isMobile ?
              <h4 onDoubleClick={this.openShippingInfoFormModal} style={{ textDecoration: 'underline' }}><Translate value="shipping_information" /></h4>
              :
              <h4><Translate value="shipping_information" /></h4>
          }
          { 
          (!isWIZ || !this.state.IsFBAAddress ) &&
            <Button
              id="shipping-info-add-button"
              type="button"
              onClick={() => {
                this.openShippingInfoEditModal()
              }
            }
              disabled={!this.props.receivingCustomer}
            >
              +
              {/* <Translate value="carrier" /> */}
            </Button>
          }
          { 
            (isWIZ && this.state.IsFBAAddress ) &&
              <Button
                id="shipping-info-add-button"
                type="button"
                onClick={() => {
                  this.openFBAEditModal()
                }
              }
                disabled={false}
              >
                +
              </Button>
          }
          {
            this.state.showCarrierButton &&
            <Button
              id="carrier-info-button"
              type="button"
              onClick={this.openCarrierInfoModal}
            >
              <Translate value="carrier" />
            </Button>
          }
          </div>
          {
            isWIZ &&
            <div className="form-group">
              <label className="col-xs-5">FBA Address</label>
              <div className="col-xs-7">
                <Field name="IsFBAAddress" checked={this.state.IsFBAAddress} component={CheckboxFormatter} handleOnClick={() => { this.setState({IsFBAAddress : !this.state.IsFBAAddress})}}/>
              </div>
            </div>
          }
          {
            (isWIZ && this.state.IsFBAAddress) &&
            <div>
              <div className="form-group">
                {/* <label className="col-xs-3"><Translate value="" /></label> */}
                <div id="fba-address-dropdown" className="col-xs-12">
                  <Field name="DestinationAddress" matchPos="any" component={Selection} options={this.state.FBAOptions} />
                </div>
              </div>
              <div className="form-group">
                <label className="col-xs-3"><Translate value="name" /></label>
                <div id="fba-address-dropdown" className="col-xs-9">
                  <Field name="DestinationAddress" matchPos="any" component={Selection} options={this.state.FBAOptions2} />
                </div>
              </div>
            </div>
          }
          { 
            (!isOCM && !isABCFF && (!isWIZ || !this.state.IsFBAAddress)) &&
            <div className="form-group">
              <div id="customer-name-dropdown" className="col-xs-11">
                {
                  isMobile ?
                  <Field
                    name="Shipping.FirstName"
                    withRef
                    // ref="quantity"
                    component={InputField}
                    onFocus={this.handleOnFocus}
                    disabled={true}
                  />
                  :
                  <Field
                    name="receivingCustomer"
                    matchPos="any"
                    placeholder={
                      <span>
                        <Translate value="customer" />
                        <span className="asteriksReq">*</span>
                      </span>
                    }
                    component={SelectionWithProps}
                    options={customerNameOptions}
                  />
                }
              </div>
            </div>
          }
          {
            (isHMM || isOCM || isABCFF) &&
              <div className="form-group">
                <label className="col-xs-3"><Translate value="receiver" /></label>
                <div id="customer-name-dropdown" className="col-xs-8">
                  <Field name={fieldName} matchPos="any" component={Selection} options={shippingNameOptions} />
                </div>
              </div>
          }
          { 
            (!isWIZ || !this.state.IsFBAAddress ) &&
              <div>
              {
                isMobile ?
                <div>
                  <div className="form-group">
                    <label className="col-xs-3"><Translate value="phone" /></label>
                    <div id="customer-id-dropdown" className="col-xs-8">
                      <Field
                        name="Shipping.Telephone"
                        withRef
                        // ref="quantity"
                        component={InputField}
                        onFocus={this.handleOnFocus}
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-xs-3"><Translate value="address" /></label>
                    <div className="col-xs-8">
                      <input style={{width: '100%', borderRadius: '5px', padding: '4px', border: '1px solid black', backgroundColor: '#CFD8DC'}} disabled value={mobileSalesUserShippingAddress}/>
                    </div>
                  </div>
                </div>
                :
                <div>
                  <div className="form-group">
                    <label className="col-xs-3"><Translate value="phone" /></label>
                    <div id="customer-id-dropdown" className="col-xs-8">
                      <Field name={fieldName} matchPos="any" component={Selection} options={shippingPhoneOptions} />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-xs-3"><Translate value="address" /></label>
                    <div className="col-xs-8">
                      <Field name={fieldName} matchPos="any" component={Selection} options={addressOptions} />
                    </div>
                  </div>
                </div>
              }
              { 
                (isNBT || isKM) &&
                  <div className="form-group">
                    <label className="col-xs-3"><Translate value="ssn" /></label>
                    <div className="col-xs-8">
                      <Field
                        name="Shipping.SSN"
                        withRef
                        component={InputField}
                        onFocus={this.handleOnFocus}
                        disabled={true}
                      />
                    </div>
                  </div>
                }
            </div>
          }
        </Col>
      );
    }
    
    renderShippingAddressSelectionsABC() {
      let { ShipTo } = this.state;
      const customerNameOptions = this.getCustomerNameOptions();
      const shippingContactOptions = this.getShippingContactOptions();
      const shippingPhoneOptions = this.getShippingPhoneOptions();
      const shippingNameOptions = this.getShippingNameOptions();
      const addressOptions = this.getAddressOptions();
      const isMobile = this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id';
      const fieldName = (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'outboundOrders/new') ? 'CustomerDetail_id' : 'Deliver_CustomerDetail_id';
      const mobileSalesUserShippingAddress = this.props.initialValues ? `${this.props.initialValues.Shipping.Street} ${this.props.initialValues.Shipping.City} ${this.props.initialValues.Shipping.State} ${this.props.initialValues.Shipping.Zip}` : null;
      return (
        <Col xs={6} id="customer-details">
          <div style={{ width: '300px', display: 'flex' }}>
            <h4><Translate value="ship_to_address" /></h4>
          </div>

          <div className="form-group">
            <div id="customer-name-dropdown" className="col-xs-11">
              {
                isMobile ?
                <Field
                  name="ShipTo.Name"
                  withRef
                  // ref="quantity"
                  component={InputField}
                  onFocus={this.handleOnFocus}
                  disabled={true}
                />
                :
                <Field
                  name="receivingCustomer"
                  matchPos="any"
                  placeholder={
                    <span>
                      <Translate value="customer" />
                      <span className="asteriksReq" >*</span>
                    </span>
                  }
                  component={SelectionWithProps}
                  options={customerNameOptions}
                />
              }
            </div>
          </div>

          <div className="form-group">
            <label className="col-xs-3"><Translate value="phone" /></label>
            <div id="customer-id-dropdown" className="col-xs-8">
              {
                isMobile ?
                <Field
                  name="ShipTo.Telephone"
                  component={InputField}
                  disabled={true}
                />
                :
                <Field name={fieldName} matchPos="any" component={Selection} options={shippingPhoneOptions} />
              }
            </div>
          </div>
          <div className="form-group">
            <label className="col-xs-3"><Translate value="address" /></label>
            <div className="col-xs-8">
              {
                isMobile ?
                <input style={{width: '100%', borderRadius: '5px', padding: '4px', border: '1px solid black', backgroundColor: '#CFD8DC'}} disabled value={ShipTo.Address}/>
                :
                <Field name={fieldName} matchPos="any" component={Selection} options={addressOptions} />
              }
            </div>
          </div>
        </Col>
      );
    }

    productHeader() {
      return (
        <div>
          <h2><Translate value="product_information" /></h2>
        </div>
      );
    }
    renderCustomerCredit() {
      return (
        <div>
          <h4 style={{ marginBottom: '5px' }}><Translate value="customer_credit" /></h4>
        </div>
      );
    }
    orderHeader() {
      return (
        <div>
          <h2><Translate value="your_order" /></h2>
        </div>
      );
    }

    moveFromPreviousOrderToSalesOrder() {
      const selectPreviousOrderRows = [...this.state.previousOrders.selectedRows];
      let newRows = [];
      let totalPrice = 0;
      let finalWeight = 0;
      let totalTax = 0;
      let totalTaxOriginal = 0;
      const totalCRV = 0;
      selectPreviousOrderRows.map((index) => {
        // check if the product already add in your order
        const check = _.findIndex(this.state.rows, { ProductNum: index.ProductNum });
        if (check === -1) {
          newRows.push(index);
        }
      });
      const rows = [...this.state.rows];
      newRows.map((row) => {
        row.Quantity = 0;
        row.TotalPrice = 0;
        if(isJML) {
          row.jmlBox = 0;
          row.jmlPackageSize1 = 0;
        }
        rows.unshift(row);
      });

      let index = rows.length;
      rows.map((row) => {
        row.Index = index;
        index--;
        // totalCRV = parseFloat(row.CRV) + totalCRV;
        if (row.IsTaxable === true) {
          if(isHMM) {
            totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(this.state.taxValue / 100);
          } else {
            if(isAN || isElegant) {
              let taxable = !this.props.salesCustomerDetails.Reseller;
              if (isAN) {
                taxable = row.IsAllTaxable === true || !this.props.salesCustomerDetails.Reseller
              }
              if(taxable) {
                totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
              }
            } else {
              totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
            }
          }
        }
        if(isHMM) {
          totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
        } else {
          totalPrice += parseFloat(row.TotalPrice);
        }
        row.TotalCRV = +roundTo(row.Quantity * row.CRV, 2).toFixed(2);
        if (row.Weight != null) { finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight); }
        row.TotalNetWeight = row.TotalNetWeight;
      });
      totalTaxOriginal = totalTax = +roundTo(totalTax, 2).toFixed(2);
      // reset selected after add
      this.handleDeselectAll();
      this.setState({
        rows,
        totalPrice,
        finalWeight,
        totalTax,
        totalTaxOriginal,
        totalCRV,
      });
    }
    
    // Quick Entry SO Number
    onChangeQuickEntry(e) {
      this.setState({ quickEntrySONum: e.target.value });
    }

    onKeyPressQuickEntry(e) {
      const handleSuccess = (response) => {
        
      };
      const handleFailure = (error) => {
        this.setState({ quickEntryShowError: true });
      };
      if (e.charCode === 13) {
        this.fetchPreviousOrderBySearch(this.state.quickEntrySONum);
        // this.props.fetchQuickAccess(this.state.quickEntrySONum, handleSuccess, handleFailure);
      }
    }

    checkblah() {
      if (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) {
        if (!(this.state.frequentItems.selectedPK) || this.state.frequentItems.selectedPK.length === 0) {
          return true;
        }
      } else {
        if (!(this.state.frequentItems.selectedIndexes) || this.state.frequentItems.selectedIndexes.length === 0) {
          return true;
        }
      }
    }

    moveFromFrequentItemsToSalesOrder() {
      const frequentRows = [...this.state.frequentItems.selectedIndexes];
      if (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) {
        this.state.frequentItems.rows = this.props.customerFrequent.record;
      }
      const prevRows = [...this.state.frequentItems.rows];
      let frequentPK = [];
      if (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) {
        frequentPK = [...this.state.frequentItems.selectedPK];
      }
      const newRows = [];
      let totalPrice = 0;
      let finalWeight = 0;
      let totalTax = 0;
      let totalTaxOriginal = 0;
      const totalCRV = 0;
      let check = null;
      if (isDSQ || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) {
        frequentPK.map((r) => {
          prevRows.map((j, index) => {
            if (r === j.pk) {
              newRows.push(prevRows[index]);
            }
          });
        });
      } else {
        frequentRows.map((index) => {
          check = _.findIndex(this.state.rows, { ProductNum: prevRows[index].ProductNum });
          if (check == -1) {
            if(isJML) {
              newRows.push({...prevRows[index], jmlBox: 0, jmlPackageSize1: 0});
            } else {
              newRows.push(prevRows[index]);
            }
          } else if (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) {
            newRows.push(prevRows[index]);
          }
        });
      }
      const rows = [...this.state.rows];
      newRows.map((row) => {
        row.Quantity = 0;
        row.TotalPrice = 0;
        if (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) {
          rows.unshift({...row});
        } else {
          rows.unshift(row);
        }
      });
      let index = rows.length;
      rows.map((row) => {
        row.Index = index;
        index--;
        // totalCRV = parseFloat(row.CRV) + totalCRV;
        if (row.IsTaxable === true) {
          if(isHMM) {
            totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(this.state.taxValue / 100);
          } else {
            if(isAN || isElegant) {
              let taxable = !this.props.salesCustomerDetails.Reseller;
              if (isAN) {
                taxable = row.IsAllTaxable === true || !this.props.salesCustomerDetails.Reseller
              }
              if(taxable) {
                totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
              }
            } else {
              totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
            }
          }
        }
        if(isHMM) {
          totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
        } else {
          totalPrice += parseFloat(row.TotalPrice);
        }
        row.TotalCRV = +roundTo(row.Quantity * row.CRV, 2).toFixed(2);
        if (row.Weight != null) { finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight); }
        row.TotalNetWeight = row.TotalNetWeight;
      });
      totalTaxOriginal = totalTax = +roundTo(totalTax, 2).toFixed(2);
      this.setState({
        rows, totalPrice, finalWeight, totalTax, totalCRV, totalTaxOriginal,
      });
    }

    moveFromFavoriteItemsToSalesOrder() {
      const favoritesRows = [...this.state.favorites.selectedIndexes];
      const prevRows = [...this.state.favorites.rows];
      const newRows = [];
      let totalPrice = 0;
      let finalWeight = 0;
      let totalTax = 0;
      let totalTaxOriginal = 0;
      const totalCRV = 0;
      favoritesRows.map((index) => {
        const check = _.findIndex(this.state.rows, { ProductNum: prevRows[index].ProductNum });
        if (check == -1) {
          newRows.push(prevRows[index]);
        }
      });
      const rows = [...this.state.rows];
      newRows.map((row) => {
        row.Quantity = 0;
        row.TotalPrice = 0;
        rows.unshift(row);
      });
      let index = rows.length;
      rows.map((row) => {
        row.Index = index;
        index--;
        // totalCRV = parseFloat(row.CRV) + totalCRV;
        if (row.IsTaxable == true) {
          if(isHMM) {
            totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(this.state.taxValue / 100);
          } else {
            if(isAN || isElegant) {
              let taxable = !this.props.salesCustomerDetails.Reseller;
              if (isAN) {
                taxable = row.IsAllTaxable === true || !this.props.salesCustomerDetails.Reseller;
              }
              if(taxable) {
                totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
              }
            } else {
              totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
            }
          }
        }
        if(isHMM) {
          totalPrice = parseFloat(totalPrice) + parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
        } else {
          totalPrice = parseFloat(totalPrice) + parseFloat(row.TotalPrice);
        }
        row.TotalCRV = +roundTo(row.Quantity * row.CRV, 2).toFixed(2);
        if (row.Weight != null) { finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight); }
        row.TotalNetWeight = row.TotalNetWeight;
      });
      totalTaxOriginal = totalTax = +roundTo(totalTax, 2).toFixed(2);
      this.setState({
        rows, totalPrice, finalWeight, totalTax, totalCRV, totalTaxOriginal,
      });
    }

    /* Handle Refund Confirm */
    handleRefundConfirm() {
      const { id } = this.props.params;
      const { refundAmount, refundReason } = this.state;
      if (id) {
        this.props.requestSORefund(id, { refundAmount, refundReason });
      }
    }

    renderEditSOPermission() {
      if (!this.props.currentSalesOrder) { return; }
      return (
        <Button
          bsStyle="primary"
          onClick={this.openEditSOPermission}
        >
          <Translate value="permission" />
        </Button>
      );
    }

    renderExpressInvoice() {
      const { currentSalesOrderDetail } = this.props;
      if (!currentSalesOrderDetail || !currentSalesOrderDetail.SaleStatus) {
        return;
      }
      const buttonShouldDisable = (
        this.state.Released ||
        currentSalesOrderDetail.SaleStatus === 'Finalized' ||
        currentSalesOrderDetail.SaleStatus === 'Refunded' ||
        currentSalesOrderDetail.SaleStatus === 'Partially Refunded' ||
        currentSalesOrderDetail.SaleStatus === 'Canceled' ||
        this.state.editing
      );
      return (
        <Button
          bsStyle="primary"
          onClick={this.openShipping}
          disabled={buttonShouldDisable}
        >
          <em className="fa fa-edit" />
          <Translate value="express_invoice" />
        </Button>
      );
    }

    renderShippingStatsEdit = () => {
      const { currentSalesOrderDetail } = this.props;
      return (
        <Button
          bsStyle="primary"
          onClick={() => this.setShippingStatsEditModalVisibility(true)}
          // disabled={!currentSalesOrderDetail || currentSalesOrderDetail.ShippingStatus === "Outbound"}
        >
          <em className="fa fa-edit" />
          <Translate value="shipping_status_edit" />
        </Button>
      );
    }
    renderDropshipButton() {
      const { currentSalesOrder } = this.props;
      if (!currentSalesOrder) {
        return null;
      }
      return (
        <Button
          bsStyle="primary"
          onClick={this.openDropship}
        >
          <em className="fa fa-plus" />
          <Translate value="dropship" />
        </Button>
      );
    }

    renderCreateBOLButton() {
      const { currentSalesOrder } = this.props;
      if (!currentSalesOrder) {
        return null;
      }
      return (
        <Button
          bsStyle="success"
          onClick={this.openCreateBOLModal}
        >
          <em className="fa fa-plus" />
          <Translate value="bol" />
        </Button>
      );
    }

    shippingIFrameIsLoaded = () => {
      if (!this.state.shippingPdfFrameLoaded) {
        const pdfFrame = window.frames.shippingPdf;
        pdfFrame.focus();
        pdfFrame.print();
        this.setState({ shippingPdfFrameLoaded: true });
      }
    }
    renderShippingIFrame() {
      if (this.props.shippingListPDF) {
        const file = window.URL.createObjectURL(this.props.shippingListPDF);
        return (
          <iframe style={{ display: 'none' }} onLoad={this.shippingIFrameIsLoaded} id="shippingPdf" name="shippingPdf" src={file} />
        );
      }
    }

    packingIFrameIsLoaded = () => {
      if (!this.state.packingListPdfFrameLoaded) {
        const pdfFrame = window.frames.packingPdf;
        pdfFrame.focus();
        pdfFrame.print();
        this.setState({ packingListPdfFrameLoaded: true });
      }
    }
    renderPackingIFrame() {
      if (this.props.packingListPDF) {
        const file = window.URL.createObjectURL(this.props.packingListPDF);
        return (
          <iframe style={{ display: 'none' }} onLoad={this.packingIFrameIsLoaded} id="packingPdf" name="packingPdf" src={file} />
        );
      }
    }

    pickingIFrameIsLoaded = () => {
      if (!this.state.pickingListPdfFrameLoaded) {
        const pdfFrame = window.frames.pickingPdf;
        pdfFrame.focus();
        pdfFrame.print();
        this.setState({ pickingListPdfFrameLoaded: true });
      }
    }
    renderPickingIFrame() {
      if (this.props.pickingListPDF) {
        const file = window.URL.createObjectURL(this.props.pickingListPDF);
        return (
          <iframe style={{ display: 'none' }} onLoad={this.pickingIFrameIsLoaded} id="pickingPdf" name="pickingPdf" src={file} />
        );
      }
    }

    salesOrderIFrameIsLoaded = () => {
      if (!this.state.salesOrderPdfFrameLoaded) {
        const pdfFrame = window.frames.salesOrderPdf;
        pdfFrame.focus();
        pdfFrame.print();
        this.setState({ salesOrderPdfFrameLoaded: true });
      }
    }
    renderSalesOrderIFrame() {
      if (this.props.salesOrderPDF) {
        const file = window.URL.createObjectURL(this.props.salesOrderPDF);
        return (
          <iframe style={{ display: 'none' }} onLoad={this.salesOrderIFrameIsLoaded} id="salesOrderPdf" name="salesOrderPdf" src={file} />
        );
      }
    }

    salesOrderSIIFrameIsLoaded = () => {
      if (!this.state.salesOrderSIPdfFrameLoaded) {
        const pdfFrame = window.frames.salesOrderSIPdf;
        pdfFrame.focus();
        pdfFrame.print();
        this.setState({ salesOrderSIPdfFrameLoaded: true });
      }
    }
    renderSalesOrderSIIFrame() {
      if (this.props.salesOrderSIPDF) {
        const file = window.URL.createObjectURL(this.props.salesOrderSIPDF);
        return (
          <iframe style={{ display: 'none' }} onLoad={this.salesOrderSIIFrameIsLoaded} id="salesOrderSIPdf" name="salesOrderSIPdf" src={file} />
        );
      }
    }

    handlePrintFrameOnLoad = () => {
      this.setState({ refundPDFFrameLoaded: true });
    }

    renderRefundIframe() {
      const { refundPDFFrameLoaded } = this.state;
      const { refundPDF } = this.props;
      return (
        <PrintIframe
          id="refundPDF"
          loaded={refundPDFFrameLoaded}
          name="refundPDF"
          onLoad={this.handlePrintFrameOnLoad}
          pdf={refundPDF}
          title={<Translate value="print_refund_summary" />}
        />
      );
    }

    renderPrint() {
      const currentSalesOrder = this.props.currentSalesOrder;
      if (!currentSalesOrder) { return; }
      const url = `${ROOT_URL}v1/sale/printorder/${currentSalesOrder.SalesOrder_id}?Bearer=${localStorage.getItem('token')}`;
      return (
        <Button
          bsStyle="primary"
          type="button"
          disabled={this.state.editing}
          onClick={() => {
            this.props.printSalesOrder(currentSalesOrder.SalesOrder_id);
          }}
        >
          <em className="fa fa-print" /><Translate value="print_so" />
        </Button>
      );
    }
    renderPrintPL() {
      const currentSalesOrder = this.props.currentSalesOrder;
      if (!currentSalesOrder) { return; }
      const picking_url = `${ROOT_URL}v1/sale/printpickinglist/${currentSalesOrder.SalesOrder_id}?Bearer=${localStorage.getItem('token')}`;
      return (
        <Button
          bsStyle="primary"
          type="button"
          disabled={this.state.editing}
          onClick={() => {
            this.props.printPickingList(currentSalesOrder.SalesOrder_id);
          }}
        >
          <em className="fa fa-print" /><Translate value="picking_list" />
        </Button>
      );
    }
    renderPrintSL() {
      const currentSalesOrder = this.props.currentSalesOrder;
      if (!currentSalesOrder) { return; }
      const shipping_url = `${ROOT_URL}v1/sale/printshippinglist/${currentSalesOrder.SalesOrder_id}?Bearer=${localStorage.getItem('token')}`;
      return (
        <Button
          bsStyle="primary"
          type="button"
          disabled={this.state.editing}
          onClick={() => {
            this.props.printShippingList(currentSalesOrder.SalesOrder_id);
          }}
        >
          <em className="fa fa-print" /><Translate value="shipping_list" />
        </Button>
      );
    }
    renderPrintPaL() {
      const currentSalesOrder = this.props.currentSalesOrder;
      if (!currentSalesOrder) { return; }
      const packing_url = `${ROOT_URL}v1/sale/printpackinglist/${currentSalesOrder.SalesOrder_id}?Bearer=${localStorage.getItem('token')}`;
      let hasInvoice = false;
      if (!isHMM || (currentSalesOrder && currentSalesOrder.InvoiceNum)) {
        hasInvoice = true;
      } 
      return (
        <Button
          bsStyle="primary"
          type="button"
          disabled={!hasInvoice}
          onClick={() => {
            this.props.printPackingList(currentSalesOrder.SalesOrder_id);
          }}
        >
          <em className="fa fa-print" /><Translate value="packing_list" />
        </Button>
      );
    }
    renderFavoritesList() {
      if (this.props.favoriteListIsLoading && !this.props.favoriteListError) return <Spinner />;
      else if (this.props.favoriteListError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.favoriteListError)}</div></ContentWrapper>;

      // Parameters of the react-data-grid
      const getRows = () => Data.Selectors.getRows(this.state.favorites);
      const getSize = () => getRows().length;
      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      const onRowsSelected = (rows) => {
        const newRows = getRows();
        const selectedIndexes = this.state.favorites.selectedIndexes.concat(rows.map(r => r.rowIdx));
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = true;
        });
        const favorites = { ...this.state.favorites, rows: newRows, selectedIndexes };
        this.setState({ favorites });
      };
      const onRowsDeselected = (rows) => {
        const rowIndexes = rows.map(r => r.rowIdx);
        const newRows = [...this.state.favorites.rows];
        const selectedIndexes = this.state.favorites.selectedIndexes.filter(i => rowIndexes.indexOf(i) === -1);
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = false;
        });
        const favorites = { ...this.state.favorites, rows: newRows, selectedIndexes };
        this.setState({ favorites });
      };

      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        const favorites = { ...this.state.favorites, sortColumn, sortDirection };
        this.setState({ favorites });
      };
      const onRowSelect = (rows) => {
        const favorites = { ...this.state.favorites, selectedRows: rows };
        this.setState({ favorites });
      };
      const onRowClick = (rowIdx, row) => {
        if (rowIdx > -1) {
          if (this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') {
          this.props.fetchItemSalesHistory(this.state.currentCustomer, row.Product_id);
          }
          // this.props.fetchProductInfo(row.Product_id);
        }
      };
      // Custom Formatter component
      const IsEnabledFormatter = React.createClass({
        render() {
          if (this.props.value) return <span className="label label-success"><Translate value="enabled" /></span>;
          return <span className="label label-danger"><Translate value="disable" /></span>;
        },
      });
      // Inventory list pop up table columns

      const showProductCost = () => {
        if ((isJML || isChinaTown || isRivera) && checkPermissionLocal('no_show_product_cost')) {
          return false;
        }
        return true;
      };

      const columns = [
        ...(!isLO) ? [{
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        }] : [],
        {
          key: 'RefNum',
          name: <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: isLO ? 160 : 70,
          filterable: true,
        },
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 250,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: 200,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 65,
          filterable: true,
          editable: true,
        },
        ...showProductCost() ? [{
          key: 'CostPrice',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 65,
          filterable: true,
          editable: true,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="unit_weight" />,
          resizable: true,
          sortable: true,
          width: 65,
          filterable: true,
          editable: true,
        },
        ...(isLO) ? [{
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        }] : [],
      ];
      return (
        <Row>
          <Col xs={12}>
            <div className="react-table-customizer" id="SalesOrderForm-dataGrid4">
              <ReactDataGrid
                columns={columns}
                enableRowSelect="single"
                minHeight={202}
                headerRowHeight={45}
                onGridSort={handleGridSort}
                onRowClick={onRowClick}
                onRowSelect={onRowSelect}
                onRowUpdated={this.handleRowUpdated}
                rowGetter={rowGetter}
                rowHeight={25}
                rowKey="Product_id"
                rowsCount={getSize()}
                rowSelection={{
                  onRowsDeselected,
                  onRowsSelected,
                  showCheckbox: true,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
              />
            </div>
          </Col>
        </Row>
      );
    }

    renderPaymentInfo() {
      const { paymentInfo, chargeID, paymentMethod } = this.state;
      if (isAFG && paymentMethod === "ACH" && paymentInfo) {
        return (
          <ContentWrapper>
            <Col xs={12}>
              <label><Translate value="account_name" />:</label>
            </Col>
            <Col xs={12}>
              <label>{paymentInfo.NameOnAccount}</label>
            </Col>
            <Col xs={12}>&nbsp;</Col>
            <Col xs={12}>
              <label><Translate value="account_number" />:</label>
            </Col>
            <Col xs={12}>
              <label>{paymentInfo.AccountNum}</label>
            </Col>
            <Col xs={12}>&nbsp;</Col>
            <Col xs={12}>
              <label><Translate value="routing_number" />:</label>
            </Col>
            <Col xs={12}>
              <label>{paymentInfo.Routing}</label>
            </Col>
            <Col xs={12}>
            <Button
                  bsStyle="success"
                  onClick={() => { this.openAchEdit(); }}
                  style={{marginTop: '10px'}}
                >
                  Edit ACH Info
                </Button>            
                </Col>
            <Col xs={12}>&nbsp;</Col>
          </ContentWrapper>
        );
      }
      if (!paymentInfo || !chargeID) {
        return (
          <ContentWrapper>
            <label><Translate value="no_payment_record" /></label>
          </ContentWrapper>
        );
      }
      return (
        <MSOPaymentInfoContainer
          info={paymentInfo}
          totalPrice={this.state.totalPrice}
          credit={this.state.creditAmount}
          Billing={this.props.currentSalesOrderDetail.Billing}
          orderID={this.props.params.id}
          openConfirmRefund={this.openConfirmRefund.bind(this)}
        />
      );
    }

    renderAutoSuggest() {
      return (
        <SalesOrderAutoSuggest
          CustomerNumber={this.state.currentCustomer}
          handleFocusQty={this.handleFocusQty}
          handleKeyPress={this.handleKeyPress}
          onChange={(e, { newValue }) => { this.clearInventoryInfo(); this.props.resetFormInputs(); this.setState({ suggestValue: newValue }); }}
          SearchType={this.props.searchType}
          Group={this.props.group}
          setAllProductQuantity={this.setAllProductQuantity}
          value={this.state.suggestValue}
        />
      );
    }

    getUsers() {
      const Users = [];
      this.props.users.map((user) => {
        Users.push({ value: user.user_id, label: user.username });
      });
      return Users;
    }

    renderUsers() {
      if (this.props.usersIsLoading) return <Spinner />; // If group is loading, show a spinner.
      const Users = this.getUsers();
      return (
        <Field name="Sales_User_id" component={Selection} options={Users}/>
        );
    };

  renderSales = () => {
    if(isLO) {
      const Users = this.getUsers();
      const { currentSalesOrderDetail } = this.props;
      const selectionShouldDisable = !currentSalesOrderDetail 
        ? false 
        : ( this.state.Released ||
          currentSalesOrderDetail.SaleStatus === 'Finalized' ||
          currentSalesOrderDetail.SaleStatus === 'Refunded' ||
          currentSalesOrderDetail.SaleStatus === 'Partially Refunded' ||
          currentSalesOrderDetail.SaleStatus === 'Canceled' ||
          this.state.editing
        );
      return (
        <Col xs={12} style={{ display: 'flex' }}>
          <label><Translate value="sales" />: </label>
          <div className="sales-order-sodetails-sales">
            <GenericSelection
              options={Users}
              disabled={selectionShouldDisable}
              value={this.state.created_by}
              setSelected={(e) => {
                this.setState({ created_by: e.value });
              }}
            />
          </div>
        </Col>
      )
    }
  }


  renderDeliveryMethodInfo() {
      if (this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id') {
        return (
          <Col xs={12}>
            <label><Translate value="delivery_method" />:</label>
            <Button
              id="delivery-method-button"
              type="button"
              onClick={this.openDeliveryMethodModal}
            >
              <Translate value="details" />
            </Button>
          </Col>
        );
      }
      return <div style={{ margin: isChinaTown ? '0' : '105px' }} />;
    }

    renderDiscountAmount() {
      if (this.context.router.routes[1].path === 'mobileSalesOrders/:id') {
        const { discount, totalPrice } = this.state;
        const { savings } = this.props;
        /**
         * @discount is greater than 0, if the promo is a 'percent off' type
         * @discount is equal to 0, if the promo is a 'dollar off' type
         */
        const savingsValue = (parseFloat(discount) === 0)
          ? roundTo(parseFloat(savings || 0), 2).toFixed(2)
          : roundTo(parseFloat(totalPrice || 0) * (parseFloat(discount || 0) / 100), 2).toFixed(2);
        return (
          <ContentWrapper>
            <label><Translate value="disc" /><span className="dollar-sign">$</span></label>
              <Input
                type="text"
                value={savingsValue}
                disabled
              />
          </ContentWrapper>
        );
      }
      if (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'salesOrders/:id' || this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
        const { SODiscount, SOSavings } = this.state;
        const savingsValue = parseFloat(SODiscount) + "%/" + roundTo(parseFloat(SOSavings || 0), 2).toFixed(2) + "$";
        return (
          <ContentWrapper>
            <label><Translate value="disc" /><span className="dollar-sign">(%/$)</span></label>
            {/* <span onDoubleClick={() => { this.openDiscountModal(); }}> */}
            {/* <span onDoubleClick={() => { this.openVerifyPasscodeDiscount(); }}>
              <Input
                type="text"
                value={savingsValue}
                disabled
              />
            </span> */}

            <div onDoubleClick={() => { this.openVerifyPasscodeDiscount() }} style={{ width: '65px', borderRadius: '3px', padding: '2px 5px', border: '1px solid black', backgroundColor: '#dddddd' }}>
              {/* <Input
                type="text"
                style={{color:(isOLG || isGGI) ? 'blue':'black', fontWeight:'bold'}}
                value={savingsValue}
                disabled
              /> */}
              {savingsValue}
            </div>

          </ContentWrapper>
        );
      }
     }

    handleSelect(yourOrderKey) {
      this.clearInventoryInfo();
      this.setState({
        selectedInventoryRow: {},
        inStock: '',
        purchased: '',
        presale: '',
        net_weight: '',
        suggestValue: '',
      });
      this.props.resetFormInputs();
      switch (yourOrderKey) {
        case 1:
          this.setState({ yourOrderTableHeight: (window.innerHeight < 930) ? 345 : 345, yourOrderKey });
          break;
        default:
          this.setState({ yourOrderTableHeight: (window.innerHeight < 930) ? 200 : 200, yourOrderKey });
      }
    }

    handleSelect2(inboundInfoKey) {
      // this.clearInventoryInfo();
      // this.setState({
      //   selectedInventoryRow: {},
      //   inStock: '',
      //   purchased: '',
      //   presale: '',
      //   net_weight: '',
      //   suggestValue: '',
      // });
      // this.props.resetFormInputs();
      switch (inboundInfoKey) {
        case 1:
          this.setState({ inboundInfoKey });
          break;
        default:
          this.setState({ inboundInfoKey });
      }
    }

    handleSelect3(fjInfoKey) {
      // this.clearInventoryInfo();
      // this.setState({
      //   selectedInventoryRow: {},
      //   inStock: '',
      //   purchased: '',
      //   presale: '',
      //   net_weight: '',
      //   suggestValue: '',
      // });
      // this.props.resetFormInputs();
      switch (fjInfoKey) {
        case 1:
          this.setState({ fjInfoKey });
          break;
        default:
          this.setState({ fjInfoKey });
      }
    }

    goToNewSales = (newRoute) => {
      this.setState({
        showSOCreatedOpen: false,
        rows: [],
        Billing: {
          AddressName: '',
          Cellphone: '',
          City: '',
          CustomerDetail: '',
          Email: '',
          Fax: '',
          FirstName: '',
          IsDefault: null,
          IsDeleted: null,
          LastName: '',
          Note: '',
          Position: '',
          State: '',
          Telephone: '',
          Type: '',
          Zip: '',
          Notation: '',
        },
      }, () => {
        if (this.props.dispatchDate && this.props.prevEstDate !== this.props.dispatchDate) {
          this.props.keepEstDate({ date: this.props.dispatchDate }, newRoute);
        } else {
          this.props.keepEstDate({ date: this.state.prevEstDate }, newRoute);
        }
      });
    }
    
    printSI = () => {
      this.props.printSalesOrderSI(this.props.salesOrderCreated.SalesOrder_id);
    }

    fetchPreviousSalesOrderByIndexFromLast() {
      this.props.fetchPreviousSalesOrderByIndexFromLast(this.state.currentCustomer, this.state.salesOrderIndexFromLast);
    }

    fetchPreviousSalesOrderByCustomer() {
      this.props.fetchPreviousSalesOrderByCustomer(this.state.currentCustomer, this.state.fromDate, this.state.toDate);
    }

    fetchPreviousOrdersFromALLSalesOrder() {
      this.props.fetchPreviousOrdersFromALLSalesOrder(this.state.currentCustomer, this.state.fromDate, this.state.toDate);
    }
    
    fetchPreviousOrderBySearch(SONum) {
      this.props.fetchPreviousOrderBySearch(SONum);
    }

    getPreviousSalesOrder() {
      let nextIndex = this.state.salesOrderIndexFromLast - 1;
      if (nextIndex < 1) nextIndex = 1;
      this.setState({
        salesOrderIndexFromLast: nextIndex,
      }, this.fetchPreviousSalesOrderByIndexFromLast);
    }

    getNextSalesOrder() {
      let nextIndex = this.state.salesOrderIndexFromLast + 1;
      this.setState({
        salesOrderIndexFromLast: nextIndex,
      }, this.fetchPreviousSalesOrderByIndexFromLast);
    }

    openVerifyPasscodeToCreaterSO = () => {
      this.setState({
        verifyPasscodeToCreateSOModalOpen: true,
      })   
    }

    closeVerifyPasscodeToCreateSO = () => {
      this.setState({
        verifyPasscodeToCreateSOModalOpen: false
      })
    }

    handleVerifypasscodeToCreateSOClose = (confirmed) => {
      this.closeVerifyPasscodeToCreateSO();
      if(confirmed) {
        this.setState({
          customerVerified: true,
        },() => {
          this.moveToSO('move', true, true);
        });
      }
    }

    reFetchSalesCustomers = () => {
      this.closeShippingInfoEditModal(); 
      const selectedSalesCustomer = this.props.receivingCustomer;
      this.props.setValue('salesOrderForm', 'receivingCustomer', '');
      this.props.fetchCustomers(() => {
        this.props.setValue('salesOrderForm', 'receivingCustomer', selectedSalesCustomer);
      })
      const fieldName = (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'outboundOrders/new') ? 'CustomerDetail_id' : 'Deliver_CustomerDetail_id';
      setTimeout(() => {
        if (this.getShippingNameOptions() && this.getShippingNameOptions().length > 0) {
          this.props.setValue('salesOrderForm', fieldName, this.getShippingNameOptions()[this.getShippingNameOptions().length-1].value);
        }
      }, 1500);
    }

    reloadThePage = () => {
      const {
        currentSalesOrder,
      } = this.props;
      let route = '';
      if (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'salesOrders/:id' || this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
        route = 'salesOrders';
      } else if (this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id') {
        route = 'mobileSalesOrders';
      }
      this.setShippingStatsEditModalVisibility();
      this.props.fetchSalesOrderDetail(currentSalesOrder.SalesOrder_id, route);
    }

    handleEditNotesButtonClick = () => {
      this.setNotesModalVisibility(true);
    }

    setNotesModalVisibility = (isNotesModalVisibile = false) => this.setState({ isNotesModalVisibile });
    renderNotesEditButton = () => {
      return (
          <Button
            bsStyle="primary"
            type="button"
            onClick={this.handleEditNotesButtonClick}
          >
            <em className="fa fa-pencil" /> <Translate value="edit_notes" />
          </Button>
      )
    }
    
    getPanelClassName = () => {
      const prefix = 'sales-order-customer-info-extendedHeight';
      if (isOCM) { return prefix + '-lg'; }
      if (isHMM) { return prefix; }
      if (isTN || isTQ || isNBT || isKM) { return prefix + '-md'; }
      else { return ''; }
    }

    checkToAddPromotedProduct = (productNum) => {
      const promotedProductQty = this.calculateQtyOfPromotedProduct(productNum);
      if (promotedProductQty) {
        this.setPromotionAddingAlertModalVisibility(true);
      }
    }

    modifyExsitingPromotion = (productNum) => {
      const {
        productPromotions,
      } = this.props;

      let filterdPromotion = productPromotions.filter(p => p.Method === "BuyAGetB" && p.IsPercent && p.Off === 100);

      const promotedProductonTable = this.state.rows.filter(row => ((row.ProductNum === filterdPromotion[0].RelatedProductNum) && (row.UnitPrice == 0)));
      const promotedProductQty = this.calculateQtyOfPromotedProduct(productNum);
      if (promotedProductonTable[0].Quantity != promotedProductQty) {
        const rows = _.map(this.state.rows, row => {
          if ((row.ProductNum === filterdPromotion[0].RelatedProductNum) && (row.IsGift)){
            return {
              ...row,
              Quantity: promotedProductQty,
            }
          }
          return row;
        });
        this.setState({
          rows,
        })
      }
    }

    setPromotionAddingAlertModalVisibility = (isPromotionAddingAlertModalVisible = false) => this.setState({ isPromotionAddingAlertModalVisible });

    checkForPromotions = (productNum) => {
      // Check if the editing product is qualified for promotion
      const {
        productPromotions,
      } = this.props;

      if (isEcity) {
        let filterdPromotion = productPromotions.filter(p => p.Method === "BuyAGetB" && p.IsPercent && p.Off === 100);
        if (!filterdPromotion || !filterdPromotion[0]) return;
        const promotedProductonTable = this.state.rows.filter(row => ((row.ProductNum === filterdPromotion[0].RelatedProductNum) && (!row.UnitPrice || (row.UnitPrice === '0') || (row.UnitPrice === '0.00') || (row.UnitPrice === '0.0'))));
        if (!promotedProductonTable[0]) {
          // check and add promoted product to the list
          this.checkToAddPromotedProduct(productNum)
        } else {
          // if is already added, adjust promoted product qty
          this.modifyExsitingPromotion(productNum);
        }
        return;
      }
    }

    calculateQtyOfPromotedProduct = (productNum) => {
      const {
        productPromotions,
      } = this.props;
      let productTotalQty = _.reduce(this.state.rows, (acc, current) => {
        if ((current.ProductNum === productNum) && (!current.IsGift)) {
          return acc + parseFloat(current.Quantity)
        }
        return acc
      }, 0);
      let filterdPromotion = productPromotions.filter(p => p.Method === "BuyAGetB" && p.IsPercent && p.Off === 100);
      const temp = filterdPromotion.sort((a, b) => a.FromQty > b.FromQty ? -1 : 1);
      const promotedProductQty = _.reduce(temp, (acc, current) => {
        const qty = parseInt(productTotalQty / current.FromQty);
        productTotalQty = productTotalQty - qty * current.FromQty
        return acc + qty * current.RelatedQuantity;
      }, 0);
      return promotedProductQty
    }

    handlePromotionAddConfirmClick = () => {
      const {
        productPromotions,
        Company_id,
        Pickup_Warehouse_id,
      } = this.props;
      let filterdPromotion = productPromotions.filter(p => p.Method === "BuyAGetB" && p.IsPercent && p.Off === 100);
      const promotedProductQty = this.calculateQtyOfPromotedProduct(filterdPromotion[0].ProductNum);
      const customer = this.state.currentCustomer.value || this.state.currentCustomer;
        const RelatedProduct_id = filterdPromotion[0].RelatedProduct_id;
        const success = (productDetails) => {
          const rows = [...this.state.rows];
          const gift = {
            ...productDetails,
            Quantity: promotedProductQty,
            UnitPrice: '0',
            TotalPrice: '0',
            IsGift: true,
          };
          rows.push(gift);
          this.setState({
            rows,
          });
        }
        this.props.fetchProductDetail(RelatedProduct_id, customer, Company_id, Pickup_Warehouse_id, success);
    }

    renderSalesOrderMargin = () => {
      if (!isEcity && !isLucky88) return null;
      return <div>
        <Col xs={6}>
          <label><Translate value="sales_margin" />:</label>
        </Col>
        <Col xs={6}>
          <label>{this.props.currentSalesOrderDetail && `${this.props.currentSalesOrderDetail.SalesMargin}%`}</label>
        </Col>
      </div>
    }

    renderRollingGate = () => {
      if (false) {
        //className="tab-products-table sales-order-freq-products"
        return <Tab eventKey={5} title={'Rolling Gate'}>
          <Row>
            <Col xs={4}>
              <div className="form-group">
                <label className="col-xs-3"><Translate value="dim_l_w" />:</label>
                <div className="col-xs-3">
                  <Field name="gate_l" component={InputField} />
                </div>
                <div className="col-xs-1" style={{ textAlign: 'center' }}>
                  {/* <Field name="CPONum" component={InputField} /> */}
                  X
                </div>
                <div className="col-xs-3">
                  <Field name="gate_w" component={InputField} />
                </div>
                <div className="col-xs-1" style={{ textAlign: 'center' }}>
                  {/* <Field name="CPONum" component={InputField} /> */}
                  (ft)
                </div>
              </div>
            </Col>
            <Col xs={4}>
              <div className="form-group">
                <label className="col-xs-2"><Translate value="motor" />:</label>
                <div className="col-xs-4">
                  <Field name="gate_motor" component={Selection} options={[{ label: 'Small', value: 'small' }, { label: 'Large', value: 'large' }]}/>
                </div>
                <label className="col-xs-1"><Translate value="qty" />:</label>
                <div className="col-xs-4">
                  <Field name="gate_quantity" component={InputField} />
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <div className="form-group">
                <label className="col-xs-3"><Translate value="roller_shutter" />:</label>
                <div className="col-xs-8">
                  <Field name="gate_shutter" component={Selection} options={[{ label: '3 Inch', value: '3' }, { label: '4 Inch', value: '4' }]}/>
                </div>
              </div>
            </Col>
            <Col xs={4}>
              <div className="form-group">
                <label className="col-xs-2"><Translate value="lock" />:</label>
                <div className="col-xs-4">
                  <Field name="gate_lock" component={Selection} options={[{ label: 'Yes', value: true }, { label: 'No', value: false }]}/>
                </div>
                <label className="col-xs-1"><Translate value="qty" />:</label>
                <div className="col-xs-4">
                  <Field name="gate_quantity_lock" component={InputField} disabled={!this.props.gate_lock || !this.props.gate_lock.value} />
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <div className="form-group">
                <label className="col-xs-3"><Translate value="reel" />:</label>
                <div className="col-xs-8">
                  <Field name="gate_reel" component={Selection} options={[{ label: 'Small', value: 'small' }, { label: 'Large', value: 'large' }]}/>
                </div>
              </div>
            </Col>
            <Col xs={4}>
              <div className="form-group">
                <label className="col-xs-3"><Translate value="roller_chain" />:</label>
                <div className="col-xs-8">
                  <Field name="gate_roller_chain" component={Selection} options={[{ label: 'Yes', value: true }, { label: 'No', value: false }]}/>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <div className="form-group">
                <label className="col-xs-3"><Translate value="guide_track" />:</label>
                <div className="col-xs-8">
                  <Field name="gate_guide_track" component={Selection} options={[{ label: 'Thin', value: 'thin' }, { label: 'Thick', value: 'thick' }]}/>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <div className="form-group">
                <label className="col-xs-3"><Translate value="bottom_beam" />:</label>
                <div className="col-xs-8">
                  <Field name="gate_bottom_beam" component={Selection} options={[{ label: 'Yes', value: true }, { label: 'No', value: false }]}/>
                </div>
              </div>
            </Col>
          </Row>
          {/* <Field name="CPONum" component={InputField} />

          <Field name="Sales_User_id" component={Selection} options={Users}/> */}
          <Row>
            <Col xs={4}>
              <Button
                bsStyle="primary"
                type="button"
                onClick={this.props.handleSubmit(form => {
                  console.log('form', form);
                })}
                style={{ width: '100%' }}
              >
                <Translate value="submit" />
              </Button>
            </Col>
          </Row>
      </Tab>
      }
    }

    render() {
      let dispNetWeight = 0.00;
      let dispShippingWeight = 0.00;
      if (this.props.currentSalesOrder && this.props.currentSalesOrder.FinalNetWeight) {
        dispNetWeight = (Number(this.props.currentSalesOrder.FinalNetWeight)).toFixed(2);
      }
      if (this.props.currentSalesOrder && this.props.currentSalesOrder.FinalShippingWeight) {
        dispShippingWeight = (Number(this.props.currentSalesOrder.FinalShippingWeight)).toFixed(2);
      }
      const createDialogInventoryStyle = {
        height: '700px',
        width: '1000px',
        marginLeft: '-28%',
        marginTop: '-20%',
      };
      const createDialogShippingStyle = {
        height: '780px',
        width: window.innerWidth * 4 / 5,
        marginLeft: '-35%',
        marginTop: '-22%',
        top: '60%'
      };
      let maxDate = new Date();
      if (this.props.createTime) {
        maxDate = new Date(this.props.createTime);
      }
      let minDate = new Date();
      if (this.props.orderDate) {
        minDate = new Date(this.props.orderDate);
      }
      let route = null;
      let newRoute = null;
      let breadcrumbTitle = null;
      if (this.context.router.routes[1].path == 'salesOrders/new' || this.context.router.routes[1].path == 'salesOrders/:id' || this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
        route = '/salesOrders';
        newRoute = '/salesOrders/new';
        breadcrumbTitle = 'sales_orders';
      } else if (this.context.router.routes[1].path == 'mobileSalesOrders/new' || this.context.router.routes[1].path == 'mobileSalesOrders/:id') {
        route = '/mobileSalesOrders';
        newRoute = '/mobilSalesOrders/new';
        breadcrumbTitle = 'mobile_sales_orders';
      }
      const selectInventoryInformation = (<Translate value="select_inventory_information" />);
      const confirmAction = (<Translate value="confirm_action" />);
      const openSalesOrder = (<Translate value="open_sales_order" />);
      const customerSalesHistory = (<Translate value="customer_sales_history" />);
      const {
        handleSubmit, submitting, pristine, isEditing, isCreating, 
      } = this.props;
      const allInventoryProducts = (<Translate value="all_products" />);
      const customerInformation = (<Translate value="customer_info" />);
      const orderInformation = (<Translate value="order_info" />);
      const drayageInformation = (<Translate value="drayage_info" />);
      const generalInformation = (<Translate value="general" />);
      const pickdropInformation = (<Translate value="pickdrop" />);
      const frequentProducts = (<Translate value="frequent_products" />);
      const inboundProducts = (<Translate value="inbound_products" />);
      const previousOrderList = (<Translate value="previous_orders" />);
      const SODetails = (<Translate value={(isWIZ || isJTB || isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isFJ) ? "details" : "so_details"} />);
      const CheckoutInfo = (<Translate value="payment_info" />);
      const changeTax = (<Translate value="choose_tax_rate" />);
      const changeDiscountTitle = (<Translate value="change_discount_rates" />);
      const changeWeight = (<Translate value="change_ship_weight" />);
      const changeEmployeeNoteTitle = (<Translate value="change_employee_note" />);
      const editAchTitle = ("Edit ACH Info");
      const changeCarrierInfo = (<Translate value="change_carrier_info" />);
      const changeDeliveryFeeTitle = (<Translate value="change_delivery_fee" />);
      const editSOPermission = (<Translate value="permission_for_editing_price_and_quantity" />);
      const confirmRefund = (<Translate value="msg_confirm_refund_order" />);
      const passcodeConfirm = (<Translate value="passcode_confirm" />);
      const favoriteList = (<Translate value="favorites_list" />);
      const ModalHeader = (<Translate value="your_sales_order_has_been_saved" />);
      const expressInvoiceHeader = (<Translate value="sales_order_express_invoice" />);
      const customerNote = (<Translate value="cust" />);
      const employeeNote = (<Translate value="emp" />);
      const routeNote = (<Translate value="route" />);
      const prefilledNote = (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Notation) ? this.props.salesCustomerDetails.Notation : '';
      let activeBreadcrumb = this.state.salesOrderNumber ? 'edit_sales_order' : 'create_sales_order';
      if (isWIZ || isJTB || isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isFJ) {
        if (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
          activeBreadcrumb = this.state.salesOrderNumber ? 'edit_outbound_order' : 'create_outbound_order';
        } else {
          activeBreadcrumb = this.state.salesOrderNumber ? 'edit_inbound_order' : 'create_inbound_order';
        }
      }
      const currentDate = new Date();
      const tomorrow = currentDate;
      const showProductCost = () => {
        if (isJML || (isChinaTown || isRivera) && checkPermissionLocal('no_show_product_cost')) {
          return false;
        }
        return true;
      };

      const jtbReceiveTypeOptions = [
        {label: "Unit", value: "unit"},
        {label: "Container", value: "container"},
      ];

      const jtbReceiveUnitOptions = [
        {label: "pallet", value: "pallet"},
        {label: "box", value: "box"},
        {label: "piece", value: "piece"},
      ];

      const jtbDropshipTypeOptions = [
        {label: "By Weight", value: "weight"},
        {label: "By Piece", value: "piece"},
      ];

      const jtbContainerSizeOptions = [
        {label: "20HQ", value: "20HQ"},
        {label: "40HQ", value: "40HQ"},
      ];

      const kdwContainerSizeOptions = [
        {label: "40", value: "40"},
        {label: "45", value: "45"},
      ];

      const abcffContainerSizeOptions = [
        {label: "20'", value: "20'"},
        {label: "40'", value: "40'"},
        {label: "40' HC", value: "40' HC"},
        {label: "45'", value: "45'"},
      ];

      const jtbOrderTypeOptions = [
        {label: "FBA", value: "FBA"},
        {label: "Drop Shipping", value: "Drop Shipping"},
      ];

      const kdwOrderTypeOptions = [
        {label: "Drayage Only", value: "DrayageOnly"},
        {label: "Devanning Only", value: "DevanningOnly"},
        {label: "Drayage & Devanning", value: "DrayageAndDevanning"},
      ];

      const timeOptions = [
        {label: "00:00", value: "00:00"}, {label: "01:00", value: "01:00"},
        {label: "02:00", value: "02:00"}, {label: "03:00", value: "03:00"},
        {label: "04:00", value: "04:00"}, {label: "05:00", value: "05:00"},
        {label: "06:00", value: "06:00"}, {label: "07:00", value: "07:00"},
        {label: "08:00", value: "08:00"}, {label: "09:00", value: "09:00"},
        {label: "10:00", value: "10:00"}, {label: "11:00", value: "11:00"},
        {label: "12:00", value: "12:00"}, {label: "13:00", value: "13:00"},
        {label: "14:00", value: "14:00"}, {label: "15:00", value: "15:00"},
        {label: "16:00", value: "16:00"}, {label: "17:00", value: "17:00"},
        {label: "18:00", value: "18:00"}, {label: "19:00", value: "19:00"},
        {label: "20:00", value: "20:00"}, {label: "21:00", value: "21:00"},
        {label: "22:00", value: "22:00"}, {label: "23:00", value: "23:00"},
      ];

      tomorrow.setDate(tomorrow.getDate() + 1);
      const createDialogStyle = {
        width: '600px',
        marginLeft: '-15%',
      };
      const createDiscountDialogStyle = {
        width: '450px',
        height: '200px',
        marginLeft: '-10%'
      }
      const createWeightDialogStyle = {
        width: '500px',
        height: '300px',
        marginLeft: '-10%'
      }
      const createNoteDialogStyle = {
        width: '500px',
        height: '250px',
        marginLeft: '-10%'
      }
      const editAchDialogStyle = {
        width: '350px',
        height: '320px',
        marginLeft: '-10%'
      }
      const editLocationDialogStyle = {
        width: '700px',
        height: '250px',
        marginLeft: '-10%'
      }
      const changeCarrierInfoStyle = {
        width: '500px',
        height: '400px',
        marginLeft: '-10%'
      }
      const changeFBAStyle = {
        width: '500px',
        height: '350px',
        marginLeft: '-10%'
      }
      const ShippingInfoConfirmModalStyle = {
        width: '500px',
        height: '200px',
        marginLeft: '-10%'
      }
      const BatchesModal2Style = {
        width: '600px',
        height: '200px',
        marginLeft: '-10%'
      }
      const MultiBatchModalStyle = {
        width: '600px',
        height: '500px',
        marginLeft: '-10%'
      }
      const MultiBatchStyle ={
        width: '690px',
        height: '500px',
        marginLeft: '-10%'
      }
      const changeDeliveryDialogStyle = {
        width: '450px',
        height: '230px',
        marginLeft: '-10%'
      }
      const createDeliveryModalDialogStyle = {
        width: '500px',
        marginLeft: '-10%'
      }
      // currentSalesOrderDetail
      const { Shipping, Billing, ShipTo, groupOptions } = this.state;

      const handleZoneChange = (el) => {
        let zoneSelected = el.value;
        let zoneDisplay = el.label;

        let binSelected = null;
        let binDisplay = "";
        let binOptions = [];
        let levelSelected = null;
        let levelDisplay = "";
        let levelOptions = [];
    
        this.setState({ 
          zoneSelected, 
          zoneDisplay, 
          binSelected, 
          binDisplay, 
          binOptions, 
          levelSelected, 
          levelDisplay, 
          levelOptions 
        });

        // let binOptions = [];
        axios.get(
          ZONES_URL + el.value + "/section/",
          {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          },
        ).then((response) => {
          if  (response && response.data) {
            response.data.map(r=>{
              binOptions.push({label: r.section_num, value: r.id})
            })
          }
      this.setState({binOptions});
    
        }, (err) => {
          if (err.status === 500 || err.status === 404) {
            err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
          } 
          alert(JSON.stringify(err.data));
        });
      }
      const handleBinChange = (el) => {
        let binSelected = el.value;
        let binDisplay = el.label;
        let levelSelected = null;
        let levelDisplay = "";
        let levelOptions = [];
    
        this.setState({ 
          binSelected, 
          binDisplay,
          levelSelected, 
          levelDisplay, 
          levelOptions 
        });

        // let levelOptions = [];
        axios.get(
          WAREHOUSES_URL + "/section/" + el.value + "/bin/",
          {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          },
        ).then((response) => {
          if  (response && response.data) {
            response.data.map(r=>{
              levelOptions.push({label: r.bin_num, value: r.id})
            })
          }
        this.setState({levelOptions});

        }, (err) => {
          if (err.status === 500 || err.status === 404) {
            err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
          } 
          alert(JSON.stringify(err.data));
        });

      }
      const handleLevelChange = (el) => {
        let levelSelected = el.value;
        let levelDisplay = el.label;
        this.setState({ levelSelected, levelDisplay });
      }

      if (this.props.detailIsLoading && !this.props.detailError) return <ContentWrapper><br />...<Translate value="reading_data" /></ContentWrapper>;
      else if (this.props.detailError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>;
      // const finalPrice = (this.state.finalPrice).toFixed(2);
      const { discount, finalPrice, totalPrice, totalCRV, totalTax, taxValue } = this.state;
      const { savings } = this.props;
      let totalTaxWithPromotion = calculateTax(this.state.rows, discount, (parseFloat(taxValue) / 100));
      // let finalPriceWithPromotion = 0;
      if ((isMyumyu || isAFG || isWecom || isAFM || isEcity || isElegant) && this.props.currentSalesOrder && this.props.currentSalesOrder.SONum && (this.props.currentSalesOrder.SONum.charAt(0) === 'M')) {
        if (this.props.currentSalesOrder && this.props.currentSalesOrder.GrandTotal) {
          this.state.finalPriceWithPromotion = this.props.currentSalesOrder.FinalPrice;
        }
      } else {
        // this.state.finalPriceWithPromotion = calculateSavings(discount, (savings || 0), totalPrice, totalCRV, totalTaxWithPromotion, this.state.delivery);
        // this.state.finalPriceWithPromotion = calculateSavings(discount, (savings || 0), totalPrice, totalCRV, totalTax, this.state.delivery) - this.state.creditAmount;
        if (this.props.currentSalesOrderDetail && this.props.currentSalesOrderDetail.Payment_Information) {
          this.state.finalPriceWithPromotion = calculateSavings(discount, (savings || 0), totalPrice, totalCRV, totalTax, this.state.delivery) - this.state.creditAmount - this.state.shareCreditAmount + this.state.fee;
        } else if (this.props.currentSalesOrderDetail && !this.props.currentSalesOrderDetail.Payment_Information) {
          // this.state.finalPriceWithPromotion = this.props.currentSalesOrder.GrandTotal - this.state.creditAmount;
          this.state.finalPriceWithPromotion = calculateSavings(discount, (savings || 0), totalPrice, totalCRV, totalTax, this.state.delivery) - this.state.creditAmount - this.state.shareCreditAmount + this.state.fee;
        }
      }
      if (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'salesOrders/:id' || this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
        if (Number(this.state.SODiscount) > 0) {
          if (isElegant) {
            totalTaxWithPromotion = totalTax;
          } else {
            totalTaxWithPromotion = (totalTax-(totalTax*(Number(this.state.SODiscount)/100)));
          }
          this.state.finalPriceWithPromotion = Number(totalPrice) - (Number(totalPrice)*(Number(this.state.SODiscount)/100)) + totalTaxWithPromotion + this.state.delivery;
        } else if (Number(this.state.SODiscount) === 0 && Number(this.state.SOSavings) > 0) {
          totalTaxWithPromotion = totalTax;
          this.state.finalPriceWithPromotion = Number(totalPrice) - Number(this.state.SOSavings) + totalTaxWithPromotion + this.state.delivery;
        } else {
          totalTaxWithPromotion = totalTax;
          this.state.finalPriceWithPromotion = Number(totalPrice) + totalTaxWithPromotion + this.state.delivery;
        }
        this.state.finalPriceWithPromotion = this.state.finalPriceWithPromotion.toFixed(2);
      }

      if (this.state && this.state.finalPriceWithPromotion > 0) {
        this.state.finalPriceWithPromotion = Number(this.state.finalPriceWithPromotion).toFixed(2);
      }

      return (
      //---------------
      // Begin HTML
      //---------------
        <ContentWrapper>
          <form autoComplete="off" method="get" action="#" onSubmit={handleSubmit(
            isHMM ? this.handleHMMFormSubmit :this.handleFormSubmit
          )} >
            <Breadcrumb style={this.state.crumbStyle}>
              <Breadcrumb.Item>
                <Translate value="sales_management" />
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to={route}><Translate value={(isWIZ || isJTB || isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isFJ) ? "orders" : "sales_orders"} /></Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item active="true">
                <Translate value={activeBreadcrumb} />
              </Breadcrumb.Item>
            </Breadcrumb>
            <ButtonToolbar id="breadcrumbButtonGroup">
              { 
                (!isABCFF) &&
                <Button
                  bsStyle="success"
                  type="button"
                  onClick={handleSubmit((data) => {
                    const quote = true
                    this.handleFormSubmit(data, quote)
                  })}
                  disabled={!checkPermissionLocal('add_sales_quote') || this.handleSaveDisable()} //revert risk high
                  // disabled={((this.state.rows.length === 0) || (this.state.Released) || (this.props.salesOrderIsCreating))}
                >
                  <em className="fa fa-save" /><Translate value="create_sales_quote" />
                </Button>
              }
              <Button
                bsStyle="success"
                type="button"
                onClick={handleSubmit((data) => {
                  if (isHMM) {
                    this.handleHMMFormSubmit(data);
                  } else {
                    this.handleFormSubmit(data)
                  }
                })}
                disabled={this.handleSaveDisable()} //revert risk high
                // disabled={((this.state.rows.length === 0) || (this.state.Released) || (this.props.salesOrderIsCreating))}
              >
                <em className="fa fa-save" /><Translate value="save" />
              </Button>
              { 
                (!isABCFF) &&
                <Button
                  bsStyle="primary"
                  type="button"
                  onClick={this.openHistory}
                  disabled={(this.state.currentCustomer === null)}
                >
                  <Translate value="customer_sales_history" />
                </Button>
              }
              {/* this.renderEditSOPermission() */}
              {isABC && this.renderShippingStatsEdit()}
              {(!isFJ && !isJTB && !isABCFF) && this.renderExpressInvoice()}
              {(isFJ && this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') && this.renderExpressInvoice()}
              {(!isWIZ && !isABCFF) && this.renderDropshipButton()}
              {/* {isWIZ && this.renderCreateBOLButton()} */}
              {(!isABCFF) && this.renderPrint()}
              {(!isABCFF) && this.renderPrintPL()}
              {(!isABCFF) && this.renderPrintPaL()}
              {(!isABCFF) && this.renderPrintSL()}
              <Button
                bsStyle="danger"
                type="button"
                onClick={() => { 
                  if (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
                    this.context.router.push('/outboundOrders'); 
                  } else {
                    this.context.router.push(route);
                  }
                }}
              >
                <em className="fa fa-close" />
                <Translate value="cancel" />
              </Button>
            </ButtonToolbar>
            <Grid id="sales-order-form">
              {/* Row Wrapper */}
              <Row>
                <Col xs={10}>
                  {/* Customer Information */}
                  { !(isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB || isMAG) &&
                  <Row>
                    {this.customerHeader()}
                    <fieldset className="form-horizontal">
                      <Panel
                        id="sales-order-customer-info"
                        className={ this.getPanelClassName() }
                      >
                        <Row>
                          <Col xs={6}>
                            {/* Customer Details */}
                            {!isABC && this.renderCustomerDetail()}
                            {isABC && this.renderCustomerDetailABC()}

                            {/* Billing Information */}
                            {
                              !isTN &&
                              <Col xs={5} id="billing-info">
                                <h4><Translate value="billing_information" /></h4>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="contact" /></label>
                                  {!Billing && <label className="col-xs-9"><Translate value="please_select_a_customer" /> </label>}
                                  {Billing &&
                                  <div className="col-xs-9">
                                    {Billing.FirstName}{Billing.LastName}
                                  </div> }
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="phone" /></label>
                                  {Billing &&
                                  <div className="col-xs-9">
                                    {Billing.Telephone}
                                  </div> }
                                </div>
                                <div className="form-group mb0">
                                  <label className="col-xs-3"><Translate value="address" /></label>
                                  {Billing &&
                                  <div className="col-xs-9">
                                    <div>{Billing.Street}</div>
                                    <div>
                                      {Billing.City}, {Billing.State} {Billing.Zip}
                                    </div>
                                  </div>}
                                </div>
                              </Col> 
                            }
                            {
                              isTN &&
                              <Col xs={5} id="billing-info-tn">
                                <h4><Translate value="order_information" /></h4>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="cpo_num" /></label>
                                  <div className="col-xs-8">
                                    <Field name="CPONum" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="ref_num" /></label>
                                  <div className="col-xs-8">
                                    <Field name="RefNum" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="order_type" /></label>
                                  <div className="col-xs-8">
                                    <Field name="Type" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="client" /></label>
                                  <div className="col-xs-8">
                                    <Field name="ClientCustName" component={InputField} />
                                  </div>
                                </div>
                              </Col>
                            }
                            {/* End Billing Information */}
                          </Col>
                          <Col xs={6}>
                            {!isABC && this.renderShippingAddressSelections()}
                            {isABC && this.renderShippingAddressSelectionsABC()}
                            {/* Sales Order Dates */}
                            <Col xs={6} id="so-dates">
                              <h4><Translate value={(isWIZ || isJTB || isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isFJ) ? "order_dates" : "sales_order_dates"} /></h4>
                              <div className="form-group">
                                <label className="col-xs-4"><Translate value="ordered" /></label>
                                <div className="col-xs-8">
                                  <Field name="OrderDate" selected={this.state.prevEstDate} component={DatePicker} />
                                </div>
                              </div>
                              {
                                (!isATL && !isRS && !isUSPride && !isDSQ && !isWUFS && !isABCFF && !isKDW && !isYI && !isFBD && !isWIZ && !isFJ && !isJTB) && (
                                  <div className="form-group" style={{backgroundColor: isChinaTown ? '#FFECB3' : 'inherit', display: 'flex', alignItems: 'center'}}>
                                    {!isTN && <label className="col-xs-4" style={{color: isChinaTown ? 'red' : 'black'}}><Translate value="est_delivery" /></label>}
                                    {isTN && <label className="col-xs-4"><Translate value="ship_date" /></label>}
                                    <div className="col-xs-8">
                                      <Field name="DispatchDate" selected={this.state.prevEstDate} component={DatePicker} />
                                    </div>
                                  </div>
                                )
                              }
                              {
                                isSY &&
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="order_type" /></label>
                                  <div className="col-xs-8">
                                    <Field name="SalesOrderTypeSy" matchPos="any" component={Selection} options={this.state.SalesOrderTypeSyOptions} />
                                  </div>
                                </div>
                              }
                              {
                                (isOCM) && (
                                  <div className="form-group" style={{backgroundColor: 'inherit', display: 'flex', alignItems: 'center'}}>
                                    <label className="col-xs-4"><Translate value="ship_start" /></label>
                                    <div id="customer-name-dropdown" className="col-xs-8">
                                      <Field name="DispatchStartTime" component={Selection} options={timeOptions} />
                                    </div>
                                  </div>
                                )
                              }
                              {
                                (isOCM) && (
                                  <div className="form-group" style={{backgroundColor: 'inherit', display: 'flex', alignItems: 'center'}}>
                                    <label className="col-xs-4"><Translate value="ship_end" /></label>
                                    <div id="customer-name-dropdown" className="col-xs-8">
                                      <Field name="DispatchEndTime" component={Selection} options={timeOptions}/>
                                    </div>
                                  </div>
                                )
                              }
                              {
                                (isFung) && (
                                  <div className="form-group" style={{backgroundColor: isChinaTown ? '#FFECB3' : 'inherit', display: 'flex', alignItems: 'center'}}>
                                    <label className="col-xs-4"><Translate value="po_num" /></label>
                                    <div className="col-xs-8">
                                      <Field name="PONum" className="PONum-no-highlight" component={ InputField }/>
                                    </div>
                                  </div>
                                )
                              }
                              {
                                (isTN || isUSPride || isATL || isRS) &&
                                  <div className="form-group">
                                    <label className="col-xs-4"><Translate value="ship_by" /></label>
                                    <div className="col-xs-8">
                                      <Field name="ShipByDate" selected={this.state.prevEstDate} component={DatePicker} />
                                    </div>
                                  </div>
                              }
                              {
                                isDHC &&
                                  <div className="form-group">
                                    <label className="col-xs-4"><Translate value="seller" /></label>
                                    <div className="col-xs-8">
                                      {this.renderUsers()}
                                    </div>
                                  </div>
                              }
                              {
                                isBobaLife &&
                                  <div className="form-group">
                                    <label className="col-xs-4"><Translate value="is_no_reduce" /></label>
                                    <Field name="IsNoReduce" disabled={this.props.currentSalesOrder} checked={this.state.IsNoReduce} component={CheckboxFormatter} handleOnClick={() => { this.setState({IsNoReduce : !this.state.IsNoReduce})}}/>
                                  </div>
                              }
                              {
                                isChinaTown &&
                                  <div className="form-group">
                                    <label className="col-xs-4"><Translate value="shipping_method" /></label>
                                    <Field name="ShippingMethod" component={pickShippingMethod}/>
                                  </div>
                              }
                              {
                                isTQ &&
                                <div>
                                  <div className="form-group">
                                    <label className="col-xs-3"><Translate value="company" /></label>
                                    <div className="col-xs-9">
                                      <Field
                                        name="Company_id" 
                                        component={Selection} 
                                        options={this.state.companyOptions}/>
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-3"><Translate value="cust_po" /></label>
                                    <div className="col-xs-9">
                                      <Field className="PONum-no-highlight" name="PONum" component={InputField} />
                                    </div>
                                  </div>
                                </div>                          
                              }
                              {isABC && this.renderNotesEditButton()}
                            </Col> {/* End Sales Order Dates */}
                          </Col>
                        </Row> {/* Customer Details */}
                      </Panel>
                    </fieldset>
                  </Row> 
                }
                { (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB || isMAG) &&
                  <Row>
                    { !isMAG && this.inboundInformationHeader()}
                    { isMAG && <h2><Translate value="order_information" /></h2>}
                    <fieldset className="form-horizontal">
                    <Tabs activeKey={this.state.inboundInfoKey} justified onSelect={this.handleSelect2}>
                      <Tab eventKey={1} title={customerInformation} >
                        <Row style={{minHeight: '150px'}}>
                          <Col xs={6} style={{minHeight: '150px'}}>
                            {/* Customer Details */}
                            {!isABC && this.renderCustomerDetail()}
                            {isABC && this.renderCustomerDetailABC()}
                            {/* Billing Information */}
                            {
                              !isTN &&
                              <Col xs={5} id="billing-info">
                                <h4><Translate value="billing_information" /></h4>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="contact" /></label>
                                  {!Billing && <label className="col-xs-9"><Translate value="please_select_a_customer" /> </label>}
                                  {Billing &&
                                  <div className="col-xs-9">
                                    {Billing.FirstName}{Billing.LastName}
                                  </div> }
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="phone" /></label>
                                  {
                                    Billing &&
                                    <div className="col-xs-9">
                                      {Billing.Telephone}
                                    </div>
                                  }
                                </div>
                                <div className="form-group mb0">
                                  <label className="col-xs-3"><Translate value="address" /></label>
                                  {
                                    Billing &&
                                    <div className="col-xs-9">
                                      <div>{Billing.Street}</div>
                                      <div>
                                        {Billing.City}, {Billing.State} {Billing.Zip}
                                      </div>
                                    </div>
                                  }
                                </div>
                              </Col> 
                            }
                            {/* End Billing Information */}
                          </Col>
                          <Col xs={6}>
                            {!isABC && this.renderShippingAddressSelections()}
                            {isABC && this.renderShippingAddressSelectionsABC()}
                            {/* Sales Order Dates */}
                            <Col xs={6} id="so-dates">
                              <h4><Translate value={(isWIZ || isJTB || isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isFJ) ? "order_dates" : "sales_order_dates"} /></h4>
                              <div className="form-group">
                                <label className="col-xs-4"><Translate value="ordered" /></label>
                                <div className="col-xs-8">
                                  <Field name="OrderDate" selected={this.state.prevEstDate} component={DatePicker} />
                                </div>
                              </div>
                              {
                                (!isATL && !isRS && !isUSPride && !isDSQ && !isWUFS && !isABCFF && !isKDW && !isYI && !isFBD && !isWIZ && !isFJ && !isJTB) && (
                                  <div className="form-group">
                                    {!isTN && <label className="col-xs-4"><Translate value="est_delivery" /></label>}
                                    {isTN && <label className="col-xs-4"><Translate value="ship_date" /></label>}
                                    <div className="col-xs-8">
                                      <Field name="DispatchDate" selected={this.state.prevEstDate} component={DatePicker} />
                                    </div>
                                  </div>
                                )
                              }
                              {isABC && this.renderNotesEditButton()}
                              {
                                (isTN || isUSPride || isATL || isRS) &&
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="ship_by" /></label>
                                  <div className="col-xs-8">
                                    <Field name="ShipByDate" selected={this.state.prevEstDate} component={DatePicker} />
                                  </div>
                                </div>
                              }
                              {
                                isDHC && <div className="form-group">
                                  <label className="col-xs-4"><Translate value="seller" /></label>
                                  <div className="col-xs-8">
                                    {this.renderUsers()}
                                  </div>
                                </div>
                              }
                              {
                                isBobaLife &&
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="is_no_reduce" /></label>
                                  <Field
                                    name="IsNoReduce"
                                    disabled={this.props.currentSalesOrder}
                                    checked={this.state.IsNoReduce}
                                    component={CheckboxFormatter}
                                    handleOnClick={() => { this.setState({IsNoReduce : !this.state.IsNoReduce})}} 
                                  />
                                </div>
                              }
                            </Col> {/* End Sales Order Dates */}
                          </Col>
                        </Row> {/* Customer Details */}
                        {/* </Panel> */}
                      </Tab>
                        {
                          (isMAG && false) &&
                          <Tab eventKey={2} title={("Container Info")} >
                            <Row>
                              <Col xs={6}>
                                <Col xs={5}>


                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="container_num" /></label>
                                  <div className="col-xs-7">
                                    <Field name="ContainerNum" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="bol_num" /></label>
                                  <div className="col-xs-7">
                                    <Field name="bolNum" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="shipping_line" /></label>
                                  <div className="col-xs-7">
                                    <Field name="shipping_line" component={InputField} />
                                  </div>
                                </div>

                                {/* <div className="form-group">
                                  <label className="col-xs-5"><Translate value="appointment_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="AppointmentDate" component={DatePicker} />
                                  </div>
                                </div> */}

                                </Col>
                                <Col xs={6} style={{paddingLeft: '50px'}}>

                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="container_size" /></label>
                                  <div className="col-xs-7">
                                    <Field name="size" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="cargo_weight" /></label>
                                  <div className="col-xs-7">
                                    <Field name="cargo_weight" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="terminal" /></label>
                                  <div className="col-xs-7">
                                    <Field name="terminal" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="note" /></label>
                                  <div className="col-xs-7">
                                    <Field name="mag_note" component={InputField} />
                                  </div>
                                </div>

                                </Col>
                              </Col>
                              <Col xs={6}>
                              <Col xs={5}>
                                {/* <div className="form-group">
                                  <label className="col-xs-5"><Translate value="return_empty" /></label>
                                    <div className="col-xs-7">
                                      <Field name="IsReturnEmpty" component={Checkbox} />
                                    </div>
                                </div> */}
                              </Col>
                              <Col xs={6} style={{paddingLeft: '50px'}}>
                                {/* <div className="form-group">
                                  <label className="col-xs-5"><Translate value="storage_out" /></label>
                                  <div className="col-xs-7">
                                    <Field name="StorageOutDate" component={DatePicker} />
                                  </div>
                                </div> */}
                              </Col>
                              </Col>
                            </Row>
                          </Tab>
                        }

                        {/* DRIVER_NAME1 =  models.CharField(max_length=50,null=True, blank=True)
                        MOVING_DATE1 = models.DateTimeField(null=True, blank=True)
                        TYPE_OF_MOVE1 = models.CharField(max_length=20,null=True, blank=True)
                        MOVING_FROM1 = models.CharField(max_length=200,null=True, blank=True)
                        MOVING_TO1 = models.CharField(max_length=200,null=True, blank=True) */}
                        {/* {
                          isMAG &&
                          <Tab eventKey={3} title={("Move Info")} >
                            <Row>
                            <Col xs={2} style={{textAlign: 'right'}}>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="driver" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DRIVER_NAME1" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="driver" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DRIVER_NAME2" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="driver" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DRIVER_NAME3" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="driver" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DRIVER_NAME4" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="driver" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DRIVER_NAME5" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="driver" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DRIVER_NAME6" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="driver" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DRIVER_NAME7" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="driver" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DRIVER_NAME8" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="driver" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DRIVER_NAME9" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="driver" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DRIVER_NAME10" component={InputField} />
                                  </div>
                                </div>
                                </Col>
                                <Col xs={2} style={{textAlign: 'right'}}>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="MOVING_DATE1" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="MOVING_DATE2" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="MOVING_DATE3" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="MOVING_DATE4" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="MOVING_DATE5" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="MOVING_DATE6" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="MOVING_DATE7" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="MOVING_DATE8" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="MOVING_DATE9" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="MOVING_DATE10" component={InputField} />
                                  </div>
                                </div>
                                </Col>

                                <Col xs={2} style={{textAlign: 'right'}}>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_type" /></label>
                                  <div className="col-xs-7">
                                    <Field name="TYPE_OF_MOVE1" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_type" /></label>
                                  <div className="col-xs-7">
                                    <Field name="TYPE_OF_MOVE2" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_type" /></label>
                                  <div className="col-xs-7">
                                    <Field name="TYPE_OF_MOVE3" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_type" /></label>
                                  <div className="col-xs-7">
                                    <Field name="TYPE_OF_MOVE4" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_type" /></label>
                                  <div className="col-xs-7">
                                    <Field name="TYPE_OF_MOVE5" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_type" /></label>
                                  <div className="col-xs-7">
                                    <Field name="TYPE_OF_MOVE6" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_type" /></label>
                                  <div className="col-xs-7">
                                    <Field name="TYPE_OF_MOVE7" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_type" /></label>
                                  <div className="col-xs-7">
                                    <Field name="TYPE_OF_MOVE8" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_type" /></label>
                                  <div className="col-xs-7">
                                    <Field name="TYPE_OF_MOVE9" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_type" /></label>
                                  <div className="col-xs-7">
                                    <Field name="TYPE_OF_MOVE10" component={InputField} />
                                  </div>
                                </div>
                                </Col>
                                <Col xs={3} style={{textAlign: 'right'}}>
                              <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_from" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_FROM1" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_from" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_FROM2" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_from" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_FROM3" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_from" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_FROM4" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_from" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_FROM5" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_from" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_FROM6" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_from" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_FROM7" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_from" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_FROM8" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_from" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_FROM9" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_from" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_FROM10" component={InputField} />
                                  </div>
                                </div>
                              </Col>
                              <Col xs={3} style={{textAlign: 'right'}}>
                              <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_to" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_TO1" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_to" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_TO2" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_to" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_TO3" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_to" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_TO4" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_to" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_TO5" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_to" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_TO6" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_to" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_TO7" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_to" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_TO8" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_to" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_TO9" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_to" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_TO10" component={InputField} />
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </Tab>
                        } */}
                        {
                          (isYI) &&
                          <Tab eventKey={2} title={orderInformation} >
                            <Row>
                              <Col xs={6}>
                                <Col xs={5}>
                                  {
                                    isDSQ &&
                                    <div className="form-group">
                                      <label className="col-xs-5"><Translate value="DSQ_ID" /></label>
                                      <div className="col-xs-7">
                                        <Field name="DSQID" component={InputField} />
                                      </div>
                                    </div>
                                  }
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="appointment_time" /></label>
                                  <div className="col-xs-7">
                                    <Field name="Appointment" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="appointment_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="AppointmentDate" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="shipment_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="ShipmentDate" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                    <label className="col-xs-5"><Translate value="isa_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ISANum" component={InputField} />
                                    </div>
                                  </div> 
                                 <div className="form-group">
                                  <label className="col-xs-5"><Translate value="warehouse" /></label>
                                  <div className="col-xs-7">
                                    <Field name="Warehouse_id" matchPos="any" component={Selection} options={this.state.yiWarehouseOptions} />
                                    {/* <Field name="Warehouse_id" component={InputField} /> */}
                                  </div>
                                </div>
                                {/* <div className="form-group">
                                  <label className="col-xs-5"><Translate value="order_pallet_qty" /></label>
                                  <div className="col-xs-7">
                                    <Field name="OrderPalletQty" component={InputField} />
                                  </div>
                                </div> */}
                                </Col>
                                <Col xs={6} style={{paddingLeft: '50px'}}>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ContainerNum" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="carrier" /></label>
                                    <div className="col-xs-7">
                                      <Field name="Carrier" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="destination" /></label>
                                    <div className="col-xs-7">
                                      <Field name="DeliverTo" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="port" /></label>
                                    <div className="col-xs-7">
                                      <Field name="Port" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="LF_Date" /></label>
                                    <div className="col-xs-7">
                                      <Field name="LFDate" component={DatePicker} />
                                    </div>
                                  </div>
                                  {/* <div className="form-group">
                                    <label className="col-xs-5"><Translate value="trailer_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="TrailerNum" component={InputField} />
                                    </div>
                                  </div> */}
                                </Col>
                              </Col>
                              <Col xs={6}>
                                <Col xs={5}>
                                <div className="form-group">
                                    <label className="col-xs-5"><Translate value="total_pallets" /></label>
                                    <div className="col-xs-7">
                                      <Field name="OrderPalletQty" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="loose_qty" /></label>
                                    <div className="col-xs-7">
                                      <Field name="LooseQty" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">Direct Ship</label>
                                    <div className="col-xs-7">
                                      <Field name="IsDirectShip" component={Checkbox} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">DO</label>
                                    <div className="col-xs-7">
                                      <Field name="IsDO" component={Checkbox} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">BOL</label>
                                    <div className="col-xs-7">
                                      <Field name="IsBOL" component={Checkbox} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">POD</label>
                                    <div className="col-xs-7">
                                      <Field name="IsPOD" component={Checkbox} />
                                    </div>
                                  </div>
                                {/* <div className="form-group">
                                  <label className="col-xs-5"><Translate value="deliver_to" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DeliverTo" component={InputField} />
                                  </div>
                                </div> */}
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="return_empty" /></label>
                                      <div className="col-xs-7">
                                        <Field name="IsReturnEmpty" component={Checkbox} />
                                      </div>
                                  </div>
                                {/* <div className="form-group">
                                  <label className="col-xs-5"><Translate value="fba_route" /></label>
                                  <div className="col-xs-7">
                                    <Field name="FBARoute" component={InputField} />
                                  </div>
                                </div> */}
                              </Col>
                              <Col xs={6} style={{paddingLeft: '50px'}}>
                              <div className="form-group">
                                    <label className="col-xs-5"><Translate value="trucking_co" /></label>
                                    <div className="col-xs-7">
                                      <Field name="TruckingCo" component={InputField} />
                                    </div>
                                  </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="arrival" /></label>
                                  <div className="col-xs-7">
                                    <Field name="ArrivalDate" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="return" /></label>
                                  <div className="col-xs-7">
                                    <Field name="ReturnDate" component={DatePicker} />
                                  </div>
                                </div>
                                {
                                  !(this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') &&
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="storage_in" /></label>
                                    <div className="col-xs-7">
                                      <Field name="StorageInDate" component={DatePicker} />
                                    </div>
                                  </div>
                                }
                                {
                                  (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') &&
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="storage_out" /></label>
                                    <div className="col-xs-7">
                                      <Field name="StorageOutDate" component={DatePicker} />
                                    </div>
                                  </div>
                                }
                              </Col>
                              </Col>
                            </Row>
                          </Tab>
                        }
                        {
                          (isDSQ || isWUFS || isFBD) &&
                          <Tab eventKey={2} title={orderInformation} >
                            <Row>
                              <Col xs={6}>
                                <Col xs={5}>
                                  {
                                    isDSQ &&
                                    <div className="form-group">
                                      <label className="col-xs-5"><Translate value="DSQ_ID" /></label>
                                      <div className="col-xs-7">
                                        <Field name="DSQID" component={InputField} />
                                      </div>
                                    </div>
                                  }
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="appointment_time" /></label>
                                  <div className="col-xs-7">
                                    <Field name="Appointment" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="appointment_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="AppointmentDate" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                    <label className="col-xs-5"><Translate value="isa_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ISANum" component={InputField} />
                                    </div>
                                  </div> 
                                {/* <div className="form-group">
                                  <label className="col-xs-5"><Translate value="order_pallet_qty" /></label>
                                  <div className="col-xs-7">
                                    <Field name="OrderPalletQty" component={InputField} />
                                  </div>
                                </div> */}
                                </Col>
                                <Col xs={6} style={{paddingLeft: '50px'}}>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ContainerNum" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="carrier" /></label>
                                    <div className="col-xs-7">
                                      <Field name="Carrier" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="destination" /></label>
                                    <div className="col-xs-7">
                                      <Field name="DeliverTo" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="port" /></label>
                                    <div className="col-xs-7">
                                      <Field name="Port" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="LF_Date" /></label>
                                    <div className="col-xs-7">
                                      <Field name="LFDate" component={DatePicker} />
                                    </div>
                                  </div>
                                  {/* <div className="form-group">
                                    <label className="col-xs-5"><Translate value="trailer_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="TrailerNum" component={InputField} />
                                    </div>
                                  </div> */}
                                </Col>
                              </Col>
                              <Col xs={6}>
                                <Col xs={5}>
                                <div className="form-group">
                                    <label className="col-xs-5"><Translate value="total_pallets" /></label>
                                    <div className="col-xs-7">
                                      <Field name="OrderPalletQty" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">Direct Ship</label>
                                    <div className="col-xs-7">
                                      <Field name="IsDirectShip" component={Checkbox} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">DO</label>
                                    <div className="col-xs-7">
                                      <Field name="IsDO" component={Checkbox} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">BOL</label>
                                    <div className="col-xs-7">
                                      <Field name="IsBOL" component={Checkbox} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">POD</label>
                                    <div className="col-xs-7">
                                      <Field name="IsPOD" component={Checkbox} />
                                    </div>
                                  </div>
                                {/* <div className="form-group">
                                  <label className="col-xs-5"><Translate value="deliver_to" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DeliverTo" component={InputField} />
                                  </div>
                                </div> */}
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="return_empty" /></label>
                                      <div className="col-xs-7">
                                        <Field name="IsReturnEmpty" component={Checkbox} />
                                      </div>
                                  </div>
                                {/* <div className="form-group">
                                  <label className="col-xs-5"><Translate value="fba_route" /></label>
                                  <div className="col-xs-7">
                                    <Field name="FBARoute" component={InputField} />
                                  </div>
                                </div> */}
                              </Col>
                              <Col xs={6} style={{paddingLeft: '50px'}}>
                              <div className="form-group">
                                    <label className="col-xs-5"><Translate value="trucking_co" /></label>
                                    <div className="col-xs-7">
                                      <Field name="TruckingCo" component={InputField} />
                                    </div>
                                  </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="arrival" /></label>
                                  <div className="col-xs-7">
                                    <Field name="ArrivalDate" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="return" /></label>
                                  <div className="col-xs-7">
                                    <Field name="ReturnDate" component={DatePicker} />
                                  </div>
                                </div>
                                {
                                  !(this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') &&
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="storage_in" /></label>
                                    <div className="col-xs-7">
                                      <Field name="StorageInDate" component={DatePicker} />
                                    </div>
                                  </div>
                                }
                                {
                                  (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') &&
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="storage_out" /></label>
                                    <div className="col-xs-7">
                                      <Field name="StorageOutDate" component={DatePicker} />
                                    </div>
                                  </div>
                                }
                              </Col>
                              </Col>
                            </Row>
                          </Tab>
                        }
                        {
                          (isABCFF) &&
                          <Tab eventKey={2} title={orderInformation} >
                            <Row>
                              <Col xs={6}>
                                <Col xs={5}>
                                <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ContainerNum" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container_size" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ContainerSize" component={Selection} options={abcffContainerSizeOptions}/>
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="isa_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ISANum" component={InputField} />
                                    </div>
                                  </div> 
                                  <div className="form-group">
                                  <label className="col-xs-5"><Translate value="cpo_num" /></label>
                                  <div className="col-xs-7">
                                    <Field name="CPONum" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="ref_num" /></label>
                                  <div className="col-xs-7">
                                    <Field name="RefNum" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="tracking_num" /></label>
                                  <div className="col-xs-7">
                                    <Field name="TrackingNum" component={InputField} />
                                  </div>
                                </div>
                                  {/* <div className="form-group">
                                    <label className="col-xs-5"><Translate value="vendor_style" /></label>
                                    <div className="col-xs-7">
                                      <Field name="VendorStyleNum" component={InputField} />
                                    </div>
                                  </div> 
                                  <div className="form-group">
                                    <label className="col-xs-5">TJX Style</label>
                                    <div className="col-xs-7">
                                      <Field name="TJXStyleNum" component={InputField} />
                                    </div>
                                  </div>  */}
                                </Col>
                                <Col xs={6} style={{paddingLeft: '50px'}}>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="appointment_time" /></label>
                                  <div className="col-xs-7">
                                    <Field name="Appointment" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="appointment_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="AppointmentDate" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="carrier" /></label>
                                  <div className="col-xs-7">
                                    <Field name="Carrier" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="destination" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DeliverTo" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="port" /></label>
                                  <div className="col-xs-7">
                                    <Field name="Port" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="LF_Date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="LFDate" component={DatePicker} />
                                  </div>
                                </div>
                                  {/* <div className="form-group">
                                    <label className="col-xs-5"><Translate value="trailer_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="TrailerNum" component={InputField} />
                                    </div>
                                  </div> */}
                                </Col>
                              </Col>
                              <Col xs={6}>
                                <Col xs={5}>
                                <div className="form-group">
                                    <label className="col-xs-5"><Translate value="total_pallets" /></label>
                                    <div className="col-xs-7">
                                      <Field name="OrderPalletQty" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">Direct Ship</label>
                                    <div className="col-xs-7">
                                      <Field name="IsDirectShip" component={Checkbox} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">DO</label>
                                    <div className="col-xs-7">
                                      <Field name="IsDO" component={Checkbox} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">BOL</label>
                                    <div className="col-xs-7">
                                      <Field name="IsBOL" component={Checkbox} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">POD</label>
                                    <div className="col-xs-7">
                                      <Field name="IsPOD" component={Checkbox} />
                                    </div>
                                  </div>
                                {/* <div className="form-group">
                                  <label className="col-xs-5"><Translate value="deliver_to" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DeliverTo" component={InputField} />
                                  </div>
                                </div> */}
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="return_empty" /></label>
                                      <div className="col-xs-7">
                                        <Field name="IsReturnEmpty" component={Checkbox} />
                                      </div>
                                  </div>
                                {/* <div className="form-group">
                                  <label className="col-xs-5"><Translate value="fba_route" /></label>
                                  <div className="col-xs-7">
                                    <Field name="FBARoute" component={InputField} />
                                  </div>
                                </div> */}
                              </Col>
                              <Col xs={6} style={{paddingLeft: '50px'}}>
                              <div className="form-group">
                                    <label className="col-xs-5"><Translate value="trucking_co" /></label>
                                    <div className="col-xs-7">
                                      <Field name="TruckingCo" component={InputField} />
                                    </div>
                                  </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="arrival" /></label>
                                  <div className="col-xs-7">
                                    <Field name="ArrivalDate" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="return" /></label>
                                  <div className="col-xs-7">
                                    <Field name="ReturnDate" component={DatePicker} />
                                  </div>
                                </div>
                                {
                                  !(this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') &&
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="storage_in" /></label>
                                    <div className="col-xs-7">
                                      <Field name="StorageInDate" component={DatePicker} />
                                    </div>
                                  </div>
                                }
                                {
                                  (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') &&
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="storage_out" /></label>
                                    <div className="col-xs-7">
                                      <Field name="StorageOutDate" component={DatePicker} />
                                    </div>
                                  </div>
                                }
                              </Col>
                              </Col>
                            </Row>
                          </Tab>
                        }
                        {
                          (isKDW) &&
                          <Tab eventKey={2} title={orderInformation} >
                            <Row>
                              <Col xs={6}>
                                <Col xs={5}>
                                <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ContainerNum" component={InputField} />
                                    </div>
                                  </div>

                                  {/* <div className="form-group">
                                    <label className="col-xs-5"><Translate value="order_type" /></label>
                                    <div className="col-xs-7">
                                    <Field name="OrderType" component={Selection} options={kdwOrderTypeOptions}/>
                                    </div>
                                  </div> */}
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="devanning" /></label>
                                    <div className="col-xs-7">
                                      <Field name="IsDevan" component={Checkbox} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="drayage" /></label>
                                    <div className="col-xs-7">
                                      <Field name="IsDrayage" component={Checkbox} />
                                    </div>
                                  </div>

                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="port" /></label>
                                    <div className="col-xs-7">
                                      <Field name="Port" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">SSL</label>
                                    <div className="col-xs-7">
                                      <Field name="SSL" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="terminal" /></label>
                                    <div className="col-xs-7">
                                      <Field name="terminal" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">MBL</label>
                                    <div className="col-xs-7">
                                      <Field name="MBL" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="pin" /></label>
                                    <div className="col-xs-7">
                                      <Field name="Pin" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="chassis" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ChassisType" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="pierpass" /></label>
                                    <div className="col-xs-7">
                                      <Field name="PierPass" component={InputField} />
                                    </div>
                                  </div>
                                   {/* <div className="form-group">
                                <label className="col-xs-5"><Translate value="delivery_address" /></label>
                                <div className="col-xs-7">
                                  <Field name="delivery_address" component={InputField} />
                                </div>
                              </div> */}

                                </Col>
                                <Col xs={6} style={{paddingLeft: '50px'}}>
                                <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container_size" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ContainerSize" component={Selection} options={kdwContainerSizeOptions}/>
                                    </div>
                                  </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="appointment_time" /></label>
                                  <div className="col-xs-7">
                                    <Field name="Appointment" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="appointment_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="AppointmentDate" component={DatePicker} />
                                  </div>
                                </div>
                                {/* <div className="form-group">
                                    <label className="col-xs-5"><Translate value="isa_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ISANum" component={InputField} />
                                    </div>
                                  </div>  */}
                                
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="carrier" /></label>
                                    <div className="col-xs-7">
                                      <Field name="Carrier" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="destination" /></label>
                                    <div className="col-xs-7">
                                      <Field name="DeliverTo" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="port" /></label>
                                    <div className="col-xs-7">
                                      <Field name="Port" component={InputField} />
                                    </div>
                                  </div>
                               
                                </Col>
                              </Col>
                              <Col xs={6}>
                                <Col xs={5}>
                                <div className="form-group">
                                    <label className="col-xs-5"><Translate value="total_pallets" /></label>
                                    <div className="col-xs-7">
                                      <Field name="OrderPalletQty" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">Direct Ship</label>
                                    <div className="col-xs-7">
                                      <Field name="IsDirectShip" component={Checkbox} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">DO</label>
                                    <div className="col-xs-7">
                                      <Field name="IsDO" component={Checkbox} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">BOL</label>
                                    <div className="col-xs-7">
                                      <Field name="IsBOL" component={Checkbox} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">POD</label>
                                    <div className="col-xs-7">
                                      <Field name="IsPOD" component={Checkbox} />
                                    </div>
                                  </div>
                                {/* <div className="form-group">
                                  <label className="col-xs-5"><Translate value="deliver_to" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DeliverTo" component={InputField} />
                                  </div>
                                </div> */}
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="return_empty" /></label>
                                      <div className="col-xs-7">
                                        <Field name="IsReturnEmpty" component={Checkbox} />
                                      </div>
                                  </div>
                                {/* <div className="form-group">
                                  <label className="col-xs-5"><Translate value="fba_route" /></label>
                                  <div className="col-xs-7">
                                    <Field name="FBARoute" component={InputField} />
                                  </div>
                                </div> */}
                              </Col>
                              <Col xs={6} style={{paddingLeft: '50px'}}>

                              <div className="form-group">
                                    <label className="col-xs-5"><Translate value="bol_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="bolNum" component={InputField} />
                                    </div>
                                  </div>

                              <div className="form-group">
                                    <label className="col-xs-5"><Translate value="trucking_co" /></label>
                                    <div className="col-xs-7">
                                      <Field name="TruckingCo" component={InputField} />
                                    </div>
                                  </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="arrival" /></label>
                                  <div className="col-xs-7">
                                    <Field name="ArrivalDate" component={DatePicker} />
                                  </div>
                                </div>
                                {/* <div className="form-group">
                                    <label className="col-xs-5"><Translate value="LF_Date" /></label>
                                    <div className="col-xs-7">
                                      <Field name="LFDate" component={DatePicker} />
                                    </div>
                                  </div> */}
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="return" /></label>
                                  <div className="col-xs-7">
                                    <Field name="ReturnDate" component={DatePicker} />
                                  </div>
                                </div>
                                {
                                  !(this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') &&
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="storage_in" /></label>
                                    <div className="col-xs-7">
                                      <Field name="StorageInDate" component={DatePicker} />
                                    </div>
                                  </div>
                                }
                                {
                                  (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') &&
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="storage_out" /></label>
                                    <div className="col-xs-7">
                                      <Field name="StorageOutDate" component={DatePicker} />
                                    </div>
                                  </div>
                                }
                                <div className="form-group">
                                  <label className="col-xs-5">ETA</label>
                                  <div className="col-xs-7">
                                    <Field name="delivery_eta" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="last_free_day" /></label>
                                  <div className="col-xs-7">
                                    <Field name="LFDate" component={DatePicker} />
                                  </div>
                                </div>

                              </Col>
                              </Col>
                            </Row>
                          </Tab>
                        }
                        {
                          (isKDW) &&
                          <Tab eventKey={3} title={drayageInformation} >
                            <Row>
                              <Col xs={6}>
                                <Col xs={5}>
                                {/* <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ContainerNum" component={InputField} />
                                    </div>
                                  </div> */}

                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="trailer_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="TrailerNum" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                  <label className="col-xs-5"><Translate value="drayage_city" /></label>
                                  <div className="col-xs-7">
                                  <Field name="DrayageCity" component={InputField} />
                                  </div>
                                </div>
                              </Col>
                              <Col xs={6} style={{paddingLeft: '50px'}}>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="pickup_appt" /></label>
                                  <div className="col-xs-7">
                                    <Field name="PickupApptDate" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="pickup_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="PickupDate" component={DatePicker} />
                                  </div>
                                </div>
                                </Col>
                              </Col>
                              <Col xs={6}>
                                <Col xs={5}>
                                  <div className="form-group">
                                  <label className="col-xs-5"><Translate value="delivery_appt" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DeliveryApptDate" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="delivery_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DeliveryDate" component={DatePicker} />
                                  </div>
                                </div>
                              </Col>
                              <Col xs={6} style={{paddingLeft: '50px'}}>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="perdiem_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="PerdiemDate" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="yard" /></label>
                                  <div className="col-xs-7">
                                    <Field name="Yard" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="port_wait_time" /></label>
                                  <div className="col-xs-7">
                                    <Field name="PortWaitTime" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="return_to" /></label>
                                  <div className="col-xs-7">
                                    <Field name="ReturnTo" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="empty_ready_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="EmptyReadyDate" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="return_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="ReturnDate" component={DatePicker} />
                                  </div>
                                </div>
                              </Col>
                              </Col>
                            </Row>
                          </Tab>
                        }

                        {
                          isJTB &&
                          <Tab eventKey={2} title={orderInformation}>
                            <Row>
                              <Col xs={6}>
                                <Col xs={5}>
                                {
                                  (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') &&
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="order_type" /></label>
                                    <div className="col-xs-7">
                                    <Field name="OrderType" component={Selection} options={jtbOrderTypeOptions}/>
                                      {/* <Field name="OrderType" component={InputField} /> */}
                                    </div>
                                  </div>
                                }
                                {
                                  (this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') &&
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="receive_type" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ReceiveType" component={Selection} options={jtbReceiveTypeOptions}/>
                                    </div>
                                  </div>
                                }
                                {
                                  (this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') &&
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="receive_unit" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ReceiveUnit" component={Selection} options={jtbReceiveUnitOptions}/>
                                    </div>
                                  </div>
                                }
                                {
                                  (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') &&
                                  <div className="form-group">
                                    <label className="col-xs-5" style={{color: this.state.dropShipWarning ? 'red' : 'black'}}><Translate value="dropship_type" /></label>
                                    <div className="col-xs-7">
                                      <Field name="DropshipType" component={Selection} options={jtbDropshipTypeOptions}/>
                                    </div>
                                  </div>
                                }
                                 <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ContainerNum" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container_size" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ContainerSize" component={Selection} options={jtbContainerSizeOptions}/>
                                    </div>
                                  </div>
                                  {/* <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ContainerNum" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container_size" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ContainerSize" component={Selection} options={jtbContainerSizeOptions}/>
                                    </div>
                                  </div> */}
                                </Col>
                                <Col xs={6} style={{paddingLeft: '50px'}}>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="fba_route" /></label>
                                    <div className="col-xs-7">
                                      <Field name="FBARoute" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="carrier" /></label>
                                    <div className="col-xs-7">
                                      <Field name="Carrier" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="port" /></label>
                                    <div className="col-xs-7">
                                      <Field name="Port" component={InputField} />
                                    </div>
                                  </div>
                                  {/* <div className="form-group">
                                  <label className="col-xs-5"><Translate value="LF_Date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="LFDate" component={DatePicker} />
                                  </div>
                                </div> */}
                                  <div className="form-group">
                                    <label className="col-xs-5">BOL</label>
                                    <div className="col-xs-7">
                                      <Field name="BOL" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">POD</label>
                                    <div className="col-xs-7">
                                      <Field name="POD" component={InputField} />
                                    </div>
                                  </div>
                                </Col>
                              </Col>
                              <Col xs={6}>
                                <Col xs={5}>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="appointment" /></label>
                                    <div className="col-xs-7">
                                      <Field name="Appointment" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="trucking_co" /></label>
                                    <div className="col-xs-7">
                                      <Field name="TruckingCo" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="deliver_to" /></label>
                                    <div className="col-xs-7">
                                      <Field name="DeliverTo" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="return_empty" /></label>
                                    <div className="col-xs-7">
                                      <Field name="IsReturnEmpty" component={Checkbox} />
                                    </div>
                                  </div>
                                </Col>
                                <Col xs={6} style={{paddingLeft: '50px'}}>
                                  <div className="form-group">
                                      <label className="col-xs-5"><Translate value="arrival" /></label>
                                      <div className="col-xs-7">
                                        <Field name="ArrivalDate" component={DatePicker} />
                                      </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="return" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ReturnDate" component={DatePicker} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="storage_in" /></label>
                                    <div className="col-xs-7">
                                      <Field name="StorageInDate" component={DatePicker} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="storage_out" /></label>
                                    <div className="col-xs-7">
                                      <Field name="StorageOutDate" component={DatePicker} />
                                    </div>
                                  </div>
                                </Col>
                              </Col>
                            </Row>
                          </Tab>
                        }
                        {
                          (isWIZ && !(this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id')) &&
                          <Tab eventKey={2} title={orderInformation} >
                            <Row>
                              <Col xs={6}>
                                <Col xs={5}>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ContainerNum" component={InputField} />
                                    </div>
                                  </div>
                                </Col>
                                {/* <Col xs={1}></Col> */}
                                <Col xs={6} style={{paddingLeft: '50px'}}>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="trailer" /></label>
                                    <div className="col-xs-7">
                                      <Field name="Trailer" component={InputField} />
                                    </div>
                                  </div>
                                </Col>
                              </Col>
                              <Col xs={6}>
                                <Col xs={5}>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="isa_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ISANum" component={InputField} />
                                    </div>
                                  </div>  
                                </Col>
                                <Col xs={6} style={{paddingLeft: '50px'}}>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="dl_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="DLNum" component={InputField} />
                                    </div>
                                  </div>  
                                </Col>
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={6}>
                                <Col xs={5}>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container_size" /></label>
                                    <div className="col-xs-7">
                                      {/* <Field name="ContainerSize" component={InputField} /> */}
                                      <Field name="ContainerSize" component={Selection} options={this.state.containerSizeOptions}/>
                                    </div>
                                  </div>
                                </Col>
                                <Col xs={6} style={{ paddingLeft: '50px' }}></Col>
                              </Col>
                              <Col xs={6}>
                                <Col xs={10}>
                                  <div className="form-group">
                                    <label className="col-xs-3">ISA Notation</label>
                                    <div className="col-xs-9">
                                      <Field name="ISANote" component="Textarea" className="form-control" />
                                    </div>
                                  </div>
                                </Col>
                              </Col>
                            </Row>
                        </Tab>
                      }
                      {
                          (isWIZ && (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id')) &&
                          <Tab eventKey={2} title={orderInformation} >
                            <Row>
                              <Col xs={6}>
                              <Col xs={5}>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="trucker" /></label>
                                    <div className="col-xs-7">
                                      <Field name="Trucker" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                  <label className="col-xs-5"><Translate value="release_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="ReleaseDate" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="ready_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="ReadyDate" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="outbound_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="OutboundDate" component={DatePicker} />
                                  </div>
                                </div>
                                </Col>
                                <Col xs={5}>
                                <div className="form-group">
                                    <label className="col-xs-5"><Translate value="isa_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ISANum" component={InputField} />
                                    </div>
                                  </div>  
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="shipment_id" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ShipmentID" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="destination" /></label>
                                    <div className="col-xs-7">
                                      <Field name="Destination" component={InputField} />
                                    </div>
                                  </div>
                                  {/* <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ContainerNum" component={InputField} />
                                    </div>
                                  </div>
                                </Col>
                                <Col xs={6} style={{paddingLeft: '50px'}}>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="trailer" /></label>
                                    <div className="col-xs-7">
                                      <Field name="Trailer" component={InputField} />
                                    </div>
                                  </div> */}
                                </Col>
                              </Col>
                              <Col xs={6}>
                                <Col xs={5}>
                                  {/* <div className="form-group">
                                    <label className="col-xs-5"><Translate value="isa_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ISANum" component={InputField} />
                                    </div>
                                  </div>   */}
                                </Col>
                                <Col xs={6} style={{paddingLeft: '50px'}}>
                                  {/* <div className="form-group">
                                    <label className="col-xs-5"><Translate value="dl_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="DLNum" component={InputField} />
                                    </div>
                                  </div>   */}
                                </Col>
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={6}>
                                {/* <Col xs={5}>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container_size" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ContainerSize" component={Selection} options={this.state.containerSizeOptions}/>
                                    </div>
                                  </div>
                                </Col>
                                <Col xs={6} style={{ paddingLeft: '50px' }}></Col> */}
                              </Col>
                              <Col xs={6}>
                                {/* <Col xs={10}>
                                  <div className="form-group">
                                    <label className="col-xs-3">ISA Notation</label>
                                    <div className="col-xs-9">
                                      <Field name="ISANote" component="Textarea" className="form-control" />
                                    </div>
                                  </div>
                                </Col> */}
                              </Col>
                            </Row>
                        </Tab>
                      }
                        {/* {
                          isFJ &&
                        <Tab eventKey={2} title={orderInformation} >
                          <Row>
                            <Col xs={6} style={{paddingRight: '25px'}}>
                              <Col xs={12}>
                              <div className="form-group">
                                  <label className="col-xs-3"><Translate value="ext_invoice" /></label>
                                  <div className="col-xs-9">
                                    <Field name="ExtInvoiceNum" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="broker" /></label>
                                  <div className="col-xs-9">
                                    <Field name="Broker" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="truckload" /></label>
                                  <div className="col-xs-9">
                                    <Field name="Truckload" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="truck_num" /></label>
                                  <div className="col-xs-9">
                                    <Field name="TruckNum" component={InputField} />
                                  </div>
                                </div>
                              </Col>
                            </Col>
                            <Col xs={6} style={{paddingLeft: '25px'}}>
                              <Col xs={12}>
                              <div className="form-group">
                                  <label className="col-xs-3"><Translate value="dispatch" /></label>
                                  <div className="col-xs-9">
                                    <Field name="Dispatch" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="detention_rate" /></label>
                                  <div className="col-xs-9">
                                    <Field name="DetentionRate" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="lumper_fee" /></label>
                                  <div className="col-xs-9">
                                    <Field name="LumperFee" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="pallet_space" /></label>
                                  <div className="col-xs-9">
                                    <Field name="PalletSpace" component={InputField} />
                                  </div>
                                </div>
                              </Col>
                            </Col>
                          </Row>
                        </Tab>
                            }
                            {isFJ &&
                        <Tab eventKey={3} title={pickdropInformation} >
                          <Row>
                            <Col xs={6} style={{paddingRight: '25px'}}>
                              <Col xs={12}>
                              <div className="form-group">
                                  <label className="col-xs-3"><Translate value="pickup_driver" /></label>
                                  <div className="col-xs-9">
                                    <Field name="PickupDriver" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="pickup_trailer" /></label>
                                  <div className="col-xs-9">
                                    <Field name="PickupTrailerNum" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="pickup_date" /></label>
                                  <div className="col-xs-4">
                                    <Field name="PickupDate" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="pickup_time" /></label>
                                  <div className="col-xs-9">
                                    <Field name="PickupTime" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="pickup_city" /></label>
                                  <div className="col-xs-9">
                                    <Field name="PickupCity" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="pickup_state" /></label>
                                  <div className="col-xs-9">
                                    <Field name="PickupState" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="pickup_appt" /></label>
                                  <div className="col-xs-9">
                                    <Field name="PickupAppt" component={InputField} />
                                  </div>
                                </div>
                              </Col>
                            </Col>
                            <Col xs={6} style={{paddingLeft: '25px'}}>
                            <Col xs={12}>
                              <div className="form-group">
                                  <label className="col-xs-3"><Translate value="dropoff_driver" /></label>
                                  <div className="col-xs-9">
                                    <Field name="DropoffDriver" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="dropoff_trailer" /></label>
                                  <div className="col-xs-9">
                                    <Field name="DropoffTrailerNum" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="dropoff_date" /></label>
                                  <div className="col-xs-4">
                                    <Field name="DropoffDate" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="dropoff_time" /></label>
                                  <div className="col-xs-9">
                                    <Field name="DropoffTime" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="dropoff_city" /></label>
                                  <div className="col-xs-9">
                                    <Field name="DropoffCity" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="dropoff_state" /></label>
                                  <div className="col-xs-9">
                                    <Field name="DropoffState" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="dropoff_appt" /></label>
                                  <div className="col-xs-9">
                                    <Field name="DropoffAppt" component={InputField} />
                                  </div>
                                </div>
                              </Col>
                            </Col>
                          </Row>
                        </Tab>
                            } */}
                    </Tabs>
                    </fieldset>
                  </Row> 
                }
                {
                  (isMAG || isKDW) &&
                  <Row>
                    {this.containerInformationHeader()}
                    <fieldset className="form-horizontal">
                    <Tabs activeKey={this.state.fjInfoKey} justified onSelect={this.handleSelect3}>
                      <Tab eventKey={1} title={orderInformation} >
                        <Row>
                          <Col xs={6} style={{paddingRight: '25px'}}>
                            <Col xs={12}>
                            <div className="form-group">
                                <label className="col-xs-3"><Translate value="status" /></label>
                                <div className="col-xs-9">
                                <Field name="SaleStatus" matchPos="any" component={Selection} options={ isKDW ? this.state.kdwStatusOptions : this.state.magStatusOptions} />
                                </div>
                              </div>
                              {/* <div className="form-group">
                                <label className="col-xs-3"><Translate value="delivery_address" /></label>
                                <div className="col-xs-9">
                                  <Field name="delivery_address" component={InputField} />
                                </div>
                              </div> */}
                              <div className="form-group">
                                <label className="col-xs-3">ETA</label>
                                <div className="col-xs-9">
                                  <Field name="delivery_eta" component={DatePicker} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="container_num" /></label>
                                <div className="col-xs-9">
                                  <Field name="ContainerNum" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3">BOL Num</label>
                                <div className="col-xs-9">
                                  <Field name="bolNum" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="terminal" /></label>
                                <div className="col-xs-9">
                                <Field name="terminal" matchPos="any" component={Selection} options={this.state.magTerminalOptions} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3">LFD</label>
                                <div className="col-xs-9">
                                  <Field name="delivery_lfd" component={DatePicker} />
                                </div>
                              </div>
                              {/* <div className="form-group">
                                <label className="col-xs-3">HOLD (Select)</label>
                                <div className="col-xs-9">
                                  <Field name="DeliveryStatus" component={InputField} />
                                </div>
                              </div> */}
                              <div className="form-group">
                                <label className="col-xs-3">HOLD (Select)</label>
                                <div className="col-xs-3">
                                <Field name="mag2FREIGHT_HOLD" checked={this.state.mag2FREIGHT_HOLD} component={CheckboxFormatter} handleOnClick={() => { this.setState({mag2FREIGHT_HOLD : !this.state.mag2FREIGHT_HOLD})}}/>
                                <span>Freight Hold</span>
                                </div>
                                <div className="col-xs-3">
                                <Field name="mag2CUSTOM_HOLD" checked={this.state.mag2CUSTOM_HOLD} component={CheckboxFormatter} handleOnClick={() => { this.setState({mag2CUSTOM_HOLD : !this.state.mag2CUSTOM_HOLD})}}/>
                                <span>Custom Hold</span>
                                </div>
                                <div className="col-xs-3">
                                <Field name="mag2PIERPASS_HOLD" checked={this.state.mag2PIERPASS_HOLD} component={CheckboxFormatter} handleOnClick={() => { this.setState({mag2PIERPASS_HOLD : !this.state.mag2PIERPASS_HOLD})}}/>
                                <span>Pierpass Hold</span>
                                </div>
                              </div>

                              <div className="form-group">
                                <label className="col-xs-3"></label>
                                <div className="col-xs-3">
                                <Field name="mag2EXAM" checked={this.state.mag2EXAM} component={CheckboxFormatter} handleOnClick={() => { this.setState({mag2EXAM : !this.state.mag2EXAM})}}/>
                                <span>Exam</span>
                                </div>
                                <div className="col-xs-3">
                                <Field name="mag2CLOSED_AREA" checked={this.state.mag2CLOSED_AREA} component={CheckboxFormatter} handleOnClick={() => { this.setState({mag2CLOSED_AREA : !this.state.mag2CLOSED_AREA})}}/>
                                <span>Closed Area</span>
                                </div>
                              </div>

                              <div className="form-group">
                                <label className="col-xs-3">HOLD (Other)</label>
                                <div className="col-xs-9">
                                  <Field name="DeliveryStatusOther" component={InputField} />
                                </div>
                              </div>
                            </Col>
                          </Col>
                          <Col xs={6} style={{paddingLeft: '25px'}}>
                            <Col xs={12}>
                            <div className="form-group">
                            <label className="col-xs-3"><Translate value="cntr_location" /></label>
                                <div className="col-xs-9">
                                  <Field name="cntrLocation" component={InputField} />
                                </div>
                              </div>
                            {/* <div className="form-group">
                                <label className="col-xs-3">Note (Select)</label>
                                <div className="col-xs-9">
                                <Field name="mag_note" matchPos="any" component={Selection} options={this.state.magNoteOptions} />
                                </div>
                              </div> */}
                              <div className="form-group">
                                <label className="col-xs-3">Note (Select)</label>
                                <div className="col-xs-3">
                                <Field name="magDryrun" checked={this.state.magDryrun} component={CheckboxFormatter} handleOnClick={() => { this.setState({magDryrun : !this.state.magDryrun})}}/>
                                <span>Dryrun</span>
                                </div>
                                <div className="col-xs-3">
                                <Field name="magOffhire" checked={this.state.magOffhire} component={CheckboxFormatter} handleOnClick={() => { this.setState({magOffhire : !this.state.magOffhire})}}/>
                                <span>Offhire</span>
                                </div>
                                <div className="col-xs-3">
                                <Field name="magExtraStop" checked={this.state.magExtraStop} component={CheckboxFormatter} handleOnClick={() => { this.setState({magExtraStop : !this.state.magExtraStop})}}/>
                                <span>Extra Stop</span>
                                </div>
                              </div>

                              <div className="form-group">
                                <label className="col-xs-3"></label>
                                <div className="col-xs-3">
                                <Field name="magExam" checked={this.state.magExam} component={CheckboxFormatter} handleOnClick={() => { this.setState({magExam : !this.state.magExam})}}/>
                                <span>Exam</span>
                                </div>
                                <div className="col-xs-3">
                                <Field name="magExtraDelivery" checked={this.state.magExtraDelivery} component={CheckboxFormatter} handleOnClick={() => { this.setState({magExtraDelivery : !this.state.magExtraDelivery})}}/>
                                <span>Extra Delivery</span>
                                </div>
                                <div className="col-xs-3">
                                <Field name="magStorage" checked={this.state.magStorage} component={CheckboxFormatter} handleOnClick={() => { this.setState({magStorage : !this.state.magStorage})}}/>
                                <span>Storage</span>
                                </div>
                              </div>

                              <div className="form-group">
                                <label className="col-xs-3"></label>
                                <div className="col-xs-3">
                                <Field name="magOverweight" checked={this.state.magOverweight} component={CheckboxFormatter} handleOnClick={() => { this.setState({magOverweight : !this.state.magOverweight})}}/>
                                <span>Overweight</span>
                                </div>
                                <div className="col-xs-3">
                                <Field name="magDropoff" checked={this.state.magDropoff} component={CheckboxFormatter} handleOnClick={() => { this.setState({magDropoff : !this.state.magDropoff})}}/>
                                <span>Dropoff</span>
                                </div>
                                <div className="col-xs-3">
                                <Field name="magCongestion" checked={this.state.magCongestion} component={CheckboxFormatter} handleOnClick={() => { this.setState({magCongestion : !this.state.magCongestion})}}/>
                                <span>Congestion</span>
                                </div>
                              </div>

                              <div className="form-group">
                                <label className="col-xs-3"></label>
                                <div className="col-xs-3">
                                <Field name="magBobtailFee" checked={this.state.magBobtailFee} component={CheckboxFormatter} handleOnClick={() => { this.setState({magBobtailFee : !this.state.magBobtailFee})}}/>
                                <span>Bobtail Fee</span>
                                </div>
                                <div className="col-xs-3">
                                <Field name="magPrepull" checked={this.state.magPrepull} component={CheckboxFormatter} handleOnClick={() => { this.setState({magPrepull : !this.state.magPrepull})}}/>
                                <span>Prepull</span>
                                </div>
                                <div className="col-xs-3">
                                <Field name="magChassisSplit" checked={this.state.magChassisSplit} component={CheckboxFormatter} handleOnClick={() => { this.setState({magChassisSplit : !this.state.magChassisSplit})}}/>
                                <span>Chassis Split</span>
                                </div>
                              </div>

                              <div className="form-group">
                                <label className="col-xs-3"></label>
                                <div className="col-xs-3">
                                <Field name="magHandling" checked={this.state.magHandling} component={CheckboxFormatter} handleOnClick={() => { this.setState({magHandling : !this.state.magHandling})}}/>
                                <span>Handling Fee</span>
                                </div>
                                <div className="col-xs-3">
                                <Field name="magPierpass" checked={this.state.magPierpass} component={CheckboxFormatter} handleOnClick={() => { this.setState({magPierpass : !this.state.magPierpass})}}/>
                                <span>Pierpass</span>
                                </div>
                                <div className="col-xs-3">
                                <Field name="magAnFee" checked={this.state.magAnFee} component={CheckboxFormatter} handleOnClick={() => { this.setState({magAnFee : !this.state.magAnFee})}}/>
                                <span>AN Fee</span>
                                </div>
                              </div>

                              <div className="form-group">
                                <label className="col-xs-3"></label>
                                <div className="col-xs-3">
                                <Field name="magCTF" checked={this.state.magCTF} component={CheckboxFormatter} handleOnClick={() => { this.setState({magCTF : !this.state.magCTF})}}/>
                                <span>CTF</span>
                                </div>
                                <div className="col-xs-3">
                                <Field name="magFSC" checked={this.state.magFSC} component={CheckboxFormatter} handleOnClick={() => { this.setState({magFSC : !this.state.magFSC})}}/>
                                <span>FSC</span>
                                </div>
                                <div className="col-xs-3">
                                <Field name="magOther" checked={this.state.magOther} component={CheckboxFormatter} handleOnClick={() => { this.setState({magOther : !this.state.magOther})}}/>
                                <span>Other</span>
                                </div>
                              </div>


                                <div className="form-group">
                                  <label className="col-xs-3">Note (Other)</label>
                                  <div className="col-xs-9">
                                  <Field name="mag_note_other" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                <label className="col-xs-3"><Translate value="size" /></label>
                                <div className="col-xs-9">
                                <Field name="size" matchPos="any" component={Selection} options={this.state.magSizeOptions} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="shipping_line" /></label>
                                <div className="col-xs-9">
                                <Field name="shipping_line" matchPos="any" component={Selection} options={this.state.magShippingLineOptions} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="cargo_weight" /></label>
                                <div className="col-xs-9">
                                  <Field name="cargo_weight" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="contact_person" /></label>
                                <div className="col-xs-9">
                                  <Field name="contact_person" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="contact_email" /></label>
                                <div className="col-xs-9">
                                  <Field name="contact_email" component={InputField} />
                                </div>
                              </div>
                            </Col>
                          </Col>
                        </Row>
                      </Tab>
                    </Tabs>
                    </fieldset>
                  </Row> 
                }
                { 
                  isFJ &&
                  <Row>
                    {this.generalInformationHeader()}
                    <fieldset className="form-horizontal">
                    <Tabs activeKey={this.state.fjInfoKey} justified onSelect={this.handleSelect3}>
                      <Tab eventKey={1} title={orderInformation} >
                      {      
                        (this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') &&
                        <Row>
                          <Col xs={6} style={{paddingRight: '25px'}}>
                            <Col xs={12}>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="container" /></label>
                                <div className="col-xs-9">
                                  <Field name="ContainerNum" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="carrier" /></label>
                                <div className="col-xs-9">
                                <Field name="Carrier" matchPos="any" component={Selection} options={this.state.fjCarrierOptions} />
                                </div>
                              </div>
                              {/* <div className="form-group">
                                <label className="col-xs-3"><Translate value="ext_invoice" /></label>
                                <div className="col-xs-9">
                                  <Field name="ExtInvoiceNum" component={InputField} />
                                </div>
                              </div> */}
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="broker" /></label>
                                <div className="col-xs-9">
                                  <Field name="Broker" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="truckload" /></label>
                                <div className="col-xs-9">
                                  <Field name="Truckload" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="truck_num" /></label>
                                <div className="col-xs-9">
                                  <Field name="TruckNum" component={InputField} />
                                </div>
                              </div>
                            </Col>
                          </Col>
                          <Col xs={6} style={{paddingLeft: '25px'}}>
                            <Col xs={12}>
                            <div className="form-group">
                                <label className="col-xs-3"><Translate value="ext_invoice" /></label>
                                <div className="col-xs-9">
                                  <Field name="ExtInvoiceNum" component={InputField} />
                                </div>
                              </div>
                            <div className="form-group">
                                <label className="col-xs-3"><Translate value="dispatch" /></label>
                                <div className="col-xs-9">
                                  <Field name="Dispatch" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="detention_rate" /></label>
                                <div className="col-xs-9">
                                  <Field name="DetentionRate" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="lumper_fee" /></label>
                                <div className="col-xs-9">
                                  <Field name="LumperFee" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="pallet_space" /></label>
                                <div className="col-xs-9">
                                  <Field name="PalletSpace" component={InputField} />
                                </div>
                              </div>
                            </Col>
                          </Col>
                        </Row>
                      }
                      {      
                        (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') &&
                        <Row>
                          <Col xs={6} style={{paddingRight: '25px'}}>
                            <Col xs={12}>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="container" /></label>
                                <div className="col-xs-9">
                                  <Field name="ContainerNum" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="ext_invoice" /></label>
                                <div className="col-xs-9">
                                  <Field name="ExtInvoiceNum" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="broker" /></label>
                                <div className="col-xs-9">
                                  <Field name="Broker" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="truckload" /></label>
                                <div className="col-xs-9">
                                  <Field name="Truckload" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="truck_num" /></label>
                                <div className="col-xs-9">
                                  <Field name="TruckNum" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="carrier" /></label>
                                <div className="col-xs-9">
                                  <Field name="Carrier" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="trailer_num" /></label>
                                <div className="col-xs-9">
                                  <Field name="TrailerNum" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="orders" /></label>
                                <div className="col-xs-9">
                                  <Field name="OrdersStuff" component={InputField} />
                                </div>
                              </div>
                            </Col>
                          </Col>
                          <Col xs={6} style={{paddingLeft: '25px'}}>
                            <Col xs={12}>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="dispatch" /></label>
                                <div className="col-xs-9">
                                  <Field name="Dispatch" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="detention_rate" /></label>
                                <div className="col-xs-9">
                                  <Field name="DetentionRate" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="lumper_fee" /></label>
                                <div className="col-xs-9">
                                  <Field name="LumperFee" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="pallet_space" /></label>
                                <div className="col-xs-9">
                                  <Field name="PalletSpace" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="deliver_by_date" /></label>
                                <div className="col-xs-9">
                                  <Field name="DeliverByDate" component={DatePicker} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="deliver_by_time" /></label>
                                <div className="col-xs-9">
                                  <Field name="DeliverByTime" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3">BOL</label>
                                <div className="col-xs-9">
                                  <Field name="IsBOL" component={Checkbox} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3">Seal</label>
                                <div className="col-xs-9">
                                  <Field name="IsSeal" component={Checkbox} />
                                </div>
                              </div>
                            </Col>
                          </Col>
                        </Row>
                      }
                      </Tab>
                      {
                      (this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') &&
                      // true &&
                      <Tab eventKey={2} title={pickdropInformation} >
                        <Row>
                          <Col xs={6} style={{paddingRight: '25px'}}>
                            <Col xs={12}>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="pickup_driver" /></label>
                                <div className="col-xs-9">
                                  <Field name="PickupDriver" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="pickup_trailer" /></label>
                                <div className="col-xs-9">
                                  <Field name="PickupTrailerNum" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="pickup_date" /></label>
                                <div className="col-xs-4">
                                  <Field name="PickupDate" component={DatePicker} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="pickup_time" /></label>
                                <div className="col-xs-9">
                                  <Field name="PickupTime" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="pickup_street" /></label>
                                <div className="col-xs-9">
                                  <Field name="PickupStreet" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="pickup_zip" /></label>
                                <div className="col-xs-9">
                                  <Field name="PickupZip" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="pickup_city" /></label>
                                <div className="col-xs-9">
                                  <Field name="PickupCity" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="pickup_state" /></label>
                                <div className="col-xs-5">
                                  {/* <Field name="PickupState" component={InputField} /> */}
                                  <Field name="PickupState" component={Selection} options={this.state.stateOptions}/>
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="pickup_appt" /></label>
                                <div className="col-xs-9">
                                  <Field name="PickupAppt" component={InputField} />
                                </div>
                              </div>
                            </Col>
                          </Col>
                          <Col xs={6} style={{paddingLeft: '25px'}}>
                            <Col xs={12}>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="dropoff_driver" /></label>
                                <div className="col-xs-9">
                                  <Field name="DropoffDriver" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="dropoff_trailer" /></label>
                                <div className="col-xs-9">
                                  <Field name="DropoffTrailerNum" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="dropoff_date" /></label>
                                <div className="col-xs-4">
                                  <Field name="DropoffDate" component={DatePicker} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="dropoff_time" /></label>
                                <div className="col-xs-9">
                                  <Field name="DropoffTime" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="dropoff_street" /></label>
                                <div className="col-xs-9">
                                  <Field name="DropoffStreet" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="dropoff_zip" /></label>
                                <div className="col-xs-9">
                                  <Field name="DropoffZip" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="dropoff_city" /></label>
                                <div className="col-xs-9">
                                  <Field name="DropoffCity" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="dropoff_state" /></label>
                                <div className="col-xs-5">
                                  {/* <Field name="DropoffState" component={InputField} /> */}
                                  <Field name="DropoffState" component={Selection} options={this.state.stateOptions}/>
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="dropoff_appt" /></label>
                                <div className="col-xs-9">
                                  <Field name="DropoffAppt" component={InputField} />
                                </div>
                              </div>
                            </Col>
                          </Col>
                        </Row>
                      </Tab>
                      }
                    </Tabs>
                    </fieldset>
                  </Row> 
                }
                {
                  ((!isMAG && !isABCFF) && !(this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id')) &&
                  <Row>
                    {this.productHeader()}
                    <fieldset className="form-horizontal">
                      <Tabs activeKey={this.state.yourOrderKey} justified onSelect={this.handleSelect}>
                        <Tab eventKey={1} title={allInventoryProducts}>
                          <Row>
                            {
                              isSY &&
                              <Col xs={6}>
                                <Row style={{ marginLeft: '-8px' }}>
                                  <Col xs={2}>
                                    <label className="search-by-max-width">
                                      <Translate value="select_group" />:
                                    </label>
                                  </Col>
                                  <Col xs={4}>
                                    {/* 01010001 */}
                                    <Field name="group" component={Selection} options={groupOptions} />
                                  </Col>
                                </Row>
                              </Col>
                            }
                            <Col xs={12}>
                              <Row>
                                <Col xs={isChinaTown ? 5 : 6}>
                                  <Field name="searchType" component={renderTypeRadios} />
                                  {/* <Field name="ProductInformation" component={InputField} ref="productSearch" withRef={true} onFocus={this.handleOnFocus} onKeyPress={(event) => {this.openShowInventory(event)}}/> */}
                                  {this.renderAutoSuggest()}
                                </Col>
                                <Col xs={isChinaTown ? 7 : 6} id="product-search-outputs">
                                  {
                                    (!isDSQ && !isWUFS && !isABCFF && !isKDW && !isYI && !isFBD) &&
                                    <Col xs={isChinaTown ? 1 : 2} className="pr0">
                                    {
                                      !isWIZ ?
                                      <label >
                                        <Translate value={isJML ? 'box_qty' : "qty"} />
                                      </label>
                                      :
                                      <label >
                                        <Translate value="rcvd_qty" />
                                      </label>
                                    }
                                    {
                                      !isJML ?
                                      <Field
                                        name="Quantity"
                                        withRef
                                        ref="quantity"
                                        component={InputField}
                                        onFocus={this.handleOnFocus}
                                        onKeyPress={(event) => {
                                          if (isRivera && !checkPermissionLocal('edit_sales_order_price')) {
                                            this.handleKeyPress('itemNotation', event);
                                          }
                                          if (!this.state.selectedInventoryRow) {
                                            return;
                                          }
                                          if (isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) {
                                            this.handleKeyPress('itemNotation', event);
                                          } else {
                                            this.handleKeyPress('unitPrice', event);
                                          }
                                        }}
                                        placeholder="must be > 0"
                                      />
                                      :
                                      <Field
                                        name="jmlBox"
                                        withRef
                                        ref="jmlBox"
                                        component={InputField}
                                        // disabled={this.state.selectedInventoryRow && this.state.selectedInventoryRow.ProductType !== 'Non-Fixed'}
                                        // normalize={normalizeFourDecimals}
                                        onFocus={this.handleOnFocus}
                                        onKeyPress={(event) => {
                                          this.handleKeyPress('unitPrice', event);
                                        }}
                                      />
                                    }
                                    </Col>
                                  }
                                  
                                  <Col xs={(isAN || isCalco) ? 2 : 1} className="pr0">
                                    <label >
                                      <Translate value="unit" />
                                      <span className="dollar-sign">$$</span>
                                    </label>
                                    <Field
                                      name="UnitPrice"
                                      withRef
                                      ref="unitPrice"
                                      component={InputField}
                                      disabled={(isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) || (isRivera && !checkPermissionLocal('edit_sales_order_price'))}
                                      // normalize={normalizeFourDecimals}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        // if (isJML && this.state.selectedInventoryRow && this.state.selectedInventoryRow.ProductType === 'Non-Fixed') {
                                        //   this.handleKeyPress('PackageSize_1', event);
                                        // } else {
                                          this.handleKeyPress('itemNotation', event);
                                        // }
                                      }}
                                    />
                                  </Col>
                                  {
                                    !isJML && <Col xs={2} className="pr0">
                                    <label><Translate value="net_wt" /></label>
                                    <Field
                                      name="Weight"
                                      withRef
                                      ref="weight"
                                      component={DisabledInputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (event.charCode === 13) {
                                          if (!this.state.selectedInventoryRow) {
                                            return;
                                          }
                                          this.handleFocusAutoSuggest();
                                          this.checkMoveToSo();
                                        }
                                      }}
                                    />
                                  </Col> }
                                  {
                                    // break point
                                    showProductCost() && <Col xs={2}>
                                      <label><Translate value="cost" /></label>
                                      <span className="dollar-sign">$$</span>
                                      <Field
                                        name={isHMM ? "" : "ProductCost"}
                                        withRef
                                        ref="ProductCost"
                                        component={DisabledInputField}
                                        onFocus={this.handleOnFocus}
                                        onKeyPress={(event) => {
                                          if (event.charCode === 13) {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                            this.handleFocusAutoSuggest();
                                            this.checkMoveToSo();
                                          }
                                        }}
                                      />
                                    </Col>
                                  }
                                  <Col xs={2}>
                                    <Row>
                                      <Col xs={12}>
                                        <label ><Translate value="subtotal" /></label>
                                      </Col>
                                      {this.renderSubtotal()}
                                    </Row>
                                  </Col>
                                  <Col xs={2}>
                                    <label><Translate value="notation" /></label>
                                    <Field
                                      name="itemNotation"
                                      withRef
                                      ref="itemNotation"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (event.charCode === 13) {
                                          if (!this.state.selectedInventoryRow) {
                                            return;
                                          }
                                          if (!isNumeric(this.props.quantityValue) || this.props.quantityValue < 0) {
                                            return;
                                          }
                                          
                                          if (isWIZ) {
                                            this.handleKeyPress('ReceivedQuantity', event);
                                          } else if (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD) {
                                            this.handleKeyPress('FBACode', event);
                                          } else if (isOCM || isTN) {
                                            const { suggestValue } = this.state;
                                            this.setBatchesModalVisibility(true);
                                          } else if(isJML) {
                                            this.setBatchesModal2Visibility(true)
                                          } else{
                                            this.handleFocusAutoSuggest();
                                            this.checkMoveToSo();
                                          }
                                          // else if (isJTB) {
                                          //   this.handleKeyPress('PalletQuantity', event);
                                          // }
                                        }
                                      }}
                                    />
                                  </Col>
                                  { 
                                    isTN &&
                                    <Col xs={1} className="pr1">
                                      <div style={{height: '23px'}}></div>
                                      <Button
                                        id="product-add-button"
                                        bsStyle="success"
                                        disabled={this.state.selectedInventoryRow.Product_id == null}
                                        onClick={() => {
                                          this.setMultiBatchModalVisibility(true);
                                        }}
                                      >
                                        +
                                      </Button>
                                    </Col>
                                  }
                                  { 
                                    isChinaTown &&
                                    <Col xs={1} className="pr1">
                                      <div style={{height: '23px'}}></div>
                                      <Button
                                        id="product-add-button"
                                        bsStyle="success"
                                        onClick={() => {
                                          this.checkMoveToSo();
                                        }}
                                      >
                                        +
                                      </Button>
                                    </Col>
                                  }
                                </Col>
                              </Row>
                              {
                              false &&
                              <Row>
                                <Col xs={6}>
                                </Col>
                                <Col xs={6}>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="pallet_qty" />
                                    </label>
                                    <Field
                                      name="PalletQuantity"
                                      withRef
                                      ref="PalletQuantity"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('BoxQuantity', event);
                                      }}
                                    />
                                  </Col>

                                  <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="box_qty" />
                                    </label>
                                    <Field
                                      name="BoxQuantity"
                                      withRef
                                      ref="BoxQuantity"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                        this.handleKeyPress('PieceQuantity', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="piece_qty" />
                                    </label>
                                    <Field
                                      name="PieceQuantity"
                                      withRef
                                      ref="PieceQuantity"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (event.charCode === 13) {
                                          if (!this.state.selectedInventoryRow) {
                                            return;
                                          }
                                          this.handleFocusAutoSuggest();
                                          this.checkMoveToSo();
                                        }
                                      }}
                                    />
                                  </Col>
                                </Col>
                              </Row>
                              }
                              {
                              (isYI) &&
                              <Row>
                                <Col xs={6}>
                                  <Col xs={2} className="pr1">
                                    <label >
                                      FBA Code
                                    </label>
                                    <Field
                                      name="FBACode"
                                      withRef
                                      ref="FBACode"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('FBARoute', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      FBA Route
                                    </label>
                                    <Field
                                      name="FBARoute"
                                      withRef
                                      ref="FBARoute"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('TrailerNum', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      Trailer
                                    </label>
                                    <Field
                                      name="TrailerNum"
                                      withRef
                                      ref="TrailerNum"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('POList', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      PO List
                                    </label>
                                    <Field
                                      name="POList"
                                      withRef
                                      ref="POList"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('POD', event);
                                      }}
                                    />
                                  </Col>
                                  {/* <Col xs={2} className="pr0">
                                    <label >
                                      POD
                                    </label>
                                    <Field
                                      name="POD"
                                      withRef
                                      ref="POD"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('DimUnit', event);
                                      }}
                                    />
                                  </Col> */}
                                  <Col xs={2} className="pr0" style={{paddingLeft: '20px'}}>
                                    <label style={{width: '100%'}}>
                                      <Translate value="POD" />
                                    </label>
                                    <Field name="POD" component={Checkbox} />
                                  </Col>

                                  {/* <Col xs={2} className="pr0">
                                    <label >
                                      Dim Unit
                                    </label>
                                    <Field
                                      name="DimUnit"
                                      withRef
                                      ref="DimUnit"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('quantity', event);
                                      }}
                                    />
                                  </Col> */}
                                </Col>
                                <Col xs={6}>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="box_qty" />
                                    </label>
                                    <Field
                                      name="Quantity"
                                      withRef
                                      ref="quantity"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('BoxLength', event);
                                      }}
                                      placeholder="must be > 0"
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label >
                                      Box L
                                    </label>
                                    <Field
                                      name="BoxLength"
                                      withRef
                                      ref="BoxLength"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('BoxWidth', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label style={{minWidth: '40px'}}>
                                      Box W
                                    </label>
                                    <Field
                                      name="BoxWidth"
                                      withRef
                                      ref="BoxWidth"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('BoxHeight', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label >
                                      Box H
                                    </label>
                                    <Field
                                      name="BoxHeight"
                                      withRef
                                      ref="BoxHeight"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('BoxVol', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      Box CBM
                                    </label>
                                    <Field
                                      name="BoxVol"
                                      withRef
                                      ref="BoxVol"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('BoxWeight', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="box_weight" />
                                    </label>
                                    <Field
                                      name="BoxWeight"
                                      withRef
                                      ref="BoxWeight"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                        this.handleKeyPress('WeightUnit', event);
                                      }}
                                    />
                                  </Col>

                                  {/* <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="weight_unit" />
                                    </label>
                                    <Field
                                      name="WeightUnit"
                                      withRef
                                      ref="WeightUnit"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                        if (isKDW) {
                                          this.handleKeyPress('ShipmentID', event);
                                        } else {
                                        this.handleKeyPress('PalletQuantity', event);
                                        }
                                      }}
                                    />
                                  </Col> */}
                                </Col>
                                </Row>
                              }
                              {
                              (isDSQ || isWUFS || isABCFF || isKDW || isFBD) &&
                              <Row>
                                <Col xs={6}>
                                  <Col xs={2} className="pr1">
                                    <label >
                                      FBA Code
                                    </label>
                                    <Field
                                      name="FBACode"
                                      withRef
                                      ref="FBACode"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('FBARoute', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      FBA Route
                                    </label>
                                    <Field
                                      name="FBARoute"
                                      withRef
                                      ref="FBARoute"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('TrailerNum', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      Trailer
                                    </label>
                                    <Field
                                      name="TrailerNum"
                                      withRef
                                      ref="TrailerNum"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('POList', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      PO List
                                    </label>
                                    <Field
                                      name="POList"
                                      withRef
                                      ref="POList"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('POD', event);
                                      }}
                                    />
                                  </Col>
                                  {/* <Col xs={2} className="pr0">
                                    <label >
                                      POD
                                    </label>
                                    <Field
                                      name="POD"
                                      withRef
                                      ref="POD"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('DimUnit', event);
                                      }}
                                    />
                                  </Col> */}
                                  <Col xs={2} className="pr0" style={{paddingLeft: '20px'}}>
                                    <label style={{width: '100%'}}>
                                      <Translate value="POD" />
                                    </label>
                                    <Field name="POD" component={Checkbox} />
                                  </Col>

                                  <Col xs={2} className="pr0">
                                    <label >
                                      Dim Unit
                                    </label>
                                    <Field
                                      name="DimUnit"
                                      withRef
                                      ref="DimUnit"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('quantity', event);
                                      }}
                                    />
                                  </Col>
                                </Col>
                                <Col xs={6}>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="box_qty" />
                                    </label>
                                    <Field
                                      name="Quantity"
                                      withRef
                                      ref="quantity"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('BoxLength', event);
                                      }}
                                      placeholder="must be > 0"
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label >
                                      Box L
                                    </label>
                                    <Field
                                      name="BoxLength"
                                      withRef
                                      ref="BoxLength"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('BoxWidth', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label style={{minWidth: '40px'}}>
                                      Box W
                                    </label>
                                    <Field
                                      name="BoxWidth"
                                      withRef
                                      ref="BoxWidth"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('BoxHeight', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label >
                                      Box H
                                    </label>
                                    <Field
                                      name="BoxHeight"
                                      withRef
                                      ref="BoxHeight"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('BoxVol', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      Box CBM
                                    </label>
                                    <Field
                                      name="BoxVol"
                                      withRef
                                      ref="BoxVol"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('BoxWeight', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="box_weight" />
                                    </label>
                                    <Field
                                      name="BoxWeight"
                                      withRef
                                      ref="BoxWeight"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                        this.handleKeyPress('WeightUnit', event);
                                      }}
                                    />
                                  </Col>

                                  <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="weight_unit" />
                                    </label>
                                    <Field
                                      name="WeightUnit"
                                      withRef
                                      ref="WeightUnit"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                        if (isKDW) {
                                          this.handleKeyPress('ShipmentID', event);
                                        } else {
                                        this.handleKeyPress('PalletQuantity', event);
                                        }
                                      }}
                                    />
                                  </Col>
                                </Col>
                                </Row>
                              }
                              {
                              (isKDW) &&
                              <Row>
                                <Col xs={6}>
                                <Col xs={2} className="pr1">
                                    <label >
                                      Shipment ID
                                    </label>
                                    <Field
                                      name="ShipmentID"
                                      withRef
                                      ref="ShipmentID"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('ServiceType', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      Service Type
                                    </label>
                                    <Field
                                      name="ServiceType"
                                      withRef
                                      ref="ServiceType"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('ISANum', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      ISA Num
                                    </label>
                                    <Field
                                      name="ISANum"
                                      withRef
                                      ref="ISANum"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('CustomerRef', event);
                                      }}
                                    />
                                  </Col>


                                  <Col xs={2} className="pr0">
                                    <label >
                                      Cust Ref#
                                    </label>
                                    <Field
                                      name="CustomerRef"
                                      withRef
                                      ref="CustomerRef"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('Unloader', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      Unloader
                                    </label>
                                    <Field
                                      name="Unloader"
                                      withRef
                                      ref="Unloader"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('TruckVendor', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                    Truck Vendor
                                    </label>
                                    <Field
                                      name="TruckVendor"
                                      withRef
                                      ref="TruckVendor"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('PalletQuantity', event);
                                      }}
                                    />
                                  </Col>
                                </Col>
                                <Col xs={6}>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="plt_qty" />
                                    </label>
                                    <Field
                                      name="PalletQuantity"
                                      withRef
                                      ref="PalletQuantity"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('PalletLength', event);
                                      }}
                                      // placeholder="must be > 0"
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label >
                                      Plt L
                                    </label>
                                    <Field
                                      name="PalletLength"
                                      withRef
                                      ref="PalletLength"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('PalletWidth', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label >
                                      Plt W
                                    </label>
                                    <Field
                                      name="PalletWidth"
                                      withRef
                                      ref="PalletWidth"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('PalletHeight', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label >
                                      Plt H
                                    </label>
                                    <Field
                                      name="PalletHeight"
                                      withRef
                                      ref="PalletHeight"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('PalletVol', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      Plt CBM
                                    </label>
                                    <Field
                                      name="PalletVol"
                                      withRef
                                      ref="PalletVol"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('PalletWeight', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="plt_weight" />
                                    </label>
                                    <Field
                                      name="PalletWeight"
                                      withRef
                                      ref="PalletWeight"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (event.charCode === 13) {
                                          if (!this.state.selectedInventoryRow) {
                                            return;
                                          }
                                          if (isABCFF) {
                                            this.handleKeyPress('CantonNum', event);
                                          } else {
                                          this.handleFocusAutoSuggest();
                                          this.checkMoveToSo();
                                          }
                                        }
                                        }}
                                    />
                                  </Col>
                                  {/* <Col xs={2} className="pr0">
                                    <label style={{width: '100%'}}>
                                      <Translate value="oversize" />
                                    </label>
                                    <Field name="IsOversize" component={Checkbox} />
                                  </Col> */}
                                  {/* <Col xs={2} className="pr0">
                                    <label style={{width: '100%'}}>
                                      <Translate value="overweight" />
                                    </label>
                                    <Field name="IsOverweight" component={Checkbox} />
                                  </Col> */}
                                  {
                                    !(isABCFF) &&
                                  <Col xs={1} className="pr0">
                                      <div style={{height: '12px'}}></div>
                                      <Button
                                        id="product-add-button"
                                        bsStyle="success"
                                        onClick={() => {
                                          this.checkMoveToSo();
                                        }}
                                      >
                                        +
                                      </Button>
                                    </Col>
                                  }
                                </Col>
                              </Row>
                              }
                              {
                              (isYI) &&
                              <Row>
                                <Col xs={6}>
                                  <Col xs={2} className="pr1">
                                    <label >
                                      Ttl Ship Wt
                                    </label>
                                    <Field
                                      name="TotalShippingWeight"
                                      withRef
                                      ref="TotalShippingWeight"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('NMFCClass', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      NMFC
                                    </label>
                                    <Field
                                      name="NMFCClass"
                                      withRef
                                      ref="NMFCClass"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('PalletQuantity', event);
                                      }}
                                    />
                                  </Col>
                                </Col>
                                <Col xs={6}>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="plt_qty" />
                                    </label>
                                    <Field
                                      name="PalletQuantity"
                                      withRef
                                      ref="PalletQuantity"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('PalletLength', event);
                                      }}
                                      // placeholder="must be > 0"
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label >
                                      Plt L
                                    </label>
                                    <Field
                                      name="PalletLength"
                                      withRef
                                      ref="PalletLength"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('PalletWidth', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label >
                                      Plt W
                                    </label>
                                    <Field
                                      name="PalletWidth"
                                      withRef
                                      ref="PalletWidth"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('PalletHeight', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label >
                                      Plt H
                                    </label>
                                    <Field
                                      name="PalletHeight"
                                      withRef
                                      ref="PalletHeight"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('PalletVol', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      Plt CBM
                                    </label>
                                    <Field
                                      name="PalletVol"
                                      withRef
                                      ref="PalletVol"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('PalletWeight', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="plt_weight" />
                                    </label>
                                    <Field
                                      name="PalletWeight"
                                      withRef
                                      ref="PalletWeight"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (event.charCode === 13) {
                                          if (!this.state.selectedInventoryRow) {
                                            return;
                                          }
                                          if (isABCFF) {
                                            this.handleKeyPress('UnitQuantity', event);
                                          } else {
                                          this.handleFocusAutoSuggest();
                                          this.checkMoveToSo();
                                          }
                                        }
                                        }}
                                    />
                                  </Col>
                                  {/* <Col xs={2} className="pr0">
                                    <label style={{width: '100%'}}>
                                      <Translate value="oversize" />
                                    </label>
                                    <Field name="IsOversize" component={Checkbox} />
                                  </Col> */}
                                  {/* <Col xs={2} className="pr0">
                                    <label style={{width: '100%'}}>
                                      <Translate value="overweight" />
                                    </label>
                                    <Field name="IsOverweight" component={Checkbox} />
                                  </Col> */}
                                  {
                                    !(isABCFF) &&
                                  <Col xs={1} className="pr0">
                                      <div style={{height: '12px'}}></div>
                                      <Button
                                        id="product-add-button"
                                        bsStyle="success"
                                        onClick={() => {
                                          this.checkMoveToSo();
                                        }}
                                      >
                                        +
                                      </Button>
                                    </Col>
                                  }
                                </Col>
                              </Row>
                              }
                              {
                              (isDSQ || isWUFS || isABCFF || isFBD) &&
                              <Row>
                                <Col xs={6}>
                                </Col>
                                <Col xs={6}>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="plt_qty" />
                                    </label>
                                    <Field
                                      name="PalletQuantity"
                                      withRef
                                      ref="PalletQuantity"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('PalletLength', event);
                                      }}
                                      // placeholder="must be > 0"
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label >
                                      Plt L
                                    </label>
                                    <Field
                                      name="PalletLength"
                                      withRef
                                      ref="PalletLength"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('PalletWidth', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label >
                                      Plt W
                                    </label>
                                    <Field
                                      name="PalletWidth"
                                      withRef
                                      ref="PalletWidth"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('PalletHeight', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label >
                                      Plt H
                                    </label>
                                    <Field
                                      name="PalletHeight"
                                      withRef
                                      ref="PalletHeight"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('PalletVol', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      Plt CBM
                                    </label>
                                    <Field
                                      name="PalletVol"
                                      withRef
                                      ref="PalletVol"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('PalletWeight', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="plt_weight" />
                                    </label>
                                    <Field
                                      name="PalletWeight"
                                      withRef
                                      ref="PalletWeight"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (event.charCode === 13) {
                                          if (!this.state.selectedInventoryRow) {
                                            return;
                                          }
                                          if (isABCFF) {
                                            this.handleKeyPress('UnitQuantity', event);
                                          } else {
                                          this.handleFocusAutoSuggest();
                                          this.checkMoveToSo();
                                          }
                                        }
                                        }}
                                    />
                                  </Col>
                                  {/* <Col xs={2} className="pr0">
                                    <label style={{width: '100%'}}>
                                      <Translate value="oversize" />
                                    </label>
                                    <Field name="IsOversize" component={Checkbox} />
                                  </Col> */}
                                  {/* <Col xs={2} className="pr0">
                                    <label style={{width: '100%'}}>
                                      <Translate value="overweight" />
                                    </label>
                                    <Field name="IsOverweight" component={Checkbox} />
                                  </Col> */}
                                  {
                                    !(isABCFF) &&
                                  <Col xs={1} className="pr0">
                                      <div style={{height: '12px'}}></div>
                                      <Button
                                        id="product-add-button"
                                        bsStyle="success"
                                        onClick={() => {
                                          this.checkMoveToSo();
                                        }}
                                      >
                                        +
                                      </Button>
                                    </Col>
                                  }
                                </Col>
                              </Row>
                              }
                              {
                              // (isABCFF) &&
                              false &&
                              <Row>
                                <Col xs={12}>
                                <Col xs={2} className="pl0">
                                    <label >
                                      <Translate value="vendor_style" />
                                    </label>
                                    <Field
                                      name="VendorStyleNum"
                                      withRef
                                      ref="VendorStyleNum"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('TJXStyleNum', event);
                                      }}
                                      // placeholder="must be > 0"
                                    />
                                  </Col>
                                  <Col xs={2} className="pl0">
                                    <label >
                                      TJX Style
                                    </label>
                                    <Field
                                      name="TJXStyleNum"
                                      withRef
                                      ref="TJXStyleNum"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('LineDescription', event);
                                      }}
                                      // placeholder="must be > 0"
                                    />
                                  </Col>
                                  <Col xs={2} className="pl0">
                                    <label >
                                    <Translate value="description" />
                                    </label>
                                    <Field
                                      name="LineDescription"
                                      withRef
                                      ref="LineDescription"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('UPC', event);
                                      }}
                                      // placeholder="must be > 0"
                                    />
                                  </Col>
                                  <Col xs={2} className="pl0">
                                    <label >
                                    UPC
                                    </label>
                                    <Field
                                      name="UPC"
                                      withRef
                                      ref="UPC"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('Color', event);
                                      }}
                                      // placeholder="must be > 0"
                                    />
                                  </Col>
                                  <Col xs={2} className="pl0">
                                    <label >
                                    <Translate value="color" />
                                    </label>
                                    <Field
                                      name="Color"
                                      withRef
                                      ref="Color"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('Size', event);
                                      }}
                                      // placeholder="must be > 0"
                                    />
                                  </Col>
                                  <Col xs={2} className="pr1">
                                    <label >
                                    Size/Ratios
                                    </label>
                                    <Field
                                      name="Size"
                                      withRef
                                      ref="Size"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('TotalUnits', event);
                                      }}
                                      // placeholder="must be > 0"
                                    />
                                  </Col>
                                </Col>
                              </Row>
                              }
                              {
                              (isABCFF) &&
                              <Row>
                                <Col xs={6}>
                                </Col>
                                <Col xs={6}>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="unit_qty" />
                                    </label>
                                    <Field
                                      name="UnitQuantity"
                                      withRef
                                      ref="UnitQuantity"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('UnitLength', event);
                                      }}
                                      // placeholder="must be > 0"
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label >
                                      Unt L
                                    </label>
                                    <Field
                                      name="UnitLength"
                                      withRef
                                      ref="UnitLength"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('UnitWidth', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label >
                                      Unt W
                                    </label>
                                    <Field
                                      name="UnitWidth"
                                      withRef
                                      ref="UnitWidth"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('UnitHeight', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label >
                                      Unt H
                                    </label>
                                    <Field
                                      name="UnitHeight"
                                      withRef
                                      ref="UnitHeight"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('UnitVol', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      Unt CBM
                                    </label>
                                    <Field
                                      name="UnitVol"
                                      withRef
                                      ref="UnitVol"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('CantonNum', event);
                                      }}
                                    />
                                  </Col>
                                  {/* <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="plt_weight" />
                                    </label>
                                    <Field
                                      name="PalletWeight"
                                      withRef
                                      ref="PalletWeight"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (event.charCode === 13) {
                                          if (!this.state.selectedInventoryRow) {
                                            return;
                                          }
                                          if (isABCFF) {
                                            this.handleKeyPress('CantonNum', event);
                                          } else {
                                          this.handleFocusAutoSuggest();
                                          this.checkMoveToSo();
                                          }
                                        }
                                        }}
                                    />
                                  </Col> */}
                                  {/* <Col xs={2} className="pr0">
                                    <label style={{width: '100%'}}>
                                      <Translate value="oversize" />
                                    </label>
                                    <Field name="IsOversize" component={Checkbox} />
                                  </Col> */}
                                  {/* <Col xs={2} className="pr0">
                                    <label style={{width: '100%'}}>
                                      <Translate value="overweight" />
                                    </label>
                                    <Field name="IsOverweight" component={Checkbox} />
                                  </Col> */}
                                 
                                </Col>
                              </Row>
                              }
                              {
                              (isABCFF) &&
                              <Row>
                                 <Col xs={4}>
                                </Col>
                                <Col xs={8}>
                                {/* <Col xs={2} className="pl0">
                                    <label >
                                      <Translate value="total_units" />
                                    </label>
                                    <Field
                                      name="TotalUnits"
                                      withRef
                                      ref="TotalUnits"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('StoreReady', event);
                                      }}
                                      // placeholder="must be > 0"
                                    />
                                  </Col> */}
                                  <Col xs={2} className="pr0">
                                  <label style={{width: '100%'}}>
                                    <Translate value="stackable" />
                                    </label>
                                    <Field name="PalletStackable" component={Checkbox} />
                                    {/* <Field
                                      name="StoreReady"
                                      withRef
                                      ref="StoreReady"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('Preticketed', event);
                                      }}
                                      // placeholder="must be > 0"
                                    /> */}
                                  </Col>

                                  <Col xs={2} className="pr0">
                                  <label style={{width: '100%'}}>
                                    <Translate value="store_ready" />
                                    </label>
                                    <Field name="StoreReady" component={Checkbox} />
                                    {/* <Field
                                      name="StoreReady"
                                      withRef
                                      ref="StoreReady"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('Preticketed', event);
                                      }}
                                      // placeholder="must be > 0"
                                    /> */}
                                  </Col>
                                  <Col xs={2} className="pl0">
                                  <label style={{width: '100%'}}>
                                    <Translate value="preticketed" />
                                    </label>
                                    <Field name="Preticketed" component={Checkbox} />
                                    {/* <Field
                                      name="Preticketed"
                                      withRef
                                      ref="Preticketed"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('CantonNum', event);
                                      }}
                                      // placeholder="must be > 0"
                                    /> */}
                                  </Col>
                                  <Col xs={2} className="pl0">
                                    <label >
                                    Canton #
                                    </label>
                                    <Field
                                      name="CantonNum"
                                      withRef
                                      ref="CantonNum"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('OriginCountry', event);
                                      }}
                                      // placeholder="must be > 0"
                                    />
                                  </Col>
                                  <Col xs={3} className="pl0">
                                    <label >
                                    <Translate value="origin_country" />
                                    </label>
                                    <Field
                                      name="OriginCountry"
                                      withRef
                                      ref="OriginCountry"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (event.charCode === 13) {
                                          if (!this.state.selectedInventoryRow) {
                                            return;
                                          }
                                          this.handleFocusAutoSuggest();
                                          this.checkMoveToSo();
                                        }
                                      }}
                                      // placeholder="must be > 0"
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                      <div style={{height: '12px'}}></div>
                                      <Button
                                        id="product-add-button"
                                        bsStyle="success"
                                        onClick={() => {
                                          this.checkMoveToSo();
                                        }}
                                      >
                                        +
                                      </Button>
                                    </Col>

                                </Col>
                                
                              </Row>
                              }
                              {
                                isWIZ &&
                                  <Row>
                                    <Col xs={6}>
                                      <Col xs={2} className="pr1">
                                        {/* <label><Translate value="rcvd_qty" /></label> */}
                                        <label><Translate value="customer_qty" /></label>
                                        <Field
                                          name="ReceivedQuantity"
                                          withRef
                                          ref="ReceivedQuantity"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('ShipmentID', event);
                                          }}
                                        />
                                      </Col>
                                      <Col xs={2} className="pr0">
                                        <label><Translate value="cust_note" /></label>
                                        <Field
                                          name="ShipmentID"
                                          withRef
                                          ref="ShipmentID"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('DispatchType', event);
                                          }}
                                        />
                                      </Col>
                                      <Col xs={2} className="pr0">
                                        <label>WH Note</label>
                                        <Field
                                          name="DispatchType"
                                          withRef
                                          ref="DispatchType"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('PalletQuantity', event);
                                          }}
                                        />
                                      </Col>
                                      <Col xs={2} className="pr0">
                                        <label><Translate value="billable_plts" /></label>
                                        <Field
                                          name="BillablePallets"
                                          withRef
                                          ref="BillablePallets"
                                          component={InputField}
                                          disabled={true}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('PalletQuantity', event);
                                          }}
                                        />
                                      </Col>
                                      <Col xs={2} className="pr0">
                                        <label><Translate value="real_plts" /></label>
                                        <Field
                                          name="PalletQuantity"
                                          withRef
                                          ref="PalletQuantity"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('BoxPerPallet', event);
                                          }}
                                        />
                                      </Col>
                                      <Col xs={2} className="pr0">
                                        <label><Translate value="box_per_plt" /></label>
                                        <Field
                                          name="BoxPerPallet"
                                          withRef
                                          ref="BoxPerPallet"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('BoxLength', event);
                                          }}
                                        />
                                      </Col>
                                    </Col>

                                    <Col xs={6}>
                                    <Col xs={1} className="pr0">
                                        <label>Box L</label>
                                        <Field
                                          name="BoxLength"
                                          withRef
                                          ref="BoxLength"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('BoxWidth', event);
                                          }}
                                        />
                                      </Col>
                                      <Col xs={1} className="pr0">
                                        <label>Box W</label>
                                        <Field
                                          name="BoxWidth"
                                          withRef
                                          ref="BoxWidth"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('BoxHeight', event);
                                          }}
                                        />
                                      </Col>
                                      <Col xs={1} className="pr0">
                                        <label>Box H</label>
                                        <Field
                                          name="BoxHeight"
                                          withRef
                                          ref="BoxHeight"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) { return; }
                                            this.handleKeyPress('BoxVol', event);
                                          }}
                                        />
                                      </Col>
                                      <Col xs={2} className="pr0">
                                        <label>
                                          <Translate value="box_vol" />
                                        </label>
                                        <Field
                                          name="BoxVol"
                                          withRef
                                          ref="BoxVol"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('BoxWeight', event);
                                          }}
                                        />
                                      </Col>
                                      <Col xs={2} className="pr0">
                                        <label>
                                          <Translate value="box_weight" />
                                        </label>
                                        <Field
                                          name="BoxWeight"
                                          withRef
                                          ref="BoxWeight"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('PalletWeight', event);
                                          }}
                                        />
                                      </Col>
                                      {/* <Col xs={1} className="pr0">
                                        <label>Plt L</label>
                                        <Field
                                          name="PalletLength"
                                          withRef
                                          ref="PalletLength"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                            this.handleKeyPress('PalletWidth', event);
                                          }}
                                        />
                                      </Col>
                                      <Col xs={1} className="pr0">
                                        <label>Plt W</label>
                                        <Field
                                          name="PalletWidth"
                                          withRef
                                          ref="PalletWidth"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('PalletHeight', event);
                                          }}
                                        />
                                      </Col>
                                      <Col xs={1} className="pr0">
                                        <label >Plt H</label>
                                        <Field
                                          name="PalletHeight"
                                          withRef
                                          ref="PalletHeight"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('PalletVol', event);
                                          }}
                                        />
                                      </Col>
                                      <Col xs={2} className="pr0">
                                        <label >
                                          <Translate value="plt_vol" />
                                        </label>
                                        <Field
                                          name="PalletVol"
                                          withRef
                                          ref="PalletVol"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('PalletWeight', event);
                                          }}
                                        />
                                      </Col> */}
                                      <Col xs={2} className="pr0">
                                        <label >
                                          <Translate value="plt_weight" />
                                        </label>
                                        <Field
                                          name="PalletWeight"
                                          withRef
                                          ref="PalletWeight"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('PortDray', event);
                                          }}
                                        />
                                      </Col>
                                      {/* <Col xs={2} className="pr0">
                                        <label style={{width: '100%'}}>
                                          <Translate value="oversize" />
                                        </label>
                                        <Field name="IsOversize" component={Checkbox} />
                                      </Col> */}
                                      {/* <Col xs={2} className="pr0">
                                        <label style={{width: '100%'}}>
                                          <Translate value="overweight" />
                                        </label>
                                        <Field name="IsOverweight" component={Checkbox} />
                                      </Col> */}
                                      {/* <Col xs={1} className="pr1">
                                      <div style={{height: '12px'}}></div>
                                      <Button
                                            id="product-add-button"
                                            bsStyle="success"
                                            onClick={() => {
                                              this.checkMoveToSo();
                                            }
                                          }
                                          >
                                            +
                                        </Button>
                                      </Col> */}
                                    </Col>
                                  </Row>
                              }
                              {
                                isWIZ &&
                                <Row>
                                  <Col xs={6}>
                                    <Col xs={2} className="pr1">
                                      <label >
                                        <Translate value="port_dray" />
                                      </label>
                                      <Field
                                        name="PortDray"
                                        withRef
                                        ref="PortDray"
                                        component={InputField}
                                        onFocus={this.handleOnFocus}
                                        onKeyPress={(event) => {
                                          if (!this.state.selectedInventoryRow) {
                                          return;
                                          }
                                          this.handleKeyPress('DrayageTrucker', event);
                                        }}
                                      />
                                    </Col>
                                    <Col xs={2}>
                                      <label >
                                        <Translate value="dray_trucker" />
                                      </label>
                                      <Field
                                        name="DrayageTrucker"
                                        withRef
                                        ref="DrayageTrucker"
                                        component={InputField}
                                        onFocus={this.handleOnFocus}
                                        onKeyPress={(event) => {
                                          if (!this.state.selectedInventoryRow) {
                                          return;
                                          }
                                          this.handleKeyPress('Location', event);
                                        }}
                                      />
                                    </Col>
                                    <Col xs={2}>
                                      <label >
                                        <Translate value="location" />
                                      </label>
                                      <Field
                                        name="Location"
                                        withRef
                                        ref="Location"
                                        component={InputField}
                                        onFocus={this.handleOnFocus}
                                        onKeyPress={(event) => {
                                        if (event.charCode === 13) {
                                          if (!this.state.selectedInventoryRow) {
                                            return;
                                          }
                                          this.handleFocusAutoSuggest();
                                          this.checkMoveToSo();
                                        }
                                        }}
                                      />
                                    </Col>
                                    <Col xs={1} className="pr1">
                                      <div style={{height: '12px'}}></div>
                                      <Button
                                        id="product-add-button"
                                        bsStyle="success"
                                        onClick={() => {
                                          this.checkMoveToSo();
                                        }}
                                      >
                                        +
                                      </Button>
                                    </Col>
                                  </Col>
                                  <Col xs={6}>
                                  </Col>
                                </Row>
                              }
                            </Col>
                          </Row>
                          {/* Inventory Details */}
                          { (!isChinaTown && !isFJ) &&
                          <Row id="inventory-details">
                            <Col xs={1}>
                              <label className="inventory-label"><Translate value="inventory" />:</label>
                            </Col>
                            <Col xs={5}>
                              <Row>
                                <Col xs={4}>
                                  <label className="col-xs-6 inlineLabel"><Translate value="in_stock" /><span className="colon">:</span></label>
                                  <span className="col-xs-6 inventory-highlight"> {this.state.inStock}</span>
                                </Col>
                                <Col xs={4}>
                                  <label className="col-xs-7 inlineLabel"><Translate value="purchased" /><span className="colon">:</span></label>
                                  <span className="col-xs-5 inventory-highlight"> {this.state.purchased}</span>
                                </Col>
                                <Col xs={4}>
                                  <label className="col-xs-6 inlineLabel"><Translate value="presale" /><span className="colon">:</span></label>
                                  <span className="col-xs-6 inventory-highlight"> {this.state.presale}</span>
                                </Col>
                              </Row>
                            </Col>
                            <Col xs={6}>
                              <Col xs={4}>
                                <label className="col-xs-5 inlineLabel"><Translate value="net_wt" /><span className="colon">:</span></label>
                                <span className="col-xs-6 inventory-highlight"> {this.state.net_weight}</span>
                              </Col>
                              <Col xs={4}>
                                <label className="col-xs-5 inlineLabel"><Translate value="ship_wt" /><span className="colon">:</span></label>
                                <span className="col-xs-6 inventory-highlight"> {this.state.ship_weight}</span>
                              </Col>
                              <Col xs={4}>
                                <label className="col-xs-5 inlineLabel"><Translate value="total_wt" /><span className="colon">:</span></label>
                                <span className="col-xs-6 inventory-highlight"> {this.state.total_weight}</span>
                              </Col>
                            </Col>
                          </Row>
                          }
                          { isChinaTown &&
                            <Row id="inventory-details" style={{fontSize: '15px'}}>
                              <Col xs={1}>
                                <label className="inventory-label-china"><Translate value="inventory" />:</label>
                              </Col>
                              <Col xs={5}>
                                <Row>
                                  <Col xs={4} className="pr1">
                                    <label className="col-xs-6 inlineLabel"><Translate value="in_stock" /><span className="colon">:</span></label>
                                    <span className="col-xs-6 inventory-highlight-china"> {this.state.inStock}</span>
                                  </Col>
                                  <Col xs={4} className="pr1">
                                    <label className="col-xs-7 inlineLabel"><Translate value="purchased" /><span className="colon">:</span></label>
                                    <span className="col-xs-5 inventory-highlight-china"> {this.state.purchased}</span>
                                  </Col>
                                  <Col xs={4} className="pr1">
                                    <label className="col-xs-6 inlineLabel"><Translate value="presale" /><span className="colon">:</span></label>
                                    <span className="col-xs-6 inventory-highlight-china"> {this.state.presale}</span>
                                  </Col>
                                </Row>
                              </Col>
                              <Col xs={6}>
                                <Col xs={4} className="pr1">
                                  <label className="col-xs-5 inlineLabel"><Translate value="net_wt" /><span className="colon">:</span></label>
                                  <span className="col-xs-6 inventory-highlight-china"> {this.state.net_weight}</span>
                                </Col>
                                <Col xs={4} className="pr1">
                                  <label className="col-xs-5 inlineLabel"><Translate value="ship_wt" /><span className="colon">:</span></label>
                                  <span className="col-xs-6 inventory-highlight-china"> {this.state.ship_weight}</span>
                                </Col>
                                <Col xs={4} className="pr1">
                                  <label className="col-xs-5 inlineLabel"><Translate value="total_wt" /><span className="colon">:</span></label>
                                  <span className="col-xs-6 inventory-highlight-china"> {this.state.total_weight}</span>
                                </Col>
                              </Col>
                            </Row>
                          }
                          {
                            isEcity && (
                            <Row id="inventory-details">
                              <Col xs={1}>
                                <label className="inventory-label"><Translate value="last_sale" />:</label>
                              </Col>
                              <Col xs={5}>
                                <Row>
                                  <Col xs={4}>
                                    <label className="col-xs-6 inlineLabel"><Translate value="price" /><span className="colon">:</span></label>
                                    <span className="col-xs-6 inventory-highlight"> {this.state.salesItemHistory[0] && this.state.salesItemHistory[0].UnitPrice}</span>
                                  </Col>
                                  <Col xs={5}>
                                    <label className="col-xs-7 inlineLabel" style={{ width: '60px'}}><Translate value="date" /><span className="colon">:</span></label>
                                    <span className="col-xs-5 inventory-highlight" style={{ width: '80px'}}> {this.state.salesItemHistory[0] && this.state.salesItemHistory[0].Date}</span>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>)
                          }
                        </Tab>
                        {this.renderRollingGate()}
                        {
                          !(isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) &&
                          <Tab eventKey={2} title={frequentProducts}>
                            <div className="tab-products-table sales-order-freq-products">
                              <Button className="btn btn-primary position" disabled={(!(this.state.frequentItems.selectedIndexes) || this.state.frequentItems.selectedIndexes.length === 0)} onClick={() => { this.moveFromFrequentItemsToSalesOrder(); }}><em className="fa fa-plus" /></Button>
                              {this.renderFrequent()}
                            </div>
                          </Tab>
                        }
                        <Tab eventKey={3} title={previousOrderList}>
                          <div className="tab-products-table">
                            <Row>
                              <Col xs={8} style={{ marginTop: '-12px', paddingBottom: '13px', zIndex: '1' }}>
                                <Button
                                  className="btn btn-primary"
                                  onClick={this.handleShowAll}
                                >
                                  <Translate value="show_from_all_orders" />
                                </Button>
                                <Button
                                  className="btn btn-primary"
                                  style={{ marginLeft: '5px' }}
                                  onClick={this.handleSelectAll}
                                >
                                  <Translate value="select_all" />
                                </Button>
                                <Button
                                  className="btn btn-primary"
                                  bsStyle="danger"
                                  style={{ marginLeft: '5px' }}
                                  onClick={this.handleDeselectAll}
                                >
                                  <Translate value="deselect_all" />
                                </Button>
                                <Button
                                  className="btn btn-primary"
                                  style={{ marginLeft: '5px' }}
                                  disabled={(!(this.state.previousOrders.selectedIndexes) || this.state.previousOrders.selectedIndexes.length === 0)}
                                  onClick={() => { this.moveFromPreviousOrderToSalesOrder(); }}
                                >
                                  <em className="fa fa-plus" />
                                </Button>
                                <input
                                  style={{width: '150px', borderRadius: '5px', marginLeft:'5px', border: '1px solid black'}}
                                  type="text"
                                  onChange={e => { this.onChangeQuickEntry(e); }}
                                  onKeyPress={e => { this.onKeyPressQuickEntry(e); }}
                                  value={this.state.quickEntrySONum}
                                  placeholder={I18n.t('order_num')}
                                />
                                {
                                  this.state.quickEntryShowError &&
                                  <span style={{ marginLeft: '3px', color: 'red' }}>
                                    <Translate value="so_not_found" />
                                  </span>
                                }
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={2}>
                                {this.renderPreviousSOs()}
                              </Col>
                              <Col xs={10} style={{ marginTop: '-18px' }}>
                                {this.renderPreviousOrders()}
                              </Col>
                            </Row>
                          </div>
                        </Tab>
                        {
                          !(isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) &&
                        <Tab eventKey={4} title={favoriteList}>
                          <div className="tab-products-table">
                            <Button
                              bsStyle="primary"
                              disabled={(!(this.state.favorites.selectedIndexes) || this.state.favorites.selectedIndexes.length == 0)}
                              onClick={() => {
                                this.moveFromFavoriteItemsToSalesOrder();
                              }}
                            >
                              <em className="fa fa-plus" />
                            </Button>
                            {this.renderFavoritesList()}
                          </div>
                        </Tab>
                        }
                      </Tabs>
                    </fieldset>
                  </Row>
                }
                {
                  (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') &&
                  <Row>
                  {this.productHeader()}
                    <fieldset className="form-horizontal">
                      <Tabs activeKey={this.state.yourOrderKey} justified onSelect={this.handleSelect}>
                        <Tab eventKey={1} title={inboundProducts}>
                          <div className="tab-products-table sales-order-freq-products">
                            <Button className="btn btn-primary position" disabled={this.checkblah()} onClick={() => { this.moveFromFrequentItemsToSalesOrder(); }}><em className="fa fa-plus" /></Button>
                            {/* (!(this.state.frequentItems.selectedIndexes) || this.state.frequentItems.selectedIndexes.length === 0) */}
                            {this.renderInboundProducts()}
                          </div>
                        </Tab>
                      </Tabs>
                    </fieldset>
                  </Row>
                }
                {
                  !isMAG &&
                  <Row>
                    {!isFJ && this.orderHeader()}
                    <fieldset className="form-horizontal">
                      <Panel>
                        {this.renderTable()}
                      </Panel>
                    </fieldset>
                  </Row>
                }
              </Col>
                {/* SO Details Pane */}
                <Col xs={2} className="sales-order-details-panel" style={{marginTop: isFJ ? '11px' : '0px'}}>
                  <Tabs defaultActiveKey={1} justified className="tab-width-fix" >
                    <Tab eventKey={1} title={SODetails} className="so-details-tab">
                      {
                        isChinaTown && //chinatest
                      <Row className="customer-specific-price-details">
                        <Col xs={6}>
                          <label><Translate value="ref" /></label>
                                : <span className="dollar-sign">$</span>{this.state.RefPrice ? this.state.RefPrice.toFixed(2) : '--'}
                        </Col>
                        <Col xs={6}>
                          <label><Translate value="lowest" /></label>
                                : <span className="dollar-sign">$</span>{this.state.LowestSalePrice ? this.state.LowestSalePrice.toFixed(2) : '--'}
                        </Col>
                          <Col xs={6}>
                            <label><Translate value="Lv1" /></label>
                                : <span className="dollar-sign">$</span>{this.state.PriceLv1 ? this.state.PriceLv1.toFixed(2) : '--'}
                          </Col>
                          <Col xs={6}>
                          <label><Translate value="Lv2" /></label>
                              : <span className="dollar-sign">$</span>{this.state.PriceLv2 ? this.state.PriceLv2.toFixed(2) : '--'}
                          </Col>
                          <Col xs={6}>
                          <label><Translate value="Lv3" /></label>
                              : <span className="dollar-sign">$</span>{this.state.PriceLv3 ? this.state.PriceLv3.toFixed(2) : '--'}
                          </Col>
                          <Col xs={6}>
                          <label><Translate value="Lv4" /></label>
                              : <span className="dollar-sign">$</span>{this.state.PriceLv4 ? this.state.PriceLv4.toFixed(2) : '--'}
                          </Col>
                          <Col xs={6}>
                          <label><Translate value="Lv5" /></label>
                              : <span className="dollar-sign">$</span>{this.state.PriceLv5 ? this.state.PriceLv5.toFixed(2) : '--'}
                          </Col>
                        {
                          isJML &&
                          <div>
                          <Col xs={4}>
                            <label><Translate value="payment_term_short" />:</label>
                          </Col>
                          <Col xs={8}>
                            <Field name="PaymentTerm_id" component={Selection} options={this.state.paymentTermOptions}/>
                          </Col>
                          </div>
                        }
                        {this.renderDeliveryMethodInfo()}
                      </Row>
                      }

                      {
                        !isChinaTown &&
                      <Row className="sales-order-number">
                        <Col xs={3}>
                          <label><Translate value={(isWIZ || isJTB || isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isFJ) ? "order_no" : "so_no"} /></label>
                        </Col>
                        <Col xs={9}>
                          <Field
                            name="SONum"
                            component={this.props.currentSalesOrderDetail != null && (this.props.currentSalesOrderDetail.SaleStatus === 'Open' || this.props.currentSalesOrderDetail.SaleStatus === 'Packing')
                                        ? InputField : DisabledInputField}
                            placeholder={this.state.salesOrderNumber}
                          />
                        </Col>
                      </Row>
                    }
                    {
                      !isChinaTown &&
                      <Row className="customer-specific-price-details">
                        {this.renderSales()}
                        <Col xs={12}>
                          <label><Translate value="created_by" /></label>
                                : {this.state.creator}
                        </Col>
                        <Col xs={12}>
                          <label><Translate value="modified_last_by" /></label>
                                : {this.state.modified_by}
                        </Col>
                        {!isHMM &&
                          <Col xs={12}>
                            <label><Translate value="customer_price_level" /></label>
                                : {this.state.customerPriceLevel}
                          </Col>
                        }
                        {
                          !isJML &&
                          <Col xs={12}>
                          <label><Translate value="payment_term" /></label>
                              : {this.state.customerPaymentTerm}
                          </Col>
                        }
                        {
                          isJML &&
                          <div>
                          <Col xs={4}>
                            <label><Translate value="payment_term_short" />:</label>
                          </Col>
                          <Col xs={8}>
                            <Field name="PaymentTerm_id" component={Selection} options={this.state.paymentTermOptions}/>
                          </Col>
                          </div>
                        }
                        {this.renderDeliveryMethodInfo()}
                      </Row>
                    }
                    {
                      !isChinaTown && !isElegant &&
                      <Row className="sale-pricing-details">
                        <Col xs={4} style={{ padding: '0px'}}>
                          {/* <label><Translate value="disc" />%</label>
                          <Field
                              name="Discount"
                              component={InputField}
                              onChange={this.handleDiscountChange}
                            /> */}
                          { this.renderDiscountAmount() }
                        </Col>
                        <Col xs={4} style={{ paddingRight: '0px' }}>
                          <label><Translate value="tax" /><span className="dollar-sign">$</span></label>
                          <div onDoubleClick={() => { this.openChangeTax() }} style={{ width: '55px', borderRadius: '3px', padding: '2px 5px', border: '1px solid black', backgroundColor: '#dddddd' }}>
                            {parseFloat(totalTaxWithPromotion).toFixed(2)}
                          </div>
                          {/* <span onDoubleClick={() => { this.openChangeTax(); }}><Field name="Tax" component={DisabledInputField} placeholder={parseFloat(totalTaxWithPromotion).toFixed(2)} /></span> */}
                        </Col>
                        <Col xs={4} style={{ paddingRight: '0px' }}>
                          <label><Translate value="CRV" /><span className="dollar-sign">$</span></label>
                          <Field name="CRV" component={DisabledInputField} placeholder={(this.state.totalCRV).toFixed(2)} />
                        </Col>
                      </Row>
                    }
                    {
                      isElegant &&
                      <Row className="sale-pricing-details">
                        <Col xs={6} style={{ padding: '0px'}}>
                          { this.renderDiscountAmount() }
                        </Col>
                        <Col xs={6} style={{ paddingRight: '0px' }}>
                          <label><Translate value="tax" /><span className="dollar-sign">$</span></label>
                          <span onDoubleClick={() => { this.openChangeTax(); }}><Field name="Tax" component={DisabledInputField} placeholder={parseFloat(totalTaxWithPromotion).toFixed(2)} /></span>
                        </Col>
                      </Row>
                    }
                    {
                      !isChinaTown &&
                      <Row className="sale-details-output">
                        {
                          (isMyumyu || isAFG || isRivera || isWecom || isDHC || isAFM || isEcity || isElegant) &&
                          <Col xs={12}>
                            <Row className="pricing-highlight">
                              <Col xs={6}>
                                <label><Translate value="delivery" /><span className="dollar-sign">$$</span>:</label>
                              </Col>
                              <Col xs={6}>
                                <div onDoubleClick={() => { this.openDeliveryFee(); }} >
                                  <label style={{color: 'blue'}}><span className="dollar-sign">$</span>{(this.state.delivery).toFixed(2)}</label>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        }
                        <Col xs={12}>
                          <Row className="pricing-highlight">
                            <Col xs={6}>
                              <label><Translate value="order" /><span className="dollar-sign">$$</span>:</label>
                            </Col>
                            <Col xs={6}>
                              <label><span className="dollar-sign">$</span>{(this.state.totalPrice).toFixed(2)}</label>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={12}>
                          <Row className="pricing-highlight">
                            <Col xs={6}>
                              <label><Translate value="transaction_fee" /><span className="dollar-sign">$$</span>:</label>
                            </Col>
                            <Col xs={6}>
                              <label><span className="dollar-sign">$</span>{(this.state.fee).toFixed(2)}</label>
                            </Col>
                          </Row>
                        </Col>
                        {
                          (this.state.creditAmount > 0) &&
                          <Col xs={12}>
                            <Row className="pricing-highlight">
                              <Col xs={6}>
                                <label><Translate value="credit" /><span className="dollar-sign">$$</span>:</label>
                              </Col>
                              <Col xs={6}>
                                <label>
                                  {/* {
                                  (this.state.creditAmount > 0) &&
                                  <span>-</span>
                                } */}
                                  <span style={{ paddingLeft: '0px' }} className="dollar-sign">-$</span>
                                  {this.state.creditAmount}
                                </label>
                              </Col>
                            </Row>
                          </Col>
                        }
                        {
                          (this.state.shareCreditAmount > 0) &&
                          <Col xs={12}>
                            <Row className="pricing-highlight">
                              <Col xs={6}>
                                <label><Translate value="share" /><span className="dollar-sign">$$</span>:</label>
                              </Col>
                              <Col xs={6}>
                                <label>
                                  <span style={{ paddingLeft: '0px' }} className="dollar-sign">-$</span>
                                  {this.state.shareCreditAmount}
                                </label>
                              </Col>
                            </Row>
                          </Col>
                        }
                        <Col xs={12}>
                          <Row className="pricing-highlight">
                            <Col xs={6}>
                              <label><Translate value="final" /><span className="dollar-sign">$$</span>:</label>
                            </Col>
                            <Col xs={6}>
                              <label><span className="dollar-sign">$</span>{parseFloat((this.state.finalPriceWithPromotion)).toFixed(2)}</label>
                            </Col>
                          </Row>
                        </Col>
                        {
                          !isHMM &&
                          <div>
                            <Col xs={6}>
                              <label><Translate value="net_wt" />:</label>
                            </Col>
                            <Col xs={6}>
                              <label>{dispNetWeight} lb</label>
                            </Col>
                            <Col xs={6}>
                              <label><Translate value="ship_wt" />:</label>
                            </Col>
                            {/* <Col xs={3}>
                          <span onDoubleClick={() => { this.openChangeWeight(); }}><Field name="ShippingWeight" component={DisabledInputField} placeholder={dispShippingWeight}/></span>
                        </Col>
                        <Col xs={1} style={{padding:'0px'}}>
                          <span style={{fontWeight: '550'}}>lb</span>
                        </Col> */}
                            <Col xs={6}>
                              <div onDoubleClick={() => { this.openChangeWeight(); }} >
                                <label style={{ color: 'blue' }}>{dispShippingWeight}</label>
                                <span style={{ fontWeight: '550' }}> lb</span>
                              </div>
                            </Col>
                          </div>
                        }
                        {this.renderSalesOrderMargin()}
                      </Row>
                    }
                    {
                      (!isWIZ && !isDSQ && !isWUFS && !isABCFF && !isKDW && !isYI && !isFBD && !isFJ && !isJTB) &&
                      <Row className="sale-history-details" style={{ 'margin-top': '0' }}>
                        <Col xs={12}>
                          <h4 style={{ marginBottom: '5px'}}><Translate value="sales_history" /></h4>
                          {/* {this.state.productHistoryLabel} */}
                          {this.renderItemHistory()}
                        </Col>
                      </Row>
                    }
                    {
                      isChinaTown &&
                      <Row className="sales-order-number">
                        <Col xs={3}>
                          <label style={{marginBottom: '0px'}}><Translate value="so_no" /></label>
                        </Col>
                        <Col xs={9}>
                          <Field
                            name="SONum"
                            component={this.props.currentSalesOrderDetail != null && (this.props.currentSalesOrderDetail.SaleStatus === 'Open' || this.props.currentSalesOrderDetail.SaleStatus === 'Packing')
                                        ? InputField : DisabledInputField}
                            placeholder={this.state.salesOrderNumber}
                          />
                        </Col>
                      </Row>
                    }
                    {
                      isChinaTown &&
                      <Row className="customer-specific-price-details">
                        <Col xs={12}>
                          <label><Translate value="created_by" /></label>
                                {/* : {this.state.created_by} */}
                                : {this.state.created_by_name}
                        </Col>
                        <Col xs={12}>
                          <label><Translate value="modified_last_by" /></label>
                                : {this.state.modified_by}
                        </Col>
                        {!isHMM &&
                          <Col xs={12}>
                            <label><Translate value="customer_price_level" /></label>
                                : {this.state.customerPriceLevel}
                          </Col>
                        }
                        {
                          !isJML &&
                          <Col xs={12}>
                          <label><Translate value="payment_term" /></label>
                              : {this.state.customerPaymentTerm}
                          </Col>
                        }
                        {
                          isJML &&
                          <div>
                          <Col xs={4}>
                            <label><Translate value="payment_term_short" />:</label>
                          </Col>
                          <Col xs={8}>
                            <Field name="PaymentTerm_id" component={Selection} options={this.state.paymentTermOptions}/>
                          </Col>
                          </div>
                        }
                        {this.renderDeliveryMethodInfo()}
                      </Row>
                    }
                    {
                      isChinaTown &&
                      <Row className="sale-details-output"  style={{marginTop: isChinaTown ? '0px' : '5px'}}>
                        <Col xs={12}>
                          <Row className="pricing-highlight">
                            <Col xs={6}>
                              <label><Translate value="order" /><span className="dollar-sign">$$</span>:</label>
                            </Col>
                            <Col xs={6}>
                              <label><span className="dollar-sign">$</span>{(this.state.totalPrice).toFixed(2)}</label>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={12}>
                          <Row className="pricing-highlight">
                            <Col xs={6}>
                              <label><Translate value="final" /><span className="dollar-sign">$$</span>:</label>
                            </Col>
                            <Col xs={6}>
                              <label><span className="dollar-sign">$</span>{parseFloat((this.state.finalPriceWithPromotion)).toFixed(2)}</label>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={12}>
                          <div style={{marginBottom: '10px'}}></div>
                        </Col>
                      </Row>
                    }
                    {
                      !isChinaTown &&
                      <Row className="customer-credit-details" style={{ 'margin-top': '0' }}>
                        <Col xs={12}>
                          {this.renderCustomerCredit()}
                        </Col>
                        <Col xs={6} style={{ color: 'red' }}>
                          <label>00-30 <Translate value="days" />:</label>
                        </Col>
                        <Col xs={6} style={{ color: 'red' }}>
                          <span className="dollar-sign">$</span>{(this.state.Amount00_30).toFixed(2)}
                        </Col>
                        <Col xs={6} style={{ color: 'red' }}>
                          <label>30-60 <Translate value="days" />:</label>
                        </Col>
                        <Col xs={6} style={{ color: 'red' }}>
                          <span className="dollar-sign">$</span>{(this.state.Amount31_60).toFixed(2)}
                        </Col>
                        <Col xs={6} style={{ color: 'red' }}>
                          <label>60-90 <Translate value="days" />:</label>
                        </Col>
                        <Col xs={6} style={{ color: 'red' }}>
                          <span className="dollar-sign">$</span>{(this.state.Amount61_90).toFixed(2)}
                        </Col>
                        <Col xs={6} style={{ color: 'red' }}>
                          <label>90+ <Translate value="days" />:</label>
                        </Col>
                        <Col xs={6} style={{ color: 'red' }}>
                          <span className="dollar-sign">$</span>{(this.state.Amount91).toFixed(2)}
                        </Col>
                        <Col xs={6}>
                          <label><Translate value="last_month" />:</label>
                        </Col>
                        <Col xs={6}>
                          <span className="dollar-sign">$</span>
                        </Col>
                        <Col xs={6}>
                          <label><Translate value="unpaid" />:</label>
                        </Col>
                        <Col xs={6}>
                          <span className="dollar-sign">$</span>
                        </Col>
                        <Col xs={6}>
                          <label><Translate value="credit_limit" />:</label>
                        </Col>
                        <Col xs={6}>
                          <span className="dollar-sign"></span>{this.state.CreditLimit}
                        </Col>
                        <Col xs={6}>
                          <label><Translate value="description" />:</label>
                        </Col>
                        <Col xs={6}>
                          <span className="dollar-sign"></span>{this.state.PaymentTermDesc}
                        </Col>
                        <Col xs={6}>
                          <label><Translate value="Credit"/>: <Translate value={this.props.salesCustomerDetails && this.props.salesCustomerDetails.CreditStatus ?
                            this.props.salesCustomerDetails.CreditStatus : ''} /></label>
                        </Col>
                      </Row>
                      }
                      {
                        !isChinaTown &&
                        <Row className="customer-note">
                          <Col xs={12} style={{ 'padding-left': '0' }}>
                            <Tabs justified className="notations">
                              <Tab eventKey={1} title={customerNote} >
                                <Field id="cust-note" name="Notation" maxLength={150} component="Textarea" className="form-control" style={{ minHeight: '130px' }}/>
                              </Tab>
                              <Tab eventKey={2} title={employeeNote} >
                                <span onDoubleClick={() => { this.openEmployeeNote(); }}>
                                  <Input
                                    type="text"
                                    value={this.state.employeeNoteDisplay}
                                    disabled
                                  />
                                </span>
                              </Tab>
                              <Tab eventKey={3} title={routeNote} >
                                <Field id="route-note" name="RouteNote" maxLength={150} component={InputField} />
                              </Tab>
                            </Tabs>
                          </Col>
                        </Row>
                    }
                    </Tab>
                    <Tab eventKey={2} title={CheckoutInfo} className="check-out-info-tab">
                      { this.renderPaymentInfo() }
                      <Row className="note-input-field">
                        <Col xs={12}>
                          <div>
                            <h4><Translate value="note" /></h4>
                          </div>
                        </Col>
                        <Col xs={12}>
                          <Field name="Note" component="Textarea" className="form-control" style={{ minHeight: '130px' }}/>
                        </Col>
                      </Row>
                    </Tab>
                  </Tabs>
                </Col> {/* End SO Details Pane */}
              </Row> {/* End Row Wrapper */}
            </Grid>
            <Notes isVisible={this.state.isNotesModalVisibile} setModalVisibility={this.setNotesModalVisibility} />
            <PromotionAddingModal
              isVisible={this.state.isPromotionAddingAlertModalVisible}
              onClose={this.setPromotionAddingAlertModalVisibility}
              onConfirm={this.handlePromotionAddConfirmClick}
              productPromotions={this.props.productPromotions}
            />
            <ShippingStatusEditModal 
              isVisible={this.state.shippingStatusEditModalVisible}
              onClose={this.setShippingStatsEditModalVisibility}
              currentSalesOrderDetail={this.props.currentSalesOrderDetail}
              reloadThePage={this.reloadThePage}
            />

            <SkyLightStateless dialogStyles={ShippingInfoConfirmModalStyle} isVisible={this.state.shippingInfoConfirmModalVisibility} onCloseClicked={() => { this.closeShippinggInfoConfirmModal(); }} title={'Shipping Info Confirmation'}>
              <ShippingInfoConfirmModal
                salesShippingCustomerDetails={this.props.salesShippingCustomerDetails || {}}
                CustomerDetail_id={(this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'outboundOrders/new') ? this.props.shipperChosen  : this.props.Deliver_CustomerDetail_id}
                handleReturnClick={() => this.closeShippinggInfoConfirmModal(false)}
                handleSaveClick={handleSubmit(form => this.handleFormSubmit(form))}
              />
            </SkyLightStateless>
            
            <SkyLightStateless dialogStyles={isJML ? MultiBatchStyle:MultiBatchModalStyle} isVisible={this.state.isBatchesModal2Visible} onCloseClicked={() => { this.setBatchesModal2Visibility(); }} title={'Edit Batch'}>
              <MultiBatchModal2
                batchesInfo={this.props.batchesInfo}
                onSelectedMultiBatch={this.onSelectedMultiBatch2}
                selectedInventoryRow={this.state.selectedInventoryRow}
                quantityValue={this.state.lineQty}
                lineBatchId={this.state.lineBatchId}
                lineBatchIdx={this.state.lineBatchIdx}
                lineBatchRows={this.state.lineBatchRows}
              />
            </SkyLightStateless>
            
            <SkyLightStateless dialogStyles={MultiBatchModalStyle} isVisible={this.state.isMultiBatchVisible} onCloseClicked={() => { this.setMultiBatchModalVisibility(); }} title={'Assign Batch'}>
              <MultiBatchModal
                batchesInfo={this.props.batchesInfo}
                onSelectedMultiBatch={this.onSelectedMultiBatch}
                selectedInventoryRow={this.state.selectedInventoryRow}
                quantityValue={this.props.quantityValue}
              />
            </SkyLightStateless>
            
            <BatchesModal
              setModalVisibility={this.setBatchesModalVisibility}
              isVisible={this.state.isBatchesModalVisible}
              batchesInfo={this.props.batchesInfo}
              onSelectedBatch={this.onSelectedBatch}
              salesOrderProduct={this.props.salesOrderProduct}
            />
          </form>
          {this.renderShippingIFrame()}
          {this.renderPackingIFrame()}
          {this.renderPickingIFrame()}
          {this.renderSalesOrderIFrame()}
          {this.renderSalesOrderSIIFrame()}
          {this.renderRefundIframe()}
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.historyOpen} onCloseClicked={() => { this.closeHistory(); }} title={customerSalesHistory}>
            {this.renderHistory()}
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.openOrderOpen} onCloseClicked={() => { this.setState({ openOrderOpen: false }); }} title={openSalesOrder}>
            {this.renderOpenOrder()}
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={createDialogInventoryStyle}
            isVisible={this.state.showInventoryOpen}
            onCloseClicked={() => {
              this.closeShowInventory('productSearch');
            }}
            title={selectInventoryInformation}
          >
            <SalesInventoryInfo
              Customer_id={this.state.currentCustomer}
              SearchType={this.props.searchType}
              SearchValue={this.props.searchValue}
              closeShowInventory={this.closeShowInventory}
              selectInventoryInfo={this.selectInventoryInfo}
              setSaleRowValue={this.props.setSaleRowValue}
              setAllProductQuantity={this.setAllProductQuantity}
            />
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.confirmOpen} onCloseClicked={() => { this.closeConfirm(); }} title={confirmAction}>
            <ConfirmActionModal
              case={this.state.case}
              closeC={this.closeConfirm}
              caseAction={() => { this.moveToSO('move'); }}
              zeroArray={this.state.quantityZero}
              lowestSalePrice={this.state.selectedInventoryRow.LowestSalePrice}
              currentPrice={this.props.unitPrice}
              rowEdited={this.state.RowBeingEdited}
              newPrice={this.state.newPrice}
              updatePrice={this.handleUpdatePrice}
            />
          </SkyLightStateless>
          <div className="remove-close-skylight">
            <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.showSOCreatedOpen} title={ModalHeader}>
              <br /><br />
              <Row className="centerStyle">
                <h4><Translate value="your_so_no_period_is" /> {(this.props.salesOrderCreated && this.props.salesOrderCreated.SONum) || this.props.soNum}</h4>
              </Row>
              <br />
              <Row className="centerStyle"><h4><Translate value="msg_ask_if_stay_on_current_page" />?</h4></Row>
              <br /><br />
              <Row className="centerStyle">
                <Button bsStyle="primary" className="mr" onClick={(event) => { this.refreshPage(event); }} type="button" ><Translate value="yes" /></Button>
                {
                  (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') &&
                  <Button bsStyle="danger" className="mr" onClick={() => { this.context.router.push("/outboundOrders"); }} type="button" ><Translate value="no" /></Button>
                }
                {
                  (this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') &&
                  <Button bsStyle="danger" className="mr" onClick={() => { this.context.router.push(route); }} type="button" ><Translate value="no" /></Button>
                }
                {
                  (this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') &&
                  <Button bsStyle="success" className="mr" onClick={() => { this.goToNewSales(newRoute); }} type="button" ><Translate value="new_so" /></Button>
                }
                {
                  (isFung && this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') &&
                  <Button bsStyle="success" onClick={() => { this.printSI(); }} type="button" ><Translate value="print_si" /></Button>
                }
              </Row>
            </SkyLightStateless>
          </div>

          <div id="sales-shipping-modal">
            <SkyLightStateless dialogStyles={createDialogShippingStyle} isVisible={this.state.showShippingOpen} onCloseClicked={this.closeShipping} title={expressInvoiceHeader}>
              <SalesShippingModal
                rows={this.state.rows}
                currentSalesOrder={this.props.currentSalesOrder}
                InvoiceNum={this.props.currentSalesOrderDetail && this.props.currentSalesOrderDetail.InvoiceNum}
              />
            </SkyLightStateless>
          </div>
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.changeTaxOpen} onCloseClicked={() => { this.closeChangeTax(); }} title={changeTax}>
            <TaxSelectionModal taxRateOptions={this.getTaxRateOptions()} taxValue={this.state.taxValue} onChange={this.handleTaxValueChange} />
          </SkyLightStateless>

          <SkyLightStateless dialogStyles={createDiscountDialogStyle} isVisible={this.state.changeDiscountOpen} onCloseClicked={() => { this.closeDiscountModal(); }} title={changeDiscountTitle}>
            <DiscountChangeModal SODiscount={this.state.SODiscount} SOSavings={this.state.SOSavings} onDiscountSavingsConfirm={this.onDiscountSavingsConfirm} />
          </SkyLightStateless>

          <SkyLightStateless dialogStyles={createWeightDialogStyle} isVisible={this.state.changeWeightOpen} onCloseClicked={() => { this.closeChangeWeight(); }} title={changeWeight}>
            <WeightChangeModal finalShippingWeight={this.state.finalShippingWeight} onClickButton={() => { this.onChangeWeightSubmit(); }} onChange={this.onShippingWeightChange}/>
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createNoteDialogStyle} isVisible={this.state.changeEmployeeNoteOpen} onCloseClicked={() => { this.closeEmployeeNote(); }} title={changeEmployeeNoteTitle}>
            <div>
              <Row className="centerStyle">
                <div style={{ width: '80%' }}>
                  <Input
                    type="textarea"
                    rows={5}
                    onChange={this.onChangeEmployeeNote}
                    value={this.state.employeeNoteText}
                  />
                </div>
              </Row>
              <Row className="centerStyle">
                <Button
                  bsStyle="success"
                  onClick={() => { this.onSubmitEmployeeNote(); }}
                >
                  <Translate value="save" />
                </Button>
              </Row>
            </div>
          </SkyLightStateless>

          <SkyLightStateless dialogStyles={editLocationDialogStyle} isVisible={this.state.ZBLModalOpen} onCloseClicked={() => { this.closeZBLModal(); }} title={"Change Location"}>
            <div>

            <Row className="centerStyle">
                <Col xs={12}>
                <p style={{fontSize: '20px'}}><Translate value="current_location" />: {this.state.currentZBL}</p>
                </Col>
            </Row>

              <Row className="centerStyle">
                <Col xs={4}>
                <label><Translate value="zone" /></label>
                </Col>
                <Col xs={4}>
                <label><Translate value="bin" /></label>
                </Col>
                <Col xs={4}>
                <label><Translate value="level" /></label>
                </Col>
              {/* <label><Translate value="account_name" />:</label>
                <div style={{ width: '80%' }}>
                  <Input
                    type="text"
                    onChange={this.onChangeNameOnAccount}
                    value={this.state.NameOnAccount}
                  />
                </div> */}
              </Row>
              <Row className="centerStyle">
                <Col xs={4}>
                {/* <Field name="Zone" matchPos="any" component={Selection} options={this.state.zoneOptions} /> */}
                <Dropdown>
                  <Dropdown.Toggle style={{ height: '28px', width: '210px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                    {this.state.zoneDisplay}
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="super-colors">
                    {this.state.zoneOptions.map(el => {
                      return (
                        <MenuItem onClick={() => handleZoneChange(el)}>{el.label}</MenuItem>
                      )
                    })}
                  </Dropdown.Menu>
                </Dropdown>
                </Col>
                <Col xs={4}>
                <Dropdown>
                  <Dropdown.Toggle style={{ height: '28px', width: '210px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                    {this.state.binDisplay}
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="super-colors">
                    {this.state.binOptions.map(el => {
                      return (
                        <MenuItem onClick={() => handleBinChange(el)}>{el.label}</MenuItem>
                      )
                    })}
                  </Dropdown.Menu>
                </Dropdown>
                </Col>
                <Col xs={4}>
                <Dropdown>
                  <Dropdown.Toggle style={{ height: '28px', width: '210px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                    {this.state.levelDisplay}
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="super-colors">
                    {this.state.levelOptions.map(el => {
                      return (
                        <MenuItem onClick={() => handleLevelChange(el)}>{el.label}</MenuItem>
                      )
                    })}
                  </Dropdown.Menu>
                </Dropdown>
                </Col>
              </Row>
              <Row className="centerStyle">
                <Button
                  bsStyle="success"
                  style={{marginTop: '20px'}}
                  onClick={() => { this.onSubmitZBLEdit(); }}
                >
                  <Translate value="save" />
                </Button>
                <Button
                  bsStyle="danger"
                  style={{marginLeft: '10px', marginTop: '20px'}}
                  onClick={() => { this.closeZBLModal(); }}
                >
                  <Translate value="cancel" />
                </Button>
              </Row>
            </div>
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={editAchDialogStyle} isVisible={this.state.achEditOpen} onCloseClicked={() => { this.closeAchEdit(); }} title={editAchTitle}>
            <div>
              <Row className="centerStyle">
              <label><Translate value="account_name" />:</label>
                <div style={{ width: '80%' }}>
                  <Input
                    type="text"
                    onChange={this.onChangeNameOnAccount}
                    value={this.state.NameOnAccount}
                  />
                </div>
              </Row>
              <Row className="centerStyle">
              <label><Translate value="account_number" />:</label>
                <div style={{ width: '80%' }}>
                  <Input
                    type="text"
                    onChange={this.onChangeAccountNum}
                    value={this.state.AccountNum}
                  />
                </div>
              </Row>
              <Row className="centerStyle">
              <label><Translate value="routing_number" />:</label>
                <div style={{ width: '80%' }}>
                  <Input
                    type="text"
                    onChange={this.onChangeRouting}
                    value={this.state.Routing}
                  />
                </div>
              </Row>
              <Row className="centerStyle">
                <Button
                  bsStyle="success"
                  onClick={() => { this.onSubmitAchEdit(); }}
                >
                  <Translate value="save" />
                </Button>
                <Button
                  bsStyle="danger"
                  style={{marginLeft: '10px'}}
                  onClick={() => { this.closeAchEdit(); }}
                >
                  <Translate value="cancel" />
                </Button>
              </Row>
            </div>
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={changeDeliveryDialogStyle} isVisible={this.state.changeDeliveryFeeOpen} onCloseClicked={() => { this.closeDeliveryFee(); }} title={changeDeliveryFeeTitle}>
            <div>
              <Row className="centerStyle" style ={{ marginTop: '30px' }}>
                <div style={{ width: '60%' }}>
                  <Input
                    type="number"
                    onChange={this.onChangeDeliveryFee}
                    value={this.state.deliveryFeeEdit}
                  />
                </div>
              </Row>
              <Row className="centerStyle">
                <Button
                  bsStyle="success"
                  onClick={() => { this.onConfirmDeliveryFee(); }}
                >
                  <Translate value="confirm" />
                </Button>
              </Row>
            </div>
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.editSOPermissionOpen} onCloseClicked={() => { this.closeEditSOPermission(); }} title={editSOPermission}>
            <ConfirmActionModal
              case={this.state.case}
              checkPermission={this.props.checkPermission}
              checkPermissionSuccess={this.props.checkPermissionSuccess}
            />
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.confirmRefundOpen} onCloseClicked={this.closeConfirmRefund.bind(this)} title={confirmRefund}>
            <ConfirmActionModal
              case={this.state.case}
              closeConfirmRefund={this.closeConfirmRefund.bind(this)}
              handleRefundConfirm={this.handleRefundConfirm.bind(this)}
              checkPermission={this.props.checkPermission}
              checkPermissionSuccess={this.props.checkPermissionSuccess}
              />
              </SkyLightStateless>
          <SkyLightStateless 
            dialogStyles={createDialogStyle} 
            isVisible={this.state.verifyPasscodeOpen} 
            onCloseClicked={this.closeVerifyPasscode} title={passcodeConfirm}
          >
            <VerifyPasscodeModal
              text={<Translate value="price_range_warning" />}
              closeConfirm={this.handleVerifyPasscodeClose}
            />
          </SkyLightStateless>
          <SkyLightStateless 
            dialogStyles={createDialogStyle} 
            isVisible={this.state.verifyPasscodeToCreateSOModalOpen} 
            onCloseClicked={this.closeVerifyPasscodeToCreateSO} 
            title={passcodeConfirm}
          >
            <VerifyPasscodeModal
              text={<Translate value="credit_limit_payment_term_warning" />}
              closeConfirm={this.handleVerifypasscodeToCreateSOClose}
            />
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={createDeliveryModalDialogStyle}
            isVisible={this.state.deliveryMethodModalOpen}
            onCloseClicked={this.closeDeliveryMethodModal}
            title={`Delivery Method: ${this.state.ShippingMethod}`}
          >
            <DeliveryMethodModal
              info={this.state.shipping}
            />
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={changeCarrierInfoStyle} isVisible={this.state.carrierInfoModalOpen} onCloseClicked={() => { this.closeCarrierInfoModal(); }} title={changeCarrierInfo}>
            <div>
              <CarrierInfoModal 
                salesOrderId={this.props.params.id}
                fetchCarrierInfo={this.props.fetchCarrierInfo}
                postCarrierInfo={this.props.postCarrierInfo}
                closeCarrierInfoModal={this.closeCarrierInfoModal}
              />
            </div>
          </SkyLightStateless>

          <SkyLightStateless dialogStyles={changeCarrierInfoStyle} isVisible={this.state.shippingInfoEditModalVisibility} onCloseClicked={() => { this.closeShippingInfoEditModal(); }} title={'Add Shipping Address'}>
            <ShippingAddressEditmodal
              receivingCustomer={this.props.receivingCustomer}
              salesCustomerDetails={this.props.salesCustomerDetails}
              reFetchSalesCustomers={this.reFetchSalesCustomers}
            />
          </SkyLightStateless>

          <SkyLightStateless dialogStyles={changeFBAStyle} isVisible={this.state.fbaEditModalVisibility} onCloseClicked={() => { this.closeFBAEditModal(); }} title={'Add FBA Address'}>
            <FBAAddressEditModal
              closeFBAEditModal={this.closeFBAEditModal}
              modalFetchFBA={this.modalFetchFBA}
              // receivingCustomer={this.props.receivingCustomer}
              // salesCustomerDetails={this.props.salesCustomerDetails}
              // reFetchSalesCustomers={this.reFetchSalesCustomers}
            />
          </SkyLightStateless>

          <SkyLightStateless 
            dialogStyles={createDialogStyle} 
            isVisible={this.state.verifyPasscodeOpenDiscount} 
            onCloseClicked={this.closeVerifyPasscodeDiscount} title={passcodeConfirm}
          >
            <VerifyPasscodeModal
              text={<Translate value="price_range_warning" />}
              closeConfirm={this.handleVerifyPasscodeCloseDiscount}
            />
          </SkyLightStateless>

          <DropshipModal
            visible={this.state.isDropshipOpen}
            onClose={this.closeDropship}
            salesOrderId={this.props.params.id}
          />
          <ShippingInfoFormModal 
            isVisible={this.state.shippingInfoModalVisibility}
            onClose={this.closeShippingInfoFormModal}
            initialValues={this.props.initialValues}
          />
        </ContentWrapper>
      //---------------
      // End HTML
      //---------------
      );
    }
}

export default withRouter(SalesOrderForm);

let pickShippingMethod = props => {
  return (
    <div className="form-group">
      <div className="col-xs-4 text-nowrap">
        <input
          {...props.input}
          type="radio"
          value="Delivery"
          checked={props.input.value === "Delivery"}
        />
        <Translate value="delivery"/>
      </div>
      <div className="col-xs-3 text-nowrap">
        <input
          {...props.input}
          type="radio"
          value="Pickup"
          checked={props.input.value === "Pickup"}
        />
        <Translate value="pickup"/>
      </div>
    </div>
  )
}

let renderTypeRadios = props => (
  <div className="form-group" id="search-product-by">
  {
  !isChinaTown &&
    <label className="col-xs-4 search-by-max-width">
      <Translate value="search_by" />
    </label>
  }
    <label className="col" style={{ paddingRight: '5px' }}>
      <input
        {...props.input}
        style={{ marginRight: '3px' }}
        type="radio"
        value="ProductNum"
        checked={props.input.value === 'ProductNum'}
      />
      <Translate value="prod_num" />
    </label>
    <label className="col" style={{ paddingRight: '5px' }}>
      <input
        {...props.input}
        style={{ marginRight: '3px' }}
        type="radio"
        value="RefNum"
        checked={props.input.value === 'RefNum'}
      />
      <Translate value="ref_num" />
    </label>
    <label className="col" style={{ paddingRight: '5px' }}>
      <input
        {...props.input}
        style={{ marginRight: '3px' }}
        type="radio"
        value="Name"
        checked={props.input.value === 'Name'}
      />
      <Translate value="name" />
    </label>
    <label className="col" style={{ paddingRight: '5px' }}>
      <input
        {...props.input}
        style={{ marginRight: '3px' }}
        type="radio"
        value="Description"
        checked={props.input.value === 'Description'}
      />
      <Translate value="desc" />
    </label>
    <label className="col" style={{ paddingRight: '5px' }}>
      <input
        {...props.input}
        style={{ marginRight: '3px' }}
        type="radio"
        value="Barcode"
        checked={props.input.value === 'Barcode'}
      />
      <Translate value="Barcode" />
    </label>
    <label className="col" style={{ paddingRight: '5px' }}>
      <input
        {...props.input}
        style={{ marginRight: '3px' }}
        type="radio"
        value="GeneralNum"
        checked={props.input.value === 'GeneralNum'}
      />
      <Translate value="general_no" />
    </label>
  </div>
);



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/salesOrderForm.jsx